// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"g0GKl":[function(require,module,exports) {
const parent = document.querySelector(".parent");
const body = document.body;
const AlgoGems = document.getElementById("algoGems");
const randGallery = document.getElementById("randGallery");
const colorPicker = document.querySelector(".colorPicker");
const cnctBtn = document.querySelector(".MyAlgo");
const perecnctBtn = document.querySelector(".MyAlgo2");
const historyContainer = document.querySelector(".history-container");
const slotLink = document.querySelector("#slot-link");
const editLink = document.querySelector(".EditLink");
const switchContainer = document.querySelector(".switch-container");
const colorExtractor = document.querySelector(".picker-container");
// import { PeraWalletConnect } from "@perawallet/connect";
const { PeraWalletConnect  } = require("cc2416b85b87cc13");
// 
const switcher = document.querySelector("#switcher");
let colorHistory = [];
let defaultNewBgValue = "#000";
let events = {
    initial: "",
    drag: "",
    terminate: ""
};
let on_testnet = false;
const chainId = on_testnet ? 416002 : 416001;
const peraWallet = new PeraWalletConnect({
    chainId: chainId
});
let userAddress = localStorage.getItem("address") ? localStorage.getItem("address").replaceAll('"', "") : "";
let userPeraAddress = localStorage.getItem("pera-address") ? localStorage.getItem("pera-address").replaceAll('"', "") : "";
let connected = localStorage.getItem("address") ? true : false;
const text = localStorage.getItem("address") ? `${userAddress[0]}${userAddress[1]}${userAddress[2]}${userAddress[3]}...${userAddress[54]}${userAddress[55]}${userAddress[56]}${userAddress[57]}` : "Connect to MyAlgo";
let peraConnected = localStorage.getItem("pera-address") ? true : false;
const peraText = localStorage.getItem("pera-address") ? `${userPeraAddress[0]}${userPeraAddress[1]}${userPeraAddress[2]}...${userPeraAddress[userPeraAddress.length - 3]}${userPeraAddress[userPeraAddress.length - 2]}${userPeraAddress[userPeraAddress.length - 1]}` : "Connect To Pera Wallet";
cnctBtn.innerText = text;
perecnctBtn.innerHTML = peraText;
let selectGrid = null;
if (connected) {
    const toolTip = document.createElement("span");
    toolTip.innerText = "Disconnect";
    toolTip.classList.add("tooltiptext");
    cnctBtn.appendChild(toolTip);
    perecnctBtn.disabled = true;
} else if (peraConnected) {
    const toolTip = document.createElement("span");
    toolTip.innerText = "Disconnect";
    toolTip.classList.add("tooltiptext");
    perecnctBtn.appendChild(toolTip);
    cnctBtn.disabled = true;
}
if (on_testnet) {
    chain = "testnet";
    node_api = "https://testnet-api.algonode.cloud";
    indexer_api = "https://testnet-idx.algonode.cloud";
    explorer_basepoint = "https://testnet.algoexplorer.io/";
    app_id_blocks = 75246277;
    app_id_links = 86091380;
    nft_ids = [
        75246513,
        75246514,
        75246516,
        75246523,
        75246526,
        75246528,
        75246529,
        75246534,
        75246540,
        75246544,
        75246546,
        75246550,
        75246552,
        75246553,
        75246557,
        75246558,
        75246559,
        75246563,
        75246569,
        75246572,
        75246575,
        75246583,
        75246586,
        75246591,
        75246594,
        75246597,
        75246599,
        75246602,
        75246605,
        75246608,
        75246612,
        75246615,
        75246619,
        75246625,
        75246632,
        75246689,
        75246696,
        75246699,
        75246705,
        75246707,
        75246715,
        75246718,
        75246729,
        75246732,
        75246734,
        75246739,
        75246741,
        75246747,
        75246749,
        75246753,
        75246757,
        75246762,
        75246763,
        75246770,
        75246776,
        75246781,
        75246783,
        75246787,
        75246791,
        75246796,
        75246803,
        75246805,
        75246807,
        75246811,
        75246818,
        75247142,
        75247149,
        75247154,
        75247159,
        75247168,
        75247172,
        75247179,
        75247182,
        75247184,
        75247189,
        75247191,
        75247194,
        75247201,
        75247206,
        75247207,
        75247212,
        75247220,
        75247227,
        75247233,
        75247250,
        75247254,
        75247263,
        75247318,
        75247325,
        75247330,
        75247335,
        75247341,
        75247352,
        75247355,
        75247356,
        75247367,
        75247375,
        75247378,
        75247383,
        75247388,
        75247393,
        75247395,
        75247407,
        75247413,
        75247420,
        75247423,
        75247431,
        75247447,
        75247448,
        75247459,
        75247463,
        75247472,
        75247479,
        75247488,
        75247501,
        75247506,
        75247510,
        75247516,
        75247531,
        75247543,
        75247552,
        75247557,
        75247618,
        75247627,
        75247649,
        75247653,
        75247661
    ];
} else {
    chain = "mainnet";
    node_api = "https://mainnet-api.algonode.cloud";
    indexer_api = "https://mainnet-idx.algonode.cloud";
    explorer_basepoint = "https://explorer.perawallet.app/";
    app_id_blocks = 711081866;
    app_id_links = 766453886;
    nft_ids = [
        710948423,
        710949039,
        710949639,
        710950112,
        710950507,
        710950966,
        710952030,
        710952598,
        710953325,
        710953805,
        710954571,
        710955287,
        710956328,
        710957117,
        710958284,
        710958883,
        710960825,
        710961473,
        710963373,
        710964157,
        710964810,
        710965366,
        710965906,
        710966336,
        710966868,
        710967352,
        710969045,
        710969691,
        710970202,
        710970536,
        710971025,
        710971470,
        710972267,
        710972708,
        710974097,
        710974705,
        710975080,
        710975526,
        710975970,
        710976513,
        710976964,
        710977594,
        710978278,
        710979983,
        710980501,
        710980880,
        710981655,
        710982083,
        710982678,
        710983157,
        710983576,
        710984044,
        710985070,
        710985682,
        710986230,
        710986613,
        710986954,
        710987254,
        711019618,
        711019922,
        711020438,
        711021134,
        711021842,
        711022291,
        711022588,
        711022895,
        711023230,
        711023556,
        711024672,
        711025157,
        711025450,
        711025700,
        711026007,
        711026235,
        711026463,
        711027024,
        711027378,
        711027584,
        711028395,
        711028659,
        711028936,
        711029243,
        711029784,
        711030180,
        711030563,
        711030883,
        711031220,
        711031520,
        711035674,
        711035936,
        711036728,
        711037031,
        711037327,
        711037611,
        711037966,
        711038241,
        711042325,
        711042866,
        711043620,
        711044164,
        711044425,
        711044909,
        711045515,
        711046155,
        711046764,
        711047276,
        711047673,
        711048254,
        711049382,
        711050401,
        711050770,
        711051186,
        711051591,
        711052204,
        711052655,
        711053236,
        711053393,
        711053780,
        711053973,
        711054286,
        711054578,
        711054809,
        711055189,
        711055389,
        711055737,
        711056067,
        711056468
    ];
}
const client = new algosdk.Algodv2("", node_api, "");
const indexer = new algosdk.Indexer("", indexer_api, "");
let palette = [
    "#400000",
    "#400000",
    "#400900",
    "#234000",
    "#004000",
    "#004000",
    "#004000",
    "#000d40",
    "#000040",
    "#000040",
    "#000040",
    "#000040",
    "#280040",
    "#400003",
    "#400000",
    "#000000",
    "#540000",
    "#540000",
    "#541d00",
    "#375400",
    "#005400",
    "#005400",
    "#005402",
    "#002154",
    "#000054",
    "#000054",
    "#000054",
    "#000054",
    "#3c0054",
    "#540017",
    "#540000",
    "#0d0d0d",
    "#680000",
    "#680000",
    "#683100",
    "#4b6800",
    "#006800",
    "#006800",
    "#006816",
    "#003568",
    "#001168",
    "#000068",
    "#000068",
    "#000068",
    "#500068",
    "#68002b",
    "#680000",
    "#212121",
    "#7c0000",
    "#7c0000",
    "#7c4500",
    "#5f7c00",
    "#0b7c00",
    "#007c00",
    "#007c2a",
    "#00497c",
    "#00257c",
    "#00007c",
    "#00007c",
    "#10007c",
    "#64007c",
    "#7c003f",
    "#7c0000",
    "#353535",
    "#900000",
    "#900400",
    "#905900",
    "#739000",
    "#1f9000",
    "#009000",
    "#00903e",
    "#005d90",
    "#003990",
    "#000090",
    "#000090",
    "#240090",
    "#780090",
    "#900053",
    "#900000",
    "#494949",
    "#a40000",
    "#a41800",
    "#a46d00",
    "#87a400",
    "#33a400",
    "#00a400",
    "#00a452",
    "#0071a4",
    "#004da4",
    "#0000a4",
    "#0000a4",
    "#3800a4",
    "#8c00a4",
    "#a40067",
    "#a40013",
    "#5d5d5d",
    "#b80000",
    "#b82c00",
    "#b88100",
    "#9bb800",
    "#47b800",
    "#00b800",
    "#00b866",
    "#0085b8",
    "#0061b8",
    "#000db8",
    "#0000b8",
    "#4c00b8",
    "#a000b8",
    "#b8007b",
    "#b80027",
    "#717171",
    "#cc0000",
    "#cc4000",
    "#cc9500",
    "#afcc00",
    "#5bcc00",
    "#06cc00",
    "#00cc7a",
    "#0099cc",
    "#0075cc",
    "#0021cc",
    "#0c00cc",
    "#6000cc",
    "#b400cc",
    "#cc008f",
    "#cc003b",
    "#858585",
    "#e00000",
    "#e05400",
    "#e0a900",
    "#c3e000",
    "#6fe000",
    "#1ae000",
    "#00e08e",
    "#00ade0",
    "#0089e0",
    "#0035e0",
    "#2000e0",
    "#7400e0",
    "#c800e0",
    "#e000a3",
    "#e0004f",
    "#999999",
    "#f41414",
    "#f46814",
    "#f4bd14",
    "#d7f414",
    "#83f414",
    "#2ef414",
    "#14f4a2",
    "#14c1f4",
    "#149df4",
    "#1449f4",
    "#3414f4",
    "#8814f4",
    "#dc14f4",
    "#f414b7",
    "#f41463",
    "#adadad",
    "#ff2828",
    "#ff7c28",
    "#ffd128",
    "#ebff28",
    "#97ff28",
    "#42ff28",
    "#28ffb6",
    "#28d5ff",
    "#28b1ff",
    "#285dff",
    "#4828ff",
    "#9c28ff",
    "#f028ff",
    "#ff28cb",
    "#ff2877",
    "#c1c1c1",
    "#ff3c3c",
    "#ff903c",
    "#ffe53c",
    "#ffff3c",
    "#abff3c",
    "#56ff3c",
    "#3cffca",
    "#3ce9ff",
    "#3cc5ff",
    "#3c71ff",
    "#5c3cff",
    "#b03cff",
    "#ff3cff",
    "#ff3cdf",
    "#ff3c8b",
    "#d5d5d5",
    "#ff5050",
    "#ffa450",
    "#fff950",
    "#ffff50",
    "#bfff50",
    "#6aff50",
    "#50ffde",
    "#50fdff",
    "#50d9ff",
    "#5085ff",
    "#7050ff",
    "#c450ff",
    "#ff50ff",
    "#ff50f3",
    "#ff509f",
    "#e9e9e9",
    "#ff6464",
    "#ffb864",
    "#ffff64",
    "#ffff64",
    "#d3ff64",
    "#7eff64",
    "#64fff2",
    "#64ffff",
    "#64edff",
    "#6499ff",
    "#8464ff",
    "#d864ff",
    "#ff64ff",
    "#ff64ff",
    "#ff64b3",
    "#fdfdfd",
    "#ff7878",
    "#ffcc78",
    "#ffff78",
    "#ffff78",
    "#e7ff78",
    "#92ff78",
    "#78ffff",
    "#78ffff",
    "#78ffff",
    "#78adff",
    "#9878ff",
    "#ec78ff",
    "#ff78ff",
    "#ff78ff",
    "#ff78c7",
    "#ffffff",
    "#ff8c8c",
    "#ffe08c",
    "#ffff8c",
    "#ffff8c",
    "#fbff8c",
    "#a6ff8c",
    "#8cffff",
    "#8cffff",
    "#8cffff",
    "#8cc1ff",
    "#ac8cff",
    "#ff8cff",
    "#ff8cff",
    "#ff8cff",
    "#ff8cdb",
    "#ffffff"
];
const picker = new EightBitColorPicker({
    el: "color-target",
    color: 15
});
const ManageHistory = (color, array)=>{
    if (array.length === 4) array.pop();
    if (colorHistory.indexOf(color) >= 0) return;
    colorHistory = [
        color,
        ...colorHistory
    ];
};
const pickerBtn = document.querySelector(".ebcp-selection");
picker.addEventListener("colorChange", function(e) {
    defaultNewBgValue = e.detail.picker.getHexColor();
    colorPicker.style.background = e.detail.picker.getHexColor();
    while(historyContainer.hasChildNodes())historyContainer.removeChild(historyContainer.firstChild);
    ManageHistory(e.detail.picker.getHexColor(), colorHistory);
    colorHistory.forEach((color, i)=>{
        const historyBox = document.createElement("div");
        historyBox.classList.add("history-box");
        if (i === 0) historyBox.style.borderRadius = "5px 5px 0 0";
        if (i == 3) historyBox.style.borderRadius = "0 0 5px 5px";
        historyBox.addEventListener("click", ()=>{
            defaultNewBgValue = historyBox.style.backgroundColor;
            colorPicker.style.background = historyBox.style.backgroundColor;
            pickerBtn.style.background = historyBox.style.backgroundColor;
        });
        historyBox.style.backgroundColor = color;
        historyContainer.appendChild(historyBox);
    });
});
let boxBaseValue = 0;
let Boxes = Array.from(Array(128), ()=>new Array(1));
let Links = [];
const instance = axios.create({
    baseURL: "https://api.algopixels.site"
});
function rgbToHex(color) {
    color = "" + color;
    if (!color || color.indexOf("rgb") < 0) return;
    if (color.charAt(0) == "#") return color;
    var nums = /(.*?)rgb\((\d+),\s*(\d+),\s*(\d+)\)/i.exec(color), r = parseInt(nums[2], 10).toString(16), g = parseInt(nums[3], 10).toString(16), b = parseInt(nums[4], 10).toString(16);
    return "#" + ((r.length == 1 ? "0" + r : r) + (g.length == 1 ? "0" + g : g) + (b.length == 1 ? "0" + b : b));
}
const linkFormat = (link)=>{
    let formatLink = link.replace("https://", "");
    formatLink = formatLink.replace("http://", "");
    if (formatLink[formatLink.length - 1] === "/") return formatLink.slice(0, -1);
    return formatLink;
};
async function Execute() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        events.initial = "touchstart";
        events.drag = "touchmove";
        events.terminate = "touchend";
    } else {
        events.initial = "mousedown";
        events.drag = "mouseenter";
        events.terminate = "mouseup";
    }
    try {
        const server = await instance.get("/pixels", {
            params: {
                chain: chain
            }
        });
        const links = await instance.get("/links", {
            params: {
                chain: chain
            }
        });
        Links = links.data;
        let boxNumber = boxBaseValue;
        let rowPixelCount = 0;
        let pixelCount = 0;
        server.data.forEach((data, i)=>{
            if (pixelCount === 8) {
                pixelCount = 0;
                boxNumber++;
            }
            if (rowPixelCount === 128) {
                boxNumber = boxBaseValue;
                pixelCount = 0;
                rowPixelCount = 0;
            }
            switch(i){
                case 1024:
                    boxBaseValue = 16;
                    boxNumber = boxBaseValue;
                    break;
                case 2048:
                    boxBaseValue = 32;
                    boxNumber = boxBaseValue;
                    break;
                case 3072:
                    boxBaseValue = 48;
                    boxNumber = boxBaseValue;
                    break;
                case 4096:
                    boxBaseValue = 64;
                    boxNumber = boxBaseValue;
                    break;
                case 5120:
                    boxBaseValue = 80;
                    boxNumber = boxBaseValue;
                    break;
                case 6144:
                    boxBaseValue = 96;
                    boxNumber = boxBaseValue;
                    break;
                case 7168:
                    boxBaseValue = 112;
                    boxNumber = boxBaseValue;
                    break;
                default:
            }
            rowPixelCount++;
            pixelCount++;
            Boxes[boxNumber][i] = data;
        });
        boxBaseValue = 0;
    } catch (error) {
        console.log(error);
    }
}
async function isOnSale() {
    try {
        const isOnSaleResponse = await instance.get("/onsale", {
            params: {
                chain: chain
            }
        });
        for (let [i, box] of Boxes.entries()){
            const purchaseDiv = document.createElement("div");
            const parentDiv = document.getElementById(i);
            const onSale = isOnSaleResponse.data[i];
            if (onSale) {
                purchaseDiv.classList.add("purchasable-slot");
                purchaseDiv.innerHTML = '<i class="uil uil-shopping-bag"></i>';
                parentDiv.appendChild(purchaseDiv);
            }
        }
    } catch (error) {
        return false;
    }
}
const Execution = ()=>{
    Boxes.map(async (Box, i)=>{
        let parentDiv = document.createElement("div");
        const mainParentDiv = document.querySelector("#mainParent");
        parentDiv.classList.add("grid-div");
        mainParentDiv.classList.add("parent-bg");
        parentDiv.id = `${i}`;
        if (i === 127) parentDiv.classList.add("grid-disabled");
        parentDiv.innerText = "";
        mainParentDiv.appendChild(parentDiv);
        switchContainer.classList.remove("hidden");
        // PURCHASABLE SLOT
        Box.forEach((el)=>{
            let childDiv = document.createElement("div");
            childDiv.style.background = el;
            parentDiv.appendChild(childDiv);
        });
        colorExtractor.classList.remove("hidden");
        parentDiv.addEventListener("click", async ()=>{
            let pixelNumber = document.querySelector("#slot-number");
            let colorDetail = document.querySelector("#old-color");
            body.style.overflow = "auto";
            const selectedGridContainer = document.querySelector("#selected-container");
            selectedGridContainer.classList.remove("selected-grid-container-hidden");
            selectedGridContainer.classList.add("selected-grid-container");
            const selectedGrid = document.querySelector(".selected-grid");
            while(selectedGrid.hasChildNodes())selectedGrid.removeChild(selectedGrid.firstChild);
            selectedGrid.id = parentDiv.id;
            const owner = await get_owner(nft_ids[selectedGrid.id]);
            slotLink.innerText = Links[selectedGrid.id] ? linkFormat(Links[selectedGrid.id]) : "";
            slotLink.href = Links[selectedGrid.id] || "";
            editLink.placeholder = Links[selectedGrid.id] || "Add a Link";
            pixelNumber.innerText = `Pixel Slot #${selectedGrid.id}`;
            colorDetail.innerText = `${owner[0] + owner[1] + owner[2] + "..." + owner[55] + owner[56] + owner[57]}`;
            colorDetail.href = `${explorer_basepoint}address/${owner}`;
            Boxes[parentDiv.id].forEach((data, i)=>{
                let selectedGridElements = document.createElement("div");
                selectedGridElements.style.background = data;
                selectedGridElements.classList.add("pixels");
                selectedGridElements.id = `target${i}`;
                selectedGridElements.innerText = "";
                selectedGrid.appendChild(selectedGridElements);
            });
            selectedGrid.scrollIntoView({
                behavior: "smooth"
            });
            AlgoGems.href = `https://algogems.io/nft/${nft_ids[selectedGrid.id]}`;
            randGallery.href = `https://www.randgallery.com/algo-collection/?address=${nft_ids[selectedGrid.id]}`;
            selectGrid = selectedGrid;
            addEventListeners();
            colorExtractor.addEventListener("click", extractColor, true);
        });
    });
    isOnSale();
    const loaderDiv = document.querySelector(".loading-con");
    loaderDiv.classList.add("loading-con-disabled");
    document.querySelector(".btns_container").classList.remove("MyAlgohidden");
    document.querySelector(".btns_container").classList.add("d-flex-row");
    const connectBtn = document.querySelector(".MyAlgo");
    const connectToPera = document.querySelector(".MyAlgo2");
    document.querySelector(".banner-img").classList.remove("hidden");
    connectBtn.addEventListener("click", async ()=>{
        if (!connected) {
            await connectMyAlgo();
            const toolTip = document.createElement("span");
            toolTip.innerText = "Disconnect";
            toolTip.classList.add("tooltiptext");
            connectBtn.appendChild(toolTip);
            connectToPera.disabled = true;
        } else {
            connectToPera.disabled = false;
            disconnectMyAlgo(connectBtn);
        }
    });
    connectToPera.addEventListener("click", async ()=>{
        if (!peraConnected) {
            await connectPeraWallet();
            const toolTip = document.createElement("span");
            toolTip.innerText = "Disconnect";
            toolTip.classList.add("tooltiptext");
            connectToPera.appendChild(toolTip);
            connectBtn.disabled = true;
        } else {
            connectBtn.disabled = false;
            await disconnectWallet(connectToPera);
        }
    });
    document.querySelector(".EditState").addEventListener("click", ()=>{
        checkIfAlgoConnected();
    });
};
Execute().then(()=>{
    setTimeout(()=>{
        switcher.addEventListener("click", ()=>{
            const purchasable = document.querySelectorAll(".purchasable-slot");
            if (switcher.checked) purchasable.forEach((purchase)=>{
                purchase.classList.remove("hidden");
            });
            else purchasable.forEach((purchase)=>{
                purchase.classList.add("hidden");
            });
        });
        Execution();
        setInterval(async ()=>{
            try {
                const updatedResponse = await instance.get("/changed", {
                    params: {
                        chain: chain
                    }
                });
                if (updatedResponse.data.length > 0) updatedResponse.data.forEach((result)=>{
                    updateBox(result.slot_number, result.slot_colors, result.slot_link);
                });
            } catch (error) {
                console.log(error);
            }
        }, 30000);
    }, 3000);
});
const handleOnSale = async ()=>{
// for (let [i, box] of Boxes.entries()) {
//   const purchaseDiv = document.createElement("div");
//   const parentDiv = document.getElementById(i);
//   const onSale = await isOnSale(nft_ids[i]);
//   if (onSale) {
//     purchaseDiv.classList.add("purchasable-slot");
//     purchaseDiv.innerHTML = '<i class="uil uil-shopping-bag"></i>';
//     parentDiv.appendChild(purchaseDiv);
//   }
// }
};
const eventsList = ()=>{
    body.style.overflow = "hidden";
    selectGrid.childNodes.forEach((child)=>{
        child.addEventListener(events.initial, changePixel, true);
        child.addEventListener(events.drag, changePixel, true);
    });
    document.addEventListener(events.terminate, ()=>{
        selectGrid.childNodes.forEach((child)=>{
            body.style.overflow = "auto";
            child.removeEventListener(events.drag, changePixel, true);
        });
    });
};
const addEventListeners = ()=>{
    selectGrid.addEventListener(events.initial, eventsList, true);
    selectGrid.childNodes.forEach((child)=>{
        child.addEventListener(events.initial, changePixel, true);
    });
};
const removeEventListeners = ()=>{
    selectGrid.removeEventListener(events.initial, eventsList, true);
    selectGrid.childNodes.forEach((child)=>{
        body.style.overflow = "auto";
        child.removeEventListener(events.initial, changePixel, true);
        child.removeEventListener(events.drag, changePixel, true);
    });
};
const extractColor = ()=>{
    removeEventListeners();
    selectGrid.childNodes.forEach((child)=>{
        child.addEventListener("click", pixelColor, true);
    });
};
const pixelColor = (e)=>{
    // el.style.background = defaultNewBgValue;
    while(historyContainer.hasChildNodes())historyContainer.removeChild(historyContainer.firstChild);
    ManageHistory(rgbToHex(e.srcElement.style.background), colorHistory);
    defaultNewBgValue = rgbToHex(e.srcElement.style.background);
    colorPicker.style.background = rgbToHex(e.srcElement.style.background);
    pickerBtn.style.background = rgbToHex(e.srcElement.style.background);
    colorHistory.forEach((color, i)=>{
        const historyBox = document.createElement("div");
        historyBox.classList.add("history-box");
        if (i === 0) historyBox.style.borderRadius = "5px 5px 0 0";
        if (i == 3) historyBox.style.borderRadius = "0 0 5px 5px";
        historyBox.addEventListener("click", ()=>{
            defaultNewBgValue = historyBox.style.backgroundColor;
            colorPicker.style.background = historyBox.style.backgroundColor;
            pickerBtn.style.background = historyBox.style.backgroundColor;
        });
        historyBox.style.backgroundColor = color;
        historyContainer.appendChild(historyBox);
    });
    // colorExtractor.removeEventListener('click',extractColor,true)
    selectGrid.childNodes.forEach((child)=>{
        child.removeEventListener("click", pixelColor, true);
    });
    addEventListeners();
};
const changePixel = (e)=>{
    if (e.touches) {
        const el = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY);
        if (el.id.includes("target")) el.style.background = defaultNewBgValue;
    }
    e.target.style.background = defaultNewBgValue;
};
async function is_owner(address, asa_id) {
    const accountInfo = await indexer.lookupAccountByID(address).do();
    const assetsOwned = accountInfo.account?.assets || [];
    let i = 0;
    while(i < assetsOwned.length){
        if (assetsOwned[i]["asset-id"] == asa_id && assetsOwned[i]["amount"] == 1) return true;
        i += 1;
    }
    return false;
}
const InitiateTransaction = async (boxId, colorIds, colors)=>{
    try {
        const res = await is_owner(userAddress, nft_ids[boxId]);
        if (!res) {
            toastr.options = {
                closeButton: false,
                debug: false,
                newestOnTop: false,
                positionClass: "toast-bottom-left",
                preventDuplicates: false,
                onclick: null,
                showDuration: "300",
                hideDuration: "1000",
                timeOut: "3000",
                extendedTimeOut: "1000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            };
            toastr["error"](`Pixel Slot #${boxId} not owned`);
        } else put_data(boxId, colorIds, colors);
    } catch (error) {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "3000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
        };
        toastr["error"](`Either the account doesn't exist or you don't have enough funds`);
    }
};
const InitiatePeraTransaction = async (boxId, colorIds, colors)=>{
    try {
        const res = await is_owner(userPeraAddress, nft_ids[boxId]);
        if (!res) {
            toastr.options = {
                closeButton: false,
                debug: false,
                newestOnTop: false,
                positionClass: "toast-bottom-left",
                preventDuplicates: false,
                onclick: null,
                showDuration: "300",
                hideDuration: "1000",
                timeOut: "3000",
                extendedTimeOut: "1000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            };
            toastr["error"](`Pixel Slot #${boxId} not owned`);
        } else put_data(boxId, colorIds, colors);
    } catch (error) {
        console.log(error);
    }
};
async function get_owner(asa_id) {
    let owner = "";
    let owners = await indexer.lookupAssetBalances(asa_id).do();
    while(true){
        let next_token = owners["next-token"];
        owners = owners["balances"];
        if (owners.length == 0) break;
        owners.forEach((element)=>{
            if (element["amount"] == 1) owner = element["address"];
        });
        if (owner != "") break;
        owners = await indexer.lookupAssetBalances(asa_id).nextToken(next_token).do();
    }
    if (owner == "") throw new Error("Owner not found");
    else return owner;
}
async function renderBox(boxNumber) {
    const number = parseInt(boxNumber);
    const res = await instance.get("/square", {
        params: {
            number: number,
            chain: chain
        }
    });
    updateBox(boxNumber, res.data);
}
function arrayEquals(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index)=>val === b[index]);
}
const updateBox = (boxNumber, colors, link)=>{
    const newArr = Boxes[boxNumber].filter((a)=>a);
    const isEqual = arrayEquals(newArr, colors);
    // Do nothing
    if (isEqual && Links[boxNumber] === link) return;
    Links[boxNumber] = link;
    Boxes[boxNumber] = colors;
    const selectedBox = document.getElementById(`${boxNumber}`);
    while(selectedBox.hasChildNodes())selectedBox.removeChild(selectedBox.firstChild);
    colors.forEach((el, i)=>{
        let childDiv = document.createElement("div");
        childDiv.style.background = el;
        childDiv.classList.add("animate");
        selectedBox.appendChild(childDiv);
    });
    setTimeout(()=>{
        selectedBox.childNodes.forEach((child)=>{
            child.classList.remove("animate");
        });
    }, 500);
};
async function build_update_transaction(block_number, argument_string, bytes_data, application_id) {
    try {
        const nft_id = nft_ids[block_number];
        const params = await client.getTransactionParams().do();
        const argument = Uint8Array.from(argument_string, (c)=>c.charCodeAt(0));
        const from = connected ? userAddress : userPeraAddress;
        return algosdk.makeApplicationNoOpTxnFromObject({
            suggestedParams: {
                ...params
            },
            from: from,
            foreignAssets: [
                nft_id
            ],
            appArgs: [
                argument,
                Uint8Array.from([
                    block_number
                ]),
                bytes_data
            ],
            appIndex: application_id
        });
    } catch (error) {
        console.log(error);
    }
}
async function put_data(block_number, indexes, colors) {
    const newArr = Boxes[block_number].filter((a)=>a);
    const isEqual = arrayEquals(newArr, colors);
    if (isEqual && editLink.value.length === 0) {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            onclick: null,
            showDuration: "0",
            hideDuration: "0",
            timeOut: "3000",
            extendedTimeOut: "0",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
        };
        toastr["info"]("Nothing to change, Please Edit");
        return;
    }
    let colorTxn;
    let linkTxn;
    let signedColorTxn;
    let signedLinkTxn;
    if (!isEqual) colorTxn = await build_update_transaction(block_number, "put_block", indexes, app_id_blocks);
    if (editLink.value.length > 0) {
        linkBytes = Uint8Array.from(editLink.value, (c)=>c.charCodeAt(0));
        linkTxn = await build_update_transaction(block_number, "write_link", linkBytes, app_id_links);
    }
    if (connected && !peraConnected) {
        const myAlgoConnect = await new MyAlgoConnect();
        if (colorTxn) signedColorTxn = await myAlgoConnect.signTransaction(colorTxn.toByte());
        if (linkTxn) signedLinkTxn = await myAlgoConnect.signTransaction(linkTxn.toByte());
        finalizeTransaction(signedColorTxn?.blob, signedLinkTxn?.blob, block_number, colors);
    } else if (peraConnected) {
        if (colorTxn) {
            const singleColorTxnG = [
                {
                    txn: colorTxn,
                    signers: [
                        userPeraAddress
                    ]
                }
            ];
            signedColorTxn = await peraWallet.signTransaction([
                singleColorTxnG
            ]);
        }
        if (linkTxn) {
            const singleLinkTxnG = [
                {
                    txn: linkTxn,
                    signers: [
                        userPeraAddress
                    ]
                }
            ];
            signedLinkTxn = await peraWallet.signTransaction([
                singleLinkTxnG
            ]);
        }
        finalizeTransaction(signedColorTxn, signedLinkTxn, block_number, colors);
    }
}
const finalizeTransaction = async (signedColorTxn, signedLinkTxn, block_number, colors)=>{
    try {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            onclick: null,
            progressBar: true,
            showDuration: "0",
            hideDuration: "0",
            timeOut: "15000",
            extendedTimeOut: "0",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
        };
        toastr["info"]("Please Wait");
        let pendingColorInfoTxn;
        let pendingLinkInfoTxn;
        let colorTransaction;
        let linkTransaction;
        if (signedColorTxn) colorTransaction = await client.sendRawTransaction(signedColorTxn).do();
        if (signedLinkTxn) linkTransaction = await client.sendRawTransaction(signedLinkTxn).do();
        colorTransaction && (pendingColorInfoTxn = await algosdk.waitForConfirmation(client, colorTransaction.txId, 10));
        linkTransaction && (pendingLinkInfoTxn = await algosdk.waitForConfirmation(client, linkTransaction.txId, 10));
        if (pendingLinkInfoTxn) {
            slotLink.innerText = linkFormat(editLink.value);
            slotLink.href = editLink.value;
            editLink.placeholder = editLink.value;
            Links[block_number] = editLink.value;
            editLink.value = "";
        }
        if (pendingColorInfoTxn || pendingLinkInfoTxn) updateCurrentBox(block_number, colors, Links);
    } catch (err) {
        showTransactionError(err);
    }
};
const showTransactionError = (err)=>{
    const error = err.message;
    toastr.options = {
        closeButton: false,
        debug: false,
        newestOnTop: false,
        positionClass: "toast-bottom-left",
        preventDuplicates: false,
        onclick: null,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "5000",
        extendedTimeOut: "1000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut"
    };
    toastr["error"](`${error}`);
    return;
};
const updateCurrentBox = (block_number, colors, Links)=>{
    toastr.clear();
    toastr.options = {
        closeButton: false,
        debug: false,
        newestOnTop: false,
        positionClass: "toast-bottom-left",
        preventDuplicates: false,
        onclick: null,
        showDuration: "0",
        hideDuration: "0",
        timeOut: "3000",
        extendedTimeOut: "0",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut"
    };
    toastr["success"]("State succesfully edited");
    setTimeout(()=>{
        updateBox(block_number, colors, Links[block_number]);
    }, 1000);
};
const connectMyAlgo = async ()=>{
    try {
        const myAlgoWallet = await new MyAlgoConnect();
        const accounts = await myAlgoWallet.connect({
            shouldSelectOneAccount: true
        });
        userAddress = accounts[0].address;
        document.querySelector(".MyAlgo").innerText = userAddress[0] + userAddress[1] + userAddress[2] + userAddress[3] + "..." + userAddress[54] + userAddress[55] + userAddress[56] + userAddress[57];
        localStorage.setItem("address", JSON.stringify(userAddress));
        connected = true;
    } catch (err) {
        console.error(err);
    }
};
const connectPeraWallet = async ()=>{
    try {
        const peraId = await peraWallet.connect();
        userPeraAddress = peraId[0];
        document.querySelector(".MyAlgo2").innerText = userPeraAddress[0] + userPeraAddress[1] + userPeraAddress[2] + "..." + userPeraAddress[userPeraAddress.length - 3] + userPeraAddress[userPeraAddress.length - 2] + userPeraAddress[userPeraAddress.length - 1];
        localStorage.setItem("pera-address", JSON.stringify(userPeraAddress));
        peraConnected = true;
    } catch (error) {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "3000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
        };
        toastr["error"](`${error.message}`);
    }
};
const disconnectMyAlgo = (connectBtn)=>{
    connected = false;
    userAddress = "";
    connectBtn.innerText = "Connect to MyAlgo";
    localStorage.clear("address");
};
const disconnectWallet = async (connectToPera)=>{
    try {
        await peraWallet.disconnect();
        peraConnected = false;
        userPeraAddress = "";
        connectToPera.innerText = "Connect To Pera Wallet";
        localStorage.clear("pera-address");
    } catch (error) {
        console.log(error);
    }
};
const checkIfAlgoConnected = ()=>{
    if (connected || peraConnected) {
        const selectedGrid = document.querySelector(".selected-grid");
        let colorIds = [];
        let colors = [];
        selectedGrid.childNodes.forEach((pixel, i)=>{
            let color = rgbToHex(pixel.style.backgroundColor);
            colorIds = [
                ...colorIds,
                palette.findIndex((col)=>col === color)
            ];
            colors = [
                ...colors,
                color
            ];
        });
        const int8array = new Uint8Array([
            ...colorIds
        ]);
        if (connected) InitiateTransaction(selectedGrid.id, int8array, colors);
        else if (peraConnected) InitiatePeraTransaction(selectedGrid.id, int8array, colors);
    } else {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "5000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
        };
        toastr["error"]("Please connect either MyAlgo or Pera Wallet");
    }
};

},{"cc2416b85b87cc13":"ckL8B"}],"ckL8B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var e = require("4fab4b40c54652f1");
require("41cab9b2b5a4bda8"), require("b61f0cfc41e85552"), require("f755f32b72bbbff5"), exports.PeraWalletConnect = e.PeraWalletConnect, exports.closePeraWalletSignTxnToast = e.closePeraWalletSignTxnToast;

},{"4fab4b40c54652f1":"bysut","41cab9b2b5a4bda8":"iB41D","b61f0cfc41e85552":"dU9OL","f755f32b72bbbff5":"3ZdDr"}],"bysut":[function(require,module,exports) {
var Buffer = require("78b3ceee3519186").Buffer;
"use strict";
var e = require("2f5b0fbe0c4a0a44"), t = require("3f53c8bcae03623a"), n = require("ed14c7550451198a");
function a(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
var o = a(e), r = a(t), l = a(n);
function s(e, t, n, a) {
    return new (n || (n = Promise))(function(o, r) {
        function l(e) {
            try {
                i(a.next(e));
            } catch (e) {
                r(e);
            }
        }
        function s(e) {
            try {
                i(a.throw(e));
            } catch (e) {
                r(e);
            }
        }
        function i(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(l, s);
        }
        i((a = a.apply(e, t || [])).next());
    });
}
class i extends Error {
    constructor(e, t, ...n){
        super(...n), Error.captureStackTrace && Error.captureStackTrace(this, i), this.name = "PeraWalletConnectError", this.data = e, this.message = t;
    }
}
const d = new class {
    constructor(e){
        this.listener = void 0, this.channel = e.channel;
    }
    setupListener({ onReceiveMessage: e  }) {
        this.close(), this.listener = (t)=>{
            if ("object" == typeof t.data) try {
                t.data.channel === this.channel && e(t);
            } catch (e) {
                console.error(e);
            }
        }, window.addEventListener("message", this.listener);
    }
    sendMessage({ message: e , targetWindow: t , origin: n , timeout: a = 1e3  }) {
        setTimeout(()=>{
            const a = {
                channel: this.channel,
                message: e
            };
            t.postMessage(a, {
                targetOrigin: n || "*"
            });
        }, a);
    }
    close() {
        this.listener && (window.removeEventListener("message", this.listener), this.listener = void 0);
    }
}({
    channel: "pera-web-wallet"
});
function c() {
    const e = document.querySelector('meta[name="name"]'), t = document.querySelector('meta[name="description"]');
    let { title: n  } = document, a = "";
    return e instanceof HTMLMetaElement && (n = e.content), t instanceof HTMLMetaElement && (a = t.content), {
        title: n,
        description: a,
        url: window.location.origin,
        favicon: u()[0]
    };
}
function u() {
    const e = document.getElementsByTagName("link"), t = [];
    for(let n = 0; n < e.length; n++){
        const a = e[n], o = a.getAttribute("rel");
        if (o && o.toLowerCase().indexOf("icon") > -1) {
            const e = a.getAttribute("href");
            if (e && -1 === e.toLowerCase().indexOf("https:") && -1 === e.toLowerCase().indexOf("http:") && 0 !== e.indexOf("//")) {
                let n = `${window.location.protocol}//${window.location.host}`;
                if (0 === e.indexOf("/")) n += e;
                else {
                    const t = window.location.pathname.split("/");
                    t.pop();
                    n += `${t.join("/")}/${e}`;
                }
                t.push(n);
            } else if (0 === (null == e ? void 0 : e.indexOf("//"))) {
                const n = window.location.protocol + e;
                t.push(n);
            } else e && t.push(e);
        }
    }
    return t;
}
function p(e) {
    return new Promise((t, n)=>{
        try {
            const a = window.open(e, "_blank");
            let o = 0;
            const r = setInterval(()=>{
                if (o += 1, 50 === o) return clearInterval(r), void n(new i({
                    type: "MESSAGE_NOT_RECEIVED"
                }, "Couldn't open Pera Wallet, please try again."));
                a && (!0 === a.closed && (clearInterval(r), n(new i({
                    type: "OPERATION_CANCELLED"
                }, "Operation cancelled by user"))), d.sendMessage({
                    message: {
                        type: "TAB_OPEN"
                    },
                    origin: e,
                    targetWindow: a
                }));
            }, 700);
            d.setupListener({
                onReceiveMessage: (e)=>{
                    "TAB_OPEN_RECEIVED" === e.data.message.type && (clearInterval(r), t(a));
                }
            });
        } catch (e) {
            n(e);
        }
    });
}
function w(e) {
    const t = document.createElement("div");
    return t.setAttribute("id", e), document.body.appendChild(t), t;
}
function g() {
    const e = w("pera-wallet-sign-txn-modal-wrapper");
    e.innerHTML = "<pera-wallet-sign-txn-modal></pera-wallet-sign-txn-modal>";
    const t = e.querySelector("pera-wallet-sign-txn-modal");
    var n, a;
    return t ? (n = t, a = "pera-wallet-sign-txn-modal__body__content", new Promise((e)=>{
        var t;
        const o = null === (t = n.shadowRoot) || void 0 === t ? void 0 : t.querySelector(`.${a}`);
        if (o) return e(o);
        const r = new MutationObserver(()=>{
            o && (e(o), r.disconnect());
        });
        r.observe(n, {
            childList: !0,
            subtree: !0
        });
    })) : Promise.reject();
}
function m(e) {
    h("pera-wallet-sign-txn-modal-wrapper"), e && e(new i({
        type: "SIGN_TXN_CANCELLED"
    }, "Transaction sign is cancelled"));
}
function h(e) {
    const t = document.getElementById(e);
    t && t.remove();
}
const v = "PeraWallet.Wallet", N = "walletconnect";
function E() {
    return "undefined" == typeof localStorage ? void 0 : localStorage;
}
function C(e, t) {
    var n;
    null === (n = E()) || void 0 === n || n.setItem(v, JSON.stringify({
        type: t || "pera-wallet",
        accounts: e,
        selectedAccount: e[0]
    }));
}
function f() {
    var e;
    const t = null === (e = E()) || void 0 === e ? void 0 : e.getItem(v);
    return t ? JSON.parse(t) : null;
}
function T() {
    return new Promise((e, t)=>{
        var n, a;
        try {
            null === (n = E()) || void 0 === n || n.removeItem(N), null === (a = E()) || void 0 === a || a.removeItem(v), e(void 0);
        } catch (e) {
            t(e);
        }
    });
}
function y(e) {
    const t = e.slice();
    for(let e = t.length - 1; e > 0; e--){
        const n = Math.floor(Math.random() * (e + 1));
        [t[e], t[n]] = [
            t[n],
            t[e]
        ];
    }
    return t;
}
function _() {
    return function(e, t = {}) {
        return fetch(e, t).then((e)=>e.json()).then((e)=>e);
    }("https://wc.perawallet.app/config.json", {
        cache: "no-store"
    });
}
function I() {
    return s(this, void 0, void 0, function*() {
        let e = {
            bridgeURL: "",
            webWalletURL: "",
            isWebWalletAvailable: !1,
            shouldDisplayNewBadge: !1,
            shouldUseSound: !0,
            silent: !1
        };
        try {
            const t = yield _();
            void 0 !== t.web_wallet && t.web_wallet_url && (e.isWebWalletAvailable = t.web_wallet), void 0 !== t.display_new_badge && (e.shouldDisplayNewBadge = t.display_new_badge), void 0 !== t.use_sound && (e.shouldUseSound = t.use_sound), void 0 !== t.silent && (e.silent = t.silent), e = Object.assign(Object.assign({}, e), {
                bridgeURL: y(t.servers || [])[0] || "",
                webWalletURL: t.web_wallet_url || ""
            });
        } catch (e) {
            console.log(e);
        }
        return e;
    });
}
function A(e) {
    return Uint8Array.from(window.atob(e), (e)=>e.charCodeAt(0));
}
function S() {
    return "undefined" != typeof navigator;
}
function b() {
    return S() && /Android/i.test(navigator.userAgent);
}
function O() {
    return S() && /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function L() {
    return S() && /iPhone|iPod|Android/i.test(navigator.userAgent);
}
function W() {
    if (!S()) return null;
    const { userAgent: e  } = navigator;
    let t;
    return t = e.match(/DuckDuckGo/i) ? "DuckDuckGo" : e.match(/OPX/i) ? "Opera GX" : navigator.brave ? "Brave" : l.default.getParser(navigator.userAgent).getBrowserName(), t;
}
const M = b() ? "algorand://" : "algorand-wc://";
function D(e) {
    return {
        ROOT: `https://${e}`,
        CONNECT: `https://${e}/connect`,
        TRANSACTION_SIGN: `https://${e}/transaction/sign`
    };
}
function R(e = !0) {
    let t = M;
    const n = W();
    return e && n && (t = `${t}?browser=${encodeURIComponent(n)}`), t;
}
function x(e) {
    const t = new URL(e);
    return t.searchParams.append("embedded", "true"), t.toString();
}
function B({ isWebWalletAvailable: e , shouldDisplayNewBadge: t , shouldUseSound: n  }) {
    var a;
    return {
        open: (a = {
            isWebWalletAvailable: e,
            shouldDisplayNewBadge: t,
            shouldUseSound: n
        }, (e)=>{
            if (!document.getElementById("pera-wallet-connect-modal-wrapper")) {
                const t = w("pera-wallet-connect-modal-wrapper"), n = `${e}&algorand=true`, { isWebWalletAvailable: o , shouldDisplayNewBadge: r , shouldUseSound: l  } = a;
                t.innerHTML = `<pera-wallet-connect-modal uri="${n}" is-web-wallet-avaliable="${o}" should-display-new-badge="${r}" should-use-sound="${l}"></pera-wallet-connect-modal>`;
            }
        }),
        close: ()=>h("pera-wallet-connect-modal-wrapper")
    };
}
"undefined" != typeof window && (window.global = window, window.Buffer = window.Buffer || require("78b3ceee3519186").Buffer, Promise.resolve().then(function() {
    return require("e8a7f1bc79071e29");
})), exports.PERA_DOWNLOAD_URL = "https://perawallet.app/download/", exports.PERA_WALLET_CONNECT_MODAL_ID = "pera-wallet-connect-modal-wrapper", exports.PERA_WALLET_MODAL_CLASSNAME = "pera-wallet-modal", exports.PERA_WALLET_REDIRECT_MODAL_ID = "pera-wallet-redirect-modal-wrapper", exports.PERA_WALLET_SIGN_TXN_MODAL_ID = "pera-wallet-sign-txn-modal-wrapper", exports.PERA_WALLET_SIGN_TXN_TOAST_ID = "pera-wallet-sign-txn-toast-wrapper", exports.PeraWalletConnect = class {
    constructor(e){
        this.bridge = (null == e ? void 0 : e.bridge) || "", this.connector = null, this.shouldShowSignTxnToast = void 0 === (null == e ? void 0 : e.shouldShowSignTxnToast) || e.shouldShowSignTxnToast, this.chainId = null == e ? void 0 : e.chainId;
    }
    get platform() {
        return function() {
            const e = f();
            let t = null;
            return "pera-wallet" === (null == e ? void 0 : e.type) ? t = "mobile" : "pera-wallet-web" === (null == e ? void 0 : e.type) && (t = "web"), t;
        }();
    }
    get isConnected() {
        var e;
        return "mobile" === this.platform ? !!this.connector : "web" === this.platform && !!(null === (e = f()) || void 0 === e ? void 0 : e.accounts.length);
    }
    connectWithWebWallet(e, t, n, a) {
        const o = W(), r = D(n), l = document.createElement("iframe");
        function s() {
            h("pera-wallet-connect-modal-wrapper");
        }
        return {
            onWebWalletConnect: function(n) {
                if ("Chrome" === o) {
                    if (l.setAttribute("id", "pera-wallet-iframe"), l.setAttribute("src", x(r.CONNECT)), n.appendChild(l), l.contentWindow) {
                        let n = 0;
                        const o = setInterval(()=>{
                            n += 1, 50 !== n ? d.sendMessage({
                                message: {
                                    type: "IFRAME_INITIALIZED"
                                },
                                origin: r.CONNECT,
                                targetWindow: l.contentWindow
                            }) : clearInterval(o);
                        }, 700);
                        d.setupListener({
                            onReceiveMessage: (n)=>{
                                var u, w, g, m, h, v;
                                if ("IFRAME_INITIALIZED_RECEIVED" === n.data.message.type) clearInterval(o), d.sendMessage({
                                    message: {
                                        type: "CONNECT",
                                        data: Object.assign(Object.assign({}, c()), {
                                            chainId: a
                                        })
                                    },
                                    origin: r.CONNECT,
                                    targetWindow: l.contentWindow
                                });
                                else if (e && "CONNECT_CALLBACK" === n.data.message.type) {
                                    const t = n.data.message.data.addresses;
                                    C(t, "pera-wallet-web"), e(t), s(), null === (u = document.getElementById("pera-wallet-iframe")) || void 0 === u || u.remove();
                                } else if ("CONNECT_NETWORK_MISMATCH" === n.data.message.type) t(new i({
                                    type: "CONNECT_NETWORK_MISMATCH",
                                    detail: n.data.message.error
                                }, n.data.message.error || "Your wallet is connected to a different network to this dApp. Update your wallet to the correct network (MainNet or TestNet) to continue.")), s(), null === (w = document.getElementById("pera-wallet-iframe")) || void 0 === w || w.remove();
                                else if ([
                                    "CREATE_PASSCODE_EMBEDDED",
                                    "SELECT_ACCOUNT_EMBEDDED"
                                ].includes(n.data.message.type)) {
                                    if ("CREATE_PASSCODE_EMBEDDED" === n.data.message.type) p(r.CONNECT).then((n)=>{
                                        n && d.sendMessage({
                                            message: {
                                                type: "CONNECT",
                                                data: Object.assign(Object.assign({}, c()), {
                                                    chainId: a
                                                })
                                            },
                                            origin: r.CONNECT,
                                            targetWindow: n
                                        });
                                        const o = setInterval(()=>{
                                            !0 === (null == n ? void 0 : n.closed) && (t(new i({
                                                type: "CONNECT_CANCELLED"
                                            }, "Connect is cancelled by user")), s(), clearInterval(o));
                                        }, 2e3);
                                        d.setupListener({
                                            onReceiveMessage: (t)=>{
                                                if (e && "CONNECT_CALLBACK" === t.data.message.type) {
                                                    const a = t.data.message.data.addresses;
                                                    C(a, "pera-wallet-web"), e(a), s(), null == n || n.close();
                                                }
                                            }
                                        });
                                    });
                                    else if ("SELECT_ACCOUNT_EMBEDDED" === n.data.message.type) {
                                        const e = document.getElementById("pera-wallet-connect-modal-wrapper"), t = null === (m = null === (g = null == e ? void 0 : e.querySelector("pera-wallet-connect-modal")) || void 0 === g ? void 0 : g.shadowRoot) || void 0 === m ? void 0 : m.querySelector(".pera-wallet-modal"), n = null === (v = null === (h = null == t ? void 0 : t.querySelector("pera-wallet-modal-desktop-mode")) || void 0 === h ? void 0 : h.shadowRoot) || void 0 === v ? void 0 : v.querySelector(".pera-wallet-connect-modal-desktop-mode");
                                        t && n && (t.classList.add("pera-wallet-modal--select-account"), t.classList.remove("pera-wallet-modal--create-passcode"), n.classList.add("pera-wallet-connect-modal-desktop-mode--select-account"), n.classList.remove("pera-wallet-connect-modal-desktop-mode--create-passcode")), d.sendMessage({
                                            message: {
                                                type: "SELECT_ACCOUNT_EMBEDDED_CALLBACK"
                                            },
                                            origin: r.CONNECT,
                                            targetWindow: l.contentWindow
                                        });
                                    }
                                }
                            }
                        });
                    }
                } else p(r.CONNECT).then((n)=>{
                    n && d.sendMessage({
                        message: {
                            type: "CONNECT",
                            data: Object.assign(Object.assign({}, c()), {
                                chainId: a
                            })
                        },
                        origin: r.CONNECT,
                        targetWindow: n
                    });
                    const o = setInterval(()=>{
                        !0 === (null == n ? void 0 : n.closed) && (t(new i({
                            type: "CONNECT_CANCELLED"
                        }, "Connect is cancelled by user")), clearInterval(o), s());
                    }, 2e3);
                    d.setupListener({
                        onReceiveMessage: (a)=>{
                            if (e && "CONNECT_CALLBACK" === a.data.message.type) {
                                const t = a.data.message.data.addresses;
                                C(t, "pera-wallet-web"), e(t), s(), null == n || n.close();
                            } else "CONNECT_NETWORK_MISMATCH" === a.data.message.type && (t(new i({
                                type: "CONNECT_NETWORK_MISMATCH",
                                detail: a.data.message.error
                            }, a.data.message.error || "Your wallet is connected to a different network to this dApp. Update your wallet to the correct network (MainNet or TestNet) to continue.")), s(), null == n || n.close());
                        }
                    });
                }).catch((e)=>{
                    s(), t(e);
                });
            }
        };
    }
    connect() {
        return new Promise((e, t)=>s(this, void 0, void 0, function*() {
                var n;
                try {
                    if (null === (n = this.connector) || void 0 === n ? void 0 : n.connected) try {
                        yield this.connector.killSession();
                    } catch (e) {}
                    const { isWebWalletAvailable: a , bridgeURL: r , webWalletURL: l , shouldDisplayNewBadge: s , shouldUseSound: d  } = yield I(), { onWebWalletConnect: c  } = this.connectWithWebWallet(e, t, l, this.chainId);
                    a && (window.onWebWalletConnect = c), this.connector = new o.default({
                        bridge: this.bridge || r || "https://bridge.walletconnect.org",
                        qrcodeModal: B({
                            isWebWalletAvailable: a,
                            shouldDisplayNewBadge: s,
                            shouldUseSound: d
                        })
                    }), yield this.connector.createSession({
                        chainId: this.chainId || 4160
                    }), function(e) {
                        var t, n, a, o;
                        const r = document.getElementById("pera-wallet-connect-modal-wrapper"), l = null === (n = null === (t = null == r ? void 0 : r.querySelector("pera-wallet-connect-modal")) || void 0 === t ? void 0 : t.shadowRoot) || void 0 === n ? void 0 : n.querySelector(".pera-wallet-modal"), s = null === (o = null === (a = null == l ? void 0 : l.querySelector("pera-wallet-modal-header")) || void 0 === a ? void 0 : a.shadowRoot) || void 0 === o ? void 0 : o.getElementById("pera-wallet-modal-header-close-button");
                        null == s || s.addEventListener("click", ()=>{
                            e(), h("pera-wallet-connect-modal-wrapper");
                        });
                    }(()=>t(new i({
                            type: "CONNECT_MODAL_CLOSED"
                        }, "Connect modal is closed by user"))), this.connector.on("connect", (n, a)=>{
                        var o, r;
                        n && t(n), e((null === (o = this.connector) || void 0 === o ? void 0 : o.accounts) || []), C((null === (r = this.connector) || void 0 === r ? void 0 : r.accounts) || []);
                    });
                } catch (e) {
                    console.log(e), t(new i({
                        type: "SESSION_CONNECT",
                        detail: e
                    }, e.message || "There was an error while connecting to Pera Wallet"));
                }
            }));
    }
    reconnectSession() {
        return new Promise((e, t)=>s(this, void 0, void 0, function*() {
                var n, a;
                try {
                    const r = f();
                    if (!r) return void e([]);
                    if ("pera-wallet-web" === (null == r ? void 0 : r.type)) {
                        const { isWebWalletAvailable: n  } = yield I();
                        n ? e(r.accounts || []) : t(new i({
                            type: "SESSION_RECONNECT",
                            detail: "Pera Web is not available"
                        }, "Pera Web is not available"));
                    }
                    this.connector && e(this.connector.accounts || []), this.bridge = (null === (n = function() {
                        var e;
                        const t = null === (e = E()) || void 0 === e ? void 0 : e.getItem(N);
                        return t ? JSON.parse(t) : null;
                    }()) || void 0 === n ? void 0 : n.bridge) || "", this.bridge && (this.connector = new o.default({
                        bridge: this.bridge
                    }), e((null === (a = this.connector) || void 0 === a ? void 0 : a.accounts) || [])), this.isConnected || e([]);
                } catch (e) {
                    yield this.disconnect(), t(new i({
                        type: "SESSION_RECONNECT",
                        detail: e
                    }, e.message || "There was an error while reconnecting to Pera Wallet"));
                }
            }));
    }
    disconnect() {
        var e;
        return s(this, void 0, void 0, function*() {
            let t;
            this.isConnected && "mobile" === this.platform && (t = null === (e = this.connector) || void 0 === e ? void 0 : e.killSession(), null == t || t.then(()=>{
                this.connector = null;
            })), yield T();
        });
    }
    signTransactionWithMobile(e) {
        return s(this, void 0, void 0, function*() {
            const t = (n = "algo_signTxn", a = [
                e
            ], {
                id: Date.now() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3)),
                jsonrpc: "2.0",
                method: n,
                params: a
            });
            var n, a;
            try {
                try {
                    const { silent: e  } = yield I(), n = (yield this.connector.sendCustomRequest(t, {
                        forcePushNotification: !e
                    })).filter(Boolean);
                    return "string" == typeof n[0] ? n.map(A) : n.map((e)=>Uint8Array.from(e));
                } catch (e) {
                    return yield Promise.reject(new i({
                        type: "SIGN_TRANSACTIONS",
                        detail: e
                    }, e.message || "Failed to sign transaction"));
                }
            } finally{
                h("pera-wallet-redirect-modal-wrapper"), h("pera-wallet-sign-txn-toast-wrapper");
            }
        });
    }
    signTransactionWithWeb(e, t) {
        return new Promise((n, a)=>{
            const o = D(t);
            "Chrome" === W() ? g().then((t)=>{
                var r, l, s, c;
                const u = t, p = document.createElement("iframe"), w = x(o.TRANSACTION_SIGN), g = `hid ${w}; bluetooth ${w}`;
                p.setAttribute("id", "pera-wallet-iframe"), p.setAttribute("src", w), p.setAttribute("allow", g), null == u || u.appendChild(p);
                const v = null === (s = null === (l = null === (r = document.getElementById("pera-wallet-sign-txn-modal-wrapper")) || void 0 === r ? void 0 : r.querySelector("pera-wallet-sign-txn-modal")) || void 0 === l ? void 0 : l.shadowRoot) || void 0 === s ? void 0 : s.querySelector("pera-wallet-modal-header"), N = null === (c = null == v ? void 0 : v.shadowRoot) || void 0 === c ? void 0 : c.getElementById("pera-wallet-modal-header-close-button");
                if (N && N.addEventListener("click", ()=>{
                    a(new i({
                        type: "SIGN_TXN_CANCELLED"
                    }, "Transaction signing is cancelled by user.")), h("pera-wallet-sign-txn-modal-wrapper");
                }), p.contentWindow) {
                    let t = 0;
                    const r = setInterval(()=>{
                        t += 1, 50 !== t ? d.sendMessage({
                            message: {
                                type: "IFRAME_INITIALIZED"
                            },
                            origin: o.CONNECT,
                            targetWindow: p.contentWindow
                        }) : clearInterval(r);
                    }, 700);
                    d.setupListener({
                        onReceiveMessage: (t)=>{
                            var l, s, c;
                            "IFRAME_INITIALIZED_RECEIVED" === t.data.message.type && (clearInterval(r), d.sendMessage({
                                message: {
                                    type: "SIGN_TXN",
                                    txn: e
                                },
                                origin: x(o.TRANSACTION_SIGN),
                                targetWindow: p.contentWindow
                            })), "SIGN_TXN_CALLBACK" === t.data.message.type && (null === (l = document.getElementById("pera-wallet-iframe")) || void 0 === l || l.remove(), m(), n(t.data.message.signedTxns.map((e)=>A(e.signedTxn)))), "SIGN_TXN_NETWORK_MISMATCH" === t.data.message.type && a(new i({
                                type: "SIGN_TXN_NETWORK_MISMATCH",
                                detail: t.data.message.error
                            }, t.data.message.error || "Network mismatch")), "SESSION_DISCONNECTED" === t.data.message.type && (null === (s = document.getElementById("pera-wallet-iframe")) || void 0 === s || s.remove(), m(), T(), a(new i({
                                type: "SESSION_DISCONNECTED",
                                detail: t.data.message.error
                            }, t.data.message.error))), "SIGN_TXN_CALLBACK_ERROR" === t.data.message.type && (null === (c = document.getElementById("pera-wallet-iframe")) || void 0 === c || c.remove(), m(), a(new i({
                                type: "SIGN_TXN_CANCELLED"
                            }, t.data.message.error)));
                        }
                    });
                }
            }).catch((e)=>{
                console.log(e);
            }) : p(o.TRANSACTION_SIGN).then((t)=>{
                t && d.sendMessage({
                    message: {
                        type: "SIGN_TXN",
                        txn: e
                    },
                    origin: o.TRANSACTION_SIGN,
                    targetWindow: t
                });
                const r = setInterval(()=>{
                    !0 === (null == t ? void 0 : t.closed) && (a(new i({
                        type: "SIGN_TXN_CANCELLED"
                    }, "Transaction signing is cancelled by user.")), clearInterval(r));
                }, 2e3);
                d.setupListener({
                    onReceiveMessage: (e)=>{
                        "SIGN_TXN_CALLBACK" === e.data.message.type && (null == t || t.close(), n(e.data.message.signedTxns.map((e)=>A(e.signedTxn)))), "SIGN_TXN_NETWORK_MISMATCH" === e.data.message.type && a(new i({
                            type: "SIGN_TXN_NETWORK_MISMATCH",
                            detail: e.data.message.error
                        }, e.data.message.error || "Network mismatch")), "SESSION_DISCONNECTED" === e.data.message.type && (null == t || t.close(), T(), a(new i({
                            type: "SESSION_DISCONNECTED",
                            detail: e.data.message.error
                        }, e.data.message.error))), "SIGN_TXN_CALLBACK_ERROR" === e.data.message.type && (null == t || t.close(), a(new i({
                            type: "SIGN_TXN_CANCELLED"
                        }, e.data.message.error)));
                    }
                });
            }).catch((e)=>{
                a(e);
            });
        });
    }
    signTransaction(e, t) {
        return s(this, void 0, void 0, function*() {
            if ("mobile" === this.platform && (L() ? w("pera-wallet-redirect-modal-wrapper").innerHTML = "<pera-wallet-redirect-modal></pera-wallet-redirect-modal>" : !L() && this.shouldShowSignTxnToast && (w("pera-wallet-sign-txn-toast-wrapper").innerHTML = "<pera-wallet-sign-txn-toast></pera-wallet-sign-txn-toast>"), !this.connector)) throw new Error("PeraWalletConnect was not initialized correctly.");
            const n = e.flatMap((e)=>e.map((e)=>(function(e, t) {
                        let n;
                        t && !(e.signers || []).includes(t) && (n = []);
                        const a = {
                            txn: (o = e.txn, Buffer.from(r.default.encodeUnsignedTransaction(o)).toString("base64"))
                        };
                        var o;
                        return Array.isArray(n) && (a.signers = n), e.authAddr && (a.authAddr = e.authAddr), e.message && (a.message = e.message), e.msig && (a.msig = e.msig), a;
                    })(e, t)));
            if ("web" === this.platform) {
                const { webWalletURL: e  } = yield I();
                return this.signTransactionWithWeb(n, e);
            }
            return this.signTransactionWithMobile(n);
        });
    }
}, exports.closePeraWalletSignTxnToast = function() {
    h("pera-wallet-sign-txn-toast-wrapper");
}, exports.detectBrowser = W, exports.generatePeraWalletAppDeepLink = R, exports.generatePeraWalletConnectDeepLink = function(e) {
    let t = R(!1);
    O() && !t.includes("-wc") && (t = t.replace("://", "-wc://"));
    let n = `${t}wc?uri=${encodeURIComponent(e)}`;
    const a = W();
    return b() && (n = e), a && (n = `${n}&browser=${encodeURIComponent(a)}`), n;
}, exports.isIOS = O, exports.isMobile = L, exports.removeModalWrapperFromDOM = h;

},{"78b3ceee3519186":"9owiu","2f5b0fbe0c4a0a44":"iB41D","3f53c8bcae03623a":"dU9OL","ed14c7550451198a":"3ZdDr","e8a7f1bc79071e29":"iYNIy"}],"9owiu":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("46a28656d20bb3dc");
const ieee754 = require("1b6dfa7e80681890");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"46a28656d20bb3dc":"6Pb1S","1b6dfa7e80681890":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"iB41D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@walletconnect/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _isoCrypto = require("@walletconnect/iso-crypto");
class WalletConnect extends (0, _coreDefault.default) {
    constructor(connectorOpts, pushServerOpts){
        super({
            cryptoLib: _isoCrypto,
            connectorOpts,
            pushServerOpts
        });
    }
}
exports.default = WalletConnect;

},{"@walletconnect/core":"1zxcH","@walletconnect/iso-crypto":"2pBwP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zxcH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
var _socketTransport = require("@walletconnect/socket-transport");
var _socketTransportDefault = parcelHelpers.interopDefault(_socketTransport);
var _errors = require("./errors");
var _events = require("./events");
var _eventsDefault = parcelHelpers.interopDefault(_events);
var _storage = require("./storage");
var _storageDefault = parcelHelpers.interopDefault(_storage);
var _url = require("./url");
class Connector {
    constructor(opts){
        this.protocol = "wc";
        this.version = 1;
        this._bridge = "";
        this._key = null;
        this._clientId = "";
        this._clientMeta = null;
        this._peerId = "";
        this._peerMeta = null;
        this._handshakeId = 0;
        this._handshakeTopic = "";
        this._connected = false;
        this._accounts = [];
        this._chainId = 0;
        this._networkId = 0;
        this._rpcUrl = "";
        this._eventManager = new (0, _eventsDefault.default)();
        this._clientMeta = (0, _utils.getClientMeta)() || opts.connectorOpts.clientMeta || null;
        this._cryptoLib = opts.cryptoLib;
        this._sessionStorage = opts.sessionStorage || new (0, _storageDefault.default)(opts.connectorOpts.storageId);
        this._qrcodeModal = opts.connectorOpts.qrcodeModal;
        this._qrcodeModalOptions = opts.connectorOpts.qrcodeModalOptions;
        this._signingMethods = [
            ...(0, _utils.signingMethods),
            ...opts.connectorOpts.signingMethods || []
        ];
        if (!opts.connectorOpts.bridge && !opts.connectorOpts.uri && !opts.connectorOpts.session) throw new Error((0, _errors.ERROR_MISSING_REQUIRED));
        if (opts.connectorOpts.bridge) this.bridge = (0, _url.getBridgeUrl)(opts.connectorOpts.bridge);
        if (opts.connectorOpts.uri) this.uri = opts.connectorOpts.uri;
        const session = opts.connectorOpts.session || this._getStorageSession();
        if (session) this.session = session;
        if (this.handshakeId) this._subscribeToSessionResponse(this.handshakeId, "Session request rejected");
        this._transport = opts.transport || new (0, _socketTransportDefault.default)({
            protocol: this.protocol,
            version: this.version,
            url: this.bridge,
            subscriptions: [
                this.clientId
            ]
        });
        this._subscribeToInternalEvents();
        this._initTransport();
        if (opts.connectorOpts.uri) this._subscribeToSessionRequest();
        if (opts.pushServerOpts) this._registerPushServer(opts.pushServerOpts);
    }
    set bridge(value) {
        if (!value) return;
        this._bridge = value;
    }
    get bridge() {
        return this._bridge;
    }
    set key(value) {
        if (!value) return;
        const key = (0, _utils.convertHexToArrayBuffer)(value);
        this._key = key;
    }
    get key() {
        if (this._key) {
            const key = (0, _utils.convertArrayBufferToHex)(this._key, true);
            return key;
        }
        return "";
    }
    set clientId(value) {
        if (!value) return;
        this._clientId = value;
    }
    get clientId() {
        let clientId = this._clientId;
        if (!clientId) clientId = this._clientId = (0, _utils.uuid)();
        return this._clientId;
    }
    set peerId(value) {
        if (!value) return;
        this._peerId = value;
    }
    get peerId() {
        return this._peerId;
    }
    set clientMeta(value) {}
    get clientMeta() {
        let clientMeta = this._clientMeta;
        if (!clientMeta) clientMeta = this._clientMeta = (0, _utils.getClientMeta)();
        return clientMeta;
    }
    set peerMeta(value) {
        this._peerMeta = value;
    }
    get peerMeta() {
        const peerMeta = this._peerMeta;
        return peerMeta;
    }
    set handshakeTopic(value) {
        if (!value) return;
        this._handshakeTopic = value;
    }
    get handshakeTopic() {
        return this._handshakeTopic;
    }
    set handshakeId(value) {
        if (!value) return;
        this._handshakeId = value;
    }
    get handshakeId() {
        return this._handshakeId;
    }
    get uri() {
        const _uri = this._formatUri();
        return _uri;
    }
    set uri(value) {
        if (!value) return;
        const { handshakeTopic , bridge , key  } = this._parseUri(value);
        this.handshakeTopic = handshakeTopic;
        this.bridge = bridge;
        this.key = key;
    }
    set chainId(value) {
        this._chainId = value;
    }
    get chainId() {
        const chainId = this._chainId;
        return chainId;
    }
    set networkId(value) {
        this._networkId = value;
    }
    get networkId() {
        const networkId = this._networkId;
        return networkId;
    }
    set accounts(value) {
        this._accounts = value;
    }
    get accounts() {
        const accounts = this._accounts;
        return accounts;
    }
    set rpcUrl(value) {
        this._rpcUrl = value;
    }
    get rpcUrl() {
        const rpcUrl = this._rpcUrl;
        return rpcUrl;
    }
    set connected(value) {}
    get connected() {
        return this._connected;
    }
    set pending(value) {}
    get pending() {
        return !!this._handshakeTopic;
    }
    get session() {
        return {
            connected: this.connected,
            accounts: this.accounts,
            chainId: this.chainId,
            bridge: this.bridge,
            key: this.key,
            clientId: this.clientId,
            clientMeta: this.clientMeta,
            peerId: this.peerId,
            peerMeta: this.peerMeta,
            handshakeId: this.handshakeId,
            handshakeTopic: this.handshakeTopic
        };
    }
    set session(value) {
        if (!value) return;
        this._connected = value.connected;
        this.accounts = value.accounts;
        this.chainId = value.chainId;
        this.bridge = value.bridge;
        this.key = value.key;
        this.clientId = value.clientId;
        this.clientMeta = value.clientMeta;
        this.peerId = value.peerId;
        this.peerMeta = value.peerMeta;
        this.handshakeId = value.handshakeId;
        this.handshakeTopic = value.handshakeTopic;
    }
    on(event, callback) {
        const eventEmitter = {
            event,
            callback
        };
        this._eventManager.subscribe(eventEmitter);
    }
    off(event) {
        this._eventManager.unsubscribe(event);
    }
    async createInstantRequest(instantRequest) {
        this._key = await this._generateKey();
        const request = this._formatRequest({
            method: "wc_instantRequest",
            params: [
                {
                    peerId: this.clientId,
                    peerMeta: this.clientMeta,
                    request: this._formatRequest(instantRequest)
                }
            ]
        });
        this.handshakeId = request.id;
        this.handshakeTopic = (0, _utils.uuid)();
        this._eventManager.trigger({
            event: "display_uri",
            params: [
                this.uri
            ]
        });
        this.on("modal_closed", ()=>{
            throw new Error((0, _errors.ERROR_QRCODE_MODAL_USER_CLOSED));
        });
        const endInstantRequest = ()=>{
            this.killSession();
        };
        try {
            const result = await this._sendCallRequest(request);
            if (result) endInstantRequest();
            return result;
        } catch (error) {
            endInstantRequest();
            throw error;
        }
    }
    async connect(opts) {
        if (!this._qrcodeModal) throw new Error((0, _errors.ERROR_QRCODE_MODAL_NOT_PROVIDED));
        if (this.connected) return {
            chainId: this.chainId,
            accounts: this.accounts
        };
        await this.createSession(opts);
        return new Promise(async (resolve, reject)=>{
            this.on("modal_closed", ()=>reject(new Error((0, _errors.ERROR_QRCODE_MODAL_USER_CLOSED))));
            this.on("connect", (error, payload)=>{
                if (error) return reject(error);
                resolve(payload.params[0]);
            });
        });
    }
    async createSession(opts) {
        if (this._connected) throw new Error((0, _errors.ERROR_SESSION_CONNECTED));
        if (this.pending) return;
        this._key = await this._generateKey();
        const request = this._formatRequest({
            method: "wc_sessionRequest",
            params: [
                {
                    peerId: this.clientId,
                    peerMeta: this.clientMeta,
                    chainId: opts && opts.chainId ? opts.chainId : null
                }
            ]
        });
        this.handshakeId = request.id;
        this.handshakeTopic = (0, _utils.uuid)();
        this._sendSessionRequest(request, "Session update rejected", {
            topic: this.handshakeTopic
        });
        this._eventManager.trigger({
            event: "display_uri",
            params: [
                this.uri
            ]
        });
    }
    approveSession(sessionStatus) {
        if (this._connected) throw new Error((0, _errors.ERROR_SESSION_CONNECTED));
        this.chainId = sessionStatus.chainId;
        this.accounts = sessionStatus.accounts;
        this.networkId = sessionStatus.networkId || 0;
        this.rpcUrl = sessionStatus.rpcUrl || "";
        const sessionParams = {
            approved: true,
            chainId: this.chainId,
            networkId: this.networkId,
            accounts: this.accounts,
            rpcUrl: this.rpcUrl,
            peerId: this.clientId,
            peerMeta: this.clientMeta
        };
        const response = {
            id: this.handshakeId,
            jsonrpc: "2.0",
            result: sessionParams
        };
        this._sendResponse(response);
        this._connected = true;
        this._setStorageSession();
        this._eventManager.trigger({
            event: "connect",
            params: [
                {
                    peerId: this.peerId,
                    peerMeta: this.peerMeta,
                    chainId: this.chainId,
                    accounts: this.accounts
                }
            ]
        });
    }
    rejectSession(sessionError) {
        if (this._connected) throw new Error((0, _errors.ERROR_SESSION_CONNECTED));
        const message = sessionError && sessionError.message ? sessionError.message : (0, _errors.ERROR_SESSION_REJECTED);
        const response = this._formatResponse({
            id: this.handshakeId,
            error: {
                message
            }
        });
        this._sendResponse(response);
        this._connected = false;
        this._eventManager.trigger({
            event: "disconnect",
            params: [
                {
                    message
                }
            ]
        });
        this._removeStorageSession();
    }
    updateSession(sessionStatus) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        this.chainId = sessionStatus.chainId;
        this.accounts = sessionStatus.accounts;
        this.networkId = sessionStatus.networkId || 0;
        this.rpcUrl = sessionStatus.rpcUrl || "";
        const sessionParams = {
            approved: true,
            chainId: this.chainId,
            networkId: this.networkId,
            accounts: this.accounts,
            rpcUrl: this.rpcUrl
        };
        const request = this._formatRequest({
            method: "wc_sessionUpdate",
            params: [
                sessionParams
            ]
        });
        this._sendSessionRequest(request, "Session update rejected");
        this._eventManager.trigger({
            event: "session_update",
            params: [
                {
                    chainId: this.chainId,
                    accounts: this.accounts
                }
            ]
        });
        this._manageStorageSession();
    }
    async killSession(sessionError) {
        const message = sessionError ? sessionError.message : "Session Disconnected";
        const sessionParams = {
            approved: false,
            chainId: null,
            networkId: null,
            accounts: null
        };
        const request = this._formatRequest({
            method: "wc_sessionUpdate",
            params: [
                sessionParams
            ]
        });
        await this._sendRequest(request);
        this._handleSessionDisconnect(message);
    }
    async sendTransaction(tx) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const parsedTx = (0, _utils.parseTransactionData)(tx);
        const request = this._formatRequest({
            method: "eth_sendTransaction",
            params: [
                parsedTx
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signTransaction(tx) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const parsedTx = (0, _utils.parseTransactionData)(tx);
        const request = this._formatRequest({
            method: "eth_signTransaction",
            params: [
                parsedTx
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signMessage(params) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const request = this._formatRequest({
            method: "eth_sign",
            params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signPersonalMessage(params) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        params = (0, _utils.parsePersonalSign)(params);
        const request = this._formatRequest({
            method: "personal_sign",
            params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signTypedData(params) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const request = this._formatRequest({
            method: "eth_signTypedData",
            params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async updateChain(chainParams) {
        if (!this._connected) throw new Error("Session currently disconnected");
        const request = this._formatRequest({
            method: "wallet_updateChain",
            params: [
                chainParams
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    unsafeSend(request, options) {
        this._sendRequest(request, options);
        this._eventManager.trigger({
            event: "call_request_sent",
            params: [
                {
                    request,
                    options
                }
            ]
        });
        return new Promise((resolve, reject)=>{
            this._subscribeToResponse(request.id, (error, payload)=>{
                if (error) {
                    reject(error);
                    return;
                }
                if (!payload) throw new Error((0, _errors.ERROR_MISSING_JSON_RPC));
                resolve(payload);
            });
        });
    }
    async sendCustomRequest(request, options) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        switch(request.method){
            case "eth_accounts":
                return this.accounts;
            case "eth_chainId":
                return (0, _utils.convertNumberToHex)(this.chainId);
            case "eth_sendTransaction":
            case "eth_signTransaction":
                if (request.params) request.params[0] = (0, _utils.parseTransactionData)(request.params[0]);
                break;
            case "personal_sign":
                if (request.params) request.params = (0, _utils.parsePersonalSign)(request.params);
                break;
            default:
                break;
        }
        const formattedRequest = this._formatRequest(request);
        const result = await this._sendCallRequest(formattedRequest, options);
        return result;
    }
    approveRequest(response) {
        if ((0, _utils.isJsonRpcResponseSuccess)(response)) {
            const formattedResponse = this._formatResponse(response);
            this._sendResponse(formattedResponse);
        } else throw new Error((0, _errors.ERROR_MISSING_RESULT));
    }
    rejectRequest(response) {
        if ((0, _utils.isJsonRpcResponseError)(response)) {
            const formattedResponse = this._formatResponse(response);
            this._sendResponse(formattedResponse);
        } else throw new Error((0, _errors.ERROR_MISSING_ERROR));
    }
    transportClose() {
        this._transport.close();
    }
    async _sendRequest(request, options) {
        const callRequest = this._formatRequest(request);
        const encryptionPayload = await this._encrypt(callRequest);
        const topic = typeof (options === null || options === void 0 ? void 0 : options.topic) !== "undefined" ? options.topic : this.peerId;
        const payload = JSON.stringify(encryptionPayload);
        const silent = typeof (options === null || options === void 0 ? void 0 : options.forcePushNotification) !== "undefined" ? !options.forcePushNotification : (0, _utils.isSilentPayload)(callRequest);
        this._transport.send(payload, topic, silent);
    }
    async _sendResponse(response) {
        const encryptionPayload = await this._encrypt(response);
        const topic = this.peerId;
        const payload = JSON.stringify(encryptionPayload);
        const silent = true;
        this._transport.send(payload, topic, silent);
    }
    async _sendSessionRequest(request, errorMsg, options) {
        this._sendRequest(request, options);
        this._subscribeToSessionResponse(request.id, errorMsg);
    }
    _sendCallRequest(request, options) {
        this._sendRequest(request, options);
        this._eventManager.trigger({
            event: "call_request_sent",
            params: [
                {
                    request,
                    options
                }
            ]
        });
        return this._subscribeToCallResponse(request.id);
    }
    _formatRequest(request) {
        if (typeof request.method === "undefined") throw new Error((0, _errors.ERROR_MISSING_METHOD));
        const formattedRequest = {
            id: typeof request.id === "undefined" ? (0, _utils.payloadId)() : request.id,
            jsonrpc: "2.0",
            method: request.method,
            params: typeof request.params === "undefined" ? [] : request.params
        };
        return formattedRequest;
    }
    _formatResponse(response) {
        if (typeof response.id === "undefined") throw new Error((0, _errors.ERROR_MISSING_ID));
        const baseResponse = {
            id: response.id,
            jsonrpc: "2.0"
        };
        if ((0, _utils.isJsonRpcResponseError)(response)) {
            const error = (0, _utils.formatRpcError)(response.error);
            const errorResponse = Object.assign(Object.assign(Object.assign({}, baseResponse), response), {
                error
            });
            return errorResponse;
        } else if ((0, _utils.isJsonRpcResponseSuccess)(response)) {
            const successResponse = Object.assign(Object.assign({}, baseResponse), response);
            return successResponse;
        }
        throw new Error((0, _errors.ERROR_INVALID_RESPONSE));
    }
    _handleSessionDisconnect(errorMsg) {
        const message = errorMsg || "Session Disconnected";
        if (!this._connected) {
            if (this._qrcodeModal) this._qrcodeModal.close();
            (0, _utils.removeLocal)((0, _utils.mobileLinkChoiceKey));
        }
        if (this._connected) this._connected = false;
        if (this._handshakeId) this._handshakeId = 0;
        if (this._handshakeTopic) this._handshakeTopic = "";
        if (this._peerId) this._peerId = "";
        this._eventManager.trigger({
            event: "disconnect",
            params: [
                {
                    message
                }
            ]
        });
        this._removeStorageSession();
        this.transportClose();
    }
    _handleSessionResponse(errorMsg, sessionParams) {
        if (sessionParams) {
            if (sessionParams.approved) {
                if (!this._connected) {
                    this._connected = true;
                    if (sessionParams.chainId) this.chainId = sessionParams.chainId;
                    if (sessionParams.accounts) this.accounts = sessionParams.accounts;
                    if (sessionParams.peerId && !this.peerId) this.peerId = sessionParams.peerId;
                    if (sessionParams.peerMeta && !this.peerMeta) this.peerMeta = sessionParams.peerMeta;
                    this._eventManager.trigger({
                        event: "connect",
                        params: [
                            {
                                peerId: this.peerId,
                                peerMeta: this.peerMeta,
                                chainId: this.chainId,
                                accounts: this.accounts
                            }
                        ]
                    });
                } else {
                    if (sessionParams.chainId) this.chainId = sessionParams.chainId;
                    if (sessionParams.accounts) this.accounts = sessionParams.accounts;
                    this._eventManager.trigger({
                        event: "session_update",
                        params: [
                            {
                                chainId: this.chainId,
                                accounts: this.accounts
                            }
                        ]
                    });
                }
                this._manageStorageSession();
            } else this._handleSessionDisconnect(errorMsg);
        } else this._handleSessionDisconnect(errorMsg);
    }
    async _handleIncomingMessages(socketMessage) {
        const activeTopics = [
            this.clientId,
            this.handshakeTopic
        ];
        if (!activeTopics.includes(socketMessage.topic)) return;
        let encryptionPayload;
        try {
            encryptionPayload = JSON.parse(socketMessage.payload);
        } catch (error) {
            return;
        }
        const payload = await this._decrypt(encryptionPayload);
        if (payload) this._eventManager.trigger(payload);
    }
    _subscribeToSessionRequest() {
        this._transport.subscribe(this.handshakeTopic);
    }
    _subscribeToResponse(id, callback) {
        this.on(`response:${id}`, callback);
    }
    _subscribeToSessionResponse(id, errorMsg) {
        this._subscribeToResponse(id, (error, payload)=>{
            if (error) {
                this._handleSessionResponse(error.message);
                return;
            }
            if ((0, _utils.isJsonRpcResponseSuccess)(payload)) this._handleSessionResponse(errorMsg, payload.result);
            else if (payload.error && payload.error.message) this._handleSessionResponse(payload.error.message);
            else this._handleSessionResponse(errorMsg);
        });
    }
    _subscribeToCallResponse(id) {
        return new Promise((resolve, reject)=>{
            this._subscribeToResponse(id, (error, payload)=>{
                if (error) {
                    reject(error);
                    return;
                }
                if ((0, _utils.isJsonRpcResponseSuccess)(payload)) resolve(payload.result);
                else if (payload.error && payload.error.message) reject(payload.error);
                else reject(new Error((0, _errors.ERROR_INVALID_RESPONSE)));
            });
        });
    }
    _subscribeToInternalEvents() {
        this.on("display_uri", ()=>{
            if (this._qrcodeModal) this._qrcodeModal.open(this.uri, ()=>{
                this._eventManager.trigger({
                    event: "modal_closed",
                    params: []
                });
            }, this._qrcodeModalOptions);
        });
        this.on("connect", ()=>{
            if (this._qrcodeModal) this._qrcodeModal.close();
        });
        this.on("call_request_sent", (error, payload)=>{
            const { request  } = payload.params[0];
            if ((0, _utils.isMobile)() && this._signingMethods.includes(request.method)) {
                const mobileLinkUrl = (0, _utils.getLocal)((0, _utils.mobileLinkChoiceKey));
                if (mobileLinkUrl) window.location.href = mobileLinkUrl.href;
            }
        });
        this.on("wc_sessionRequest", (error, payload)=>{
            if (error) this._eventManager.trigger({
                event: "error",
                params: [
                    {
                        code: "SESSION_REQUEST_ERROR",
                        message: error.toString()
                    }
                ]
            });
            this.handshakeId = payload.id;
            this.peerId = payload.params[0].peerId;
            this.peerMeta = payload.params[0].peerMeta;
            const internalPayload = Object.assign(Object.assign({}, payload), {
                method: "session_request"
            });
            this._eventManager.trigger(internalPayload);
        });
        this.on("wc_sessionUpdate", (error, payload)=>{
            if (error) this._handleSessionResponse(error.message);
            this._handleSessionResponse("Session disconnected", payload.params[0]);
        });
    }
    _initTransport() {
        this._transport.on("message", (socketMessage)=>this._handleIncomingMessages(socketMessage));
        this._transport.on("open", ()=>this._eventManager.trigger({
                event: "transport_open",
                params: []
            }));
        this._transport.on("close", ()=>this._eventManager.trigger({
                event: "transport_close",
                params: []
            }));
        this._transport.on("error", ()=>this._eventManager.trigger({
                event: "transport_error",
                params: [
                    "Websocket connection failed"
                ]
            }));
        this._transport.open();
    }
    _formatUri() {
        const protocol = this.protocol;
        const handshakeTopic = this.handshakeTopic;
        const version = this.version;
        const bridge = encodeURIComponent(this.bridge);
        const key = this.key;
        const uri = `${protocol}:${handshakeTopic}@${version}?bridge=${bridge}&key=${key}`;
        return uri;
    }
    _parseUri(uri) {
        const result = (0, _utils.parseWalletConnectUri)(uri);
        if (result.protocol === this.protocol) {
            if (!result.handshakeTopic) throw Error("Invalid or missing handshakeTopic parameter value");
            const handshakeTopic = result.handshakeTopic;
            if (!result.bridge) throw Error("Invalid or missing bridge url parameter value");
            const bridge = decodeURIComponent(result.bridge);
            if (!result.key) throw Error("Invalid or missing key parameter value");
            const key = result.key;
            return {
                handshakeTopic,
                bridge,
                key
            };
        } else throw new Error((0, _errors.ERROR_INVALID_URI));
    }
    async _generateKey() {
        if (this._cryptoLib) {
            const result = await this._cryptoLib.generateKey();
            return result;
        }
        return null;
    }
    async _encrypt(data) {
        const key = this._key;
        if (this._cryptoLib && key) {
            const result = await this._cryptoLib.encrypt(data, key);
            return result;
        }
        return null;
    }
    async _decrypt(payload) {
        const key = this._key;
        if (this._cryptoLib && key) {
            const result = await this._cryptoLib.decrypt(payload, key);
            return result;
        }
        return null;
    }
    _getStorageSession() {
        let result = null;
        if (this._sessionStorage) result = this._sessionStorage.getSession();
        return result;
    }
    _setStorageSession() {
        if (this._sessionStorage) this._sessionStorage.setSession(this.session);
    }
    _removeStorageSession() {
        if (this._sessionStorage) this._sessionStorage.removeSession();
    }
    _manageStorageSession() {
        if (this._connected) this._setStorageSession();
        else this._removeStorageSession();
    }
    _registerPushServer(pushServerOpts) {
        if (!pushServerOpts.url || typeof pushServerOpts.url !== "string") throw Error("Invalid or missing pushServerOpts.url parameter value");
        if (!pushServerOpts.type || typeof pushServerOpts.type !== "string") throw Error("Invalid or missing pushServerOpts.type parameter value");
        if (!pushServerOpts.token || typeof pushServerOpts.token !== "string") throw Error("Invalid or missing pushServerOpts.token parameter value");
        const pushSubscription = {
            bridge: this.bridge,
            topic: this.clientId,
            type: pushServerOpts.type,
            token: pushServerOpts.token,
            peerName: "",
            language: pushServerOpts.language || ""
        };
        this.on("connect", async (error, payload)=>{
            if (error) throw error;
            if (pushServerOpts.peerMeta) {
                const peerName = payload.params[0].peerMeta.name;
                pushSubscription.peerName = peerName;
            }
            try {
                const response = await fetch(`${pushServerOpts.url}/new`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(pushSubscription)
                });
                const json = await response.json();
                if (!json.success) throw Error("Failed to register in Push Server");
            } catch (error) {
                throw Error("Failed to register in Push Server");
            }
        });
    }
}
exports.default = Connector;

},{"@walletconnect/utils":"bFQqa","@walletconnect/socket-transport":"gJV9X","./errors":"4WfNb","./events":"j47yZ","./storage":"lpAt8","./url":"k2XH2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bFQqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _browserUtils = require("@walletconnect/browser-utils");
parcelHelpers.exportAll(_browserUtils, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _encoding = require("./encoding");
parcelHelpers.exportAll(_encoding, exports);
var _ethereum = require("./ethereum");
parcelHelpers.exportAll(_ethereum, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _payload = require("./payload");
parcelHelpers.exportAll(_payload, exports);
var _session = require("./session");
parcelHelpers.exportAll(_session, exports);
var _url = require("./url");
parcelHelpers.exportAll(_url, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"@walletconnect/browser-utils":"5uxh8","./constants":"dx6md","./encoding":"2rdaL","./ethereum":"9dyAP","./misc":"6tzxQ","./payload":"i6C0L","./session":"f7wDl","./url":"1cGmR","./validators":"lkbI7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5uxh8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _browser = require("./browser");
parcelHelpers.exportAll(_browser, exports);
var _json = require("./json");
parcelHelpers.exportAll(_json, exports);
var _local = require("./local");
parcelHelpers.exportAll(_local, exports);
var _mobile = require("./mobile");
parcelHelpers.exportAll(_mobile, exports);
var _registry = require("./registry");
parcelHelpers.exportAll(_registry, exports);

},{"./browser":"4hf14","./json":"l26Iq","./local":"dxA7J","./mobile":"k0rpd","./registry":"3s2kY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4hf14":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectEnv", ()=>detectEnv);
parcelHelpers.export(exports, "detectOS", ()=>detectOS);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "isIOS", ()=>isIOS);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "getFromWindow", ()=>getFromWindow);
parcelHelpers.export(exports, "getFromWindowOrThrow", ()=>getFromWindowOrThrow);
parcelHelpers.export(exports, "getDocumentOrThrow", ()=>getDocumentOrThrow);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
parcelHelpers.export(exports, "getNavigatorOrThrow", ()=>getNavigatorOrThrow);
parcelHelpers.export(exports, "getNavigator", ()=>getNavigator);
parcelHelpers.export(exports, "getLocationOrThrow", ()=>getLocationOrThrow);
parcelHelpers.export(exports, "getLocation", ()=>getLocation);
parcelHelpers.export(exports, "getCryptoOrThrow", ()=>getCryptoOrThrow);
parcelHelpers.export(exports, "getCrypto", ()=>getCrypto);
parcelHelpers.export(exports, "getLocalStorageOrThrow", ()=>getLocalStorageOrThrow);
parcelHelpers.export(exports, "getLocalStorage", ()=>getLocalStorage);
parcelHelpers.export(exports, "getClientMeta", ()=>getClientMeta);
var _windowMetadata = require("@walletconnect/window-metadata");
var _windowGetters = require("@walletconnect/window-getters");
var _detectBrowser = require("detect-browser");
function detectEnv(userAgent) {
    return (0, _detectBrowser.detect)(userAgent);
}
function detectOS() {
    const env = detectEnv();
    return env && env.os ? env.os : undefined;
}
function isAndroid() {
    const os = detectOS();
    return os ? os.toLowerCase().includes("android") : false;
}
function isIOS() {
    const os = detectOS();
    return os ? os.toLowerCase().includes("ios") || os.toLowerCase().includes("mac") && navigator.maxTouchPoints > 1 : false;
}
function isMobile() {
    const os = detectOS();
    return os ? isAndroid() || isIOS() : false;
}
function isNode() {
    const env = detectEnv();
    const result = env && env.name ? env.name.toLowerCase() === "node" : false;
    return result;
}
function isBrowser() {
    const result = !isNode() && !!getNavigator();
    return result;
}
const getFromWindow = _windowGetters.getFromWindow;
const getFromWindowOrThrow = _windowGetters.getFromWindowOrThrow;
const getDocumentOrThrow = _windowGetters.getDocumentOrThrow;
const getDocument = _windowGetters.getDocument;
const getNavigatorOrThrow = _windowGetters.getNavigatorOrThrow;
const getNavigator = _windowGetters.getNavigator;
const getLocationOrThrow = _windowGetters.getLocationOrThrow;
const getLocation = _windowGetters.getLocation;
const getCryptoOrThrow = _windowGetters.getCryptoOrThrow;
const getCrypto = _windowGetters.getCrypto;
const getLocalStorageOrThrow = _windowGetters.getLocalStorageOrThrow;
const getLocalStorage = _windowGetters.getLocalStorage;
function getClientMeta() {
    return _windowMetadata.getWindowMetadata();
}

},{"@walletconnect/window-metadata":"5mGkl","@walletconnect/window-getters":"igbNt","detect-browser":"CIp0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mGkl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWindowMetadata = void 0;
const window_getters_1 = require("17ee693c665ef3c1");
function getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = window_getters_1.getDocumentOrThrow();
        loc = window_getters_1.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description,
        url,
        icons,
        name
    };
    return meta;
}
exports.getWindowMetadata = getWindowMetadata;

},{"17ee693c665ef3c1":"igbNt"}],"igbNt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocalStorage = exports.getLocalStorageOrThrow = exports.getCrypto = exports.getCryptoOrThrow = exports.getLocation = exports.getLocationOrThrow = exports.getNavigator = exports.getNavigatorOrThrow = exports.getDocument = exports.getDocumentOrThrow = exports.getFromWindowOrThrow = exports.getFromWindow = void 0;
function getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
exports.getFromWindow = getFromWindow;
function getFromWindowOrThrow(name) {
    const res = getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
exports.getFromWindowOrThrow = getFromWindowOrThrow;
function getDocumentOrThrow() {
    return getFromWindowOrThrow("document");
}
exports.getDocumentOrThrow = getDocumentOrThrow;
function getDocument() {
    return getFromWindow("document");
}
exports.getDocument = getDocument;
function getNavigatorOrThrow() {
    return getFromWindowOrThrow("navigator");
}
exports.getNavigatorOrThrow = getNavigatorOrThrow;
function getNavigator() {
    return getFromWindow("navigator");
}
exports.getNavigator = getNavigator;
function getLocationOrThrow() {
    return getFromWindowOrThrow("location");
}
exports.getLocationOrThrow = getLocationOrThrow;
function getLocation() {
    return getFromWindow("location");
}
exports.getLocation = getLocation;
function getCryptoOrThrow() {
    return getFromWindowOrThrow("crypto");
}
exports.getCryptoOrThrow = getCryptoOrThrow;
function getCrypto() {
    return getFromWindow("crypto");
}
exports.getCrypto = getCrypto;
function getLocalStorageOrThrow() {
    return getFromWindowOrThrow("localStorage");
}
exports.getLocalStorageOrThrow = getLocalStorageOrThrow;
function getLocalStorage() {
    return getFromWindow("localStorage");
}
exports.getLocalStorage = getLocalStorage;

},{}],"CIp0q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserInfo", ()=>BrowserInfo);
parcelHelpers.export(exports, "NodeInfo", ()=>NodeInfo);
parcelHelpers.export(exports, "SearchBotDeviceInfo", ()=>SearchBotDeviceInfo);
parcelHelpers.export(exports, "BotInfo", ()=>BotInfo);
parcelHelpers.export(exports, "ReactNativeInfo", ()=>ReactNativeInfo);
parcelHelpers.export(exports, "detect", ()=>detect);
parcelHelpers.export(exports, "browserName", ()=>browserName);
parcelHelpers.export(exports, "parseUserAgent", ()=>parseUserAgent);
parcelHelpers.export(exports, "detectOS", ()=>detectOS);
parcelHelpers.export(exports, "getNodeVersion", ()=>getNodeVersion);
var process = require("333d4e2381a056a9");
var __spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var BrowserInfo = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var NodeInfo = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = process.platform;
    }
    return NodeInfo;
}();
var SearchBotDeviceInfo = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var BotInfo = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var ReactNativeInfo = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FBAV\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "searchbot",
        SEARCHBOX_UA_REGEX
    ]
];
var operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function detect(userAgent) {
    if (!!userAgent) return parseUserAgent(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new ReactNativeInfo();
    if (typeof navigator !== "undefined") return parseUserAgent(navigator.userAgent);
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function browserName(ua) {
    var data = matchUserAgent(ua);
    return data ? data[0] : null;
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new BotInfo();
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for(var ii = 0, count = operatingSystemRules.length; ii < count; ii++){
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== "undefined" && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

},{"333d4e2381a056a9":"13Pcp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"l26Iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJsonParse", ()=>safeJsonParse);
parcelHelpers.export(exports, "safeJsonStringify", ()=>safeJsonStringify);
var _safeJson = require("@walletconnect/safe-json");
const safeJsonParse = _safeJson.safeJsonParse;
const safeJsonStringify = _safeJson.safeJsonStringify;

},{"@walletconnect/safe-json":"gaejp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaejp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJsonParse", ()=>safeJsonParse);
parcelHelpers.export(exports, "safeJsonStringify", ()=>safeJsonStringify);
function safeJsonParse(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
function safeJsonStringify(value) {
    return typeof value === "string" ? value : JSON.stringify(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxA7J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLocal", ()=>setLocal);
parcelHelpers.export(exports, "getLocal", ()=>getLocal);
parcelHelpers.export(exports, "removeLocal", ()=>removeLocal);
var _json = require("./json");
var _browser = require("./browser");
function setLocal(key, data) {
    const raw = (0, _json.safeJsonStringify)(data);
    const local = (0, _browser.getLocalStorage)();
    if (local) local.setItem(key, raw);
}
function getLocal(key) {
    let data = null;
    let raw = null;
    const local = (0, _browser.getLocalStorage)();
    if (local) raw = local.getItem(key);
    data = raw ? (0, _json.safeJsonParse)(raw) : raw;
    return data;
}
function removeLocal(key) {
    const local = (0, _browser.getLocalStorage)();
    if (local) local.removeItem(key);
}

},{"./json":"l26Iq","./browser":"4hf14","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k0rpd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mobileLinkChoiceKey", ()=>mobileLinkChoiceKey);
parcelHelpers.export(exports, "formatIOSMobile", ()=>formatIOSMobile);
parcelHelpers.export(exports, "saveMobileLinkInfo", ()=>saveMobileLinkInfo);
parcelHelpers.export(exports, "getMobileRegistryEntry", ()=>getMobileRegistryEntry);
parcelHelpers.export(exports, "getMobileLinkRegistry", ()=>getMobileLinkRegistry);
var _local = require("./local");
const mobileLinkChoiceKey = "WALLETCONNECT_DEEPLINK_CHOICE";
function formatIOSMobile(uri, entry) {
    const encodedUri = encodeURIComponent(uri);
    return entry.universalLink ? `${entry.universalLink}/wc?uri=${encodedUri}` : entry.deepLink ? `${entry.deepLink}${entry.deepLink.endsWith(":") ? "//" : "/"}wc?uri=${encodedUri}` : "";
}
function saveMobileLinkInfo(data) {
    const focusUri = data.href.split("?")[0];
    (0, _local.setLocal)(mobileLinkChoiceKey, Object.assign(Object.assign({}, data), {
        href: focusUri
    }));
}
function getMobileRegistryEntry(registry, name) {
    return registry.filter((entry)=>entry.name.toLowerCase().includes(name.toLowerCase()))[0];
}
function getMobileLinkRegistry(registry, whitelist) {
    let links = registry;
    if (whitelist) links = whitelist.map((name)=>getMobileRegistryEntry(registry, name)).filter(Boolean);
    return links;
}

},{"./local":"dxA7J","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3s2kY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWalletRegistryUrl", ()=>getWalletRegistryUrl);
parcelHelpers.export(exports, "getDappRegistryUrl", ()=>getDappRegistryUrl);
parcelHelpers.export(exports, "formatMobileRegistryEntry", ()=>formatMobileRegistryEntry);
parcelHelpers.export(exports, "formatMobileRegistry", ()=>formatMobileRegistry);
const API_URL = "https://registry.walletconnect.com";
function getWalletRegistryUrl() {
    return API_URL + "/api/v2/wallets";
}
function getDappRegistryUrl() {
    return API_URL + "/api/v2/dapps";
}
function formatMobileRegistryEntry(entry, platform = "mobile") {
    var _a;
    return {
        name: entry.name || "",
        shortName: entry.metadata.shortName || "",
        color: entry.metadata.colors.primary || "",
        logo: (_a = entry.image_url.sm) !== null && _a !== void 0 ? _a : "",
        universalLink: entry[platform].universal || "",
        deepLink: entry[platform].native || ""
    };
}
function formatMobileRegistry(registry, platform = "mobile") {
    return Object.values(registry).filter((entry)=>!!entry[platform].universal || !!entry[platform].native).map((entry)=>formatMobileRegistryEntry(entry, platform));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dx6md":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reservedEvents", ()=>reservedEvents);
parcelHelpers.export(exports, "signingMethods", ()=>signingMethods);
parcelHelpers.export(exports, "stateMethods", ()=>stateMethods);
parcelHelpers.export(exports, "infuraNetworks", ()=>infuraNetworks);
const reservedEvents = [
    "session_request",
    "session_update",
    "exchange_key",
    "connect",
    "disconnect",
    "display_uri",
    "modal_closed",
    "transport_open",
    "transport_close",
    "transport_error"
];
const signingMethods = [
    "eth_sendTransaction",
    "eth_signTransaction",
    "eth_sign",
    "eth_signTypedData",
    "eth_signTypedData_v1",
    "eth_signTypedData_v2",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "personal_sign",
    "wallet_addEthereumChain",
    "wallet_switchEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
];
const stateMethods = [
    "eth_accounts",
    "eth_chainId",
    "net_version"
];
const infuraNetworks = {
    1: "mainnet",
    3: "ropsten",
    4: "rinkeby",
    5: "goerli",
    42: "kovan"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2rdaL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertArrayBufferToBuffer", ()=>convertArrayBufferToBuffer);
parcelHelpers.export(exports, "convertArrayBufferToUtf8", ()=>convertArrayBufferToUtf8);
parcelHelpers.export(exports, "convertArrayBufferToHex", ()=>convertArrayBufferToHex);
parcelHelpers.export(exports, "convertArrayBufferToNumber", ()=>convertArrayBufferToNumber);
parcelHelpers.export(exports, "concatArrayBuffers", ()=>concatArrayBuffers);
parcelHelpers.export(exports, "convertBufferToArrayBuffer", ()=>convertBufferToArrayBuffer);
parcelHelpers.export(exports, "convertBufferToUtf8", ()=>convertBufferToUtf8);
parcelHelpers.export(exports, "convertBufferToHex", ()=>convertBufferToHex);
parcelHelpers.export(exports, "convertBufferToNumber", ()=>convertBufferToNumber);
parcelHelpers.export(exports, "concatBuffers", ()=>concatBuffers);
parcelHelpers.export(exports, "convertUtf8ToArrayBuffer", ()=>convertUtf8ToArrayBuffer);
parcelHelpers.export(exports, "convertUtf8ToBuffer", ()=>convertUtf8ToBuffer);
parcelHelpers.export(exports, "convertUtf8ToHex", ()=>convertUtf8ToHex);
parcelHelpers.export(exports, "convertUtf8ToNumber", ()=>convertUtf8ToNumber);
parcelHelpers.export(exports, "convertHexToBuffer", ()=>convertHexToBuffer);
parcelHelpers.export(exports, "convertHexToArrayBuffer", ()=>convertHexToArrayBuffer);
parcelHelpers.export(exports, "convertHexToUtf8", ()=>convertHexToUtf8);
parcelHelpers.export(exports, "convertHexToNumber", ()=>convertHexToNumber);
parcelHelpers.export(exports, "convertNumberToBuffer", ()=>convertNumberToBuffer);
parcelHelpers.export(exports, "convertNumberToArrayBuffer", ()=>convertNumberToArrayBuffer);
parcelHelpers.export(exports, "convertNumberToUtf8", ()=>convertNumberToUtf8);
parcelHelpers.export(exports, "convertNumberToHex", ()=>convertNumberToHex);
var _bnJs = require("bn.js");
var _bnJsDefault = parcelHelpers.interopDefault(_bnJs);
var _encoding = require("@walletconnect/encoding");
function convertArrayBufferToBuffer(arrBuf) {
    return _encoding.arrayToBuffer(new Uint8Array(arrBuf));
}
function convertArrayBufferToUtf8(arrBuf) {
    return _encoding.arrayToUtf8(new Uint8Array(arrBuf));
}
function convertArrayBufferToHex(arrBuf, noPrefix) {
    return _encoding.arrayToHex(new Uint8Array(arrBuf), !noPrefix);
}
function convertArrayBufferToNumber(arrBuf) {
    return _encoding.arrayToNumber(new Uint8Array(arrBuf));
}
function concatArrayBuffers(...args) {
    return _encoding.hexToArray(args.map((b)=>_encoding.arrayToHex(new Uint8Array(b))).join("")).buffer;
}
function convertBufferToArrayBuffer(buf) {
    return _encoding.bufferToArray(buf).buffer;
}
function convertBufferToUtf8(buf) {
    return _encoding.bufferToUtf8(buf);
}
function convertBufferToHex(buf, noPrefix) {
    return _encoding.bufferToHex(buf, !noPrefix);
}
function convertBufferToNumber(buf) {
    return _encoding.bufferToNumber(buf);
}
function concatBuffers(...args) {
    return _encoding.concatBuffers(...args);
}
function convertUtf8ToArrayBuffer(utf8) {
    return _encoding.utf8ToArray(utf8).buffer;
}
function convertUtf8ToBuffer(utf8) {
    return _encoding.utf8ToBuffer(utf8);
}
function convertUtf8ToHex(utf8, noPrefix) {
    return _encoding.utf8ToHex(utf8, !noPrefix);
}
function convertUtf8ToNumber(utf8) {
    return new (0, _bnJsDefault.default)(utf8, 10).toNumber();
}
function convertHexToBuffer(hex) {
    return _encoding.hexToBuffer(hex);
}
function convertHexToArrayBuffer(hex) {
    return _encoding.hexToArray(hex).buffer;
}
function convertHexToUtf8(hex) {
    return _encoding.hexToUtf8(hex);
}
function convertHexToNumber(hex) {
    return new (0, _bnJsDefault.default)(_encoding.removeHexPrefix(hex), "hex").toNumber();
}
function convertNumberToBuffer(num) {
    return _encoding.numberToBuffer(num);
}
function convertNumberToArrayBuffer(num) {
    return _encoding.numberToArray(num).buffer;
}
function convertNumberToUtf8(num) {
    return new (0, _bnJsDefault.default)(num).toString();
}
function convertNumberToHex(num, noPrefix) {
    const hex = _encoding.removeHexPrefix(_encoding.sanitizeHex(new (0, _bnJsDefault.default)(num).toString(16)));
    return noPrefix ? hex : _encoding.addHexPrefix(hex);
}

},{"bn.js":"x4ItY","@walletconnect/encoding":"hIv0Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"x4ItY":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = require("bd440367abe2ded7").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"bd440367abe2ded7":"13Pcp"}],"hIv0Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToArray", ()=>bufferToArray);
parcelHelpers.export(exports, "bufferToHex", ()=>bufferToHex);
parcelHelpers.export(exports, "bufferToUtf8", ()=>bufferToUtf8);
parcelHelpers.export(exports, "bufferToNumber", ()=>bufferToNumber);
parcelHelpers.export(exports, "bufferToBinary", ()=>bufferToBinary);
parcelHelpers.export(exports, "arrayToBuffer", ()=>arrayToBuffer);
parcelHelpers.export(exports, "arrayToHex", ()=>arrayToHex);
parcelHelpers.export(exports, "arrayToUtf8", ()=>arrayToUtf8);
parcelHelpers.export(exports, "arrayToNumber", ()=>arrayToNumber);
parcelHelpers.export(exports, "arrayToBinary", ()=>arrayToBinary);
parcelHelpers.export(exports, "hexToBuffer", ()=>hexToBuffer);
parcelHelpers.export(exports, "hexToArray", ()=>hexToArray);
parcelHelpers.export(exports, "hexToUtf8", ()=>hexToUtf8);
parcelHelpers.export(exports, "hexToNumber", ()=>hexToNumber);
parcelHelpers.export(exports, "hexToBinary", ()=>hexToBinary);
parcelHelpers.export(exports, "utf8ToBuffer", ()=>utf8ToBuffer);
parcelHelpers.export(exports, "utf8ToArray", ()=>utf8ToArray);
parcelHelpers.export(exports, "utf8ToHex", ()=>utf8ToHex);
parcelHelpers.export(exports, "utf8ToNumber", ()=>utf8ToNumber);
parcelHelpers.export(exports, "utf8ToBinary", ()=>utf8ToBinary);
parcelHelpers.export(exports, "numberToBuffer", ()=>numberToBuffer);
parcelHelpers.export(exports, "numberToArray", ()=>numberToArray);
parcelHelpers.export(exports, "numberToHex", ()=>numberToHex);
parcelHelpers.export(exports, "numberToUtf8", ()=>numberToUtf8);
parcelHelpers.export(exports, "numberToBinary", ()=>numberToBinary);
parcelHelpers.export(exports, "binaryToBuffer", ()=>binaryToBuffer);
parcelHelpers.export(exports, "binaryToArray", ()=>binaryToArray);
parcelHelpers.export(exports, "binaryToHex", ()=>binaryToHex);
parcelHelpers.export(exports, "binaryToUtf8", ()=>binaryToUtf8);
parcelHelpers.export(exports, "binaryToNumber", ()=>binaryToNumber);
parcelHelpers.export(exports, "isBinaryString", ()=>isBinaryString);
parcelHelpers.export(exports, "isHexString", ()=>isHexString);
parcelHelpers.export(exports, "isBuffer", ()=>isBuffer);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "getEncoding", ()=>getEncoding);
parcelHelpers.export(exports, "concatBuffers", ()=>concatBuffers);
parcelHelpers.export(exports, "concatArrays", ()=>concatArrays);
parcelHelpers.export(exports, "trimLeft", ()=>trimLeft);
parcelHelpers.export(exports, "trimRight", ()=>trimRight);
parcelHelpers.export(exports, "calcByteLength", ()=>calcByteLength);
parcelHelpers.export(exports, "splitBytes", ()=>splitBytes);
parcelHelpers.export(exports, "swapBytes", ()=>swapBytes);
parcelHelpers.export(exports, "swapHex", ()=>swapHex);
parcelHelpers.export(exports, "sanitizeBytes", ()=>sanitizeBytes);
parcelHelpers.export(exports, "padLeft", ()=>padLeft);
parcelHelpers.export(exports, "padRight", ()=>padRight);
parcelHelpers.export(exports, "removeHexPrefix", ()=>removeHexPrefix);
parcelHelpers.export(exports, "addHexPrefix", ()=>addHexPrefix);
parcelHelpers.export(exports, "sanitizeHex", ()=>sanitizeHex);
parcelHelpers.export(exports, "removeHexLeadingZeros", ()=>removeHexLeadingZeros);
var _isTypedarray = require("is-typedarray");
var _isTypedarrayDefault = parcelHelpers.interopDefault(_isTypedarray);
var _typedarrayToBuffer = require("typedarray-to-buffer");
var _typedarrayToBufferDefault = parcelHelpers.interopDefault(_typedarrayToBuffer);
var Buffer = require("79ef0aad0414f771").Buffer;
const ENC_HEX = "hex";
const ENC_UTF8 = "utf8";
const ENC_BIN = "binary";
const TYPE_BUFFER = "buffer";
const TYPE_ARRAY = "array";
const TYPE_TYPED_ARRAY = "typed-array";
const TYPE_ARRAY_BUFFER = "array-buffer";
const STRING_ZERO = "0";
function bufferToArray(buf) {
    return new Uint8Array(buf);
}
function bufferToHex(buf, prefixed = false) {
    const hex = buf.toString(ENC_HEX);
    return prefixed ? addHexPrefix(hex) : hex;
}
function bufferToUtf8(buf) {
    return buf.toString(ENC_UTF8);
}
function bufferToNumber(buf) {
    return buf.readUIntBE(0, buf.length);
}
function bufferToBinary(buf) {
    return arrayToBinary(bufferToArray(buf));
}
function arrayToBuffer(arr) {
    return (0, _typedarrayToBufferDefault.default)(arr);
}
function arrayToHex(arr, prefixed = false) {
    return bufferToHex(arrayToBuffer(arr), prefixed);
}
function arrayToUtf8(arr) {
    return bufferToUtf8(arrayToBuffer(arr));
}
function arrayToNumber(arr) {
    return bufferToNumber(arrayToBuffer(arr));
}
function arrayToBinary(arr) {
    return Array.from(arr).map(numberToBinary).join("");
}
function hexToBuffer(hex) {
    return Buffer.from(removeHexPrefix(hex), ENC_HEX);
}
function hexToArray(hex) {
    return bufferToArray(hexToBuffer(hex));
}
function hexToUtf8(hex) {
    return bufferToUtf8(hexToBuffer(hex));
}
function hexToNumber(hex) {
    return arrayToNumber(hexToArray(hex));
}
function hexToBinary(hex) {
    return arrayToBinary(hexToArray(hex));
}
function utf8ToBuffer(utf8) {
    return Buffer.from(utf8, ENC_UTF8);
}
function utf8ToArray(utf8) {
    return bufferToArray(utf8ToBuffer(utf8));
}
function utf8ToHex(utf8, prefixed = false) {
    return bufferToHex(utf8ToBuffer(utf8), prefixed);
}
function utf8ToNumber(utf8) {
    const num = parseInt(utf8, 10);
    assert(isDefined(num), "Number can only safely store up to 53 bits");
    return num;
}
function utf8ToBinary(utf8) {
    return arrayToBinary(utf8ToArray(utf8));
}
function numberToBuffer(num) {
    return binaryToBuffer(numberToBinary(num));
}
function numberToArray(num) {
    return binaryToArray(numberToBinary(num));
}
function numberToHex(num, prefixed) {
    return binaryToHex(numberToBinary(num), prefixed);
}
function numberToUtf8(num) {
    return `${num}`;
}
function numberToBinary(num) {
    const bin = (num >>> 0).toString(2);
    return sanitizeBytes(bin);
}
function binaryToBuffer(bin) {
    return arrayToBuffer(binaryToArray(bin));
}
function binaryToArray(bin) {
    return new Uint8Array(splitBytes(bin).map((x)=>parseInt(x, 2)));
}
function binaryToHex(bin, prefixed) {
    return arrayToHex(binaryToArray(bin), prefixed);
}
function binaryToUtf8(bin) {
    return arrayToUtf8(binaryToArray(bin));
}
function binaryToNumber(bin) {
    return arrayToNumber(binaryToArray(bin));
}
function isBinaryString(str) {
    if (typeof str !== "string" || !new RegExp(/^[01]+$/).test(str)) return false;
    if (str.length % 8 !== 0) return false;
    return true;
}
function isHexString(str, length) {
    if (typeof str !== "string" || !str.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && str.length !== 2 + 2 * length) return false;
    return true;
}
function isBuffer(val) {
    return Buffer.isBuffer(val);
}
function isTypedArray(val) {
    return (0, _isTypedarrayDefault.default).strict(val) && !isBuffer(val);
}
function isArrayBuffer(val) {
    return !isTypedArray(val) && !isBuffer(val) && typeof val.byteLength !== "undefined";
}
function getType(val) {
    if (isBuffer(val)) return TYPE_BUFFER;
    else if (isTypedArray(val)) return TYPE_TYPED_ARRAY;
    else if (isArrayBuffer(val)) return TYPE_ARRAY_BUFFER;
    else if (Array.isArray(val)) return TYPE_ARRAY;
    else return typeof val;
}
function getEncoding(str) {
    if (isBinaryString(str)) return ENC_BIN;
    if (isHexString(str)) return ENC_HEX;
    return ENC_UTF8;
}
function concatBuffers(...args) {
    const result = Buffer.concat(args);
    return result;
}
function concatArrays(...args) {
    let result = [];
    args.forEach((arg)=>result = result.concat(Array.from(arg)));
    return new Uint8Array([
        ...result
    ]);
}
function trimLeft(data, length) {
    const diff = data.length - length;
    if (diff > 0) data = data.slice(diff);
    return data;
}
function trimRight(data, length) {
    return data.slice(0, length);
}
function calcByteLength(length, byteSize = 8) {
    const remainder = length % byteSize;
    return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}
function splitBytes(str, byteSize = 8) {
    const bytes = sanitizeBytes(str).match(new RegExp(`.{${byteSize}}`, "gi"));
    return Array.from(bytes || []);
}
function swapBytes(str) {
    return splitBytes(str).map(reverseString).join("");
}
function swapHex(str) {
    return binaryToHex(swapBytes(hexToBinary(str)));
}
function sanitizeBytes(str, byteSize = 8, padding = STRING_ZERO) {
    return padLeft(str, calcByteLength(str.length, byteSize), padding);
}
function padLeft(str, length, padding = STRING_ZERO) {
    return padString(str, length, true, padding);
}
function padRight(str, length, padding = STRING_ZERO) {
    return padString(str, length, false, padding);
}
function removeHexPrefix(hex) {
    return hex.replace(/^0x/, "");
}
function addHexPrefix(hex) {
    return hex.startsWith("0x") ? hex : `0x${hex}`;
}
function sanitizeHex(hex) {
    hex = removeHexPrefix(hex);
    hex = sanitizeBytes(hex, 2);
    if (hex) hex = addHexPrefix(hex);
    return hex;
}
function removeHexLeadingZeros(hex) {
    const prefixed = hex.startsWith("0x");
    hex = removeHexPrefix(hex);
    hex = hex.startsWith(STRING_ZERO) ? hex.substring(1) : hex;
    return prefixed ? addHexPrefix(hex) : hex;
}
function isUndefined(value) {
    return typeof value === "undefined";
}
function isDefined(value) {
    return !isUndefined(value);
}
function assert(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}
function reverseString(str) {
    return str.split("").reverse().join("");
}
function padString(str, length, left, padding = STRING_ZERO) {
    const diff = length - str.length;
    let result = str;
    if (diff > 0) {
        const pad = padding.repeat(diff);
        result = left ? pad + str : str + pad;
    }
    return result;
}

},{"79ef0aad0414f771":"l5Twm","is-typedarray":"gGOie","typedarray-to-buffer":"cEFLQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"gGOie":[function(require,module,exports) {
module.exports = isTypedArray;
isTypedArray.strict = isStrictTypedArray;
isTypedArray.loose = isLooseTypedArray;
var toString = Object.prototype.toString;
var names = {
    "[object Int8Array]": true,
    "[object Int16Array]": true,
    "[object Int32Array]": true,
    "[object Uint8Array]": true,
    "[object Uint8ClampedArray]": true,
    "[object Uint16Array]": true,
    "[object Uint32Array]": true,
    "[object Float32Array]": true,
    "[object Float64Array]": true
};
function isTypedArray(arr) {
    return isStrictTypedArray(arr) || isLooseTypedArray(arr);
}
function isStrictTypedArray(arr) {
    return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
}
function isLooseTypedArray(arr) {
    return names[toString.call(arr)];
}

},{}],"cEFLQ":[function(require,module,exports) {
/**
 * Convert a typed array to a Buffer without a copy
 *
 * Author:   Feross Aboukhadijeh <https://feross.org>
 * License:  MIT
 *
 * `npm install typedarray-to-buffer`
 */ var Buffer = require("1a78dd7d8c10fe5c").Buffer;
var isTypedArray = require("dfcbed822b77bad7").strict;
module.exports = function typedarrayToBuffer(arr) {
    if (isTypedArray(arr)) {
        // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
        var buf = Buffer.from(arr.buffer);
        if (arr.byteLength !== arr.buffer.byteLength) // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
        buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
        return buf;
    } else // Pass through all other types to `Buffer.from`
    return Buffer.from(arr);
};

},{"1a78dd7d8c10fe5c":"l5Twm","dfcbed822b77bad7":"gGOie"}],"9dyAP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toChecksumAddress", ()=>toChecksumAddress);
parcelHelpers.export(exports, "isValidAddress", ()=>isValidAddress);
parcelHelpers.export(exports, "parsePersonalSign", ()=>parsePersonalSign);
parcelHelpers.export(exports, "parseTransactionData", ()=>parseTransactionData);
var _jsSha3 = require("js-sha3");
var _encoding = require("@walletconnect/encoding");
var _encoding1 = require("./encoding");
var _misc = require("./misc");
var _validators = require("./validators");
function toChecksumAddress(address) {
    address = (0, _encoding.removeHexPrefix)(address.toLowerCase());
    const hash = (0, _encoding.removeHexPrefix)((0, _jsSha3.keccak_256)((0, _encoding1.convertUtf8ToBuffer)(address)));
    let checksum = "";
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) > 7) checksum += address[i].toUpperCase();
    else checksum += address[i];
    return (0, _encoding.addHexPrefix)(checksum);
}
const isValidAddress = (address)=>{
    if (!address) return false;
    else if (address.toLowerCase().substring(0, 2) !== "0x") return false;
    else if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) return false;
    else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) return true;
    else return address === toChecksumAddress(address);
};
function parsePersonalSign(params) {
    if (!(0, _validators.isEmptyArray)(params) && !(0, _validators.isHexString)(params[0])) params[0] = (0, _encoding1.convertUtf8ToHex)(params[0]);
    return params;
}
function parseTransactionData(txData) {
    if (typeof txData.type !== "undefined" && txData.type !== "0") return txData;
    if (typeof txData.from === "undefined" || !isValidAddress(txData.from)) throw new Error(`Transaction object must include a valid 'from' value.`);
    function parseHexValues(value) {
        let result = value;
        if (typeof value === "number" || typeof value === "string" && !(0, _validators.isEmptyString)(value)) {
            if (!(0, _validators.isHexString)(value)) result = (0, _encoding1.convertNumberToHex)(value);
            else if (typeof value === "string") result = (0, _misc.sanitizeHex)(value);
        }
        if (typeof result === "string") result = (0, _misc.removeHexLeadingZeros)(result);
        return result;
    }
    const txDataRPC = {
        from: (0, _misc.sanitizeHex)(txData.from),
        to: typeof txData.to === "undefined" ? undefined : (0, _misc.sanitizeHex)(txData.to),
        gasPrice: typeof txData.gasPrice === "undefined" ? "" : parseHexValues(txData.gasPrice),
        gas: typeof txData.gas === "undefined" ? typeof txData.gasLimit === "undefined" ? "" : parseHexValues(txData.gasLimit) : parseHexValues(txData.gas),
        value: typeof txData.value === "undefined" ? "" : parseHexValues(txData.value),
        nonce: typeof txData.nonce === "undefined" ? "" : parseHexValues(txData.nonce),
        data: typeof txData.data === "undefined" ? "" : (0, _misc.sanitizeHex)(txData.data) || "0x"
    };
    const prunable = [
        "gasPrice",
        "gas",
        "value",
        "nonce"
    ];
    Object.keys(txDataRPC).forEach((key)=>{
        if ((typeof txDataRPC[key] === "undefined" || typeof txDataRPC[key] === "string" && !txDataRPC[key].trim().length) && prunable.includes(key)) delete txDataRPC[key];
    });
    return txDataRPC;
}

},{"js-sha3":"hqGBR","@walletconnect/encoding":"hIv0Z","./encoding":"2rdaL","./misc":"6tzxQ","./validators":"lkbI7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hqGBR":[function(require,module,exports) {
var process = require("5defb539e98cbde3");
var global = arguments[3];
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

},{"5defb539e98cbde3":"13Pcp"}],"6tzxQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeHex", ()=>sanitizeHex);
parcelHelpers.export(exports, "addHexPrefix", ()=>addHexPrefix);
parcelHelpers.export(exports, "removeHexPrefix", ()=>removeHexPrefix);
parcelHelpers.export(exports, "removeHexLeadingZeros", ()=>removeHexLeadingZeros);
parcelHelpers.export(exports, "payloadId", ()=>payloadId);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "logDeprecationWarning", ()=>logDeprecationWarning);
parcelHelpers.export(exports, "getInfuraRpcUrl", ()=>getInfuraRpcUrl);
parcelHelpers.export(exports, "getRpcUrl", ()=>getRpcUrl);
var _encoding = require("@walletconnect/encoding");
var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");
var _constants = require("./constants");
function sanitizeHex(hex) {
    return _encoding.sanitizeHex(hex);
}
function addHexPrefix(hex) {
    return _encoding.addHexPrefix(hex);
}
function removeHexPrefix(hex) {
    return _encoding.removeHexPrefix(hex);
}
function removeHexLeadingZeros(hex) {
    return _encoding.removeHexLeadingZeros(_encoding.addHexPrefix(hex));
}
const payloadId = _jsonrpcUtils.payloadId;
function uuid() {
    const result = ((a, b)=>{
        for(b = a = ""; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-");
        return b;
    })();
    return result;
}
function logDeprecationWarning() {
    console.warn("DEPRECATION WARNING: This WalletConnect client library will be deprecated in favor of @walletconnect/client. Please check docs.walletconnect.org to learn more about this migration!");
}
function getInfuraRpcUrl(chainId, infuraId) {
    let rpcUrl;
    const network = (0, _constants.infuraNetworks)[chainId];
    if (network) rpcUrl = `https://${network}.infura.io/v3/${infuraId}`;
    return rpcUrl;
}
function getRpcUrl(chainId, rpc) {
    let rpcUrl;
    const infuraUrl = getInfuraRpcUrl(chainId, rpc.infuraId);
    if (rpc.custom && rpc.custom[chainId]) rpcUrl = rpc.custom[chainId];
    else if (infuraUrl) rpcUrl = infuraUrl;
    return rpcUrl;
}

},{"@walletconnect/encoding":"hIv0Z","@walletconnect/jsonrpc-utils":"dUcPw","./constants":"dx6md","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dUcPw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _format = require("./format");
parcelHelpers.exportAll(_format, exports);
var _routing = require("./routing");
parcelHelpers.exportAll(_routing, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _url = require("./url");
parcelHelpers.exportAll(_url, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"./constants":"dic9X","./error":"lpnqm","./env":"3Rucj","./format":"jPgVJ","./routing":"fXfep","./types":"UuYNN","./url":"lT9DQ","./validators":"bqcdC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dic9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PARSE_ERROR", ()=>PARSE_ERROR);
parcelHelpers.export(exports, "INVALID_REQUEST", ()=>INVALID_REQUEST);
parcelHelpers.export(exports, "METHOD_NOT_FOUND", ()=>METHOD_NOT_FOUND);
parcelHelpers.export(exports, "INVALID_PARAMS", ()=>INVALID_PARAMS);
parcelHelpers.export(exports, "INTERNAL_ERROR", ()=>INTERNAL_ERROR);
parcelHelpers.export(exports, "SERVER_ERROR", ()=>SERVER_ERROR);
parcelHelpers.export(exports, "RESERVED_ERROR_CODES", ()=>RESERVED_ERROR_CODES);
parcelHelpers.export(exports, "SERVER_ERROR_CODE_RANGE", ()=>SERVER_ERROR_CODE_RANGE);
parcelHelpers.export(exports, "STANDARD_ERROR_MAP", ()=>STANDARD_ERROR_MAP);
parcelHelpers.export(exports, "DEFAULT_ERROR", ()=>DEFAULT_ERROR);
const PARSE_ERROR = "PARSE_ERROR";
const INVALID_REQUEST = "INVALID_REQUEST";
const METHOD_NOT_FOUND = "METHOD_NOT_FOUND";
const INVALID_PARAMS = "INVALID_PARAMS";
const INTERNAL_ERROR = "INTERNAL_ERROR";
const SERVER_ERROR = "SERVER_ERROR";
const RESERVED_ERROR_CODES = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const SERVER_ERROR_CODE_RANGE = [
    -32000,
    -32099
];
const STANDARD_ERROR_MAP = {
    [PARSE_ERROR]: {
        code: -32700,
        message: "Parse error"
    },
    [INVALID_REQUEST]: {
        code: -32600,
        message: "Invalid Request"
    },
    [METHOD_NOT_FOUND]: {
        code: -32601,
        message: "Method not found"
    },
    [INVALID_PARAMS]: {
        code: -32602,
        message: "Invalid params"
    },
    [INTERNAL_ERROR]: {
        code: -32603,
        message: "Internal error"
    },
    [SERVER_ERROR]: {
        code: -32000,
        message: "Server error"
    }
};
const DEFAULT_ERROR = SERVER_ERROR;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpnqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServerErrorCode", ()=>isServerErrorCode);
parcelHelpers.export(exports, "isReservedErrorCode", ()=>isReservedErrorCode);
parcelHelpers.export(exports, "isValidErrorCode", ()=>isValidErrorCode);
parcelHelpers.export(exports, "getError", ()=>getError);
parcelHelpers.export(exports, "getErrorByCode", ()=>getErrorByCode);
parcelHelpers.export(exports, "validateJsonRpcError", ()=>validateJsonRpcError);
parcelHelpers.export(exports, "parseConnectionError", ()=>parseConnectionError);
var _constants = require("./constants");
function isServerErrorCode(code) {
    return code <= (0, _constants.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, _constants.SERVER_ERROR_CODE_RANGE)[1];
}
function isReservedErrorCode(code) {
    return (0, _constants.RESERVED_ERROR_CODES).includes(code);
}
function isValidErrorCode(code) {
    return typeof code === "number";
}
function getError(type) {
    if (!Object.keys((0, _constants.STANDARD_ERROR_MAP)).includes(type)) return (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR];
    return (0, _constants.STANDARD_ERROR_MAP)[type];
}
function getErrorByCode(code) {
    const match = Object.values((0, _constants.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR];
    return match;
}
function validateJsonRpcError(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!isValidErrorCode(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if (isReservedErrorCode(response.error.code)) {
        const error = getErrorByCode(response.error.code);
        if (error.message !== (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function parseConnectionError(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

},{"./constants":"dic9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Rucj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeJs", ()=>isNodeJs);
var _environment = require("@walletconnect/environment");
parcelHelpers.exportAll(_environment, exports);
const isNodeJs = (0, _environment.isNode);

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ljiRg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("7ea7787f9cb444bc");
tslib_1.__exportStar(require("224c4ee8cc5fb5e6"), exports);
tslib_1.__exportStar(require("ca369212861f50d2"), exports);

},{"7ea7787f9cb444bc":"gBS4y","224c4ee8cc5fb5e6":"9qgYL","ca369212861f50d2":"21TsA"}],"gBS4y":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qgYL":[function(require,module,exports) {
var global = arguments[3];
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBrowserCryptoAvailable = exports.getSubtleCrypto = exports.getBrowerCrypto = void 0;
function getBrowerCrypto() {
    return (global === null || global === void 0 ? void 0 : global.crypto) || (global === null || global === void 0 ? void 0 : global.msCrypto) || {};
}
exports.getBrowerCrypto = getBrowerCrypto;
function getSubtleCrypto() {
    const browserCrypto = getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
exports.getSubtleCrypto = getSubtleCrypto;
function isBrowserCryptoAvailable() {
    return !!getBrowerCrypto() && !!getSubtleCrypto();
}
exports.isBrowserCryptoAvailable = isBrowserCryptoAvailable;

},{}],"21TsA":[function(require,module,exports) {
var process = require("6ccfe05cfad71fdb");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBrowser = exports.isNode = exports.isReactNative = void 0;
function isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
exports.isReactNative = isReactNative;
function isNode() {
    return typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined";
}
exports.isNode = isNode;
function isBrowser() {
    return !isReactNative() && !isNode();
}
exports.isBrowser = isBrowser;

},{"6ccfe05cfad71fdb":"13Pcp"}],"jPgVJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "payloadId", ()=>payloadId);
parcelHelpers.export(exports, "getBigIntRpcId", ()=>getBigIntRpcId);
parcelHelpers.export(exports, "formatJsonRpcRequest", ()=>formatJsonRpcRequest);
parcelHelpers.export(exports, "formatJsonRpcResult", ()=>formatJsonRpcResult);
parcelHelpers.export(exports, "formatJsonRpcError", ()=>formatJsonRpcError);
parcelHelpers.export(exports, "formatErrorMessage", ()=>formatErrorMessage);
var _error = require("./error");
var _constants = require("./constants");
function payloadId(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function getBigIntRpcId(entropy = 6) {
    return BigInt(payloadId(entropy));
}
function formatJsonRpcRequest(method, params, id) {
    return {
        id: id || payloadId(),
        jsonrpc: "2.0",
        method,
        params
    };
}
function formatJsonRpcResult(id, result) {
    return {
        id,
        jsonrpc: "2.0",
        result
    };
}
function formatJsonRpcError(id, error, data) {
    return {
        id,
        jsonrpc: "2.0",
        error: formatErrorMessage(error, data)
    };
}
function formatErrorMessage(error, data) {
    if (typeof error === "undefined") return (0, _error.getError)((0, _constants.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, _error.getError)((0, _constants.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, _error.isReservedErrorCode)(error.code)) error = (0, _error.getErrorByCode)(error.code);
    return error;
}

},{"./error":"lpnqm","./constants":"dic9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fXfep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidRoute", ()=>isValidRoute);
parcelHelpers.export(exports, "isValidDefaultRoute", ()=>isValidDefaultRoute);
parcelHelpers.export(exports, "isValidWildcardRoute", ()=>isValidWildcardRoute);
parcelHelpers.export(exports, "isValidLeadingWildcardRoute", ()=>isValidLeadingWildcardRoute);
parcelHelpers.export(exports, "isValidTrailingWildcardRoute", ()=>isValidTrailingWildcardRoute);
function isValidRoute(route) {
    if (route.includes("*")) return isValidWildcardRoute(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function isValidDefaultRoute(route) {
    return route === "*";
}
function isValidWildcardRoute(route) {
    if (isValidDefaultRoute(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function isValidLeadingWildcardRoute(route) {
    return !isValidDefaultRoute(route) && isValidWildcardRoute(route) && !route.split("*")[0].trim();
}
function isValidTrailingWildcardRoute(route) {
    return !isValidDefaultRoute(route) && isValidWildcardRoute(route) && !route.split("*")[1].trim();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UuYNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrpcTypes = require("@walletconnect/jsonrpc-types");
parcelHelpers.exportAll(_jsonrpcTypes, exports);

},{"@walletconnect/jsonrpc-types":"5PTpM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PTpM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrpc = require("./jsonrpc");
parcelHelpers.exportAll(_jsonrpc, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _validator = require("./validator");
parcelHelpers.exportAll(_validator, exports);

},{"./jsonrpc":"ak6bw","./misc":"e7Cib","./provider":"9ntku","./validator":"loXJL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ak6bw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7Cib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IEvents", ()=>IEvents);
class IEvents {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ntku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IJsonRpcConnection", ()=>IJsonRpcConnection);
parcelHelpers.export(exports, "IBaseJsonRpcProvider", ()=>IBaseJsonRpcProvider);
parcelHelpers.export(exports, "IJsonRpcProvider", ()=>IJsonRpcProvider);
var _misc = require("./misc");
class IJsonRpcConnection extends (0, _misc.IEvents) {
    constructor(opts){
        super();
    }
}
class IBaseJsonRpcProvider extends (0, _misc.IEvents) {
    constructor(){
        super();
    }
}
class IJsonRpcProvider extends IBaseJsonRpcProvider {
    constructor(connection){
        super();
    }
}

},{"./misc":"e7Cib","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loXJL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lT9DQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHttpUrl", ()=>isHttpUrl);
parcelHelpers.export(exports, "isWsUrl", ()=>isWsUrl);
parcelHelpers.export(exports, "isLocalhostUrl", ()=>isLocalhostUrl);
const HTTP_REGEX = "^https?:";
const WS_REGEX = "^wss?:";
function getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function matchRegexProtocol(url, regex) {
    const protocol = getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function isHttpUrl(url) {
    return matchRegexProtocol(url, HTTP_REGEX);
}
function isWsUrl(url) {
    return matchRegexProtocol(url, WS_REGEX);
}
function isLocalhostUrl(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bqcdC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isJsonRpcPayload", ()=>isJsonRpcPayload);
parcelHelpers.export(exports, "isJsonRpcRequest", ()=>isJsonRpcRequest);
parcelHelpers.export(exports, "isJsonRpcResponse", ()=>isJsonRpcResponse);
parcelHelpers.export(exports, "isJsonRpcResult", ()=>isJsonRpcResult);
parcelHelpers.export(exports, "isJsonRpcError", ()=>isJsonRpcError);
parcelHelpers.export(exports, "isJsonRpcValidationInvalid", ()=>isJsonRpcValidationInvalid);
function isJsonRpcPayload(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function isJsonRpcRequest(payload) {
    return isJsonRpcPayload(payload) && "method" in payload;
}
function isJsonRpcResponse(payload) {
    return isJsonRpcPayload(payload) && (isJsonRpcResult(payload) || isJsonRpcError(payload));
}
function isJsonRpcResult(payload) {
    return "result" in payload;
}
function isJsonRpcError(payload) {
    return "error" in payload;
}
function isJsonRpcValidationInvalid(validation) {
    return "error" in validation && validation.valid === false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkbI7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isBuffer", ()=>isBuffer);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "getEncoding", ()=>getEncoding);
parcelHelpers.export(exports, "isHexString", ()=>isHexString);
parcelHelpers.export(exports, "isJsonRpcSubscription", ()=>isJsonRpcSubscription);
parcelHelpers.export(exports, "isJsonRpcRequest", ()=>isJsonRpcRequest);
parcelHelpers.export(exports, "isJsonRpcResponseSuccess", ()=>isJsonRpcResponseSuccess);
parcelHelpers.export(exports, "isJsonRpcResponseError", ()=>isJsonRpcResponseError);
parcelHelpers.export(exports, "isInternalEvent", ()=>isInternalEvent);
parcelHelpers.export(exports, "isReservedEvent", ()=>isReservedEvent);
parcelHelpers.export(exports, "isSilentPayload", ()=>isSilentPayload);
var _encoding = require("@walletconnect/encoding");
var _constants = require("./constants");
function isEmptyString(value) {
    return value === "" || typeof value === "string" && value.trim() === "";
}
function isEmptyArray(array) {
    return !(array && array.length);
}
function isBuffer(val) {
    return _encoding.isBuffer(val);
}
function isTypedArray(val) {
    return _encoding.isTypedArray(val);
}
function isArrayBuffer(val) {
    return _encoding.isArrayBuffer(val);
}
function getType(val) {
    return _encoding.getType(val);
}
function getEncoding(val) {
    return _encoding.getEncoding(val);
}
function isHexString(value, length) {
    return _encoding.isHexString(value, length);
}
function isJsonRpcSubscription(object) {
    return typeof object.params === "object";
}
function isJsonRpcRequest(object) {
    return typeof object.method !== "undefined";
}
function isJsonRpcResponseSuccess(object) {
    return typeof object.result !== "undefined";
}
function isJsonRpcResponseError(object) {
    return typeof object.error !== "undefined";
}
function isInternalEvent(object) {
    return typeof object.event !== "undefined";
}
function isReservedEvent(event) {
    return (0, _constants.reservedEvents).includes(event) || event.startsWith("wc_");
}
function isSilentPayload(request) {
    if (request.method.startsWith("wc_")) return true;
    if ((0, _constants.signingMethods).includes(request.method)) return false;
    return true;
}

},{"@walletconnect/encoding":"hIv0Z","./constants":"dx6md","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i6C0L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "promisify", ()=>promisify);
parcelHelpers.export(exports, "formatRpcError", ()=>formatRpcError);
function promisify(originalFn, thisArg) {
    const promisifiedFunction = async (...callArgs)=>{
        return new Promise((resolve, reject)=>{
            const callback = (err, data)=>{
                if (err === null || typeof err === "undefined") reject(err);
                resolve(data);
            };
            originalFn.apply(thisArg, [
                ...callArgs,
                callback
            ]);
        });
    };
    return promisifiedFunction;
}
function formatRpcError(error) {
    const message = error.message || "Failed or Rejected Request";
    let code = -32000;
    if (error && !error.code) switch(message){
        case "Parse error":
            code = -32700;
            break;
        case "Invalid request":
            code = -32600;
            break;
        case "Method not found":
            code = -32601;
            break;
        case "Invalid params":
            code = -32602;
            break;
        case "Internal error":
            code = -32603;
            break;
        default:
            code = -32000;
            break;
    }
    const result = {
        code,
        message
    };
    if (error.data) result.data = error.data;
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7wDl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWalletConnectSession", ()=>isWalletConnectSession);
parcelHelpers.export(exports, "parseWalletConnectUri", ()=>parseWalletConnectUri);
var _url = require("./url");
function isWalletConnectSession(object) {
    return typeof object.bridge !== "undefined";
}
function parseWalletConnectUri(str) {
    const pathStart = str.indexOf(":");
    const pathEnd = str.indexOf("?") !== -1 ? str.indexOf("?") : undefined;
    const protocol = str.substring(0, pathStart);
    const path = str.substring(pathStart + 1, pathEnd);
    function parseRequiredParams(path) {
        const separator = "@";
        const values = path.split(separator);
        const requiredParams = {
            handshakeTopic: values[0],
            version: parseInt(values[1], 10)
        };
        return requiredParams;
    }
    const requiredParams = parseRequiredParams(path);
    const queryString = typeof pathEnd !== "undefined" ? str.substr(pathEnd) : "";
    function parseQueryParams(queryString) {
        const result = (0, _url.parseQueryString)(queryString);
        const parameters = {
            key: result.key || "",
            bridge: result.bridge || ""
        };
        return parameters;
    }
    const queryParams = parseQueryParams(queryString);
    const result = Object.assign(Object.assign({
        protocol
    }, requiredParams), queryParams);
    return result;
}

},{"./url":"1cGmR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cGmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueryString", ()=>getQueryString);
parcelHelpers.export(exports, "appendToQueryString", ()=>appendToQueryString);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
parcelHelpers.export(exports, "formatQueryString", ()=>formatQueryString);
var _queryString = require("query-string");
function getQueryString(url) {
    const pathEnd = url.indexOf("?") !== -1 ? url.indexOf("?") : undefined;
    const queryString = typeof pathEnd !== "undefined" ? url.substr(pathEnd) : "";
    return queryString;
}
function appendToQueryString(queryString, newQueryParams) {
    let queryParams = parseQueryString(queryString);
    queryParams = Object.assign(Object.assign({}, queryParams), newQueryParams);
    queryString = formatQueryString(queryParams);
    return queryString;
}
function parseQueryString(queryString) {
    return _queryString.parse(queryString);
}
function formatQueryString(queryParams) {
    return _queryString.stringify(queryParams);
}

},{"query-string":"klvAV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klvAV":[function(require,module,exports) {
"use strict";
const strictUriEncode = require("5752d3663915398f");
const decodeComponent = require("4cbbda34882b91a3");
const splitOnFirst = require("53494decacb36d1b");
const isNullOrUndefined = (value)=>value === null || value === undefined;
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            encode(index, options),
                            "]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.split("").indexOf(options.arrayFormatSeparator) > -1;
                const newValue = isArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function parse(input, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof input !== "string") return ret;
    input = input.trim().replace(/^[?#&]/, "");
    if (!input) return ret;
    for (const param of input.split("&")){
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
        else ret[key] = parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
exports.parseUrl = (input, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url, hash] = splitOnFirst(input, "#");
    return Object.assign({
        url: url.split("?")[0] || "",
        query: parse(extract(input), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = (input, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = removeHash(input.url).split("?")[0] || "";
    const queryFromUrl = exports.extract(input.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, input.query);
    let queryString = exports.stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(input.url);
    if (input.fragmentIdentifier) hash = `#${encode(input.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};

},{"5752d3663915398f":"kO7zY","4cbbda34882b91a3":"5LMgi","53494decacb36d1b":"fCebu"}],"kO7zY":[function(require,module,exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

},{}],"5LMgi":[function(require,module,exports) {
"use strict";
var token = "%[a-f0-9]{2}";
var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
var multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join("");
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{}],"fCebu":[function(require,module,exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"gJV9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
var _network = require("./network");
var _networkDefault = parcelHelpers.interopDefault(_network);
var global = arguments[3];
const WS = typeof global.WebSocket !== "undefined" ? global.WebSocket : require("e984abbfe49d252d");
class SocketTransport {
    constructor(opts){
        this.opts = opts;
        this._queue = [];
        this._events = [];
        this._subscriptions = [];
        this._protocol = opts.protocol;
        this._version = opts.version;
        this._url = "";
        this._netMonitor = null;
        this._socket = null;
        this._nextSocket = null;
        this._subscriptions = opts.subscriptions || [];
        this._netMonitor = opts.netMonitor || new (0, _networkDefault.default)();
        if (!opts.url || typeof opts.url !== "string") throw new Error("Missing or invalid WebSocket url");
        this._url = opts.url;
        this._netMonitor.on("online", ()=>this._socketCreate());
    }
    set readyState(value) {}
    get readyState() {
        return this._socket ? this._socket.readyState : -1;
    }
    set connecting(value) {}
    get connecting() {
        return this.readyState === 0;
    }
    set connected(value) {}
    get connected() {
        return this.readyState === 1;
    }
    set closing(value) {}
    get closing() {
        return this.readyState === 2;
    }
    set closed(value) {}
    get closed() {
        return this.readyState === 3;
    }
    open() {
        this._socketCreate();
    }
    close() {
        this._socketClose();
    }
    send(message, topic, silent) {
        if (!topic || typeof topic !== "string") throw new Error("Missing or invalid topic field");
        this._socketSend({
            topic: topic,
            type: "pub",
            payload: message,
            silent: !!silent
        });
    }
    subscribe(topic) {
        this._socketSend({
            topic: topic,
            type: "sub",
            payload: "",
            silent: true
        });
    }
    on(event, callback) {
        this._events.push({
            event,
            callback
        });
    }
    _socketCreate() {
        if (this._nextSocket) return;
        const url = getWebSocketUrl(this._url, this._protocol, this._version);
        this._nextSocket = new WS(url);
        if (!this._nextSocket) throw new Error("Failed to create socket");
        this._nextSocket.onmessage = (event)=>this._socketReceive(event);
        this._nextSocket.onopen = ()=>this._socketOpen();
        this._nextSocket.onerror = (event)=>this._socketError(event);
        this._nextSocket.onclose = ()=>{
            setTimeout(()=>{
                this._nextSocket = null;
                this._socketCreate();
            }, 1000);
        };
    }
    _socketOpen() {
        this._socketClose();
        this._socket = this._nextSocket;
        this._nextSocket = null;
        this._queueSubscriptions();
        this._pushQueue();
    }
    _socketClose() {
        if (this._socket) {
            this._socket.onclose = ()=>{};
            this._socket.close();
        }
    }
    _socketSend(socketMessage) {
        const message = JSON.stringify(socketMessage);
        if (this._socket && this._socket.readyState === 1) this._socket.send(message);
        else {
            this._setToQueue(socketMessage);
            this._socketCreate();
        }
    }
    async _socketReceive(event) {
        let socketMessage;
        try {
            socketMessage = JSON.parse(event.data);
        } catch (error) {
            return;
        }
        this._socketSend({
            topic: socketMessage.topic,
            type: "ack",
            payload: "",
            silent: true
        });
        if (this._socket && this._socket.readyState === 1) {
            const events = this._events.filter((event)=>event.event === "message");
            if (events && events.length) events.forEach((event)=>event.callback(socketMessage));
        }
    }
    _socketError(e) {
        const events = this._events.filter((event)=>event.event === "error");
        if (events && events.length) events.forEach((event)=>event.callback(e));
    }
    _queueSubscriptions() {
        const subscriptions = this._subscriptions;
        subscriptions.forEach((topic)=>this._queue.push({
                topic: topic,
                type: "sub",
                payload: "",
                silent: true
            }));
        this._subscriptions = this.opts.subscriptions || [];
    }
    _setToQueue(socketMessage) {
        this._queue.push(socketMessage);
    }
    _pushQueue() {
        const queue = this._queue;
        queue.forEach((socketMessage)=>this._socketSend(socketMessage));
        this._queue = [];
    }
}
function getWebSocketUrl(_url, protocol, version) {
    var _a, _b;
    const url = _url.startsWith("https") ? _url.replace("https", "wss") : _url.startsWith("http") ? _url.replace("http", "ws") : _url;
    const splitUrl = url.split("?");
    const params = (0, _utils.isBrowser)() ? {
        protocol,
        version,
        env: "browser",
        host: ((_a = (0, _utils.getLocation)()) === null || _a === void 0 ? void 0 : _a.host) || ""
    } : {
        protocol,
        version,
        env: ((_b = (0, _utils.detectEnv)()) === null || _b === void 0 ? void 0 : _b.name) || ""
    };
    const queryString = (0, _utils.appendToQueryString)((0, _utils.getQueryString)(splitUrl[1] || ""), params);
    return splitUrl[0] + "?" + queryString;
}
exports.default = SocketTransport;

},{"@walletconnect/utils":"bFQqa","./network":"bNnFG","e984abbfe49d252d":"26vSj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNnFG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class NetworkMonitor {
    constructor(){
        this._eventEmitters = [];
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
            window.addEventListener("online", ()=>this.trigger("online"));
            window.addEventListener("offline", ()=>this.trigger("offline"));
        }
    }
    on(event, callback) {
        this._eventEmitters.push({
            event,
            callback
        });
    }
    trigger(event) {
        let eventEmitters = [];
        if (event) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === event);
        eventEmitters.forEach((eventEmitter)=>{
            eventEmitter.callback();
        });
    }
}
exports.default = NetworkMonitor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26vSj":[function(require,module,exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

},{}],"4WfNb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_SESSION_CONNECTED", ()=>ERROR_SESSION_CONNECTED);
parcelHelpers.export(exports, "ERROR_SESSION_DISCONNECTED", ()=>ERROR_SESSION_DISCONNECTED);
parcelHelpers.export(exports, "ERROR_SESSION_REJECTED", ()=>ERROR_SESSION_REJECTED);
parcelHelpers.export(exports, "ERROR_MISSING_JSON_RPC", ()=>ERROR_MISSING_JSON_RPC);
parcelHelpers.export(exports, "ERROR_MISSING_RESULT", ()=>ERROR_MISSING_RESULT);
parcelHelpers.export(exports, "ERROR_MISSING_ERROR", ()=>ERROR_MISSING_ERROR);
parcelHelpers.export(exports, "ERROR_MISSING_METHOD", ()=>ERROR_MISSING_METHOD);
parcelHelpers.export(exports, "ERROR_MISSING_ID", ()=>ERROR_MISSING_ID);
parcelHelpers.export(exports, "ERROR_MISSING_REQUIRED", ()=>ERROR_MISSING_REQUIRED);
parcelHelpers.export(exports, "ERROR_INVALID_RESPONSE", ()=>ERROR_INVALID_RESPONSE);
parcelHelpers.export(exports, "ERROR_INVALID_URI", ()=>ERROR_INVALID_URI);
parcelHelpers.export(exports, "ERROR_QRCODE_MODAL_NOT_PROVIDED", ()=>ERROR_QRCODE_MODAL_NOT_PROVIDED);
parcelHelpers.export(exports, "ERROR_QRCODE_MODAL_USER_CLOSED", ()=>ERROR_QRCODE_MODAL_USER_CLOSED);
const ERROR_SESSION_CONNECTED = "Session currently connected";
const ERROR_SESSION_DISCONNECTED = "Session currently disconnected";
const ERROR_SESSION_REJECTED = "Session Rejected";
const ERROR_MISSING_JSON_RPC = "Missing JSON RPC response";
const ERROR_MISSING_RESULT = `JSON-RPC success response must include "result" field`;
const ERROR_MISSING_ERROR = `JSON-RPC error response must include "error" field`;
const ERROR_MISSING_METHOD = `JSON RPC request must have valid "method" value`;
const ERROR_MISSING_ID = `JSON RPC request must have valid "id" value`;
const ERROR_MISSING_REQUIRED = "Missing one of the required parameters: bridge / uri / session";
const ERROR_INVALID_RESPONSE = "JSON RPC response format is invalid";
const ERROR_INVALID_URI = "URI format is invalid";
const ERROR_QRCODE_MODAL_NOT_PROVIDED = "QRCode Modal not provided";
const ERROR_QRCODE_MODAL_USER_CLOSED = "User close QRCode Modal";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j47yZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
class EventManager {
    constructor(){
        this._eventEmitters = [];
    }
    subscribe(eventEmitter) {
        this._eventEmitters.push(eventEmitter);
    }
    unsubscribe(event) {
        this._eventEmitters = this._eventEmitters.filter((x)=>x.event !== event);
    }
    trigger(payload) {
        let eventEmitters = [];
        let event;
        if ((0, _utils.isJsonRpcRequest)(payload)) event = payload.method;
        else if ((0, _utils.isJsonRpcResponseSuccess)(payload) || (0, _utils.isJsonRpcResponseError)(payload)) event = `response:${payload.id}`;
        else if ((0, _utils.isInternalEvent)(payload)) event = payload.event;
        else event = "";
        if (event) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === event);
        if ((!eventEmitters || !eventEmitters.length) && !(0, _utils.isReservedEvent)(event) && !(0, _utils.isInternalEvent)(event)) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === "call_request");
        eventEmitters.forEach((eventEmitter)=>{
            if ((0, _utils.isJsonRpcResponseError)(payload)) {
                const error = new Error(payload.error.message);
                eventEmitter.callback(error, null);
            } else eventEmitter.callback(null, payload);
        });
    }
}
exports.default = EventManager;

},{"@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpAt8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
class SessionStorage {
    constructor(storageId = "walletconnect"){
        this.storageId = storageId;
    }
    getSession() {
        let session = null;
        const json = (0, _utils.getLocal)(this.storageId);
        if (json && (0, _utils.isWalletConnectSession)(json)) session = json;
        return session;
    }
    setSession(session) {
        (0, _utils.setLocal)(this.storageId, session);
        return session;
    }
    removeSession() {
        (0, _utils.removeLocal)(this.storageId);
    }
}
exports.default = SessionStorage;

},{"@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2XH2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractHostname", ()=>extractHostname);
parcelHelpers.export(exports, "extractRootDomain", ()=>extractRootDomain);
parcelHelpers.export(exports, "randomBridgeIndex", ()=>randomBridgeIndex);
parcelHelpers.export(exports, "selectRandomBridgeUrl", ()=>selectRandomBridgeUrl);
parcelHelpers.export(exports, "shouldSelectRandomly", ()=>shouldSelectRandomly);
parcelHelpers.export(exports, "getBridgeUrl", ()=>getBridgeUrl);
const domain = "walletconnect.org";
const alphanumerical = "abcdefghijklmnopqrstuvwxyz0123456789";
const bridges = alphanumerical.split("").map((char)=>`https://${char}.bridge.walletconnect.org`);
function extractHostname(url) {
    let hostname = url.indexOf("//") > -1 ? url.split("/")[2] : url.split("/")[0];
    hostname = hostname.split(":")[0];
    hostname = hostname.split("?")[0];
    return hostname;
}
function extractRootDomain(url) {
    return extractHostname(url).split(".").slice(-2).join(".");
}
function randomBridgeIndex() {
    return Math.floor(Math.random() * bridges.length);
}
function selectRandomBridgeUrl() {
    return bridges[randomBridgeIndex()];
}
function shouldSelectRandomly(url) {
    return extractRootDomain(url) === domain;
}
function getBridgeUrl(url) {
    if (shouldSelectRandomly(url)) return selectRandomBridgeUrl();
    return url;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pBwP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateKey", ()=>generateKey);
parcelHelpers.export(exports, "verifyHmac", ()=>verifyHmac);
parcelHelpers.export(exports, "encrypt", ()=>encrypt);
parcelHelpers.export(exports, "decrypt", ()=>decrypt);
var _crypto = require("@walletconnect/crypto");
var _encoding = require("@walletconnect/encoding");
var _utils = require("@walletconnect/utils");
async function generateKey(length) {
    const _length = (length || 256) / 8;
    const bytes = _crypto.randomBytes(_length);
    const result = (0, _utils.convertBufferToArrayBuffer)(_encoding.arrayToBuffer(bytes));
    return result;
}
async function verifyHmac(payload, key) {
    const cipherText = _encoding.hexToArray(payload.data);
    const iv = _encoding.hexToArray(payload.iv);
    const hmac = _encoding.hexToArray(payload.hmac);
    const hmacHex = _encoding.arrayToHex(hmac, false);
    const unsigned = _encoding.concatArrays(cipherText, iv);
    const chmac = await _crypto.hmacSha256Sign(key, unsigned);
    const chmacHex = _encoding.arrayToHex(chmac, false);
    if (_encoding.removeHexPrefix(hmacHex) === _encoding.removeHexPrefix(chmacHex)) return true;
    return false;
}
async function encrypt(data, key, providedIv) {
    const _key = _encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(key));
    const ivArrayBuffer = providedIv || await generateKey(128);
    const iv = _encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(ivArrayBuffer));
    const ivHex = _encoding.arrayToHex(iv, false);
    const contentString = JSON.stringify(data);
    const content = _encoding.utf8ToArray(contentString);
    const cipherText = await _crypto.aesCbcEncrypt(iv, _key, content);
    const cipherTextHex = _encoding.arrayToHex(cipherText, false);
    const unsigned = _encoding.concatArrays(cipherText, iv);
    const hmac = await _crypto.hmacSha256Sign(_key, unsigned);
    const hmacHex = _encoding.arrayToHex(hmac, false);
    return {
        data: cipherTextHex,
        hmac: hmacHex,
        iv: ivHex
    };
}
async function decrypt(payload, key) {
    const _key = _encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(key));
    if (!_key) throw new Error("Missing key: required for decryption");
    const verified = await verifyHmac(payload, _key);
    if (!verified) return null;
    const cipherText = _encoding.hexToArray(payload.data);
    const iv = _encoding.hexToArray(payload.iv);
    const buffer = await _crypto.aesCbcDecrypt(iv, _key, cipherText);
    const utf8 = _encoding.arrayToUtf8(buffer);
    let data;
    try {
        data = JSON.parse(utf8);
    } catch (error) {
        return null;
    }
    return data;
}

},{"@walletconnect/crypto":"lqwVi","@walletconnect/encoding":"hIv0Z","@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lqwVi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _randombytes = require("@walletconnect/randombytes");
parcelHelpers.exportAll(_randombytes, exports);
var _aes = require("./aes");
parcelHelpers.exportAll(_aes, exports);
var _hmac = require("./hmac");
parcelHelpers.exportAll(_hmac, exports);
var _sha2 = require("./sha2");
parcelHelpers.exportAll(_sha2, exports);
var _helpers = require("../helpers");
parcelHelpers.exportAll(_helpers, exports);
var _constants = require("../constants");
parcelHelpers.exportAll(_constants, exports);

},{"@walletconnect/randombytes":"3XMds","./aes":"e0ecp","./hmac":"8Pt3b","./sha2":"71NKK","../helpers":"3yn5C","../constants":"lPzSJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3XMds":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
var _environment = require("@walletconnect/environment");
function randomBytes(length) {
    const browserCrypto = _environment.getBrowerCrypto();
    return browserCrypto.getRandomValues(new Uint8Array(length));
}

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0ecp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aesCbcEncrypt", ()=>aesCbcEncrypt);
parcelHelpers.export(exports, "aesCbcDecrypt", ()=>aesCbcDecrypt);
var _browser = require("../lib/browser");
function aesCbcEncrypt(iv, key, data) {
    return (0, _browser.browserAesEncrypt)(iv, key, data);
}
function aesCbcDecrypt(iv, key, data) {
    return (0, _browser.browserAesDecrypt)(iv, key, data);
}

},{"../lib/browser":"hfrPc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfrPc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlgo", ()=>getAlgo);
parcelHelpers.export(exports, "getOps", ()=>getOps);
parcelHelpers.export(exports, "browserExportKey", ()=>browserExportKey);
parcelHelpers.export(exports, "browserImportKey", ()=>browserImportKey);
parcelHelpers.export(exports, "browserAesEncrypt", ()=>browserAesEncrypt);
parcelHelpers.export(exports, "browserAesDecrypt", ()=>browserAesDecrypt);
parcelHelpers.export(exports, "browserHmacSha256Sign", ()=>browserHmacSha256Sign);
parcelHelpers.export(exports, "browserHmacSha512Sign", ()=>browserHmacSha512Sign);
parcelHelpers.export(exports, "browserSha256", ()=>browserSha256);
parcelHelpers.export(exports, "browserSha512", ()=>browserSha512);
var _environment = require("@walletconnect/environment");
var _constants = require("../constants");
function getAlgo(type) {
    return type === (0, _constants.AES_BROWSER_ALGO) ? {
        length: (0, _constants.AES_LENGTH),
        name: (0, _constants.AES_BROWSER_ALGO)
    } : {
        hash: {
            name: (0, _constants.HMAC_BROWSER_ALGO)
        },
        name: (0, _constants.HMAC_BROWSER)
    };
}
function getOps(type) {
    return type === (0, _constants.AES_BROWSER_ALGO) ? [
        (0, _constants.ENCRYPT_OP),
        (0, _constants.DECRYPT_OP)
    ] : [
        (0, _constants.SIGN_OP),
        (0, _constants.VERIFY_OP)
    ];
}
async function browserExportKey(cryptoKey, type = (0, _constants.AES_BROWSER_ALGO)) {
    const subtle = _environment.getSubtleCrypto();
    return new Uint8Array(await subtle.exportKey("raw", cryptoKey));
}
async function browserImportKey(buffer, type = (0, _constants.AES_BROWSER_ALGO)) {
    return _environment.getSubtleCrypto().importKey("raw", buffer, getAlgo(type), true, getOps(type));
}
async function browserAesEncrypt(iv, key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.AES_BROWSER_ALGO));
    const result = await subtle.encrypt({
        iv,
        name: (0, _constants.AES_BROWSER_ALGO)
    }, cryptoKey, data);
    return new Uint8Array(result);
}
async function browserAesDecrypt(iv, key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.AES_BROWSER_ALGO));
    const result = await subtle.decrypt({
        iv,
        name: (0, _constants.AES_BROWSER_ALGO)
    }, cryptoKey, data);
    return new Uint8Array(result);
}
async function browserHmacSha256Sign(key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.HMAC_BROWSER));
    const signature = await subtle.sign({
        length: (0, _constants.HMAC_LENGTH),
        name: (0, _constants.HMAC_BROWSER)
    }, cryptoKey, data);
    return new Uint8Array(signature);
}
async function browserHmacSha512Sign(key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.HMAC_BROWSER));
    const signature = await subtle.sign({
        length: (0, _constants.LENGTH_512),
        name: (0, _constants.HMAC_BROWSER)
    }, cryptoKey, data);
    return new Uint8Array(signature);
}
async function browserSha256(data) {
    const subtle = _environment.getSubtleCrypto();
    const result = await subtle.digest({
        name: (0, _constants.SHA256_BROWSER_ALGO)
    }, data);
    return new Uint8Array(result);
}
async function browserSha512(data) {
    const subtle = _environment.getSubtleCrypto();
    const result = await subtle.digest({
        name: (0, _constants.SHA512_BROWSER_ALGO)
    }, data);
    return new Uint8Array(result);
}

},{"@walletconnect/environment":"ljiRg","../constants":"lPzSJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lPzSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _default = require("./default");
parcelHelpers.exportAll(_default, exports);
var _encoding = require("./encoding");
parcelHelpers.exportAll(_encoding, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _length = require("./length");
parcelHelpers.exportAll(_length, exports);
var _operations = require("./operations");
parcelHelpers.exportAll(_operations, exports);

},{"./default":"33Kaw","./encoding":"8ZKPZ","./error":"l4I2w","./length":"dJGKm","./operations":"8PVdx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33Kaw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AES_LENGTH", ()=>AES_LENGTH);
parcelHelpers.export(exports, "HMAC_LENGTH", ()=>HMAC_LENGTH);
parcelHelpers.export(exports, "AES_BROWSER_ALGO", ()=>AES_BROWSER_ALGO);
parcelHelpers.export(exports, "HMAC_BROWSER_ALGO", ()=>HMAC_BROWSER_ALGO);
parcelHelpers.export(exports, "HMAC_BROWSER", ()=>HMAC_BROWSER);
parcelHelpers.export(exports, "SHA256_BROWSER_ALGO", ()=>SHA256_BROWSER_ALGO);
parcelHelpers.export(exports, "SHA512_BROWSER_ALGO", ()=>SHA512_BROWSER_ALGO);
parcelHelpers.export(exports, "AES_NODE_ALGO", ()=>AES_NODE_ALGO);
parcelHelpers.export(exports, "HMAC_NODE_ALGO", ()=>HMAC_NODE_ALGO);
parcelHelpers.export(exports, "SHA256_NODE_ALGO", ()=>SHA256_NODE_ALGO);
parcelHelpers.export(exports, "SHA512_NODE_ALGO", ()=>SHA512_NODE_ALGO);
parcelHelpers.export(exports, "RIPEMD160_NODE_ALGO", ()=>RIPEMD160_NODE_ALGO);
parcelHelpers.export(exports, "PREFIX_LENGTH", ()=>PREFIX_LENGTH);
parcelHelpers.export(exports, "KEY_LENGTH", ()=>KEY_LENGTH);
parcelHelpers.export(exports, "IV_LENGTH", ()=>IV_LENGTH);
parcelHelpers.export(exports, "MAC_LENGTH", ()=>MAC_LENGTH);
var _length = require("./length");
const AES_LENGTH = (0, _length.LENGTH_256);
const HMAC_LENGTH = (0, _length.LENGTH_256);
const AES_BROWSER_ALGO = "AES-CBC";
const HMAC_BROWSER_ALGO = `SHA-${AES_LENGTH}`;
const HMAC_BROWSER = "HMAC";
const SHA256_BROWSER_ALGO = "SHA-256";
const SHA512_BROWSER_ALGO = "SHA-512";
const AES_NODE_ALGO = `aes-${AES_LENGTH}-cbc`;
const HMAC_NODE_ALGO = `sha${HMAC_LENGTH}`;
const SHA256_NODE_ALGO = "sha256";
const SHA512_NODE_ALGO = "sha512";
const RIPEMD160_NODE_ALGO = "ripemd160";
const PREFIX_LENGTH = (0, _length.LENGTH_1);
const KEY_LENGTH = (0, _length.LENGTH_32);
const IV_LENGTH = (0, _length.LENGTH_16);
const MAC_LENGTH = (0, _length.LENGTH_32);

},{"./length":"dJGKm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJGKm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LENGTH_0", ()=>LENGTH_0);
parcelHelpers.export(exports, "LENGTH_1", ()=>LENGTH_1);
parcelHelpers.export(exports, "LENGTH_16", ()=>LENGTH_16);
parcelHelpers.export(exports, "LENGTH_32", ()=>LENGTH_32);
parcelHelpers.export(exports, "LENGTH_64", ()=>LENGTH_64);
parcelHelpers.export(exports, "LENGTH_128", ()=>LENGTH_128);
parcelHelpers.export(exports, "LENGTH_256", ()=>LENGTH_256);
parcelHelpers.export(exports, "LENGTH_512", ()=>LENGTH_512);
parcelHelpers.export(exports, "LENGTH_1024", ()=>LENGTH_1024);
const LENGTH_0 = 0;
const LENGTH_1 = 1;
const LENGTH_16 = 16;
const LENGTH_32 = 32;
const LENGTH_64 = 64;
const LENGTH_128 = 128;
const LENGTH_256 = 256;
const LENGTH_512 = 512;
const LENGTH_1024 = 1024;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ZKPZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HEX_ENC", ()=>HEX_ENC);
parcelHelpers.export(exports, "UTF8_ENC", ()=>UTF8_ENC);
const HEX_ENC = "hex";
const UTF8_ENC = "utf8";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l4I2w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_BAD_MAC", ()=>ERROR_BAD_MAC);
const ERROR_BAD_MAC = "Bad MAC";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8PVdx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENCRYPT_OP", ()=>ENCRYPT_OP);
parcelHelpers.export(exports, "DECRYPT_OP", ()=>DECRYPT_OP);
parcelHelpers.export(exports, "SIGN_OP", ()=>SIGN_OP);
parcelHelpers.export(exports, "VERIFY_OP", ()=>VERIFY_OP);
const ENCRYPT_OP = "encrypt";
const DECRYPT_OP = "decrypt";
const SIGN_OP = "sign";
const VERIFY_OP = "verify";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Pt3b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hmacSha256Sign", ()=>hmacSha256Sign);
parcelHelpers.export(exports, "hmacSha256Verify", ()=>hmacSha256Verify);
parcelHelpers.export(exports, "hmacSha512Sign", ()=>hmacSha512Sign);
parcelHelpers.export(exports, "hmacSha512Verify", ()=>hmacSha512Verify);
var _browser = require("../lib/browser");
var _helpers = require("../helpers");
async function hmacSha256Sign(key, msg) {
    const result = await (0, _browser.browserHmacSha256Sign)(key, msg);
    return result;
}
async function hmacSha256Verify(key, msg, sig) {
    const expectedSig = await (0, _browser.browserHmacSha256Sign)(key, msg);
    const result = (0, _helpers.isConstantTime)(expectedSig, sig);
    return result;
}
async function hmacSha512Sign(key, msg) {
    const result = await (0, _browser.browserHmacSha512Sign)(key, msg);
    return result;
}
async function hmacSha512Verify(key, msg, sig) {
    const expectedSig = await (0, _browser.browserHmacSha512Sign)(key, msg);
    const result = (0, _helpers.isConstantTime)(expectedSig, sig);
    return result;
}

},{"../lib/browser":"hfrPc","../helpers":"3yn5C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yn5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _pkcs7 = require("./pkcs7");
parcelHelpers.exportAll(_pkcs7, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"./env":"gre6M","./pkcs7":"c46It","./types":"7UEWa","./validators":"kTOfb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gre6M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _environment = require("@walletconnect/environment");
parcelHelpers.exportAll(_environment, exports);

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c46It":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pkcs7", ()=>pkcs7);
const PADDING = [
    [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16
    ],
    [
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15
    ],
    [
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14
    ],
    [
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13
    ],
    [
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ],
    [
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11
    ],
    [
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10
    ],
    [
        9,
        9,
        9,
        9,
        9,
        9,
        9,
        9,
        9
    ],
    [
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8
    ],
    [
        7,
        7,
        7,
        7,
        7,
        7,
        7
    ],
    [
        6,
        6,
        6,
        6,
        6,
        6
    ],
    [
        5,
        5,
        5,
        5,
        5
    ],
    [
        4,
        4,
        4,
        4
    ],
    [
        3,
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        1
    ]
];
const pkcs7 = {
    pad (plaintext) {
        const padding = PADDING[plaintext.byteLength % 16 || 0];
        const result = new Uint8Array(plaintext.byteLength + padding.length);
        result.set(plaintext);
        result.set(padding, plaintext.byteLength);
        return result;
    },
    unpad (padded) {
        return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7UEWa":[function(require,module,exports) {

},{}],"kTOfb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "isConstantTime", ()=>isConstantTime);
function assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
function isConstantTime(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    let res = 0;
    for(let i = 0; i < arr1.length; i++)res |= arr1[i] ^ arr2[i];
    return res === 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"71NKK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sha256", ()=>sha256);
parcelHelpers.export(exports, "sha512", ()=>sha512);
parcelHelpers.export(exports, "ripemd160", ()=>ripemd160);
var _browser = require("../lib/browser");
async function sha256(msg) {
    const result = await (0, _browser.browserSha256)(msg);
    return result;
}
async function sha512(msg) {
    const result = await (0, _browser.browserSha512)(msg);
    return result;
}
async function ripemd160(msg) {
    throw new Error("Not supported for Browser async methods, use sync instead!");
}

},{"../lib/browser":"hfrPc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dU9OL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _main = require("./main");
parcelHelpers.exportAll(_main, exports);
exports.default = _main;

},{"./main":"5YGLm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YGLm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Algodv2", ()=>(0, _algodDefault.default));
parcelHelpers.export(exports, "Kmd", ()=>(0, _kmdDefault.default));
parcelHelpers.export(exports, "IntDecoding", ()=>(0, _intDecodingDefault.default));
parcelHelpers.export(exports, "Indexer", ()=>(0, _indexerDefault.default));
parcelHelpers.export(exports, "waitForConfirmation", ()=>(0, _wait.waitForConfirmation));
parcelHelpers.export(exports, "isValidAddress", ()=>(0, _address.isValidAddress));
parcelHelpers.export(exports, "encodeAddress", ()=>(0, _address.encodeAddress));
parcelHelpers.export(exports, "decodeAddress", ()=>(0, _address.decodeAddress));
parcelHelpers.export(exports, "getApplicationAddress", ()=>(0, _address.getApplicationAddress));
parcelHelpers.export(exports, "bytesToBigInt", ()=>(0, _bigint.bytesToBigInt));
parcelHelpers.export(exports, "bigIntToBytes", ()=>(0, _bigint.bigIntToBytes));
parcelHelpers.export(exports, "encodeUint64", ()=>(0, _uint64.encodeUint64));
parcelHelpers.export(exports, "decodeUint64", ()=>(0, _uint64.decodeUint64));
parcelHelpers.export(exports, "generateAccount", ()=>(0, _accountDefault.default));
parcelHelpers.export(exports, "mnemonicToMasterDerivationKey", ()=>(0, _mnemonic.mnemonicToMasterDerivationKey));
parcelHelpers.export(exports, "masterDerivationKeyToMnemonic", ()=>(0, _mnemonic.masterDerivationKeyToMnemonic));
parcelHelpers.export(exports, "secretKeyToMnemonic", ()=>(0, _mnemonic.secretKeyToMnemonic));
parcelHelpers.export(exports, "mnemonicToSecretKey", ()=>(0, _mnemonic.mnemonicToSecretKey));
parcelHelpers.export(exports, "seedFromMnemonic", ()=>(0, _mnemonic.seedFromMnemonic));
parcelHelpers.export(exports, "mnemonicFromSeed", ()=>(0, _mnemonic.mnemonicFromSeed));
parcelHelpers.export(exports, "microalgosToAlgos", ()=>(0, _convert.microalgosToAlgos));
parcelHelpers.export(exports, "algosToMicroalgos", ()=>(0, _convert.algosToMicroalgos));
parcelHelpers.export(exports, "INVALID_MICROALGOS_ERROR_MSG", ()=>(0, _convert.INVALID_MICROALGOS_ERROR_MSG));
parcelHelpers.export(exports, "computeGroupID", ()=>(0, _group.computeGroupID));
parcelHelpers.export(exports, "assignGroupID", ()=>(0, _group.assignGroupID));
parcelHelpers.export(exports, "LogicSig", ()=>(0, _logicsig.LogicSig));
parcelHelpers.export(exports, "LogicSigAccount", ()=>(0, _logicsig.LogicSigAccount));
parcelHelpers.export(exports, "signLogicSigTransaction", ()=>(0, _logicsig.signLogicSigTransaction));
parcelHelpers.export(exports, "signLogicSigTransactionObject", ()=>(0, _logicsig.signLogicSigTransactionObject));
parcelHelpers.export(exports, "logicSigFromByte", ()=>(0, _logicsig.logicSigFromByte));
parcelHelpers.export(exports, "tealSign", ()=>(0, _logicsig.tealSign));
parcelHelpers.export(exports, "tealSignFromProgram", ()=>(0, _logicsig.tealSignFromProgram));
parcelHelpers.export(exports, "verifyTealSign", ()=>(0, _logicsig.verifyTealSign));
parcelHelpers.export(exports, "signMultisigTransaction", ()=>(0, _multisig.signMultisigTransaction));
parcelHelpers.export(exports, "mergeMultisigTransactions", ()=>(0, _multisig.mergeMultisigTransactions));
parcelHelpers.export(exports, "appendSignMultisigTransaction", ()=>(0, _multisig.appendSignMultisigTransaction));
parcelHelpers.export(exports, "createMultisigTransaction", ()=>(0, _multisig.createMultisigTransaction));
parcelHelpers.export(exports, "appendSignRawMultisigSignature", ()=>(0, _multisig.appendSignRawMultisigSignature));
parcelHelpers.export(exports, "verifyMultisig", ()=>(0, _multisig.verifyMultisig));
parcelHelpers.export(exports, "multisigAddress", ()=>(0, _multisig.multisigAddress));
parcelHelpers.export(exports, "SourceMap", ()=>(0, _sourcemap.SourceMap));
parcelHelpers.export(exports, "MULTISIG_BAD_SENDER_ERROR_MSG", ()=>MULTISIG_BAD_SENDER_ERROR_MSG);
/**
 * signTransaction takes an object with either payment or key registration fields and
 * a secret key and returns a signed blob.
 *
 * Payment transaction fields: from, to, amount, fee, firstRound, lastRound, genesisHash,
 * note(optional), GenesisID(optional), closeRemainderTo(optional)
 *
 * Key registration fields: fee, firstRound, lastRound, voteKey, selectionKey, voteFirst,
 * voteLast, voteKeyDilution, genesisHash, note(optional), GenesisID(optional)
 *
 * If flatFee is not set and the final calculated fee is lower than the protocol minimum fee, the fee will be increased to match the minimum.
 * @param txn - object with either payment or key registration fields
 * @param sk - Algorand Secret Key
 * @returns object contains the binary signed transaction and its txID
 */ parcelHelpers.export(exports, "signTransaction", ()=>signTransaction);
/**
 * signBid takes an object with the following fields: bidder key, bid amount, max price, bid ID, auctionKey, auction ID,
 * and a secret key and returns a signed blob to be inserted into a transaction Algorand note field.
 * @param bid - Algorand Bid
 * @param sk - Algorand secret key
 * @returns Uint8Array binary signed bid
 */ parcelHelpers.export(exports, "signBid", ()=>signBid);
/**
 * signBytes takes arbitrary bytes and a secret key, prepends the bytes with "MX" for domain separation, signs the bytes
 * with the private key, and returns the signature.
 * @param bytes - Uint8array
 * @param sk - Algorand secret key
 * @returns binary signature
 */ parcelHelpers.export(exports, "signBytes", ()=>signBytes);
/**
 * verifyBytes takes array of bytes, an address, and a signature and verifies if the signature is correct for the public
 * key and the bytes (the bytes should have been signed with "MX" prepended for domain separation).
 * @param bytes - Uint8Array
 * @param signature - binary signature
 * @param addr - string address
 * @returns bool
 */ parcelHelpers.export(exports, "verifyBytes", ()=>verifyBytes);
/**
 * encodeObj takes a javascript object and returns its msgpack encoding
 * Note that the encoding sorts the fields alphabetically
 * @param o - js obj
 * @returns Uint8Array binary representation
 */ parcelHelpers.export(exports, "encodeObj", ()=>encodeObj);
/**
 * decodeObj takes a Uint8Array and returns its javascript obj
 * @param o - Uint8Array to decode
 * @returns object
 */ parcelHelpers.export(exports, "decodeObj", ()=>decodeObj);
parcelHelpers.export(exports, "ERROR_MULTISIG_BAD_SENDER", ()=>ERROR_MULTISIG_BAD_SENDER);
parcelHelpers.export(exports, "ERROR_INVALID_MICROALGOS", ()=>ERROR_INVALID_MICROALGOS);
parcelHelpers.export(exports, "modelsv2", ()=>_types);
parcelHelpers.export(exports, "indexerModels", ()=>_types1);
var _buffer = require("buffer");
var _naclWrappers = require("./nacl/naclWrappers");
var _address = require("./encoding/address");
var _encoding = require("./encoding/encoding");
var _transaction = require("./transaction");
var _bid = require("./bid");
var _bidDefault = parcelHelpers.interopDefault(_bid);
var _convert = require("./convert");
var _utils = require("./utils/utils");
var _algod = require("./client/v2/algod/algod");
var _algodDefault = parcelHelpers.interopDefault(_algod);
var _kmd = require("./client/kmd");
var _kmdDefault = parcelHelpers.interopDefault(_kmd);
var _intDecoding = require("./types/intDecoding");
var _intDecodingDefault = parcelHelpers.interopDefault(_intDecoding);
var _indexer = require("./client/v2/indexer/indexer");
var _indexerDefault = parcelHelpers.interopDefault(_indexer);
var _wait = require("./wait");
var _bigint = require("./encoding/bigint");
var _uint64 = require("./encoding/uint64");
var _account = require("./account");
var _accountDefault = parcelHelpers.interopDefault(_account);
var _types = require("./client/v2/algod/models/types");
var _types1 = require("./client/v2/indexer/models/types");
var _mnemonic = require("./mnemonic/mnemonic");
var _group = require("./group");
var _logicsig = require("./logicsig");
var _multisig = require("./multisig");
var _sourcemap = require("./logic/sourcemap");
var _dryrun = require("./dryrun");
parcelHelpers.exportAll(_dryrun, exports);
var _makeTxn = require("./makeTxn");
parcelHelpers.exportAll(_makeTxn, exports);
parcelHelpers.exportAll(_transaction, exports);
var _signer = require("./signer");
parcelHelpers.exportAll(_signer, exports);
var _composer = require("./composer");
parcelHelpers.exportAll(_composer, exports);
var _types2 = require("./types");
parcelHelpers.exportAll(_types2, exports);
var _abi = require("./abi");
parcelHelpers.exportAll(_abi, exports);
const SIGN_BYTES_PREFIX = (0, _buffer.Buffer).from([
    77,
    88
]); // "MX"
const MULTISIG_BAD_SENDER_ERROR_MSG = "The transaction sender address and multisig preimage do not match.";
function signTransaction(txn, sk) {
    if (typeof txn.from === "undefined") {
        // Get pk from sk if no sender specified
        const key = _naclWrappers.keyPairFromSecretKey(sk);
        // eslint-disable-next-line no-param-reassign
        txn.from = _address.encodeAddress(key.publicKey);
    }
    const algoTxn = _transaction.instantiateTxnIfNeeded(txn);
    return {
        txID: algoTxn.txID().toString(),
        blob: algoTxn.signTxn(sk)
    };
}
function signBid(bid, sk) {
    const signedBid = new (0, _bidDefault.default)(bid);
    return signedBid.signBid(sk);
}
function signBytes(bytes, sk) {
    const toBeSigned = (0, _buffer.Buffer).from(_utils.concatArrays(SIGN_BYTES_PREFIX, bytes));
    const sig = _naclWrappers.sign(toBeSigned, sk);
    return sig;
}
function verifyBytes(bytes, signature, addr) {
    const toBeVerified = (0, _buffer.Buffer).from(_utils.concatArrays(SIGN_BYTES_PREFIX, bytes));
    const pk = _address.decodeAddress(addr).publicKey;
    return _naclWrappers.verify(toBeVerified, signature, pk);
}
function encodeObj(o) {
    return new Uint8Array(_encoding.encode(o));
}
function decodeObj(o) {
    return _encoding.decode(o);
}
const ERROR_MULTISIG_BAD_SENDER = new Error(MULTISIG_BAD_SENDER_ERROR_MSG);
const ERROR_INVALID_MICROALGOS = new Error(_convert.INVALID_MICROALGOS_ERROR_MSG);

},{"buffer":"jlSk7","./nacl/naclWrappers":"hIiu2","./encoding/address":"7lw2f","./encoding/encoding":"1Yg70","./transaction":"1n32l","./bid":"kz1L0","./convert":"29i3t","./utils/utils":"izzsC","./client/v2/algod/algod":"6wbp5","./client/kmd":"l0X2i","./types/intDecoding":"bwLkl","./client/v2/indexer/indexer":"dlJxD","./wait":"lIpq2","./encoding/bigint":"1CIMA","./encoding/uint64":"aZ6qP","./account":"8hjV7","./client/v2/algod/models/types":"5YZy0","./client/v2/indexer/models/types":"glILl","./mnemonic/mnemonic":"hBqyO","./group":"7ZBIn","./logicsig":"3OHRO","./multisig":"lw3S9","./logic/sourcemap":"kOmkQ","./dryrun":"dZxpY","./makeTxn":"hBsla","./signer":"dp7CF","./composer":"k3NTg","./types":"dMWK6","./abi":"jd344","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlSk7":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("78ca804f65ced86c");
const ieee754 = require("3b48bc532cba47e6");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"78ca804f65ced86c":"6Pb1S","3b48bc532cba47e6":"6ifNR"}],"hIiu2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genericHash", ()=>genericHash);
parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
parcelHelpers.export(exports, "keyPairFromSeed", ()=>keyPairFromSeed);
parcelHelpers.export(exports, "keyPair", ()=>keyPair);
parcelHelpers.export(exports, "isValidSignatureLength", ()=>isValidSignatureLength);
parcelHelpers.export(exports, "keyPairFromSecretKey", ()=>keyPairFromSecretKey);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "bytesEqual", ()=>bytesEqual);
parcelHelpers.export(exports, "verify", ()=>verify);
parcelHelpers.export(exports, "PUBLIC_KEY_LENGTH", ()=>PUBLIC_KEY_LENGTH);
parcelHelpers.export(exports, "SECRET_KEY_LENGTH", ()=>SECRET_KEY_LENGTH);
parcelHelpers.export(exports, "HASH_BYTES_LENGTH", ()=>HASH_BYTES_LENGTH);
parcelHelpers.export(exports, "SEED_BTYES_LENGTH", ()=>SEED_BTYES_LENGTH);
var _tweetnacl = require("tweetnacl");
var _tweetnaclDefault = parcelHelpers.interopDefault(_tweetnacl);
var _jsSha512 = require("js-sha512");
var _jsSha512Default = parcelHelpers.interopDefault(_jsSha512);
function genericHash(arr) {
    return (0, _jsSha512Default.default).sha512_256.array(arr);
}
function randomBytes(length) {
    return (0, _tweetnaclDefault.default).randomBytes(length);
}
function keyPairFromSeed(seed) {
    return (0, _tweetnaclDefault.default).sign.keyPair.fromSeed(seed);
}
function keyPair() {
    const seed = randomBytes((0, _tweetnaclDefault.default).box.secretKeyLength);
    return keyPairFromSeed(seed);
}
function isValidSignatureLength(len) {
    return len === (0, _tweetnaclDefault.default).sign.signatureLength;
}
function keyPairFromSecretKey(sk) {
    return (0, _tweetnaclDefault.default).sign.keyPair.fromSecretKey(sk);
}
function sign(msg, secretKey) {
    return (0, _tweetnaclDefault.default).sign.detached(msg, secretKey);
}
function bytesEqual(a, b) {
    return (0, _tweetnaclDefault.default).verify(a, b);
}
function verify(message, signature, verifyKey) {
    return (0, _tweetnaclDefault.default).sign.detached.verify(message, signature, verifyKey);
}
const PUBLIC_KEY_LENGTH = (0, _tweetnaclDefault.default).sign.publicKeyLength;
const SECRET_KEY_LENGTH = (0, _tweetnaclDefault.default).sign.secretKeyLength;
const HASH_BYTES_LENGTH = 32;
const SEED_BTYES_LENGTH = 32;

},{"tweetnacl":"5I6xv","js-sha512":"c2Q99","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5I6xv":[function(require,module,exports) {
(function(nacl) {
    "use strict";
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = require("64deaebb838d47b8");
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

},{"64deaebb838d47b8":"13Pcp"}],"c2Q99":[function(require,module,exports) {
var process = require("e419cd92b0e74748");
var global = arguments[3];
/*
 * [js-sha512]{@link https://github.com/emn178/js-sha512}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA512_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA512_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA512_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428A2F98,
        0xD728AE22,
        0x71374491,
        0x23EF65CD,
        0xB5C0FBCF,
        0xEC4D3B2F,
        0xE9B5DBA5,
        0x8189DBBC,
        0x3956C25B,
        0xF348B538,
        0x59F111F1,
        0xB605D019,
        0x923F82A4,
        0xAF194F9B,
        0xAB1C5ED5,
        0xDA6D8118,
        0xD807AA98,
        0xA3030242,
        0x12835B01,
        0x45706FBE,
        0x243185BE,
        0x4EE4B28C,
        0x550C7DC3,
        0xD5FFB4E2,
        0x72BE5D74,
        0xF27B896F,
        0x80DEB1FE,
        0x3B1696B1,
        0x9BDC06A7,
        0x25C71235,
        0xC19BF174,
        0xCF692694,
        0xE49B69C1,
        0x9EF14AD2,
        0xEFBE4786,
        0x384F25E3,
        0x0FC19DC6,
        0x8B8CD5B5,
        0x240CA1CC,
        0x77AC9C65,
        0x2DE92C6F,
        0x592B0275,
        0x4A7484AA,
        0x6EA6E483,
        0x5CB0A9DC,
        0xBD41FBD4,
        0x76F988DA,
        0x831153B5,
        0x983E5152,
        0xEE66DFAB,
        0xA831C66D,
        0x2DB43210,
        0xB00327C8,
        0x98FB213F,
        0xBF597FC7,
        0xBEEF0EE4,
        0xC6E00BF3,
        0x3DA88FC2,
        0xD5A79147,
        0x930AA725,
        0x06CA6351,
        0xE003826F,
        0x14292967,
        0x0A0E6E70,
        0x27B70A85,
        0x46D22FFC,
        0x2E1B2138,
        0x5C26C926,
        0x4D2C6DFC,
        0x5AC42AED,
        0x53380D13,
        0x9D95B3DF,
        0x650A7354,
        0x8BAF63DE,
        0x766A0ABB,
        0x3C77B2A8,
        0x81C2C92E,
        0x47EDAEE6,
        0x92722C85,
        0x1482353B,
        0xA2BFE8A1,
        0x4CF10364,
        0xA81A664B,
        0xBC423001,
        0xC24B8B70,
        0xD0F89791,
        0xC76C51A3,
        0x0654BE30,
        0xD192E819,
        0xD6EF5218,
        0xD6990624,
        0x5565A910,
        0xF40E3585,
        0x5771202A,
        0x106AA070,
        0x32BBD1B8,
        0x19A4C116,
        0xB8D2D0C8,
        0x1E376C08,
        0x5141AB53,
        0x2748774C,
        0xDF8EEB99,
        0x34B0BCB5,
        0xE19B48A8,
        0x391C0CB3,
        0xC5C95A63,
        0x4ED8AA4A,
        0xE3418ACB,
        0x5B9CCA4F,
        0x7763E373,
        0x682E6FF3,
        0xD6B2B8A3,
        0x748F82EE,
        0x5DEFB2FC,
        0x78A5636F,
        0x43172F60,
        0x84C87814,
        0xA1F0AB72,
        0x8CC70208,
        0x1A6439EC,
        0x90BEFFFA,
        0x23631E28,
        0xA4506CEB,
        0xDE82BDE9,
        0xBEF9A3F7,
        0xB2C67915,
        0xC67178F2,
        0xE372532B,
        0xCA273ECE,
        0xEA26619C,
        0xD186B8C7,
        0x21C0C207,
        0xEADA7DD6,
        0xCDE0EB1E,
        0xF57D4F7F,
        0xEE6ED178,
        0x06F067AA,
        0x72176FBA,
        0x0A637DC5,
        0xA2C898A6,
        0x113F9804,
        0xBEF90DAE,
        0x1B710B35,
        0x131C471B,
        0x28DB77F5,
        0x23047D84,
        0x32CAAB7B,
        0x40C72493,
        0x3C9EBE0A,
        0x15C9BEBC,
        0x431D67C4,
        0x9C100D4C,
        0x4CC5D4BE,
        0xCB3E42B6,
        0x597F299C,
        0xFC657E2A,
        0x5FCB6FAB,
        0x3AD6FAEC,
        0x6C44198C,
        0x4A475817
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA512_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, bits) {
        return function(message) {
            return new Sha512(bits, true).update(message)[outputType]();
        };
    };
    var createMethod = function(bits) {
        var method = createOutputMethod("hex", bits);
        method.create = function() {
            return new Sha512(bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, bits);
        }
        return method;
    };
    var createHmacOutputMethod = function(outputType, bits) {
        return function(key, message) {
            return new HmacSha512(key, bits, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(bits) {
        var method = createHmacOutputMethod("hex", bits);
        method.create = function(key) {
            return new HmacSha512(key, bits);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, bits);
        }
        return method;
    };
    function Sha512(bits, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (bits == 384) {
            this.h0h = 0xCBBB9D5D;
            this.h0l = 0xC1059ED8;
            this.h1h = 0x629A292A;
            this.h1l = 0x367CD507;
            this.h2h = 0x9159015A;
            this.h2l = 0x3070DD17;
            this.h3h = 0x152FECD8;
            this.h3l = 0xF70E5939;
            this.h4h = 0x67332667;
            this.h4l = 0xFFC00B31;
            this.h5h = 0x8EB44A87;
            this.h5l = 0x68581511;
            this.h6h = 0xDB0C2E0D;
            this.h6l = 0x64F98FA7;
            this.h7h = 0x47B5481D;
            this.h7l = 0xBEFA4FA4;
        } else if (bits == 256) {
            this.h0h = 0x22312194;
            this.h0l = 0xFC2BF72C;
            this.h1h = 0x9F555FA3;
            this.h1l = 0xC84C64C2;
            this.h2h = 0x2393B86B;
            this.h2l = 0x6F53B151;
            this.h3h = 0x96387719;
            this.h3l = 0x5940EABD;
            this.h4h = 0x96283EE2;
            this.h4l = 0xA88EFFE3;
            this.h5h = 0xBE5E1E25;
            this.h5l = 0x53863992;
            this.h6h = 0x2B0199FC;
            this.h6l = 0x2C85B8AA;
            this.h7h = 0x0EB72DDC;
            this.h7l = 0x81C52CA2;
        } else if (bits == 224) {
            this.h0h = 0x8C3D37C8;
            this.h0l = 0x19544DA2;
            this.h1h = 0x73E19966;
            this.h1l = 0x89DCD4D6;
            this.h2h = 0x1DFAB7AE;
            this.h2l = 0x32FF9C82;
            this.h3h = 0x679DD514;
            this.h3l = 0x582F9FCF;
            this.h4h = 0x0F6D2B69;
            this.h4l = 0x7BD44DA8;
            this.h5h = 0x77E36F73;
            this.h5l = 0x04C48942;
            this.h6h = 0x3F9D85A8;
            this.h6l = 0x6A1D36C8;
            this.h7h = 0x1112E6AD;
            this.h7l = 0x91D692A1;
        } else {
            this.h0h = 0x6A09E667;
            this.h0l = 0xF3BCC908;
            this.h1h = 0xBB67AE85;
            this.h1l = 0x84CAA73B;
            this.h2h = 0x3C6EF372;
            this.h2l = 0xFE94F82B;
            this.h3h = 0xA54FF53A;
            this.h3l = 0x5F1D36F1;
            this.h4h = 0x510E527F;
            this.h4l = 0xADE682D1;
            this.h5h = 0x9B05688C;
            this.h5l = 0x2B3E6C1F;
            this.h6h = 0x1F83D9AB;
            this.h6l = 0xFB41BD6B;
            this.h7h = 0x5BE0CD19;
            this.h7l = 0x137E2179;
        }
        this.bits = bits;
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
    }
    Sha512.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 128; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 128; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 128) {
                this.block = blocks[32];
                this.start = i - 128;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha512.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[32] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[32];
        if (i >= 112) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
        }
        blocks[30] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[31] = this.bytes << 3;
        this.hash();
    };
    Sha512.prototype.hash = function() {
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, blocks = this.blocks, j, s0h, s0l, s1h, s1l, c1, c2, c3, c4, abh, abl, dah, dal, cdh, cdl, bch, bcl, majh, majl, t1h, t1l, t2h, t2l, chh, chl;
        for(j = 32; j < 160; j += 2){
            t1h = blocks[j - 30];
            t1l = blocks[j - 29];
            s0h = (t1h >>> 1 | t1l << 31) ^ (t1h >>> 8 | t1l << 24) ^ t1h >>> 7;
            s0l = (t1l >>> 1 | t1h << 31) ^ (t1l >>> 8 | t1h << 24) ^ (t1l >>> 7 | t1h << 25);
            t1h = blocks[j - 4];
            t1l = blocks[j - 3];
            s1h = (t1h >>> 19 | t1l << 13) ^ (t1l >>> 29 | t1h << 3) ^ t1h >>> 6;
            s1l = (t1l >>> 19 | t1h << 13) ^ (t1h >>> 29 | t1l << 3) ^ (t1l >>> 6 | t1h << 26);
            t1h = blocks[j - 32];
            t1l = blocks[j - 31];
            t2h = blocks[j - 14];
            t2l = blocks[j - 13];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (s0l & 0xFFFF) + (s1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (s0l >>> 16) + (s1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (s0h & 0xFFFF) + (s1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (s0h >>> 16) + (s1h >>> 16) + (c3 >>> 16);
            blocks[j] = c4 << 16 | c3 & 0xFFFF;
            blocks[j + 1] = c2 << 16 | c1 & 0xFFFF;
        }
        var ah = h0h, al = h0l, bh = h1h, bl = h1l, ch = h2h, cl = h2l, dh = h3h, dl = h3l, eh = h4h, el = h4l, fh = h5h, fl = h5l, gh = h6h, gl = h6l, hh = h7h, hl = h7l;
        bch = bh & ch;
        bcl = bl & cl;
        for(j = 0; j < 160; j += 8){
            s0h = (ah >>> 28 | al << 4) ^ (al >>> 2 | ah << 30) ^ (al >>> 7 | ah << 25);
            s0l = (al >>> 28 | ah << 4) ^ (ah >>> 2 | al << 30) ^ (ah >>> 7 | al << 25);
            s1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (el >>> 9 | eh << 23);
            s1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (eh >>> 9 | el << 23);
            abh = ah & bh;
            abl = al & bl;
            majh = abh ^ ah & ch ^ bch;
            majl = abl ^ al & cl ^ bcl;
            chh = eh & fh ^ ~eh & gh;
            chl = el & fl ^ ~el & gl;
            t1h = blocks[j];
            t1l = blocks[j + 1];
            t2h = K[j];
            t2l = K[j + 1];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (hl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (hl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (hh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (dl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (dl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (dh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (dh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            hh = c4 << 16 | c3 & 0xFFFF;
            hl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            dh = c4 << 16 | c3 & 0xFFFF;
            dl = c2 << 16 | c1 & 0xFFFF;
            s0h = (dh >>> 28 | dl << 4) ^ (dl >>> 2 | dh << 30) ^ (dl >>> 7 | dh << 25);
            s0l = (dl >>> 28 | dh << 4) ^ (dh >>> 2 | dl << 30) ^ (dh >>> 7 | dl << 25);
            s1h = (hh >>> 14 | hl << 18) ^ (hh >>> 18 | hl << 14) ^ (hl >>> 9 | hh << 23);
            s1l = (hl >>> 14 | hh << 18) ^ (hl >>> 18 | hh << 14) ^ (hh >>> 9 | hl << 23);
            dah = dh & ah;
            dal = dl & al;
            majh = dah ^ dh & bh ^ abh;
            majl = dal ^ dl & bl ^ abl;
            chh = hh & eh ^ ~hh & fh;
            chl = hl & el ^ ~hl & fl;
            t1h = blocks[j + 2];
            t1l = blocks[j + 3];
            t2h = K[j + 2];
            t2l = K[j + 3];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (gl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (gl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (gh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (cl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (cl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (ch & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (ch >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            gh = c4 << 16 | c3 & 0xFFFF;
            gl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            ch = c4 << 16 | c3 & 0xFFFF;
            cl = c2 << 16 | c1 & 0xFFFF;
            s0h = (ch >>> 28 | cl << 4) ^ (cl >>> 2 | ch << 30) ^ (cl >>> 7 | ch << 25);
            s0l = (cl >>> 28 | ch << 4) ^ (ch >>> 2 | cl << 30) ^ (ch >>> 7 | cl << 25);
            s1h = (gh >>> 14 | gl << 18) ^ (gh >>> 18 | gl << 14) ^ (gl >>> 9 | gh << 23);
            s1l = (gl >>> 14 | gh << 18) ^ (gl >>> 18 | gh << 14) ^ (gh >>> 9 | gl << 23);
            cdh = ch & dh;
            cdl = cl & dl;
            majh = cdh ^ ch & ah ^ dah;
            majl = cdl ^ cl & al ^ dal;
            chh = gh & hh ^ ~gh & eh;
            chl = gl & hl ^ ~gl & el;
            t1h = blocks[j + 4];
            t1l = blocks[j + 5];
            t2h = K[j + 4];
            t2l = K[j + 5];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (fl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (fl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (fh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (bl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (bl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (bh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (bh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            fh = c4 << 16 | c3 & 0xFFFF;
            fl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            bh = c4 << 16 | c3 & 0xFFFF;
            bl = c2 << 16 | c1 & 0xFFFF;
            s0h = (bh >>> 28 | bl << 4) ^ (bl >>> 2 | bh << 30) ^ (bl >>> 7 | bh << 25);
            s0l = (bl >>> 28 | bh << 4) ^ (bh >>> 2 | bl << 30) ^ (bh >>> 7 | bl << 25);
            s1h = (fh >>> 14 | fl << 18) ^ (fh >>> 18 | fl << 14) ^ (fl >>> 9 | fh << 23);
            s1l = (fl >>> 14 | fh << 18) ^ (fl >>> 18 | fh << 14) ^ (fh >>> 9 | fl << 23);
            bch = bh & ch;
            bcl = bl & cl;
            majh = bch ^ bh & dh ^ cdh;
            majl = bcl ^ bl & dl ^ cdl;
            chh = fh & gh ^ ~fh & hh;
            chl = fl & gl ^ ~fl & hl;
            t1h = blocks[j + 6];
            t1l = blocks[j + 7];
            t2h = K[j + 6];
            t2l = K[j + 7];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (el & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (el >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (eh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (al & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (al >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (ah & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (ah >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            eh = c4 << 16 | c3 & 0xFFFF;
            el = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            ah = c4 << 16 | c3 & 0xFFFF;
            al = c2 << 16 | c1 & 0xFFFF;
        }
        c1 = (h0l & 0xFFFF) + (al & 0xFFFF);
        c2 = (h0l >>> 16) + (al >>> 16) + (c1 >>> 16);
        c3 = (h0h & 0xFFFF) + (ah & 0xFFFF) + (c2 >>> 16);
        c4 = (h0h >>> 16) + (ah >>> 16) + (c3 >>> 16);
        this.h0h = c4 << 16 | c3 & 0xFFFF;
        this.h0l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h1l & 0xFFFF) + (bl & 0xFFFF);
        c2 = (h1l >>> 16) + (bl >>> 16) + (c1 >>> 16);
        c3 = (h1h & 0xFFFF) + (bh & 0xFFFF) + (c2 >>> 16);
        c4 = (h1h >>> 16) + (bh >>> 16) + (c3 >>> 16);
        this.h1h = c4 << 16 | c3 & 0xFFFF;
        this.h1l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h2l & 0xFFFF) + (cl & 0xFFFF);
        c2 = (h2l >>> 16) + (cl >>> 16) + (c1 >>> 16);
        c3 = (h2h & 0xFFFF) + (ch & 0xFFFF) + (c2 >>> 16);
        c4 = (h2h >>> 16) + (ch >>> 16) + (c3 >>> 16);
        this.h2h = c4 << 16 | c3 & 0xFFFF;
        this.h2l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h3l & 0xFFFF) + (dl & 0xFFFF);
        c2 = (h3l >>> 16) + (dl >>> 16) + (c1 >>> 16);
        c3 = (h3h & 0xFFFF) + (dh & 0xFFFF) + (c2 >>> 16);
        c4 = (h3h >>> 16) + (dh >>> 16) + (c3 >>> 16);
        this.h3h = c4 << 16 | c3 & 0xFFFF;
        this.h3l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h4l & 0xFFFF) + (el & 0xFFFF);
        c2 = (h4l >>> 16) + (el >>> 16) + (c1 >>> 16);
        c3 = (h4h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
        c4 = (h4h >>> 16) + (eh >>> 16) + (c3 >>> 16);
        this.h4h = c4 << 16 | c3 & 0xFFFF;
        this.h4l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h5l & 0xFFFF) + (fl & 0xFFFF);
        c2 = (h5l >>> 16) + (fl >>> 16) + (c1 >>> 16);
        c3 = (h5h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
        c4 = (h5h >>> 16) + (fh >>> 16) + (c3 >>> 16);
        this.h5h = c4 << 16 | c3 & 0xFFFF;
        this.h5l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h6l & 0xFFFF) + (gl & 0xFFFF);
        c2 = (h6l >>> 16) + (gl >>> 16) + (c1 >>> 16);
        c3 = (h6h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
        c4 = (h6h >>> 16) + (gh >>> 16) + (c3 >>> 16);
        this.h6h = c4 << 16 | c3 & 0xFFFF;
        this.h6l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h7l & 0xFFFF) + (hl & 0xFFFF);
        c2 = (h7l >>> 16) + (hl >>> 16) + (c1 >>> 16);
        c3 = (h7h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
        c4 = (h7h >>> 16) + (hh >>> 16) + (c3 >>> 16);
        this.h7h = c4 << 16 | c3 & 0xFFFF;
        this.h7l = c2 << 16 | c1 & 0xFFFF;
    };
    Sha512.prototype.hex = function() {
        this.finalize();
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, bits = this.bits;
        var hex = HEX_CHARS[h0h >> 28 & 0x0F] + HEX_CHARS[h0h >> 24 & 0x0F] + HEX_CHARS[h0h >> 20 & 0x0F] + HEX_CHARS[h0h >> 16 & 0x0F] + HEX_CHARS[h0h >> 12 & 0x0F] + HEX_CHARS[h0h >> 8 & 0x0F] + HEX_CHARS[h0h >> 4 & 0x0F] + HEX_CHARS[h0h & 0x0F] + HEX_CHARS[h0l >> 28 & 0x0F] + HEX_CHARS[h0l >> 24 & 0x0F] + HEX_CHARS[h0l >> 20 & 0x0F] + HEX_CHARS[h0l >> 16 & 0x0F] + HEX_CHARS[h0l >> 12 & 0x0F] + HEX_CHARS[h0l >> 8 & 0x0F] + HEX_CHARS[h0l >> 4 & 0x0F] + HEX_CHARS[h0l & 0x0F] + HEX_CHARS[h1h >> 28 & 0x0F] + HEX_CHARS[h1h >> 24 & 0x0F] + HEX_CHARS[h1h >> 20 & 0x0F] + HEX_CHARS[h1h >> 16 & 0x0F] + HEX_CHARS[h1h >> 12 & 0x0F] + HEX_CHARS[h1h >> 8 & 0x0F] + HEX_CHARS[h1h >> 4 & 0x0F] + HEX_CHARS[h1h & 0x0F] + HEX_CHARS[h1l >> 28 & 0x0F] + HEX_CHARS[h1l >> 24 & 0x0F] + HEX_CHARS[h1l >> 20 & 0x0F] + HEX_CHARS[h1l >> 16 & 0x0F] + HEX_CHARS[h1l >> 12 & 0x0F] + HEX_CHARS[h1l >> 8 & 0x0F] + HEX_CHARS[h1l >> 4 & 0x0F] + HEX_CHARS[h1l & 0x0F] + HEX_CHARS[h2h >> 28 & 0x0F] + HEX_CHARS[h2h >> 24 & 0x0F] + HEX_CHARS[h2h >> 20 & 0x0F] + HEX_CHARS[h2h >> 16 & 0x0F] + HEX_CHARS[h2h >> 12 & 0x0F] + HEX_CHARS[h2h >> 8 & 0x0F] + HEX_CHARS[h2h >> 4 & 0x0F] + HEX_CHARS[h2h & 0x0F] + HEX_CHARS[h2l >> 28 & 0x0F] + HEX_CHARS[h2l >> 24 & 0x0F] + HEX_CHARS[h2l >> 20 & 0x0F] + HEX_CHARS[h2l >> 16 & 0x0F] + HEX_CHARS[h2l >> 12 & 0x0F] + HEX_CHARS[h2l >> 8 & 0x0F] + HEX_CHARS[h2l >> 4 & 0x0F] + HEX_CHARS[h2l & 0x0F] + HEX_CHARS[h3h >> 28 & 0x0F] + HEX_CHARS[h3h >> 24 & 0x0F] + HEX_CHARS[h3h >> 20 & 0x0F] + HEX_CHARS[h3h >> 16 & 0x0F] + HEX_CHARS[h3h >> 12 & 0x0F] + HEX_CHARS[h3h >> 8 & 0x0F] + HEX_CHARS[h3h >> 4 & 0x0F] + HEX_CHARS[h3h & 0x0F];
        if (bits >= 256) hex += HEX_CHARS[h3l >> 28 & 0x0F] + HEX_CHARS[h3l >> 24 & 0x0F] + HEX_CHARS[h3l >> 20 & 0x0F] + HEX_CHARS[h3l >> 16 & 0x0F] + HEX_CHARS[h3l >> 12 & 0x0F] + HEX_CHARS[h3l >> 8 & 0x0F] + HEX_CHARS[h3l >> 4 & 0x0F] + HEX_CHARS[h3l & 0x0F];
        if (bits >= 384) hex += HEX_CHARS[h4h >> 28 & 0x0F] + HEX_CHARS[h4h >> 24 & 0x0F] + HEX_CHARS[h4h >> 20 & 0x0F] + HEX_CHARS[h4h >> 16 & 0x0F] + HEX_CHARS[h4h >> 12 & 0x0F] + HEX_CHARS[h4h >> 8 & 0x0F] + HEX_CHARS[h4h >> 4 & 0x0F] + HEX_CHARS[h4h & 0x0F] + HEX_CHARS[h4l >> 28 & 0x0F] + HEX_CHARS[h4l >> 24 & 0x0F] + HEX_CHARS[h4l >> 20 & 0x0F] + HEX_CHARS[h4l >> 16 & 0x0F] + HEX_CHARS[h4l >> 12 & 0x0F] + HEX_CHARS[h4l >> 8 & 0x0F] + HEX_CHARS[h4l >> 4 & 0x0F] + HEX_CHARS[h4l & 0x0F] + HEX_CHARS[h5h >> 28 & 0x0F] + HEX_CHARS[h5h >> 24 & 0x0F] + HEX_CHARS[h5h >> 20 & 0x0F] + HEX_CHARS[h5h >> 16 & 0x0F] + HEX_CHARS[h5h >> 12 & 0x0F] + HEX_CHARS[h5h >> 8 & 0x0F] + HEX_CHARS[h5h >> 4 & 0x0F] + HEX_CHARS[h5h & 0x0F] + HEX_CHARS[h5l >> 28 & 0x0F] + HEX_CHARS[h5l >> 24 & 0x0F] + HEX_CHARS[h5l >> 20 & 0x0F] + HEX_CHARS[h5l >> 16 & 0x0F] + HEX_CHARS[h5l >> 12 & 0x0F] + HEX_CHARS[h5l >> 8 & 0x0F] + HEX_CHARS[h5l >> 4 & 0x0F] + HEX_CHARS[h5l & 0x0F];
        if (bits == 512) hex += HEX_CHARS[h6h >> 28 & 0x0F] + HEX_CHARS[h6h >> 24 & 0x0F] + HEX_CHARS[h6h >> 20 & 0x0F] + HEX_CHARS[h6h >> 16 & 0x0F] + HEX_CHARS[h6h >> 12 & 0x0F] + HEX_CHARS[h6h >> 8 & 0x0F] + HEX_CHARS[h6h >> 4 & 0x0F] + HEX_CHARS[h6h & 0x0F] + HEX_CHARS[h6l >> 28 & 0x0F] + HEX_CHARS[h6l >> 24 & 0x0F] + HEX_CHARS[h6l >> 20 & 0x0F] + HEX_CHARS[h6l >> 16 & 0x0F] + HEX_CHARS[h6l >> 12 & 0x0F] + HEX_CHARS[h6l >> 8 & 0x0F] + HEX_CHARS[h6l >> 4 & 0x0F] + HEX_CHARS[h6l & 0x0F] + HEX_CHARS[h7h >> 28 & 0x0F] + HEX_CHARS[h7h >> 24 & 0x0F] + HEX_CHARS[h7h >> 20 & 0x0F] + HEX_CHARS[h7h >> 16 & 0x0F] + HEX_CHARS[h7h >> 12 & 0x0F] + HEX_CHARS[h7h >> 8 & 0x0F] + HEX_CHARS[h7h >> 4 & 0x0F] + HEX_CHARS[h7h & 0x0F] + HEX_CHARS[h7l >> 28 & 0x0F] + HEX_CHARS[h7l >> 24 & 0x0F] + HEX_CHARS[h7l >> 20 & 0x0F] + HEX_CHARS[h7l >> 16 & 0x0F] + HEX_CHARS[h7l >> 12 & 0x0F] + HEX_CHARS[h7l >> 8 & 0x0F] + HEX_CHARS[h7l >> 4 & 0x0F] + HEX_CHARS[h7l & 0x0F];
        return hex;
    };
    Sha512.prototype.toString = Sha512.prototype.hex;
    Sha512.prototype.digest = function() {
        this.finalize();
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, bits = this.bits;
        var arr = [
            h0h >> 24 & 0xFF,
            h0h >> 16 & 0xFF,
            h0h >> 8 & 0xFF,
            h0h & 0xFF,
            h0l >> 24 & 0xFF,
            h0l >> 16 & 0xFF,
            h0l >> 8 & 0xFF,
            h0l & 0xFF,
            h1h >> 24 & 0xFF,
            h1h >> 16 & 0xFF,
            h1h >> 8 & 0xFF,
            h1h & 0xFF,
            h1l >> 24 & 0xFF,
            h1l >> 16 & 0xFF,
            h1l >> 8 & 0xFF,
            h1l & 0xFF,
            h2h >> 24 & 0xFF,
            h2h >> 16 & 0xFF,
            h2h >> 8 & 0xFF,
            h2h & 0xFF,
            h2l >> 24 & 0xFF,
            h2l >> 16 & 0xFF,
            h2l >> 8 & 0xFF,
            h2l & 0xFF,
            h3h >> 24 & 0xFF,
            h3h >> 16 & 0xFF,
            h3h >> 8 & 0xFF,
            h3h & 0xFF
        ];
        if (bits >= 256) arr.push(h3l >> 24 & 0xFF, h3l >> 16 & 0xFF, h3l >> 8 & 0xFF, h3l & 0xFF);
        if (bits >= 384) arr.push(h4h >> 24 & 0xFF, h4h >> 16 & 0xFF, h4h >> 8 & 0xFF, h4h & 0xFF, h4l >> 24 & 0xFF, h4l >> 16 & 0xFF, h4l >> 8 & 0xFF, h4l & 0xFF, h5h >> 24 & 0xFF, h5h >> 16 & 0xFF, h5h >> 8 & 0xFF, h5h & 0xFF, h5l >> 24 & 0xFF, h5l >> 16 & 0xFF, h5l >> 8 & 0xFF, h5l & 0xFF);
        if (bits == 512) arr.push(h6h >> 24 & 0xFF, h6h >> 16 & 0xFF, h6h >> 8 & 0xFF, h6h & 0xFF, h6l >> 24 & 0xFF, h6l >> 16 & 0xFF, h6l >> 8 & 0xFF, h6l & 0xFF, h7h >> 24 & 0xFF, h7h >> 16 & 0xFF, h7h >> 8 & 0xFF, h7h & 0xFF, h7l >> 24 & 0xFF, h7l >> 16 & 0xFF, h7l >> 8 & 0xFF, h7l & 0xFF);
        return arr;
    };
    Sha512.prototype.array = Sha512.prototype.digest;
    Sha512.prototype.arrayBuffer = function() {
        this.finalize();
        var bits = this.bits;
        var buffer = new ArrayBuffer(bits / 8);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0h);
        dataView.setUint32(4, this.h0l);
        dataView.setUint32(8, this.h1h);
        dataView.setUint32(12, this.h1l);
        dataView.setUint32(16, this.h2h);
        dataView.setUint32(20, this.h2l);
        dataView.setUint32(24, this.h3h);
        if (bits >= 256) dataView.setUint32(28, this.h3l);
        if (bits >= 384) {
            dataView.setUint32(32, this.h4h);
            dataView.setUint32(36, this.h4l);
            dataView.setUint32(40, this.h5h);
            dataView.setUint32(44, this.h5l);
        }
        if (bits == 512) {
            dataView.setUint32(48, this.h6h);
            dataView.setUint32(52, this.h6l);
            dataView.setUint32(56, this.h7h);
            dataView.setUint32(60, this.h7l);
        }
        return buffer;
    };
    Sha512.prototype.clone = function() {
        var hash = new Sha512(this.bits, false);
        this.copyTo(hash);
        return hash;
    };
    Sha512.prototype.copyTo = function(hash) {
        var i = 0, attrs = [
            "h0h",
            "h0l",
            "h1h",
            "h1l",
            "h2h",
            "h2l",
            "h3h",
            "h3l",
            "h4h",
            "h4l",
            "h5h",
            "h5l",
            "h6h",
            "h6l",
            "h7h",
            "h7l",
            "start",
            "bytes",
            "hBytes",
            "finalized",
            "hashed",
            "lastByteIndex"
        ];
        for(i = 0; i < attrs.length; ++i)hash[attrs[i]] = this[attrs[i]];
        for(i = 0; i < this.blocks.length; ++i)hash.blocks[i] = this.blocks[i];
    };
    function HmacSha512(key, bits, sharedMemory) {
        var notString, type = typeof key;
        if (type !== "string") {
            if (type === "object") {
                if (key === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var length = key.length;
        if (!notString) {
            var bytes = [], length = key.length, index = 0, code;
            for(var i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        }
        if (key.length > 128) key = new Sha512(bits, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(var i = 0; i < 128; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha512.call(this, bits, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha512.prototype = new Sha512();
    HmacSha512.prototype.finalize = function() {
        Sha512.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha512.call(this, this.bits, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha512.prototype.finalize.call(this);
        }
    };
    HmacSha512.prototype.clone = function() {
        var hash = new HmacSha512([], this.bits, false);
        this.copyTo(hash);
        hash.inner = this.inner;
        for(var i = 0; i < this.oKeyPad.length; ++i)hash.oKeyPad[i] = this.oKeyPad[i];
        return hash;
    };
    var exports = createMethod(512);
    exports.sha512 = exports;
    exports.sha384 = createMethod(384);
    exports.sha512_256 = createMethod(256);
    exports.sha512_224 = createMethod(224);
    exports.sha512.hmac = createHmacMethod(512);
    exports.sha384.hmac = createHmacMethod(384);
    exports.sha512_256.hmac = createHmacMethod(256);
    exports.sha512_224.hmac = createHmacMethod(224);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha512 = exports.sha512;
        root.sha384 = exports.sha384;
        root.sha512_256 = exports.sha512_256;
        root.sha512_224 = exports.sha512_224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

},{"e419cd92b0e74748":"13Pcp"}],"7lw2f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORAND_ZERO_ADDRESS_STRING", ()=>ALGORAND_ZERO_ADDRESS_STRING);
parcelHelpers.export(exports, "MALFORMED_ADDRESS_ERROR_MSG", ()=>MALFORMED_ADDRESS_ERROR_MSG);
parcelHelpers.export(exports, "CHECKSUM_ADDRESS_ERROR_MSG", ()=>CHECKSUM_ADDRESS_ERROR_MSG);
parcelHelpers.export(exports, "INVALID_MSIG_VERSION_ERROR_MSG", ()=>INVALID_MSIG_VERSION_ERROR_MSG);
parcelHelpers.export(exports, "INVALID_MSIG_THRESHOLD_ERROR_MSG", ()=>INVALID_MSIG_THRESHOLD_ERROR_MSG);
parcelHelpers.export(exports, "INVALID_MSIG_PK_ERROR_MSG", ()=>INVALID_MSIG_PK_ERROR_MSG);
parcelHelpers.export(exports, "UNEXPECTED_PK_LEN_ERROR_MSG", ()=>UNEXPECTED_PK_LEN_ERROR_MSG);
/**
 * decodeAddress takes an Algorand address in string form and decodes it into a Uint8Array.
 * @param address - an Algorand address with checksum.
 * @returns the decoded form of the address's public key and checksum
 */ parcelHelpers.export(exports, "decodeAddress", ()=>decodeAddress);
/**
 * isValidAddress checks if a string is a valid Algorand address.
 * @param address - an Algorand address with checksum.
 * @returns true if valid, false otherwise
 */ parcelHelpers.export(exports, "isValidAddress", ()=>isValidAddress);
/**
 * encodeAddress takes an Algorand address as a Uint8Array and encodes it into a string with checksum.
 * @param address - a raw Algorand address
 * @returns the address and checksum encoded as a string.
 */ parcelHelpers.export(exports, "encodeAddress", ()=>encodeAddress);
/**
 * fromMultisigPreImg takes multisig parameters and returns a 32 byte typed array public key,
 * representing an address that identifies the "exact group, version, and public keys" that are required for signing.
 * Hash("MultisigAddr" || version uint8 || threshold uint8 || PK1 || PK2 || ...)
 * Encoding this output yields a human readable address.
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param pks - array of typed array public keys
 */ parcelHelpers.export(exports, "fromMultisigPreImg", ()=>fromMultisigPreImg);
/**
 * fromMultisigPreImgAddrs takes multisig parameters and returns a human readable Algorand address.
 * This is equivalent to fromMultisigPreImg, but interfaces with encoded addresses.
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param addrs - array of encoded addresses
 */ parcelHelpers.export(exports, "fromMultisigPreImgAddrs", ()=>fromMultisigPreImgAddrs);
/**
 * Get the escrow address of an application.
 * @param appID - The ID of the application.
 * @returns The address corresponding to that application's escrow account.
 */ parcelHelpers.export(exports, "getApplicationAddress", ()=>getApplicationAddress);
var _buffer = require("buffer");
var _hiBase32 = require("hi-base32");
var _hiBase32Default = parcelHelpers.interopDefault(_hiBase32);
var _naclWrappers = require("../nacl/naclWrappers");
var _utils = require("../utils/utils");
var _uint64 = require("./uint64");
const ALGORAND_ADDRESS_BYTE_LENGTH = 36;
const ALGORAND_CHECKSUM_BYTE_LENGTH = 4;
const ALGORAND_ADDRESS_LENGTH = 58;
const ALGORAND_ZERO_ADDRESS_STRING = "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY5HFKQ";
// Convert "MultisigAddr" UTF-8 to byte array
const MULTISIG_PREIMG2ADDR_PREFIX = new Uint8Array([
    77,
    117,
    108,
    116,
    105,
    115,
    105,
    103,
    65,
    100,
    100,
    114
]);
const APP_ID_PREFIX = (0, _buffer.Buffer).from("appID");
const MALFORMED_ADDRESS_ERROR_MSG = "address seems to be malformed";
const CHECKSUM_ADDRESS_ERROR_MSG = "wrong checksum for address";
const INVALID_MSIG_VERSION_ERROR_MSG = "invalid multisig version";
const INVALID_MSIG_THRESHOLD_ERROR_MSG = "bad multisig threshold";
const INVALID_MSIG_PK_ERROR_MSG = "bad multisig public key - wrong length";
const UNEXPECTED_PK_LEN_ERROR_MSG = "nacl public key length is not 32 bytes";
function decodeAddress(address) {
    if (typeof address !== "string" || address.length !== ALGORAND_ADDRESS_LENGTH) throw new Error(MALFORMED_ADDRESS_ERROR_MSG);
    // try to decode
    const decoded = (0, _hiBase32Default.default).decode.asBytes(address.toString());
    // Sanity check
    if (decoded.length !== ALGORAND_ADDRESS_BYTE_LENGTH) throw new Error(MALFORMED_ADDRESS_ERROR_MSG);
    // Find publickey and checksum
    const pk = new Uint8Array(decoded.slice(0, ALGORAND_ADDRESS_BYTE_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH));
    const cs = new Uint8Array(decoded.slice(_naclWrappers.PUBLIC_KEY_LENGTH, ALGORAND_ADDRESS_BYTE_LENGTH));
    // Compute checksum
    const checksum = _naclWrappers.genericHash(pk).slice(_naclWrappers.HASH_BYTES_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH, _naclWrappers.HASH_BYTES_LENGTH);
    // Check if the checksum and the address are equal
    if (!_utils.arrayEqual(checksum, cs)) throw new Error(CHECKSUM_ADDRESS_ERROR_MSG);
    return {
        publicKey: pk,
        checksum: cs
    };
}
function isValidAddress(address) {
    // Try to decode
    try {
        decodeAddress(address);
    } catch (e) {
        return false;
    }
    return true;
}
function encodeAddress(address) {
    // compute checksum
    const checksum = _naclWrappers.genericHash(address).slice(_naclWrappers.PUBLIC_KEY_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH, _naclWrappers.PUBLIC_KEY_LENGTH);
    const addr = (0, _hiBase32Default.default).encode(_utils.concatArrays(address, checksum));
    return addr.toString().slice(0, ALGORAND_ADDRESS_LENGTH); // removing the extra '===='
}
function fromMultisigPreImg({ version , threshold , pks  }) {
    if (version !== 1 || version > 255 || version < 0) // ^ a tad redundant, but in case in the future version != 1, still check for uint8
    throw new Error(INVALID_MSIG_VERSION_ERROR_MSG);
    if (threshold === 0 || pks.length === 0 || threshold > pks.length || threshold > 255) throw new Error(INVALID_MSIG_THRESHOLD_ERROR_MSG);
    const pkLen = ALGORAND_ADDRESS_BYTE_LENGTH - ALGORAND_CHECKSUM_BYTE_LENGTH;
    if (pkLen !== _naclWrappers.PUBLIC_KEY_LENGTH) throw new Error(UNEXPECTED_PK_LEN_ERROR_MSG);
    const merged = new Uint8Array(MULTISIG_PREIMG2ADDR_PREFIX.length + 2 + pkLen * pks.length);
    merged.set(MULTISIG_PREIMG2ADDR_PREFIX, 0);
    merged.set([
        version
    ], MULTISIG_PREIMG2ADDR_PREFIX.length);
    merged.set([
        threshold
    ], MULTISIG_PREIMG2ADDR_PREFIX.length + 1);
    for(let i = 0; i < pks.length; i++){
        if (pks[i].length !== pkLen) throw new Error(INVALID_MSIG_PK_ERROR_MSG);
        merged.set(pks[i], MULTISIG_PREIMG2ADDR_PREFIX.length + 2 + i * pkLen);
    }
    return new Uint8Array(_naclWrappers.genericHash(merged));
}
function fromMultisigPreImgAddrs({ version , threshold , addrs  }) {
    const pks = addrs.map((addr)=>decodeAddress(addr).publicKey);
    return encodeAddress(fromMultisigPreImg({
        version,
        threshold,
        pks
    }));
}
function getApplicationAddress(appID) {
    const toBeSigned = _utils.concatArrays(APP_ID_PREFIX, (0, _uint64.encodeUint64)(appID));
    const hash = _naclWrappers.genericHash(toBeSigned);
    return encodeAddress(new Uint8Array(hash));
}

},{"buffer":"jlSk7","hi-base32":"7wgAP","../nacl/naclWrappers":"hIiu2","../utils/utils":"izzsC","./uint64":"aZ6qP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wgAP":[function(require,module,exports) {
var process = require("de50b2bc6f02047c");
var global = arguments[3];
/*
 * [hi-base32]{@link https://github.com/emn178/hi-base32}
 *
 * @version 0.5.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var root = typeof window === "object" ? window : {};
    var NODE_JS = !root.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
    var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
    };
    var blocks = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var throwInvalidUtf8 = function(position, partial) {
        if (partial.length > 10) partial = "..." + partial.substr(-10);
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position + " bytes: " + partial + " <-");
        err.position = position;
        throw err;
    };
    var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i = 0, followingChars = 0, b, c;
        while(i < length){
            b = bytes[i++];
            if (b <= 0x7F) {
                str += String.fromCharCode(b);
                continue;
            } else if (b > 0xBF && b <= 0xDF) {
                c = b & 0x1F;
                followingChars = 1;
            } else if (b <= 0xEF) {
                c = b & 0x0F;
                followingChars = 2;
            } else if (b <= 0xF7) {
                c = b & 0x07;
                followingChars = 3;
            } else throwInvalidUtf8(i, str);
            for(var j = 0; j < followingChars; ++j){
                b = bytes[i++];
                if (b < 0x80 || b > 0xBF) throwInvalidUtf8(i, str);
                c <<= 6;
                c += b & 0x3F;
            }
            if (c >= 0xD800 && c <= 0xDFFF) throwInvalidUtf8(i, str);
            if (c > 0x10FFFF) throwInvalidUtf8(i, str);
            if (c <= 0xFFFF) str += String.fromCharCode(c);
            else {
                c -= 0x10000;
                str += String.fromCharCode((c >> 10) + 0xD800);
                str += String.fromCharCode((c & 0x3FF) + 0xDC00);
            }
        }
        return str;
    };
    var decodeAsBytes = function(base32Str) {
        if (base32Str === "") return [];
        else if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = base32Str.length;
        // 4 char to 3 bytes
        for(var i = 0, count = length >> 3 << 3; i < count;){
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
            bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
            bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
            bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
            bytes[index++] = (v7 << 5 | v8) & 255;
        }
        // remain bytes
        var remain = length - count;
        if (remain === 2) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
            bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
            bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
            bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
            bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
            bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
            bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
    };
    var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for(var i = 0, count = parseInt(length / 5) * 5; i < count;){
            v1 = str.charCodeAt(i++);
            v2 = str.charCodeAt(i++);
            v3 = str.charCodeAt(i++);
            v4 = str.charCodeAt(i++);
            v5 = str.charCodeAt(i++);
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        // remain char
        var remain = length - count;
        if (remain === 1) {
            v1 = str.charCodeAt(i);
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
            v1 = str.charCodeAt(i++);
            v2 = str.charCodeAt(i);
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
            v1 = str.charCodeAt(i++);
            v2 = str.charCodeAt(i++);
            v3 = str.charCodeAt(i);
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
            v1 = str.charCodeAt(i++);
            v2 = str.charCodeAt(i++);
            v3 = str.charCodeAt(i++);
            v4 = str.charCodeAt(i);
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
    };
    var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code, end = false, base32Str = "", index = 0, i, start = 0, bytes = 0, length = str.length;
        if (str === "") return base32Str;
        do {
            blocks[0] = blocks[5];
            blocks[1] = blocks[6];
            blocks[2] = blocks[7];
            for(i = start; index < length && i < 5; ++index){
                code = str.charCodeAt(index);
                if (code < 0x80) blocks[i++] = code;
                else if (code < 0x800) {
                    blocks[i++] = 0xc0 | code >> 6;
                    blocks[i++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i++] = 0xe0 | code >> 12;
                    blocks[i++] = 0x80 | code >> 6 & 0x3f;
                    blocks[i++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++index) & 0x3ff);
                    blocks[i++] = 0xf0 | code >> 18;
                    blocks[i++] = 0x80 | code >> 12 & 0x3f;
                    blocks[i++] = 0x80 | code >> 6 & 0x3f;
                    blocks[i++] = 0x80 | code & 0x3f;
                }
            }
            bytes += i - start;
            start = i - 5;
            if (index === length) ++index;
            if (index > length && i < 6) end = true;
            v1 = blocks[0];
            if (i > 4) {
                v2 = blocks[1];
                v3 = blocks[2];
                v4 = blocks[3];
                v5 = blocks[4];
                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
            } else if (i === 1) base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
            else if (i === 2) {
                v2 = blocks[1];
                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
            } else if (i === 3) {
                v2 = blocks[1];
                v3 = blocks[2];
                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
            } else {
                v2 = blocks[1];
                v3 = blocks[2];
                v4 = blocks[3];
                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
            }
        }while (!end);
        return base32Str;
    };
    var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for(var i = 0, count = parseInt(length / 5) * 5; i < count;){
            v1 = bytes[i++];
            v2 = bytes[i++];
            v3 = bytes[i++];
            v4 = bytes[i++];
            v5 = bytes[i++];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        // remain char
        var remain = length - count;
        if (remain === 1) {
            v1 = bytes[i];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
            v1 = bytes[i++];
            v2 = bytes[i];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
            v1 = bytes[i++];
            v2 = bytes[i++];
            v3 = bytes[i];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
            v1 = bytes[i++];
            v2 = bytes[i++];
            v3 = bytes[i++];
            v4 = bytes[i];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
    };
    var encode = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) input = new Uint8Array(input);
        if (notString) return encodeBytes(input);
        else if (asciiOnly) return encodeAscii(input);
        else return encodeUtf8(input);
    };
    var decode = function(base32Str, asciiOnly) {
        if (!asciiOnly) return toUtf8String(decodeAsBytes(base32Str));
        if (base32Str === "") return "";
        else if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) length = base32Str.length;
        // 8 char to 5 bytes
        for(var i = 0, count = length >> 3 << 3; i < count;){
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        // remain bytes
        var remain = length - count;
        if (remain === 2) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
            str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
    };
    var exports = {
        encode: encode,
        decode: decode
    };
    decode.asBytes = decodeAsBytes;
    if (COMMON_JS) module.exports = exports;
    else {
        root.base32 = exports;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

},{"de50b2bc6f02047c":"13Pcp"}],"izzsC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse JSON with additional options.
 * @param str - The JSON string to parse.
 * @param options - Options object to configure how integers in
 *   this request's JSON response will be decoded. Use the `intDecoding`
 *   property with one of the following options:
 *
 *   * "default": All integers will be decoded as Numbers, meaning any values greater than
 *     Number.MAX_SAFE_INTEGER will lose precision.
 *   * "safe": All integers will be decoded as Numbers, but if any values are greater than
 *     Number.MAX_SAFE_INTEGER an error will be thrown.
 *   * "mixed": Integers will be decoded as Numbers if they are less than or equal to
 *     Number.MAX_SAFE_INTEGER, otherwise they will be decoded as BigInts.
 *   * "bigint": All integers will be decoded as BigInts.
 *
 *   Defaults to "default" if not included.
 */ parcelHelpers.export(exports, "parseJSON", ()=>parseJSON);
/**
 * ArrayEqual takes two arrays and return true if equal, false otherwise
 */ parcelHelpers.export(exports, "arrayEqual", ()=>arrayEqual);
/**
 * ConcatArrays takes n number arrays and returns a joint Uint8Array
 * @param arrs - An arbitrary number of n array-like number list arguments
 * @returns [a,b]
 */ parcelHelpers.export(exports, "concatArrays", ()=>concatArrays);
/**
 * Remove undefined properties from an object
 * @param obj - An object, preferably one with some undefined properties
 * @returns A copy of the object with undefined properties removed
 */ parcelHelpers.export(exports, "removeUndefinedProperties", ()=>removeUndefinedProperties);
/**
 * Check whether the environment is Node.js (as opposed to the browser)
 * @returns True if Node.js environment, false otherwise
 */ parcelHelpers.export(exports, "isNode", ()=>isNode);
var _jsonBigint = require("json-bigint");
var _jsonBigintDefault = parcelHelpers.interopDefault(_jsonBigint);
var _intDecoding = require("../types/intDecoding");
var _intDecodingDefault = parcelHelpers.interopDefault(_intDecoding);
var process = require("420b40bcc26b8927");
const JSONbig = (0, _jsonBigintDefault.default)({
    useNativeBigInt: true,
    strict: true
});
function parseJSON(str, options) {
    const intDecoding = options && options.intDecoding ? options.intDecoding : (0, _intDecodingDefault.default).DEFAULT;
    return JSONbig.parse(str, (_, value)=>{
        if (value != null && typeof value === "object" && Object.getPrototypeOf(value) == null) // JSONbig.parse objects are created with Object.create(null) and thus have a null prototype
        // let us remedy that
        Object.setPrototypeOf(value, Object.prototype);
        if (typeof value === "bigint") {
            if (intDecoding === "safe" && value > Number.MAX_SAFE_INTEGER) throw new Error(`Integer exceeds maximum safe integer: ${value.toString()}. Try parsing with a different intDecoding option.`);
            if (intDecoding === "bigint" || intDecoding === "mixed" && value > Number.MAX_SAFE_INTEGER) return value;
            // JSONbig.parse converts number to BigInts if they are >= 10**15. This is smaller than
            // Number.MAX_SAFE_INTEGER, so we can convert some BigInts back to normal numbers.
            return Number(value);
        }
        if (typeof value === "number") {
            if (intDecoding === "bigint" && Number.isInteger(value)) return BigInt(value);
        }
        return value;
    });
}
function arrayEqual(a, b) {
    if (a.length !== b.length) return false;
    return Array.from(a).every((val, i)=>val === b[i]);
}
function concatArrays(...arrs) {
    const size = arrs.reduce((sum, arr)=>sum + arr.length, 0);
    const c = new Uint8Array(size);
    let offset = 0;
    for(let i = 0; i < arrs.length; i++){
        c.set(arrs[i], offset);
        offset += arrs[i].length;
    }
    return c;
}
function removeUndefinedProperties(obj) {
    const mutableCopy = {
        ...obj
    };
    Object.keys(mutableCopy).forEach((key)=>{
        if (typeof mutableCopy[key] === "undefined") delete mutableCopy[key];
    });
    return mutableCopy;
}
function isNode() {
    return(// @ts-ignore
    typeof process === "object" && // @ts-ignore
    typeof process.versions === "object" && // @ts-ignore
    typeof process.versions.node !== "undefined");
}

},{"420b40bcc26b8927":"13Pcp","json-bigint":"uhbIa","../types/intDecoding":"bwLkl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"uhbIa":[function(require,module,exports) {
var json_stringify = require("ac6808d94deda7ad").stringify;
var json_parse = require("beea4b36c4a11926");
module.exports = function(options) {
    return {
        parse: json_parse(options),
        stringify: json_stringify
    };
};
//create the default method members with no options applied for backwards compatibility
module.exports.parse = json_parse();
module.exports.stringify = json_stringify;

},{"ac6808d94deda7ad":"cpiHV","beea4b36c4a11926":"k7kho"}],"cpiHV":[function(require,module,exports) {
var BigNumber = require("c0606fdb60ab717b");
/*
    json2.js
    2013-05-26

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    See http://www.JSON.org/js.html


    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.


    This file creates a global JSON object containing two methods: stringify
    and parse.

        JSON.stringify(value, replacer, space)
            value       any JavaScript value, usually an object or array.

            replacer    an optional parameter that determines how object
                        values are stringified for objects. It can be a
                        function or an array of strings.

            space       an optional parameter that specifies the indentation
                        of nested structures. If it is omitted, the text will
                        be packed without extra whitespace. If it is a number,
                        it will specify the number of spaces to indent at each
                        level. If it is a string (such as '\t' or '&nbsp;'),
                        it contains the characters used to indent at each level.

            This method produces a JSON text from a JavaScript value.

            When an object value is found, if the object contains a toJSON
            method, its toJSON method will be called and the result will be
            stringified. A toJSON method does not serialize: it returns the
            value represented by the name/value pair that should be serialized,
            or undefined if nothing should be serialized. The toJSON method
            will be passed the key associated with the value, and this will be
            bound to the value

            For example, this would serialize Dates as ISO strings.

                Date.prototype.toJSON = function (key) {
                    function f(n) {
                        // Format integers to have at least two digits.
                        return n < 10 ? '0' + n : n;
                    }

                    return this.getUTCFullYear()   + '-' +
                         f(this.getUTCMonth() + 1) + '-' +
                         f(this.getUTCDate())      + 'T' +
                         f(this.getUTCHours())     + ':' +
                         f(this.getUTCMinutes())   + ':' +
                         f(this.getUTCSeconds())   + 'Z';
                };

            You can provide an optional replacer method. It will be passed the
            key and value of each member, with this bound to the containing
            object. The value that is returned from your method will be
            serialized. If your method returns undefined, then the member will
            be excluded from the serialization.

            If the replacer parameter is an array of strings, then it will be
            used to select the members to be serialized. It filters the results
            such that only members with keys listed in the replacer array are
            stringified.

            Values that do not have JSON representations, such as undefined or
            functions, will not be serialized. Such values in objects will be
            dropped; in arrays they will be replaced with null. You can use
            a replacer function to replace those with JSON values.
            JSON.stringify(undefined) returns undefined.

            The optional space parameter produces a stringification of the
            value that is filled with line breaks and indentation to make it
            easier to read.

            If the space parameter is a non-empty string, then that string will
            be used for indentation. If the space parameter is a number, then
            the indentation will be that many spaces.

            Example:

            text = JSON.stringify(['e', {pluribus: 'unum'}]);
            // text is '["e",{"pluribus":"unum"}]'


            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

            text = JSON.stringify([new Date()], function (key, value) {
                return this[key] instanceof Date ?
                    'Date(' + this[key] + ')' : value;
            });
            // text is '["Date(---current time---)"]'


        JSON.parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = JSON.parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
                var d;
                if (typeof value === 'string' &&
                        value.slice(0, 5) === 'Date(' &&
                        value.slice(-1) === ')') {
                    d = new Date(value.slice(5, -1));
                    if (d) {
                        return d;
                    }
                }
                return value;
            });


    This is a reference implementation. You are free to copy, modify, or
    redistribute.
*/ /*jslint evil: true, regexp: true */ /*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
var JSON = module.exports;
(function() {
    "use strict";
    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    }
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, gap, indent, meta = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    }, rep;
    function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }
    function str(key, holder) {
        // Produce a string from holder[key].
        var i, k, v, length, mind = gap, partial, value = holder[key], isBigNumber = value != null && (value instanceof BigNumber || BigNumber.isBigNumber(value));
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value){
            case "string":
                if (isBigNumber) return value;
                else return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
            case "bigint":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce 'null'. The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is 'object', we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is 'object',
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else // Otherwise, iterate through all of the keys in the object.
                Object.keys(value).forEach(function(k) {
                    var v = str(k, value);
                    if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                });
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof JSON.stringify !== "function") JSON.stringify = function(value, replacer, space) {
        // The stringify method takes a value and an optional replacer, and an optional
        // space parameter, and returns a JSON text. The replacer can be a function
        // that can replace values, or an array of strings that will select the keys.
        // A default replacer method can be provided. Use of the space parameter can
        // produce text that is more easily readable.
        var i;
        gap = "";
        indent = "";
        // If the space parameter is a number, make an indent string containing that
        // many spaces.
        if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
        else if (typeof space === "string") indent = space;
        // If there is a replacer, it must be a function or an array.
        // Otherwise, throw an error.
        rep = replacer;
        if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
})();

},{"c0606fdb60ab717b":"2fTAY"}],"2fTAY":[function(require,module,exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var n, i = 1, m = new BigNumber(args[0]);
            for(; i < args.length; i++){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(this);

},{}],"k7kho":[function(require,module,exports) {
var BigNumber = null;
// regexpxs extracted from
// (c) BSD-3-Clause
// https://github.com/fastify/secure-json-parse/graphs/contributors and https://github.com/hapijs/bourne/graphs/contributors
const suspectProtoRx = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/;
const suspectConstructorRx = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;
/*
    json_parse.js
    2012-06-20

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    This file creates a json_parse function.
    During create you can (optionally) specify some behavioural switches

        require('json-bigint')(options)

            The optional options parameter holds switches that drive certain
            aspects of the parsing process:
            * options.strict = true will warn about duplicate-key usage in the json.
              The default (strict = false) will silently ignore those and overwrite
              values for keys that are in duplicate use.

    The resulting function follows this signature:
        json_parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = json_parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

    This is a reference implementation. You are free to copy, modify, or
    redistribute.

    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.
*/ /*members "", "\"", "\/", "\\", at, b, call, charAt, f, fromCharCode,
    hasOwnProperty, message, n, name, prototype, push, r, t, text
*/ var json_parse = function(options) {
    "use strict";
    // This is a function that can parse a JSON text, producing a JavaScript
    // data structure. It is a simple, recursive descent parser. It does not use
    // eval or regular expressions, so it can be used as a model for implementing
    // a JSON parser in other languages.
    // We are defining the function inside of another function to avoid creating
    // global variables.
    // Default options one can override by passing options to the parse()
    var _options = {
        strict: false,
        storeAsString: false,
        alwaysParseAsBig: false,
        useNativeBigInt: false,
        protoAction: "error",
        constructorAction: "error"
    };
    // If there are options, then use them to override the default _options
    if (options !== undefined && options !== null) {
        if (options.strict === true) _options.strict = true;
        if (options.storeAsString === true) _options.storeAsString = true;
        _options.alwaysParseAsBig = options.alwaysParseAsBig === true ? options.alwaysParseAsBig : false;
        _options.useNativeBigInt = options.useNativeBigInt === true ? options.useNativeBigInt : false;
        if (typeof options.constructorAction !== "undefined") {
            if (options.constructorAction === "error" || options.constructorAction === "ignore" || options.constructorAction === "preserve") _options.constructorAction = options.constructorAction;
            else throw new Error(`Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${options.constructorAction}`);
        }
        if (typeof options.protoAction !== "undefined") {
            if (options.protoAction === "error" || options.protoAction === "ignore" || options.protoAction === "preserve") _options.protoAction = options.protoAction;
            else throw new Error(`Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${options.protoAction}`);
        }
    }
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "	"
    }, text, error = function(m) {
        // Call error when something is wrong.
        throw {
            name: "SyntaxError",
            message: m,
            at: at,
            text: text
        };
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else {
            if (BigNumber == null) BigNumber = require("a5b343398027541d");
            //if (number > 9007199254740992 || number < -9007199254740992)
            // Bignumber has stricter check: everything with length > 15 digits disallowed
            if (string.length > 15) return _options.storeAsString ? string : _options.useNativeBigInt ? BigInt(string) : new BigNumber(string);
            else return !_options.alwaysParseAsBig ? number : _options.useNativeBigInt ? BigInt(number) : new BigNumber(number);
        }
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') {
            var startAt = at;
            while(next()){
                if (ch === '"') {
                    if (at - 1 > startAt) string += text.substring(startAt, at - 1);
                    next();
                    return string;
                }
                if (ch === "\\") {
                    if (at - 1 > startAt) string += text.substring(startAt, at - 1);
                    next();
                    if (ch === "u") {
                        uffff = 0;
                        for(i = 0; i < 4; i += 1){
                            hex = parseInt(next(), 16);
                            if (!isFinite(hex)) break;
                            uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                    } else if (typeof escapee[ch] === "string") string += escapee[ch];
                    else break;
                    startAt = at;
                }
            }
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error("Unexpected '" + ch + "'");
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = Object.create(null);
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (_options.strict === true && Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                if (suspectProtoRx.test(key) === true) {
                    if (_options.protoAction === "error") error("Object contains forbidden prototype property");
                    else if (_options.protoAction === "ignore") value();
                    else object[key] = value();
                } else if (suspectConstructorRx.test(key) === true) {
                    if (_options.constructorAction === "error") error("Object contains forbidden constructor property");
                    else if (_options.constructorAction === "ignore") value();
                    else object[key] = value();
                } else object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string, a number,
        // or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the above
    // functions and variables.
    return function(source, reviver) {
        var result;
        text = source + "";
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        // If there is a reviver function, we recursively walk the new structure,
        // passing each name/value pair to the reviver function for possible
        // transformation, starting with a temporary root object that holds the result
        // in an empty key. If there is not a reviver function, we simply return the
        // result.
        return typeof reviver === "function" ? function walk(holder, key) {
            var k, v, value = holder[key];
            if (value && typeof value === "object") Object.keys(value).forEach(function(k) {
                v = walk(value, k);
                if (v !== undefined) value[k] = v;
                else delete value[k];
            });
            return reviver.call(holder, key, value);
        }({
            "": result
        }, "") : result;
    };
};
module.exports = json_parse;

},{"a5b343398027541d":"2fTAY"}],"bwLkl":[function(require,module,exports) {
/**
 * Configure how integers in JSON response will be decoded.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var IntDecoding;
(function(IntDecoding) {
    /**
     * All integers will be decoded as Numbers, meaning any values greater than
     * Number.MAX_SAFE_INTEGER will lose precision.
     */ IntDecoding["DEFAULT"] = "default";
    /**
     * All integers will be decoded as Numbers, but if any values are greater than
     * Number.MAX_SAFE_INTEGER an error will be thrown.
     */ IntDecoding["SAFE"] = "safe";
    /**
     * Integers will be decoded as Numbers if they are less than or equal to
     * Number.MAX_SAFE_INTEGER, otherwise they will be decoded as BigInts.
     */ IntDecoding["MIXED"] = "mixed";
    /**
     * All integers will be decoded as BigInts.
     */ IntDecoding["BIGINT"] = "bigint";
})(IntDecoding || (IntDecoding = {}));
exports.default = IntDecoding;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aZ6qP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// NOTE: at the moment we specifically do not use Buffer.writeBigUInt64BE and
// Buffer.readBigUInt64BE. This is because projects using webpack v4
// automatically include an old version of the npm `buffer` package (v4.9.2 at
// the time of writing), and this old version does not have these methods.
/**
 * encodeUint64 converts an integer to its binary representation.
 * @param num - The number to convert. This must be an unsigned integer less than
 *   2^64.
 * @returns An 8-byte typed array containing the big-endian encoding of the input
 *   integer.
 */ parcelHelpers.export(exports, "encodeUint64", ()=>encodeUint64);
parcelHelpers.export(exports, "decodeUint64", ()=>decodeUint64);
var _utils = require("../utils/utils");
function encodeUint64(num) {
    const isInteger = typeof num === "bigint" || Number.isInteger(num);
    if (!isInteger || num < 0 || num > BigInt("0xffffffffffffffff")) throw new Error("Input is not a 64-bit unsigned integer");
    const encoding = new Uint8Array(8);
    const view = new DataView(encoding.buffer);
    view.setBigUint64(0, BigInt(num));
    return encoding;
}
function decodeUint64(data, decodingMode = "safe") {
    if (decodingMode !== "safe" && decodingMode !== "mixed" && decodingMode !== "bigint") throw new Error(`Unknown decodingMode option: ${decodingMode}`);
    if (data.byteLength === 0 || data.byteLength > 8) throw new Error(`Data has unacceptable length. Expected length is between 1 and 8, got ${data.byteLength}`);
    // insert 0s at the beginning if data is smaller than 8 bytes
    const padding = new Uint8Array(8 - data.byteLength);
    const encoding = (0, _utils.concatArrays)(padding, data);
    const view = new DataView(encoding.buffer);
    const num = view.getBigUint64(0);
    const isBig = num > BigInt(Number.MAX_SAFE_INTEGER);
    if (decodingMode === "safe") {
        if (isBig) throw new Error(`Integer exceeds maximum safe integer: ${num.toString()}. Try decoding with "mixed" or "safe" decodingMode.`);
        return Number(num);
    }
    if (decodingMode === "mixed" && !isBig) return Number(num);
    return num;
}

},{"../utils/utils":"izzsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Yg70":[function(require,module,exports) {
/**
 * This file is a wrapper of msgpack.js.
 * The wrapper was written in order to ensure correct encoding of Algorand Transaction and other formats.
 * In particular, it matches go-algorand blockchain client, written in go (https://www.github.com/algorand/go-algorand.
 * Algorand's msgpack encoding follows to following rules -
 *  1. Every integer must be encoded to the smallest type possible (0-255-\>8bit, 256-65535-\>16bit, etx)
 *  2. All fields names must be sorted
 *  3. All empty and 0 fields should be omitted
 *  4. Every positive number must be encoded as uint
 *  5. Binary blob should be used for binary data and string for strings
 *  */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_CONTAINS_EMPTY_STRING", ()=>ERROR_CONTAINS_EMPTY_STRING);
/**
 * rawEncode encodes objects using msgpack, regardless of whether there are
 * empty or 0 value fields.
 * @param obj - a dictionary to be encoded. May or may not contain empty or 0 values.
 * @returns msgpack representation of the object
 */ parcelHelpers.export(exports, "rawEncode", ()=>rawEncode);
/**
 * encode encodes objects using msgpack
 * @param obj - a dictionary to be encoded. Must not contain empty or 0 values.
 * @returns msgpack representation of the object
 * @throws Error containing ERROR_CONTAINS_EMPTY_STRING if the object contains empty or zero values
 */ parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
var _algoMsgpackWithBigint = require("algo-msgpack-with-bigint");
const ERROR_CONTAINS_EMPTY_STRING = "The object contains empty or 0 values. First empty or 0 value encountered during encoding: ";
/**
 * containsEmpty returns true if any of the object's values are empty, false otherwise.
 * Empty arrays considered empty
 * @param obj - The object to check
 * @returns \{true, empty key\} if contains empty, \{false, undefined\} otherwise
 */ function containsEmpty(obj) {
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (!obj[key] || obj[key].length === 0) return {
            containsEmpty: true,
            firstEmptyKey: key
        };
    }
    return {
        containsEmpty: false,
        firstEmptyKey: undefined
    };
}
function rawEncode(obj) {
    // enable the canonical option
    const options = {
        sortKeys: true
    };
    return _algoMsgpackWithBigint.encode(obj, options);
}
function encode(obj) {
    // Check for empty values
    const emptyCheck = containsEmpty(obj);
    if (emptyCheck.containsEmpty) throw new Error(ERROR_CONTAINS_EMPTY_STRING + emptyCheck.firstEmptyKey);
    // enable the canonical option
    return rawEncode(obj);
}
function decode(buffer) {
    return _algoMsgpackWithBigint.decode(buffer);
}

},{"algo-msgpack-with-bigint":"6UD61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6UD61":[function(require,module,exports) {
var process = require("178201740996c230");
!function(t, e) {
    module.exports = e();
}(this, function() {
    return function(t) {
        var e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var i = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = t, r.c = e, r.d = function(t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)r.d(n, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return n;
        }, r.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return r.d(e, "a", e), e;
        }, r.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 0);
    }([
        function(t, e, r) {
            "use strict";
            r.r(e), r.d(e, "encode", function() {
                return T;
            }), r.d(e, "decode", function() {
                return V;
            }), r.d(e, "decodeAsync", function() {
                return Y;
            }), r.d(e, "decodeArrayStream", function() {
                return Z;
            }), r.d(e, "decodeStream", function() {
                return $;
            }), r.d(e, "Decoder", function() {
                return O;
            }), r.d(e, "Encoder", function() {
                return I;
            }), r.d(e, "ExtensionCodec", function() {
                return S;
            }), r.d(e, "ExtData", function() {
                return p;
            }), r.d(e, "EXT_TIMESTAMP", function() {
                return w;
            }), r.d(e, "encodeDateToTimeSpec", function() {
                return g;
            }), r.d(e, "encodeTimeSpecToTimestamp", function() {
                return v;
            }), r.d(e, "decodeTimestampToTimeSpec", function() {
                return U;
            }), r.d(e, "encodeTimestampExtension", function() {
                return b;
            }), r.d(e, "decodeTimestampExtension", function() {
                return m;
            });
            var n = function(t, e) {
                var r = "function" == typeof Symbol && t[Symbol.iterator];
                if (!r) return t;
                var n, i, o = r.call(t), s = [];
                try {
                    for(; (void 0 === e || e-- > 0) && !(n = o.next()).done;)s.push(n.value);
                } catch (t) {
                    i = {
                        error: t
                    };
                } finally{
                    try {
                        n && !n.done && (r = o.return) && r.call(o);
                    } finally{
                        if (i) throw i.error;
                    }
                }
                return s;
            }, i = function() {
                for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(n(arguments[e]));
                return t;
            }, o = "undefined" != typeof process && "undefined" != typeof TextEncoder && "undefined" != typeof TextDecoder;
            function s(t) {
                for(var e = t.length, r = 0, n = 0; n < e;){
                    var i = t.charCodeAt(n++);
                    if (0 != (4294967168 & i)) {
                        if (0 == (4294965248 & i)) r += 2;
                        else {
                            if (i >= 55296 && i <= 56319 && n < e) {
                                var o = t.charCodeAt(n);
                                56320 == (64512 & o) && (++n, i = ((1023 & i) << 10) + (1023 & o) + 65536);
                            }
                            r += 0 == (4294901760 & i) ? 3 : 4;
                        }
                    } else r++;
                }
                return r;
            }
            var a = o ? new TextEncoder : void 0, h = "undefined" != typeof process ? 200 : 0;
            var u = (null == a ? void 0 : a.encodeInto) ? function(t, e, r) {
                a.encodeInto(t, e.subarray(r));
            } : function(t, e, r) {
                e.set(a.encode(t), r);
            };
            function c(t, e, r) {
                for(var n = e, o = n + r, s = [], a = ""; n < o;){
                    var h = t[n++];
                    if (0 == (128 & h)) s.push(h);
                    else if (192 == (224 & h)) {
                        var u = 63 & t[n++];
                        s.push((31 & h) << 6 | u);
                    } else if (224 == (240 & h)) {
                        u = 63 & t[n++];
                        var c = 63 & t[n++];
                        s.push((31 & h) << 12 | u << 6 | c);
                    } else if (240 == (248 & h)) {
                        var f = (7 & h) << 18 | (u = 63 & t[n++]) << 12 | (c = 63 & t[n++]) << 6 | 63 & t[n++];
                        f > 65535 && (f -= 65536, s.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), s.push(f);
                    } else s.push(h);
                    s.length >= 4096 && (a += String.fromCharCode.apply(String, i(s)), s.length = 0);
                }
                return s.length > 0 && (a += String.fromCharCode.apply(String, i(s))), a;
            }
            var f = o ? new TextDecoder : null, l = "undefined" != typeof process ? 200 : 0;
            var p = function(t, e) {
                this.type = t, this.data = e;
            };
            function d(t, e, r) {
                var n = Math.floor(r / 4294967296), i = r;
                t.setUint32(e, n), t.setUint32(e + 4, i);
            }
            function y(t, e) {
                var r = t.getInt32(e), n = t.getUint32(e + 4), i = r < Math.floor(Number.MIN_SAFE_INTEGER / 4294967296) || r === Math.floor(Number.MIN_SAFE_INTEGER / 4294967296) && 0 === n, o = r > Math.floor(Number.MAX_SAFE_INTEGER / 4294967296);
                return i || o ? BigInt(r) * BigInt(4294967296) + BigInt(n) : 4294967296 * r + n;
            }
            var w = -1;
            function v(t) {
                var e = t.sec, r = t.nsec;
                if (e >= 0 && r >= 0 && e <= 17179869183) {
                    if (0 === r && e <= 4294967295) {
                        var n = new Uint8Array(4);
                        return (s = new DataView(n.buffer)).setUint32(0, e), n;
                    }
                    var i = e / 4294967296, o = 4294967295 & e;
                    n = new Uint8Array(8);
                    return (s = new DataView(n.buffer)).setUint32(0, r << 2 | 3 & i), s.setUint32(4, o), n;
                }
                var s;
                n = new Uint8Array(12);
                return (s = new DataView(n.buffer)).setUint32(0, r), d(s, 4, e), n;
            }
            function g(t) {
                var e = t.getTime(), r = Math.floor(e / 1e3), n = 1e6 * (e - 1e3 * r), i = Math.floor(n / 1e9);
                return {
                    sec: r + i,
                    nsec: n - 1e9 * i
                };
            }
            function b(t) {
                return t instanceof Date ? v(g(t)) : null;
            }
            function U(t) {
                var e = new DataView(t.buffer, t.byteOffset, t.byteLength);
                switch(t.byteLength){
                    case 4:
                        return {
                            sec: e.getUint32(0),
                            nsec: 0
                        };
                    case 8:
                        var r = e.getUint32(0);
                        return {
                            sec: 4294967296 * (3 & r) + e.getUint32(4),
                            nsec: r >>> 2
                        };
                    case 12:
                        return {
                            sec: y(e, 4),
                            nsec: e.getUint32(0)
                        };
                    default:
                        throw new Error("Unrecognized data size for timestamp: " + t.length);
                }
            }
            function m(t) {
                var e = U(t);
                return new Date(1e3 * e.sec + e.nsec / 1e6);
            }
            var x = {
                type: w,
                encode: b,
                decode: m
            }, S = function() {
                function t() {
                    this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(x);
                }
                return t.prototype.register = function(t) {
                    var e = t.type, r = t.encode, n = t.decode;
                    if (e >= 0) this.encoders[e] = r, this.decoders[e] = n;
                    else {
                        var i = 1 + e;
                        this.builtInEncoders[i] = r, this.builtInDecoders[i] = n;
                    }
                }, t.prototype.tryToEncode = function(t, e) {
                    for(var r = 0; r < this.builtInEncoders.length; r++)if (null != (n = this.builtInEncoders[r])) {
                        if (null != (i = n(t, e))) return new p(-1 - r, i);
                    }
                    for(r = 0; r < this.encoders.length; r++){
                        var n, i;
                        if (null != (n = this.encoders[r])) {
                            if (null != (i = n(t, e))) return new p(r, i);
                        }
                    }
                    return t instanceof p ? t : null;
                }, t.prototype.decode = function(t, e, r) {
                    var n = e < 0 ? this.builtInDecoders[-1 - e] : this.decoders[e];
                    return n ? n(t, e, r) : new p(e, t);
                }, t.defaultCodec = new t, t;
            }();
            function B(t) {
                return t instanceof Uint8Array ? t : ArrayBuffer.isView(t) ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t instanceof ArrayBuffer ? new Uint8Array(t) : Uint8Array.from(t);
            }
            var E = function(t) {
                var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
                if (r) return r.call(t);
                if (t && "number" == typeof t.length) return {
                    next: function() {
                        return t && n >= t.length && (t = void 0), {
                            value: t && t[n++],
                            done: !t
                        };
                    }
                };
                throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }, I = function() {
                function t(t, e, r, n, i, o, s, a) {
                    void 0 === t && (t = S.defaultCodec), void 0 === e && (e = void 0), void 0 === r && (r = 100), void 0 === n && (n = 2048), void 0 === i && (i = !1), void 0 === o && (o = !1), void 0 === s && (s = !1), void 0 === a && (a = !1), this.extensionCodec = t, this.context = e, this.maxDepth = r, this.initialBufferSize = n, this.sortKeys = i, this.forceFloat32 = o, this.ignoreUndefined = s, this.forceIntegerToFloat = a, this.pos = 0, this.view = new DataView(new ArrayBuffer(this.initialBufferSize)), this.bytes = new Uint8Array(this.view.buffer);
                }
                return t.prototype.getUint8Array = function() {
                    return this.bytes.subarray(0, this.pos);
                }, t.prototype.reinitializeState = function() {
                    this.pos = 0;
                }, t.prototype.encode = function(t) {
                    return this.reinitializeState(), this.doEncode(t, 1), this.getUint8Array();
                }, t.prototype.doEncode = function(t, e) {
                    if (e > this.maxDepth) throw new Error("Too deep objects in depth " + e);
                    null == t ? this.encodeNil() : "boolean" == typeof t ? this.encodeBoolean(t) : "number" == typeof t ? this.encodeNumber(t) : "string" == typeof t ? this.encodeString(t) : "bigint" == typeof t ? this.encodebigint(t) : this.encodeObject(t, e);
                }, t.prototype.ensureBufferSizeToWrite = function(t) {
                    var e = this.pos + t;
                    this.view.byteLength < e && this.resizeBuffer(2 * e);
                }, t.prototype.resizeBuffer = function(t) {
                    var e = new ArrayBuffer(t), r = new Uint8Array(e), n = new DataView(e);
                    r.set(this.bytes), this.view = n, this.bytes = r;
                }, t.prototype.encodeNil = function() {
                    this.writeU8(192);
                }, t.prototype.encodeBoolean = function(t) {
                    !1 === t ? this.writeU8(194) : this.writeU8(195);
                }, t.prototype.encodeNumber = function(t) {
                    Number.isSafeInteger(t) && !this.forceIntegerToFloat ? t >= 0 ? t < 128 ? this.writeU8(t) : t < 256 ? (this.writeU8(204), this.writeU8(t)) : t < 65536 ? (this.writeU8(205), this.writeU16(t)) : t < 4294967296 ? (this.writeU8(206), this.writeU32(t)) : (this.writeU8(207), this.writeU64(t)) : t >= -32 ? this.writeU8(224 | t + 32) : t >= -128 ? (this.writeU8(208), this.writeI8(t)) : t >= -32768 ? (this.writeU8(209), this.writeI16(t)) : t >= -2147483648 ? (this.writeU8(210), this.writeI32(t)) : (this.writeU8(211), this.writeI64(t)) : this.forceFloat32 ? (this.writeU8(202), this.writeF32(t)) : (this.writeU8(203), this.writeF64(t));
                }, t.prototype.encodebigint = function(t) {
                    t >= BigInt(0) ? t < BigInt(128) ? this.writeU8(Number(t)) : t < BigInt(256) ? (this.writeU8(204), this.writeU8(Number(t))) : t < BigInt(65536) ? (this.writeU8(205), this.writeU16(Number(t))) : t < BigInt(4294967296) ? (this.writeU8(206), this.writeU32(Number(t))) : (this.writeU8(207), this.writeBig64(t)) : t >= BigInt(-32) ? this.writeU8(224 | Number(t) + 32) : t >= BigInt(-128) ? (this.writeU8(208), this.writeI8(Number(t))) : t >= BigInt(-32768) ? (this.writeU8(209), this.writeI16(Number(t))) : t >= BigInt(-2147483648) ? (this.writeU8(210), this.writeI32(Number(t))) : (this.writeU8(211), this.writeBig64(t));
                }, t.prototype.writeStringHeader = function(t) {
                    if (t < 32) this.writeU8(160 + t);
                    else if (t < 256) this.writeU8(217), this.writeU8(t);
                    else if (t < 65536) this.writeU8(218), this.writeU16(t);
                    else {
                        if (!(t < 4294967296)) throw new Error("Too long string: " + t + " bytes in UTF-8");
                        this.writeU8(219), this.writeU32(t);
                    }
                }, t.prototype.encodeString = function(t) {
                    var e = t.length;
                    if (o && e > h) {
                        var r = s(t);
                        this.ensureBufferSizeToWrite(5 + r), this.writeStringHeader(r), u(t, this.bytes, this.pos), this.pos += r;
                    } else {
                        r = s(t);
                        this.ensureBufferSizeToWrite(5 + r), this.writeStringHeader(r), function(t, e, r) {
                            for(var n = t.length, i = r, o = 0; o < n;){
                                var s = t.charCodeAt(o++);
                                if (0 != (4294967168 & s)) {
                                    if (0 == (4294965248 & s)) e[i++] = s >> 6 & 31 | 192;
                                    else {
                                        if (s >= 55296 && s <= 56319 && o < n) {
                                            var a = t.charCodeAt(o);
                                            56320 == (64512 & a) && (++o, s = ((1023 & s) << 10) + (1023 & a) + 65536);
                                        }
                                        0 == (4294901760 & s) ? (e[i++] = s >> 12 & 15 | 224, e[i++] = s >> 6 & 63 | 128) : (e[i++] = s >> 18 & 7 | 240, e[i++] = s >> 12 & 63 | 128, e[i++] = s >> 6 & 63 | 128);
                                    }
                                    e[i++] = 63 & s | 128;
                                } else e[i++] = s;
                            }
                        }(t, this.bytes, this.pos), this.pos += r;
                    }
                }, t.prototype.encodeObject = function(t, e) {
                    var r = this.extensionCodec.tryToEncode(t, this.context);
                    if (null != r) this.encodeExtension(r);
                    else if (Array.isArray(t)) this.encodeArray(t, e);
                    else if (ArrayBuffer.isView(t)) this.encodeBinary(t);
                    else {
                        if ("object" != typeof t) throw new Error("Unrecognized object: " + Object.prototype.toString.apply(t));
                        this.encodeMap(t, e);
                    }
                }, t.prototype.encodeBinary = function(t) {
                    var e = t.byteLength;
                    if (e < 256) this.writeU8(196), this.writeU8(e);
                    else if (e < 65536) this.writeU8(197), this.writeU16(e);
                    else {
                        if (!(e < 4294967296)) throw new Error("Too large binary: " + e);
                        this.writeU8(198), this.writeU32(e);
                    }
                    var r = B(t);
                    this.writeU8a(r);
                }, t.prototype.encodeArray = function(t, e) {
                    var r, n, i = t.length;
                    if (i < 16) this.writeU8(144 + i);
                    else if (i < 65536) this.writeU8(220), this.writeU16(i);
                    else {
                        if (!(i < 4294967296)) throw new Error("Too large array: " + i);
                        this.writeU8(221), this.writeU32(i);
                    }
                    try {
                        for(var o = E(t), s = o.next(); !s.done; s = o.next()){
                            var a = s.value;
                            this.doEncode(a, e + 1);
                        }
                    } catch (t) {
                        r = {
                            error: t
                        };
                    } finally{
                        try {
                            s && !s.done && (n = o.return) && n.call(o);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                }, t.prototype.countWithoutUndefined = function(t, e) {
                    var r, n, i = 0;
                    try {
                        for(var o = E(e), s = o.next(); !s.done; s = o.next())void 0 !== t[s.value] && i++;
                    } catch (t) {
                        r = {
                            error: t
                        };
                    } finally{
                        try {
                            s && !s.done && (n = o.return) && n.call(o);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return i;
                }, t.prototype.encodeMap = function(t, e) {
                    var r, n, i = Object.keys(t);
                    this.sortKeys && i.sort();
                    var o = this.ignoreUndefined ? this.countWithoutUndefined(t, i) : i.length;
                    if (o < 16) this.writeU8(128 + o);
                    else if (o < 65536) this.writeU8(222), this.writeU16(o);
                    else {
                        if (!(o < 4294967296)) throw new Error("Too large map object: " + o);
                        this.writeU8(223), this.writeU32(o);
                    }
                    try {
                        for(var s = E(i), a = s.next(); !a.done; a = s.next()){
                            var h = a.value, u = t[h];
                            this.ignoreUndefined && void 0 === u || (this.encodeString(h), this.doEncode(u, e + 1));
                        }
                    } catch (t) {
                        r = {
                            error: t
                        };
                    } finally{
                        try {
                            a && !a.done && (n = s.return) && n.call(s);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                }, t.prototype.encodeExtension = function(t) {
                    var e = t.data.length;
                    if (1 === e) this.writeU8(212);
                    else if (2 === e) this.writeU8(213);
                    else if (4 === e) this.writeU8(214);
                    else if (8 === e) this.writeU8(215);
                    else if (16 === e) this.writeU8(216);
                    else if (e < 256) this.writeU8(199), this.writeU8(e);
                    else if (e < 65536) this.writeU8(200), this.writeU16(e);
                    else {
                        if (!(e < 4294967296)) throw new Error("Too large extension object: " + e);
                        this.writeU8(201), this.writeU32(e);
                    }
                    this.writeI8(t.type), this.writeU8a(t.data);
                }, t.prototype.writeU8 = function(t) {
                    this.ensureBufferSizeToWrite(1), this.view.setUint8(this.pos, t), this.pos++;
                }, t.prototype.writeU8a = function(t) {
                    var e = t.length;
                    this.ensureBufferSizeToWrite(e), this.bytes.set(t, this.pos), this.pos += e;
                }, t.prototype.writeI8 = function(t) {
                    this.ensureBufferSizeToWrite(1), this.view.setInt8(this.pos, t), this.pos++;
                }, t.prototype.writeU16 = function(t) {
                    this.ensureBufferSizeToWrite(2), this.view.setUint16(this.pos, t), this.pos += 2;
                }, t.prototype.writeI16 = function(t) {
                    this.ensureBufferSizeToWrite(2), this.view.setInt16(this.pos, t), this.pos += 2;
                }, t.prototype.writeU32 = function(t) {
                    this.ensureBufferSizeToWrite(4), this.view.setUint32(this.pos, t), this.pos += 4;
                }, t.prototype.writeI32 = function(t) {
                    this.ensureBufferSizeToWrite(4), this.view.setInt32(this.pos, t), this.pos += 4;
                }, t.prototype.writeF32 = function(t) {
                    this.ensureBufferSizeToWrite(4), this.view.setFloat32(this.pos, t), this.pos += 4;
                }, t.prototype.writeF64 = function(t) {
                    this.ensureBufferSizeToWrite(8), this.view.setFloat64(this.pos, t), this.pos += 8;
                }, t.prototype.writeU64 = function(t) {
                    this.ensureBufferSizeToWrite(8), function(t, e, r) {
                        var n = r / 4294967296, i = r;
                        t.setUint32(e, n), t.setUint32(e + 4, i);
                    }(this.view, this.pos, t), this.pos += 8;
                }, t.prototype.writeI64 = function(t) {
                    this.ensureBufferSizeToWrite(8), d(this.view, this.pos, t), this.pos += 8;
                }, t.prototype.writeBig64 = function(t) {
                    this.ensureBufferSizeToWrite(8), function(t, e, r) {
                        var n = Number(r / BigInt(4294967296)), i = Number(r % BigInt(4294967296));
                        n < 0 && 0 !== i && (n -= 1), t.setUint32(e, n), t.setUint32(e + 4, i);
                    }(this.view, this.pos, t), this.pos += 8;
                }, t;
            }(), A = {};
            function T(t, e) {
                return void 0 === e && (e = A), new I(e.extensionCodec, e.context, e.maxDepth, e.initialBufferSize, e.sortKeys, e.forceFloat32, e.ignoreUndefined, e.forceIntegerToFloat).encode(t);
            }
            function L(t) {
                return (t < 0 ? "-" : "") + "0x" + Math.abs(t).toString(16).padStart(2, "0");
            }
            var M = function() {
                function t(t, e) {
                    void 0 === t && (t = 16), void 0 === e && (e = 16), this.maxKeyLength = t, this.maxLengthPerKey = e, this.hit = 0, this.miss = 0, this.caches = [];
                    for(var r = 0; r < this.maxKeyLength; r++)this.caches.push([]);
                }
                return t.prototype.canBeCached = function(t) {
                    return t > 0 && t <= this.maxKeyLength;
                }, t.prototype.get = function(t, e, r) {
                    var n = this.caches[r - 1], i = n.length;
                    t: for(var o = 0; o < i; o++){
                        for(var s = n[o], a = s.bytes, h = 0; h < r; h++)if (a[h] !== t[e + h]) continue t;
                        return s.value;
                    }
                    return null;
                }, t.prototype.store = function(t, e) {
                    var r = this.caches[t.length - 1], n = {
                        bytes: t,
                        value: e
                    };
                    r.length >= this.maxLengthPerKey ? r[Math.random() * r.length | 0] = n : r.push(n);
                }, t.prototype.decode = function(t, e, r) {
                    var n = this.get(t, e, r);
                    if (null != n) return this.hit++, n;
                    this.miss++;
                    var i = c(t, e, r), o = Uint8Array.prototype.slice.call(t, e, e + r);
                    return this.store(o, i), i;
                }, t;
            }(), k = function(t, e, r, n) {
                return new (r || (r = Promise))(function(i, o) {
                    function s(t) {
                        try {
                            h(n.next(t));
                        } catch (t) {
                            o(t);
                        }
                    }
                    function a(t) {
                        try {
                            h(n.throw(t));
                        } catch (t) {
                            o(t);
                        }
                    }
                    function h(t) {
                        var e;
                        t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                            t(e);
                        })).then(s, a);
                    }
                    h((n = n.apply(t, e || [])).next());
                });
            }, z = function(t, e) {
                var r, n, i, o, s = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    throw: a(1),
                    return: a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function a(o) {
                    return function(a) {
                        return function(o) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for(; s;)try {
                                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                switch(n = 0, i && (o = [
                                    2 & o[0],
                                    i.value
                                ]), o[0]){
                                    case 0:
                                    case 1:
                                        i = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue;
                                        }
                                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                            s.label = o[1];
                                            break;
                                        }
                                        if (6 === o[0] && s.label < i[1]) {
                                            s.label = i[1], i = o;
                                            break;
                                        }
                                        if (i && s.label < i[2]) {
                                            s.label = i[2], s.ops.push(o);
                                            break;
                                        }
                                        i[2] && s.ops.pop(), s.trys.pop();
                                        continue;
                                }
                                o = e.call(t, s);
                            } catch (t) {
                                o = [
                                    6,
                                    t
                                ], n = 0;
                            } finally{
                                r = i = 0;
                            }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            };
                        }([
                            o,
                            a
                        ]);
                    };
                }
            }, D = function(t) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var e, r = t[Symbol.asyncIterator];
                return r ? r.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function() {
                    return this;
                }, e);
                function n(r) {
                    e[r] = t[r] && function(e) {
                        return new Promise(function(n, i) {
                            (function(t, e, r, n) {
                                Promise.resolve(n).then(function(e) {
                                    t({
                                        value: e,
                                        done: r
                                    });
                                }, e);
                            })(n, i, (e = t[r](e)).done, e.value);
                        });
                    };
                }
            }, N = function(t) {
                return this instanceof N ? (this.v = t, this) : new N(t);
            }, C = function(t, e, r) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var n, i = r.apply(t, e || []), o = [];
                return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function() {
                    return this;
                }, n;
                function s(t) {
                    i[t] && (n[t] = function(e) {
                        return new Promise(function(r, n) {
                            o.push([
                                t,
                                e,
                                r,
                                n
                            ]) > 1 || a(t, e);
                        });
                    });
                }
                function a(t, e) {
                    try {
                        (r = i[t](e)).value instanceof N ? Promise.resolve(r.value.v).then(h, u) : c(o[0][2], r);
                    } catch (t) {
                        c(o[0][3], t);
                    }
                    var r;
                }
                function h(t) {
                    a("next", t);
                }
                function u(t) {
                    a("throw", t);
                }
                function c(t, e) {
                    t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
                }
            }, P = new DataView(new ArrayBuffer(0)), F = new Uint8Array(P.buffer), j = function() {
                try {
                    P.getInt8(0);
                } catch (t) {
                    return t.constructor;
                }
                throw new Error("never reached");
            }(), _ = new j("Insufficient data"), W = new M, O = function() {
                function t(t, e, r, n, i, o, s, a) {
                    void 0 === t && (t = S.defaultCodec), void 0 === e && (e = void 0), void 0 === r && (r = 4294967295), void 0 === n && (n = 4294967295), void 0 === i && (i = 4294967295), void 0 === o && (o = 4294967295), void 0 === s && (s = 4294967295), void 0 === a && (a = W), this.extensionCodec = t, this.context = e, this.maxStrLength = r, this.maxBinLength = n, this.maxArrayLength = i, this.maxMapLength = o, this.maxExtLength = s, this.keyDecoder = a, this.totalPos = 0, this.pos = 0, this.view = P, this.bytes = F, this.headByte = -1, this.stack = [];
                }
                return t.prototype.reinitializeState = function() {
                    this.totalPos = 0, this.headByte = -1;
                }, t.prototype.setBuffer = function(t) {
                    this.bytes = B(t), this.view = function(t) {
                        if (t instanceof ArrayBuffer) return new DataView(t);
                        var e = B(t);
                        return new DataView(e.buffer, e.byteOffset, e.byteLength);
                    }(this.bytes), this.pos = 0;
                }, t.prototype.appendBuffer = function(t) {
                    if (-1 !== this.headByte || this.hasRemaining()) {
                        var e = this.bytes.subarray(this.pos), r = B(t), n = new Uint8Array(e.length + r.length);
                        n.set(e), n.set(r, e.length), this.setBuffer(n);
                    } else this.setBuffer(t);
                }, t.prototype.hasRemaining = function(t) {
                    return void 0 === t && (t = 1), this.view.byteLength - this.pos >= t;
                }, t.prototype.createNoExtraBytesError = function(t) {
                    var e = this.view, r = this.pos;
                    return new RangeError("Extra " + (e.byteLength - r) + " of " + e.byteLength + " byte(s) found at buffer[" + t + "]");
                }, t.prototype.decode = function(t) {
                    return this.reinitializeState(), this.setBuffer(t), this.doDecodeSingleSync();
                }, t.prototype.doDecodeSingleSync = function() {
                    var t = this.doDecodeSync();
                    if (this.hasRemaining()) throw this.createNoExtraBytesError(this.pos);
                    return t;
                }, t.prototype.decodeAsync = function(t) {
                    var e, r, n, i;
                    return k(this, void 0, void 0, function() {
                        var o, s, a, h, u, c, f, l;
                        return z(this, function(p) {
                            switch(p.label){
                                case 0:
                                    o = !1, p.label = 1;
                                case 1:
                                    p.trys.push([
                                        1,
                                        6,
                                        7,
                                        12
                                    ]), e = D(t), p.label = 2;
                                case 2:
                                    return [
                                        4,
                                        e.next()
                                    ];
                                case 3:
                                    if ((r = p.sent()).done) return [
                                        3,
                                        5
                                    ];
                                    if (a = r.value, o) throw this.createNoExtraBytesError(this.totalPos);
                                    this.appendBuffer(a);
                                    try {
                                        s = this.doDecodeSync(), o = !0;
                                    } catch (t) {
                                        if (!(t instanceof j)) throw t;
                                    }
                                    this.totalPos += this.pos, p.label = 4;
                                case 4:
                                    return [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        12
                                    ];
                                case 6:
                                    return h = p.sent(), n = {
                                        error: h
                                    }, [
                                        3,
                                        12
                                    ];
                                case 7:
                                    return p.trys.push([
                                        7,
                                        ,
                                        10,
                                        11
                                    ]), r && !r.done && (i = e.return) ? [
                                        4,
                                        i.call(e)
                                    ] : [
                                        3,
                                        9
                                    ];
                                case 8:
                                    p.sent(), p.label = 9;
                                case 9:
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    if (n) throw n.error;
                                    return [
                                        7
                                    ];
                                case 11:
                                    return [
                                        7
                                    ];
                                case 12:
                                    if (o) {
                                        if (this.hasRemaining()) throw this.createNoExtraBytesError(this.totalPos);
                                        return [
                                            2,
                                            s
                                        ];
                                    }
                                    throw c = (u = this).headByte, f = u.pos, l = u.totalPos, new RangeError("Insufficient data in parcing " + L(c) + " at " + l + " (" + f + " in the current buffer)");
                            }
                        });
                    });
                }, t.prototype.decodeArrayStream = function(t) {
                    return this.decodeMultiAsync(t, !0);
                }, t.prototype.decodeStream = function(t) {
                    return this.decodeMultiAsync(t, !1);
                }, t.prototype.decodeMultiAsync = function(t, e) {
                    return C(this, arguments, function() {
                        var r, n, i, o, s, a, h, u, c;
                        return z(this, function(f) {
                            switch(f.label){
                                case 0:
                                    r = e, n = -1, f.label = 1;
                                case 1:
                                    f.trys.push([
                                        1,
                                        13,
                                        14,
                                        19
                                    ]), i = D(t), f.label = 2;
                                case 2:
                                    return [
                                        4,
                                        N(i.next())
                                    ];
                                case 3:
                                    if ((o = f.sent()).done) return [
                                        3,
                                        12
                                    ];
                                    if (s = o.value, e && 0 === n) throw this.createNoExtraBytesError(this.totalPos);
                                    this.appendBuffer(s), r && (n = this.readArraySize(), r = !1, this.complete()), f.label = 4;
                                case 4:
                                    f.trys.push([
                                        4,
                                        9,
                                        ,
                                        10
                                    ]), f.label = 5;
                                case 5:
                                    return [
                                        4,
                                        N(this.doDecodeSync())
                                    ];
                                case 6:
                                    return [
                                        4,
                                        f.sent()
                                    ];
                                case 7:
                                    return f.sent(), 0 == --n ? [
                                        3,
                                        8
                                    ] : [
                                        3,
                                        5
                                    ];
                                case 8:
                                    return [
                                        3,
                                        10
                                    ];
                                case 9:
                                    if (!((a = f.sent()) instanceof j)) throw a;
                                    return [
                                        3,
                                        10
                                    ];
                                case 10:
                                    this.totalPos += this.pos, f.label = 11;
                                case 11:
                                    return [
                                        3,
                                        2
                                    ];
                                case 12:
                                    return [
                                        3,
                                        19
                                    ];
                                case 13:
                                    return h = f.sent(), u = {
                                        error: h
                                    }, [
                                        3,
                                        19
                                    ];
                                case 14:
                                    return f.trys.push([
                                        14,
                                        ,
                                        17,
                                        18
                                    ]), o && !o.done && (c = i.return) ? [
                                        4,
                                        N(c.call(i))
                                    ] : [
                                        3,
                                        16
                                    ];
                                case 15:
                                    f.sent(), f.label = 16;
                                case 16:
                                    return [
                                        3,
                                        18
                                    ];
                                case 17:
                                    if (u) throw u.error;
                                    return [
                                        7
                                    ];
                                case 18:
                                    return [
                                        7
                                    ];
                                case 19:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, t.prototype.doDecodeSync = function() {
                    t: for(;;){
                        var t = this.readHeadByte(), e = void 0;
                        if (t >= 224) e = t - 256;
                        else if (t < 192) {
                            if (t < 128) e = t;
                            else if (t < 144) {
                                if (0 !== (n = t - 128)) {
                                    this.pushMapState(n), this.complete();
                                    continue t;
                                }
                                e = {};
                            } else if (t < 160) {
                                if (0 !== (n = t - 144)) {
                                    this.pushArrayState(n), this.complete();
                                    continue t;
                                }
                                e = [];
                            } else {
                                var r = t - 160;
                                e = this.decodeUtf8String(r, 0);
                            }
                        } else if (192 === t) e = null;
                        else if (194 === t) e = !1;
                        else if (195 === t) e = !0;
                        else if (202 === t) e = this.readF32();
                        else if (203 === t) e = this.readF64();
                        else if (204 === t) e = this.readU8();
                        else if (205 === t) e = this.readU16();
                        else if (206 === t) e = this.readU32();
                        else if (207 === t) e = this.readU64();
                        else if (208 === t) e = this.readI8();
                        else if (209 === t) e = this.readI16();
                        else if (210 === t) e = this.readI32();
                        else if (211 === t) e = this.readI64();
                        else if (217 === t) {
                            r = this.lookU8();
                            e = this.decodeUtf8String(r, 1);
                        } else if (218 === t) {
                            r = this.lookU16();
                            e = this.decodeUtf8String(r, 2);
                        } else if (219 === t) {
                            r = this.lookU32();
                            e = this.decodeUtf8String(r, 4);
                        } else if (220 === t) {
                            if (0 !== (n = this.readU16())) {
                                this.pushArrayState(n), this.complete();
                                continue t;
                            }
                            e = [];
                        } else if (221 === t) {
                            if (0 !== (n = this.readU32())) {
                                this.pushArrayState(n), this.complete();
                                continue t;
                            }
                            e = [];
                        } else if (222 === t) {
                            if (0 !== (n = this.readU16())) {
                                this.pushMapState(n), this.complete();
                                continue t;
                            }
                            e = {};
                        } else if (223 === t) {
                            if (0 !== (n = this.readU32())) {
                                this.pushMapState(n), this.complete();
                                continue t;
                            }
                            e = {};
                        } else if (196 === t) {
                            var n = this.lookU8();
                            e = this.decodeBinary(n, 1);
                        } else if (197 === t) {
                            n = this.lookU16();
                            e = this.decodeBinary(n, 2);
                        } else if (198 === t) {
                            n = this.lookU32();
                            e = this.decodeBinary(n, 4);
                        } else if (212 === t) e = this.decodeExtension(1, 0);
                        else if (213 === t) e = this.decodeExtension(2, 0);
                        else if (214 === t) e = this.decodeExtension(4, 0);
                        else if (215 === t) e = this.decodeExtension(8, 0);
                        else if (216 === t) e = this.decodeExtension(16, 0);
                        else if (199 === t) {
                            n = this.lookU8();
                            e = this.decodeExtension(n, 1);
                        } else if (200 === t) {
                            n = this.lookU16();
                            e = this.decodeExtension(n, 2);
                        } else {
                            if (201 !== t) throw new Error("Unrecognized type byte: " + L(t));
                            n = this.lookU32();
                            e = this.decodeExtension(n, 4);
                        }
                        this.complete();
                        for(var i = this.stack; i.length > 0;){
                            var o = i[i.length - 1];
                            if (0 === o.type) {
                                if (o.array[o.position] = e, o.position++, o.position !== o.size) continue t;
                                i.pop(), e = o.array;
                            } else {
                                if (1 === o.type) {
                                    if (s = void 0, "string" !== (s = typeof e) && "number" !== s) throw new Error("The type of key must be string or number but " + typeof e);
                                    o.key = e, o.type = 2;
                                    continue t;
                                }
                                if (o.map[o.key] = e, o.readCount++, o.readCount !== o.size) {
                                    o.key = null, o.type = 1;
                                    continue t;
                                }
                                i.pop(), e = o.map;
                            }
                        }
                        return e;
                    }
                    var s;
                }, t.prototype.readHeadByte = function() {
                    return -1 === this.headByte && (this.headByte = this.readU8()), this.headByte;
                }, t.prototype.complete = function() {
                    this.headByte = -1;
                }, t.prototype.readArraySize = function() {
                    var t = this.readHeadByte();
                    switch(t){
                        case 220:
                            return this.readU16();
                        case 221:
                            return this.readU32();
                        default:
                            if (t < 160) return t - 144;
                            throw new Error("Unrecognized array type byte: " + L(t));
                    }
                }, t.prototype.pushMapState = function(t) {
                    if (t > this.maxMapLength) throw new Error("Max length exceeded: map length (" + t + ") > maxMapLengthLength (" + this.maxMapLength + ")");
                    this.stack.push({
                        type: 1,
                        size: t,
                        key: null,
                        readCount: 0,
                        map: {}
                    });
                }, t.prototype.pushArrayState = function(t) {
                    if (t > this.maxArrayLength) throw new Error("Max length exceeded: array length (" + t + ") > maxArrayLength (" + this.maxArrayLength + ")");
                    this.stack.push({
                        type: 0,
                        size: t,
                        array: new Array(t),
                        position: 0
                    });
                }, t.prototype.decodeUtf8String = function(t, e) {
                    var r;
                    if (t > this.maxStrLength) throw new Error("Max length exceeded: UTF-8 byte length (" + t + ") > maxStrLength (" + this.maxStrLength + ")");
                    if (this.bytes.byteLength < this.pos + e + t) throw _;
                    var n, i = this.pos + e;
                    return n = this.stateIsMapKey() && (null === (r = this.keyDecoder) || void 0 === r ? void 0 : r.canBeCached(t)) ? this.keyDecoder.decode(this.bytes, i, t) : o && t > l ? function(t, e, r) {
                        var n = t.subarray(e, e + r);
                        return f.decode(n);
                    }(this.bytes, i, t) : c(this.bytes, i, t), this.pos += e + t, n;
                }, t.prototype.stateIsMapKey = function() {
                    return this.stack.length > 0 && 1 === this.stack[this.stack.length - 1].type;
                }, t.prototype.decodeBinary = function(t, e) {
                    if (t > this.maxBinLength) throw new Error("Max length exceeded: bin length (" + t + ") > maxBinLength (" + this.maxBinLength + ")");
                    if (!this.hasRemaining(t + e)) throw _;
                    var r = this.pos + e, n = this.bytes.subarray(r, r + t);
                    return this.pos += e + t, n;
                }, t.prototype.decodeExtension = function(t, e) {
                    if (t > this.maxExtLength) throw new Error("Max length exceeded: ext length (" + t + ") > maxExtLength (" + this.maxExtLength + ")");
                    var r = this.view.getInt8(this.pos + e), n = this.decodeBinary(t, e + 1);
                    return this.extensionCodec.decode(n, r, this.context);
                }, t.prototype.lookU8 = function() {
                    return this.view.getUint8(this.pos);
                }, t.prototype.lookU16 = function() {
                    return this.view.getUint16(this.pos);
                }, t.prototype.lookU32 = function() {
                    return this.view.getUint32(this.pos);
                }, t.prototype.readU8 = function() {
                    var t = this.view.getUint8(this.pos);
                    return this.pos++, t;
                }, t.prototype.readI8 = function() {
                    var t = this.view.getInt8(this.pos);
                    return this.pos++, t;
                }, t.prototype.readU16 = function() {
                    var t = this.view.getUint16(this.pos);
                    return this.pos += 2, t;
                }, t.prototype.readI16 = function() {
                    var t = this.view.getInt16(this.pos);
                    return this.pos += 2, t;
                }, t.prototype.readU32 = function() {
                    var t = this.view.getUint32(this.pos);
                    return this.pos += 4, t;
                }, t.prototype.readI32 = function() {
                    var t = this.view.getInt32(this.pos);
                    return this.pos += 4, t;
                }, t.prototype.readU64 = function() {
                    var t, e, r, n, i = (t = this.view, e = this.pos, r = t.getUint32(e), n = t.getUint32(e + 4), r > Math.floor(Number.MAX_SAFE_INTEGER / 4294967296) ? BigInt(r) * BigInt(4294967296) + BigInt(n) : 4294967296 * r + n);
                    return this.pos += 8, i;
                }, t.prototype.readI64 = function() {
                    var t = y(this.view, this.pos);
                    return this.pos += 8, t;
                }, t.prototype.readF32 = function() {
                    var t = this.view.getFloat32(this.pos);
                    return this.pos += 4, t;
                }, t.prototype.readF64 = function() {
                    var t = this.view.getFloat64(this.pos);
                    return this.pos += 8, t;
                }, t;
            }(), R = {};
            function V(t, e) {
                return void 0 === e && (e = R), new O(e.extensionCodec, e.context, e.maxStrLength, e.maxBinLength, e.maxArrayLength, e.maxMapLength, e.maxExtLength).decode(t);
            }
            var K = function(t, e) {
                var r, n, i, o, s = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    throw: a(1),
                    return: a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function a(o) {
                    return function(a) {
                        return function(o) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for(; s;)try {
                                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                switch(n = 0, i && (o = [
                                    2 & o[0],
                                    i.value
                                ]), o[0]){
                                    case 0:
                                    case 1:
                                        i = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue;
                                        }
                                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                            s.label = o[1];
                                            break;
                                        }
                                        if (6 === o[0] && s.label < i[1]) {
                                            s.label = i[1], i = o;
                                            break;
                                        }
                                        if (i && s.label < i[2]) {
                                            s.label = i[2], s.ops.push(o);
                                            break;
                                        }
                                        i[2] && s.ops.pop(), s.trys.pop();
                                        continue;
                                }
                                o = e.call(t, s);
                            } catch (t) {
                                o = [
                                    6,
                                    t
                                ], n = 0;
                            } finally{
                                r = i = 0;
                            }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            };
                        }([
                            o,
                            a
                        ]);
                    };
                }
            }, G = function(t) {
                return this instanceof G ? (this.v = t, this) : new G(t);
            }, H = function(t, e, r) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var n, i = r.apply(t, e || []), o = [];
                return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function() {
                    return this;
                }, n;
                function s(t) {
                    i[t] && (n[t] = function(e) {
                        return new Promise(function(r, n) {
                            o.push([
                                t,
                                e,
                                r,
                                n
                            ]) > 1 || a(t, e);
                        });
                    });
                }
                function a(t, e) {
                    try {
                        (r = i[t](e)).value instanceof G ? Promise.resolve(r.value.v).then(h, u) : c(o[0][2], r);
                    } catch (t) {
                        c(o[0][3], t);
                    }
                    var r;
                }
                function h(t) {
                    a("next", t);
                }
                function u(t) {
                    a("throw", t);
                }
                function c(t, e) {
                    t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
                }
            };
            function X(t) {
                if (null == t) throw new Error("Assertion Failure: value must not be null nor undefined");
            }
            function q(t) {
                return null != t[Symbol.asyncIterator] ? t : function(t) {
                    return H(this, arguments, function() {
                        var e, r, n, i;
                        return K(this, function(o) {
                            switch(o.label){
                                case 0:
                                    e = t.getReader(), o.label = 1;
                                case 1:
                                    o.trys.push([
                                        1,
                                        ,
                                        9,
                                        10
                                    ]), o.label = 2;
                                case 2:
                                    return [
                                        4,
                                        G(e.read())
                                    ];
                                case 3:
                                    return r = o.sent(), n = r.done, i = r.value, n ? [
                                        4,
                                        G(void 0)
                                    ] : [
                                        3,
                                        5
                                    ];
                                case 4:
                                    return [
                                        2,
                                        o.sent()
                                    ];
                                case 5:
                                    return X(i), [
                                        4,
                                        G(i)
                                    ];
                                case 6:
                                    return [
                                        4,
                                        o.sent()
                                    ];
                                case 7:
                                    return o.sent(), [
                                        3,
                                        2
                                    ];
                                case 8:
                                    return [
                                        3,
                                        10
                                    ];
                                case 9:
                                    return e.releaseLock(), [
                                        7
                                    ];
                                case 10:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }(t);
            }
            var J = function(t, e, r, n) {
                return new (r || (r = Promise))(function(i, o) {
                    function s(t) {
                        try {
                            h(n.next(t));
                        } catch (t) {
                            o(t);
                        }
                    }
                    function a(t) {
                        try {
                            h(n.throw(t));
                        } catch (t) {
                            o(t);
                        }
                    }
                    function h(t) {
                        var e;
                        t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                            t(e);
                        })).then(s, a);
                    }
                    h((n = n.apply(t, e || [])).next());
                });
            }, Q = function(t, e) {
                var r, n, i, o, s = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    throw: a(1),
                    return: a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function a(o) {
                    return function(a) {
                        return function(o) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for(; s;)try {
                                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                switch(n = 0, i && (o = [
                                    2 & o[0],
                                    i.value
                                ]), o[0]){
                                    case 0:
                                    case 1:
                                        i = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue;
                                        }
                                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                            s.label = o[1];
                                            break;
                                        }
                                        if (6 === o[0] && s.label < i[1]) {
                                            s.label = i[1], i = o;
                                            break;
                                        }
                                        if (i && s.label < i[2]) {
                                            s.label = i[2], s.ops.push(o);
                                            break;
                                        }
                                        i[2] && s.ops.pop(), s.trys.pop();
                                        continue;
                                }
                                o = e.call(t, s);
                            } catch (t) {
                                o = [
                                    6,
                                    t
                                ], n = 0;
                            } finally{
                                r = i = 0;
                            }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            };
                        }([
                            o,
                            a
                        ]);
                    };
                }
            };
            function Y(t, e) {
                return void 0 === e && (e = R), J(this, void 0, void 0, function() {
                    var r;
                    return Q(this, function(n) {
                        return r = q(t), [
                            2,
                            new O(e.extensionCodec, e.context, e.maxStrLength, e.maxBinLength, e.maxArrayLength, e.maxMapLength, e.maxExtLength).decodeAsync(r)
                        ];
                    });
                });
            }
            function Z(t, e) {
                void 0 === e && (e = R);
                var r = q(t);
                return new O(e.extensionCodec, e.context, e.maxStrLength, e.maxBinLength, e.maxArrayLength, e.maxMapLength, e.maxExtLength).decodeArrayStream(r);
            }
            function $(t, e) {
                void 0 === e && (e = R);
                var r = q(t);
                return new O(e.extensionCodec, e.context, e.maxStrLength, e.maxBinLength, e.maxArrayLength, e.maxMapLength, e.maxExtLength).decodeStream(r);
            }
        }
    ]);
});

},{"178201740996c230":"13Pcp"}],"1n32l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORAND_MIN_TX_FEE", ()=>ALGORAND_MIN_TX_FEE);
/**
 * Transaction enables construction of Algorand transactions
 * */ parcelHelpers.export(exports, "Transaction", ()=>Transaction);
/**
 * encodeUnsignedSimulateTransaction takes a txnBuilder.Transaction object,
 * converts it into a SignedTransaction-like object, and converts it to a Buffer.
 *
 * Note: this function should only be used to simulate unsigned transactions.
 *
 * @param transactionObject - Transaction object to simulate.
 */ parcelHelpers.export(exports, "encodeUnsignedSimulateTransaction", ()=>encodeUnsignedSimulateTransaction);
/**
 * encodeUnsignedTransaction takes a completed txnBuilder.Transaction object, such as from the makeFoo
 * family of transactions, and converts it to a Buffer
 * @param transactionObject - the completed Transaction object
 */ parcelHelpers.export(exports, "encodeUnsignedTransaction", ()=>encodeUnsignedTransaction);
/**
 * decodeUnsignedTransaction takes a Buffer (as if from encodeUnsignedTransaction) and converts it to a txnBuilder.Transaction object
 * @param transactionBuffer - the Uint8Array containing a transaction
 */ parcelHelpers.export(exports, "decodeUnsignedTransaction", ()=>decodeUnsignedTransaction);
/**
 * decodeSignedTransaction takes a Buffer (from transaction.signTxn) and converts it to an object
 * containing the Transaction (txn), the signature (sig), and the auth-addr field if applicable (sgnr)
 * @param transactionBuffer - the Uint8Array containing a transaction
 * @returns containing a Transaction, the signature, and possibly an auth-addr field
 */ parcelHelpers.export(exports, "decodeSignedTransaction", ()=>decodeSignedTransaction);
parcelHelpers.export(exports, "instantiateTxnIfNeeded", ()=>instantiateTxnIfNeeded);
var _buffer = require("buffer");
var _hiBase32 = require("hi-base32");
var _hiBase32Default = parcelHelpers.interopDefault(_hiBase32);
var _address = require("./encoding/address");
var _encoding = require("./encoding/encoding");
var _naclWrappers = require("./nacl/naclWrappers");
var _utils = require("./utils/utils");
var _boxStorage = require("./boxStorage");
var _base = require("./types/transactions/base");
const ALGORAND_TRANSACTION_LENGTH = 52;
const ALGORAND_MIN_TX_FEE = 1000; // version v5
const ALGORAND_TRANSACTION_LEASE_LENGTH = 32;
const ALGORAND_MAX_ASSET_DECIMALS = 19;
const NUM_ADDL_BYTES_AFTER_SIGNING = 75; // NUM_ADDL_BYTES_AFTER_SIGNING is the number of bytes added to a txn after signing it
const ALGORAND_TRANSACTION_LEASE_LABEL_LENGTH = 5;
const ALGORAND_TRANSACTION_ADDRESS_LENGTH = 32;
const ALGORAND_TRANSACTION_REKEY_LABEL_LENGTH = 5;
const ASSET_METADATA_HASH_LENGTH = 32;
const KEYREG_VOTE_KEY_LENGTH = 32;
const KEYREG_SELECTION_KEY_LENGTH = 32;
const KEYREG_STATE_PROOF_KEY_LENGTH = 64;
function getKeyregKey(input, inputName, length) {
    if (input == null) return undefined;
    let inputAsBuffer;
    if (typeof input === "string") inputAsBuffer = (0, _buffer.Buffer).from(input, "base64");
    else if (input.constructor === Uint8Array) inputAsBuffer = (0, _buffer.Buffer).from(input);
    else if ((0, _buffer.Buffer).isBuffer(input)) inputAsBuffer = input;
    if (inputAsBuffer == null || inputAsBuffer.byteLength !== length) throw Error(`${inputName} must be a ${length} byte Uint8Array or Buffer or base64 string.`);
    return inputAsBuffer;
}
class Transaction {
    constructor({ ...transaction }){
        this.name = "Transaction";
        this.tag = (0, _buffer.Buffer).from("TX");
        // Populate defaults
        /* eslint-disable no-param-reassign */ const defaults = {
            type: (0, _base.TransactionType).pay,
            flatFee: false,
            nonParticipation: false
        };
        // Default type
        if (typeof transaction.type === "undefined") transaction.type = defaults.type;
        // Default flatFee
        if (typeof transaction.flatFee === "undefined") transaction.flatFee = defaults.flatFee;
        // Default nonParticipation
        if (transaction.type === (0, _base.TransactionType).keyreg && typeof transaction.voteKey !== "undefined" && typeof transaction.nonParticipation === "undefined") transaction.nonParticipation = defaults.nonParticipation;
        /* eslint-enable no-param-reassign */ // Move suggested parameters from its object to inline
        if (transaction.suggestedParams !== undefined) {
            // Create a temporary reference to the transaction object that has params inline and also as a suggested params object
            //   - Helpful for moving params from named object to inline
            const reference = transaction;
            reference.genesisHash = reference.suggestedParams.genesisHash;
            reference.fee = reference.suggestedParams.fee;
            if (reference.suggestedParams.flatFee !== undefined) reference.flatFee = reference.suggestedParams.flatFee;
            reference.firstRound = reference.suggestedParams.firstRound;
            reference.lastRound = reference.suggestedParams.lastRound;
            reference.genesisID = reference.suggestedParams.genesisID;
        }
        // At this point all suggestedParams have been moved to be inline, so we can reassign the transaction object type
        // to one which is more useful as we prepare properties for storing
        const txn = transaction;
        txn.from = _address.decodeAddress(txn.from);
        if (txn.to !== undefined) txn.to = _address.decodeAddress(txn.to);
        if (txn.closeRemainderTo !== undefined) txn.closeRemainderTo = _address.decodeAddress(txn.closeRemainderTo);
        if (txn.assetManager !== undefined) txn.assetManager = _address.decodeAddress(txn.assetManager);
        if (txn.assetReserve !== undefined) txn.assetReserve = _address.decodeAddress(txn.assetReserve);
        if (txn.assetFreeze !== undefined) txn.assetFreeze = _address.decodeAddress(txn.assetFreeze);
        if (txn.assetClawback !== undefined) txn.assetClawback = _address.decodeAddress(txn.assetClawback);
        if (txn.assetRevocationTarget !== undefined) txn.assetRevocationTarget = _address.decodeAddress(txn.assetRevocationTarget);
        if (txn.freezeAccount !== undefined) txn.freezeAccount = _address.decodeAddress(txn.freezeAccount);
        if (txn.reKeyTo !== undefined) txn.reKeyTo = _address.decodeAddress(txn.reKeyTo);
        if (txn.genesisHash === undefined) throw Error("genesis hash must be specified and in a base64 string.");
        txn.genesisHash = (0, _buffer.Buffer).from(txn.genesisHash, "base64");
        if (txn.amount !== undefined && (!(Number.isSafeInteger(txn.amount) || typeof txn.amount === "bigint" && txn.amount <= BigInt("0xffffffffffffffff")) || txn.amount < 0)) throw Error("Amount must be a positive number and smaller than 2^64-1. If the number is larger than 2^53-1, use bigint.");
        if (!Number.isSafeInteger(txn.fee) || txn.fee < 0) throw Error("fee must be a positive number and smaller than 2^53-1");
        if (!Number.isSafeInteger(txn.firstRound) || txn.firstRound < 0) throw Error("firstRound must be a positive number");
        if (!Number.isSafeInteger(txn.lastRound) || txn.lastRound < 0) throw Error("lastRound must be a positive number");
        if (txn.extraPages !== undefined && (!Number.isInteger(txn.extraPages) || txn.extraPages < 0 || txn.extraPages > 3)) throw Error("extraPages must be an Integer between and including 0 to 3");
        if (txn.assetTotal !== undefined && (!(Number.isSafeInteger(txn.assetTotal) || typeof txn.assetTotal === "bigint" && txn.assetTotal <= BigInt("0xffffffffffffffff")) || txn.assetTotal < 0)) throw Error("Total asset issuance must be a positive number and smaller than 2^64-1. If the number is larger than 2^53-1, use bigint.");
        if (txn.assetDecimals !== undefined && (!Number.isSafeInteger(txn.assetDecimals) || txn.assetDecimals < 0 || txn.assetDecimals > ALGORAND_MAX_ASSET_DECIMALS)) throw Error(`assetDecimals must be a positive number and smaller than ${ALGORAND_MAX_ASSET_DECIMALS.toString()}`);
        if (txn.assetIndex !== undefined && (!Number.isSafeInteger(txn.assetIndex) || txn.assetIndex < 0)) throw Error("Asset index must be a positive number and smaller than 2^53-1");
        if (txn.appIndex !== undefined && (!Number.isSafeInteger(txn.appIndex) || txn.appIndex < 0)) throw Error("Application index must be a positive number and smaller than 2^53-1");
        if (txn.appLocalInts !== undefined && (!Number.isSafeInteger(txn.appLocalInts) || txn.appLocalInts < 0)) throw Error("Application local ints count must be a positive number and smaller than 2^53-1");
        if (txn.appLocalByteSlices !== undefined && (!Number.isSafeInteger(txn.appLocalByteSlices) || txn.appLocalByteSlices < 0)) throw Error("Application local byte slices count must be a positive number and smaller than 2^53-1");
        if (txn.appGlobalInts !== undefined && (!Number.isSafeInteger(txn.appGlobalInts) || txn.appGlobalInts < 0)) throw Error("Application global ints count must be a positive number and smaller than 2^53-1");
        if (txn.appGlobalByteSlices !== undefined && (!Number.isSafeInteger(txn.appGlobalByteSlices) || txn.appGlobalByteSlices < 0)) throw Error("Application global byte slices count must be a positive number and smaller than 2^53-1");
        if (txn.appApprovalProgram !== undefined) {
            if (txn.appApprovalProgram.constructor !== Uint8Array) throw Error("appApprovalProgram must be a Uint8Array.");
        }
        if (txn.appClearProgram !== undefined) {
            if (txn.appClearProgram.constructor !== Uint8Array) throw Error("appClearProgram must be a Uint8Array.");
        }
        if (txn.appArgs !== undefined) {
            if (!Array.isArray(txn.appArgs)) throw Error("appArgs must be an Array of Uint8Array.");
            txn.appArgs = txn.appArgs.slice();
            txn.appArgs.forEach((arg)=>{
                if (arg.constructor !== Uint8Array) throw Error("each element of AppArgs must be a Uint8Array.");
            });
        } else txn.appArgs = [];
        if (txn.appAccounts !== undefined) {
            if (!Array.isArray(txn.appAccounts)) throw Error("appAccounts must be an Array of addresses.");
            txn.appAccounts = txn.appAccounts.map((addressAsString)=>_address.decodeAddress(addressAsString));
        }
        if (txn.appForeignApps !== undefined) {
            if (!Array.isArray(txn.appForeignApps)) throw Error("appForeignApps must be an Array of integers.");
            txn.appForeignApps = txn.appForeignApps.slice();
            txn.appForeignApps.forEach((foreignAppIndex)=>{
                if (!Number.isSafeInteger(foreignAppIndex) || foreignAppIndex < 0) throw Error("each foreign application index must be a positive number and smaller than 2^53-1");
            });
        }
        if (txn.appForeignAssets !== undefined) {
            if (!Array.isArray(txn.appForeignAssets)) throw Error("appForeignAssets must be an Array of integers.");
            txn.appForeignAssets = txn.appForeignAssets.slice();
            txn.appForeignAssets.forEach((foreignAssetIndex)=>{
                if (!Number.isSafeInteger(foreignAssetIndex) || foreignAssetIndex < 0) throw Error("each foreign asset index must be a positive number and smaller than 2^53-1");
            });
        }
        if (txn.boxes !== undefined) {
            if (!Array.isArray(txn.boxes)) throw Error("boxes must be an Array of BoxReference.");
            txn.boxes = txn.boxes.slice();
            txn.boxes.forEach((box)=>{
                if (!Number.isSafeInteger(box.appIndex) || box.name.constructor !== Uint8Array) throw Error("box app index must be a number and name must be an Uint8Array.");
            });
        }
        if (txn.assetMetadataHash !== undefined && txn.assetMetadataHash.length !== 0) {
            if (typeof txn.assetMetadataHash === "string") txn.assetMetadataHash = new Uint8Array((0, _buffer.Buffer).from(txn.assetMetadataHash));
            if (txn.assetMetadataHash.constructor !== Uint8Array || txn.assetMetadataHash.byteLength !== ASSET_METADATA_HASH_LENGTH) throw Error(`assetMetadataHash must be a ${ASSET_METADATA_HASH_LENGTH} byte Uint8Array or string.`);
            if (txn.assetMetadataHash.every((value)=>value === 0)) // if hash contains all 0s, omit it
            txn.assetMetadataHash = undefined;
        } else txn.assetMetadataHash = undefined;
        if (txn.note !== undefined) {
            if (txn.note.constructor !== Uint8Array) throw Error("note must be a Uint8Array.");
        } else txn.note = new Uint8Array(0);
        if (txn.lease !== undefined) {
            if (txn.lease.constructor !== Uint8Array) throw Error("lease must be a Uint8Array.");
            if (txn.lease.length !== ALGORAND_TRANSACTION_LEASE_LENGTH) throw Error(`lease must be of length ${ALGORAND_TRANSACTION_LEASE_LENGTH.toString()}.`);
            if (txn.lease.every((value)=>value === 0)) // if lease contains all 0s, omit it
            txn.lease = new Uint8Array(0);
        } else txn.lease = new Uint8Array(0);
        txn.voteKey = getKeyregKey(txn.voteKey, "voteKey", KEYREG_VOTE_KEY_LENGTH);
        txn.selectionKey = getKeyregKey(txn.selectionKey, "selectionKey", KEYREG_SELECTION_KEY_LENGTH);
        txn.stateProofKey = getKeyregKey(txn.stateProofKey, "stateProofKey", KEYREG_STATE_PROOF_KEY_LENGTH);
        // Checking non-participation key registration
        if (txn.nonParticipation && (txn.voteKey || txn.selectionKey || txn.voteFirst || txn.stateProofKey || txn.voteLast || txn.voteKeyDilution)) throw new Error("nonParticipation is true but participation params are present.");
        // Checking online key registration
        if (!txn.nonParticipation && (txn.voteKey || txn.selectionKey || txn.stateProofKey || txn.voteFirst || txn.voteLast || txn.voteKeyDilution) && !(txn.voteKey && txn.selectionKey && txn.voteFirst && txn.voteLast && txn.voteKeyDilution)) throw new Error("online key registration missing at least one of the following fields: voteKey, selectionKey, voteFirst, voteLast, voteKeyDilution");
        // The last option is an offline key registration where all the fields
        // nonParticipation, voteKey, selectionKey, voteFirst, voteLast, voteKeyDilution
        // are all undefined/false
        // Remove unwanted properties and store transaction on instance
        delete txn.suggestedParams;
        Object.assign(this, _utils.removeUndefinedProperties(txn));
        // Modify Fee
        if (!txn.flatFee) {
            this.fee *= this.estimateSize();
            // If suggested fee too small and will be rejected, set to min tx fee
            if (this.fee < ALGORAND_MIN_TX_FEE) this.fee = ALGORAND_MIN_TX_FEE;
        }
        // say we are aware of groups
        this.group = undefined;
        // stpf fields
        if (txn.stateProofType !== undefined && (!Number.isSafeInteger(txn.stateProofType) || txn.stateProofType < 0)) throw Error("State Proof type must be a positive number and smaller than 2^53-1");
        if (txn.stateProofMessage !== undefined) {
            if (txn.stateProofMessage.constructor !== Uint8Array) throw Error("stateProofMessage must be a Uint8Array.");
        } else txn.stateProofMessage = new Uint8Array(0);
        if (txn.stateProof !== undefined) {
            if (txn.stateProof.constructor !== Uint8Array) throw Error("stateProof must be a Uint8Array.");
        } else txn.stateProof = new Uint8Array(0);
    }
    // eslint-disable-next-line camelcase
    get_obj_for_encoding() {
        if (this.type === "pay") {
            const txn = {
                amt: this.amount,
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                type: "pay",
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                grp: this.group
            };
            // parse close address
            if (this.closeRemainderTo !== undefined && _address.encodeAddress(this.closeRemainderTo.publicKey) !== _address.ALGORAND_ZERO_ADDRESS_STRING) txn.close = (0, _buffer.Buffer).from(this.closeRemainderTo.publicKey);
            if (this.reKeyTo !== undefined) txn.rekey = (0, _buffer.Buffer).from(this.reKeyTo.publicKey);
            // allowed zero values
            if (this.to !== undefined) txn.rcv = (0, _buffer.Buffer).from(this.to.publicKey);
            if (!txn.note.length) delete txn.note;
            if (!txn.amt) delete txn.amt;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (txn.grp === undefined) delete txn.grp;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.rekey) delete txn.rekey;
            return txn;
        }
        if (this.type === "keyreg") {
            const txn = {
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                type: this.type,
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                grp: this.group,
                votekey: this.voteKey,
                selkey: this.selectionKey,
                sprfkey: this.stateProofKey,
                votefst: this.voteFirst,
                votelst: this.voteLast,
                votekd: this.voteKeyDilution
            };
            // allowed zero values
            if (!txn.note.length) delete txn.note;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (txn.grp === undefined) delete txn.grp;
            if (this.reKeyTo !== undefined) txn.rekey = (0, _buffer.Buffer).from(this.reKeyTo.publicKey);
            if (this.nonParticipation) txn.nonpart = true;
            if (!txn.selkey) delete txn.selkey;
            if (!txn.votekey) delete txn.votekey;
            if (!txn.sprfkey) delete txn.sprfkey;
            if (!txn.votefst) delete txn.votefst;
            if (!txn.votelst) delete txn.votelst;
            if (!txn.votekd) delete txn.votekd;
            return txn;
        }
        if (this.type === "acfg") {
            // asset creation, or asset reconfigure, or asset destruction
            const txn = {
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                type: this.type,
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                grp: this.group,
                caid: this.assetIndex,
                apar: {
                    t: this.assetTotal,
                    df: this.assetDefaultFrozen,
                    dc: this.assetDecimals
                }
            };
            if (this.assetManager !== undefined) txn.apar.m = (0, _buffer.Buffer).from(this.assetManager.publicKey);
            if (this.assetReserve !== undefined) txn.apar.r = (0, _buffer.Buffer).from(this.assetReserve.publicKey);
            if (this.assetFreeze !== undefined) txn.apar.f = (0, _buffer.Buffer).from(this.assetFreeze.publicKey);
            if (this.assetClawback !== undefined) txn.apar.c = (0, _buffer.Buffer).from(this.assetClawback.publicKey);
            if (this.assetName !== undefined) txn.apar.an = this.assetName;
            if (this.assetUnitName !== undefined) txn.apar.un = this.assetUnitName;
            if (this.assetURL !== undefined) txn.apar.au = this.assetURL;
            if (this.assetMetadataHash !== undefined) txn.apar.am = (0, _buffer.Buffer).from(this.assetMetadataHash);
            // allowed zero values
            if (!txn.note.length) delete txn.note;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.amt) delete txn.amt;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (this.reKeyTo !== undefined) txn.rekey = (0, _buffer.Buffer).from(this.reKeyTo.publicKey);
            if (!txn.caid) delete txn.caid;
            if (!txn.apar.t && !txn.apar.un && !txn.apar.an && !txn.apar.df && !txn.apar.m && !txn.apar.r && !txn.apar.f && !txn.apar.c && !txn.apar.au && !txn.apar.am && !txn.apar.dc) delete txn.apar;
            else {
                if (!txn.apar.t) delete txn.apar.t;
                if (!txn.apar.dc) delete txn.apar.dc;
                if (!txn.apar.un) delete txn.apar.un;
                if (!txn.apar.an) delete txn.apar.an;
                if (!txn.apar.df) delete txn.apar.df;
                if (!txn.apar.m) delete txn.apar.m;
                if (!txn.apar.r) delete txn.apar.r;
                if (!txn.apar.f) delete txn.apar.f;
                if (!txn.apar.c) delete txn.apar.c;
                if (!txn.apar.au) delete txn.apar.au;
                if (!txn.apar.am) delete txn.apar.am;
            }
            if (txn.grp === undefined) delete txn.grp;
            return txn;
        }
        if (this.type === "axfer") {
            // asset transfer, acceptance, revocation, mint, or burn
            const txn = {
                aamt: this.amount,
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                arcv: (0, _buffer.Buffer).from(this.to.publicKey),
                type: this.type,
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                grp: this.group,
                xaid: this.assetIndex
            };
            if (this.closeRemainderTo !== undefined) txn.aclose = (0, _buffer.Buffer).from(this.closeRemainderTo.publicKey);
            if (this.assetRevocationTarget !== undefined) txn.asnd = (0, _buffer.Buffer).from(this.assetRevocationTarget.publicKey);
            // allowed zero values
            if (!txn.note.length) delete txn.note;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.aamt) delete txn.aamt;
            if (!txn.amt) delete txn.amt;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (txn.grp === undefined) delete txn.grp;
            if (!txn.aclose) delete txn.aclose;
            if (!txn.asnd) delete txn.asnd;
            if (!txn.rekey) delete txn.rekey;
            if (this.reKeyTo !== undefined) txn.rekey = (0, _buffer.Buffer).from(this.reKeyTo.publicKey);
            return txn;
        }
        if (this.type === "afrz") {
            // asset freeze or unfreeze
            const txn = {
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                type: this.type,
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                grp: this.group,
                faid: this.assetIndex,
                afrz: this.freezeState
            };
            if (this.freezeAccount !== undefined) txn.fadd = (0, _buffer.Buffer).from(this.freezeAccount.publicKey);
            // allowed zero values
            if (!txn.note.length) delete txn.note;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.amt) delete txn.amt;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (!txn.afrz) delete txn.afrz;
            if (txn.grp === undefined) delete txn.grp;
            if (this.reKeyTo !== undefined) txn.rekey = (0, _buffer.Buffer).from(this.reKeyTo.publicKey);
            return txn;
        }
        if (this.type === "appl") {
            // application call of some kind
            const txn = {
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                type: this.type,
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                grp: this.group,
                apid: this.appIndex,
                apan: this.appOnComplete,
                apls: {
                    nui: this.appLocalInts,
                    nbs: this.appLocalByteSlices
                },
                apgs: {
                    nui: this.appGlobalInts,
                    nbs: this.appGlobalByteSlices
                },
                apfa: this.appForeignApps,
                apas: this.appForeignAssets,
                apep: this.extraPages,
                apbx: (0, _boxStorage.translateBoxReferences)(this.boxes, this.appForeignApps, this.appIndex)
            };
            if (this.reKeyTo !== undefined) txn.rekey = (0, _buffer.Buffer).from(this.reKeyTo.publicKey);
            if (this.appApprovalProgram !== undefined) txn.apap = (0, _buffer.Buffer).from(this.appApprovalProgram);
            if (this.appClearProgram !== undefined) txn.apsu = (0, _buffer.Buffer).from(this.appClearProgram);
            if (this.appArgs !== undefined) txn.apaa = this.appArgs.map((arg)=>(0, _buffer.Buffer).from(arg));
            if (this.appAccounts !== undefined) txn.apat = this.appAccounts.map((decodedAddress)=>(0, _buffer.Buffer).from(decodedAddress.publicKey));
            // allowed zero values
            if (!txn.note.length) delete txn.note;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.amt) delete txn.amt;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (!txn.apid) delete txn.apid;
            if (!txn.apls.nui) delete txn.apls.nui;
            if (!txn.apls.nbs) delete txn.apls.nbs;
            if (!txn.apls.nui && !txn.apls.nbs) delete txn.apls;
            if (!txn.apgs.nui) delete txn.apgs.nui;
            if (!txn.apgs.nbs) delete txn.apgs.nbs;
            if (!txn.apaa || !txn.apaa.length) delete txn.apaa;
            if (!txn.apgs.nui && !txn.apgs.nbs) delete txn.apgs;
            if (!txn.apap) delete txn.apap;
            if (!txn.apsu) delete txn.apsu;
            if (!txn.apan) delete txn.apan;
            if (!txn.apfa || !txn.apfa.length) delete txn.apfa;
            if (!txn.apas || !txn.apas.length) delete txn.apas;
            for (const box of txn.apbx){
                if (!box.i) delete box.i;
                if (!box.n || !box.n.length) delete box.n;
            }
            if (!txn.apbx || !txn.apbx.length) delete txn.apbx;
            if (!txn.apat || !txn.apat.length) delete txn.apat;
            if (!txn.apep) delete txn.apep;
            if (txn.grp === undefined) delete txn.grp;
            return txn;
        }
        if (this.type === "stpf") {
            // state proof txn
            const txn = {
                fee: this.fee,
                fv: this.firstRound,
                lv: this.lastRound,
                note: (0, _buffer.Buffer).from(this.note),
                snd: (0, _buffer.Buffer).from(this.from.publicKey),
                type: this.type,
                gen: this.genesisID,
                gh: this.genesisHash,
                lx: (0, _buffer.Buffer).from(this.lease),
                sptype: this.stateProofType,
                spmsg: (0, _buffer.Buffer).from(this.stateProofMessage),
                sp: (0, _buffer.Buffer).from(this.stateProof)
            };
            // allowed zero values
            if (!txn.sptype) delete txn.sptype;
            if (!txn.note.length) delete txn.note;
            if (!txn.lx.length) delete txn.lx;
            if (!txn.amt) delete txn.amt;
            if (!txn.fee) delete txn.fee;
            if (!txn.fv) delete txn.fv;
            if (!txn.gen) delete txn.gen;
            if (!txn.apid) delete txn.apid;
            if (!txn.apaa || !txn.apaa.length) delete txn.apaa;
            if (!txn.apap) delete txn.apap;
            if (!txn.apsu) delete txn.apsu;
            if (!txn.apan) delete txn.apan;
            if (!txn.apfa || !txn.apfa.length) delete txn.apfa;
            if (!txn.apas || !txn.apas.length) delete txn.apas;
            if (!txn.apat || !txn.apat.length) delete txn.apat;
            if (!txn.apep) delete txn.apep;
            if (txn.grp === undefined) delete txn.grp;
            return txn;
        }
        return undefined;
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(txnForEnc) {
        const txn = Object.create(this.prototype);
        txn.name = "Transaction";
        txn.tag = (0, _buffer.Buffer).from("TX");
        txn.genesisID = txnForEnc.gen;
        txn.genesisHash = (0, _buffer.Buffer).from(txnForEnc.gh);
        if (!(0, _base.isTransactionType)(txnForEnc.type)) throw new Error(`Unrecognized transaction type: ${txnForEnc.type}`);
        txn.type = txnForEnc.type;
        txn.fee = txnForEnc.fee;
        txn.firstRound = txnForEnc.fv;
        txn.lastRound = txnForEnc.lv;
        txn.note = new Uint8Array(txnForEnc.note);
        txn.lease = new Uint8Array(txnForEnc.lx);
        txn.from = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.snd)));
        if (txnForEnc.grp !== undefined) txn.group = (0, _buffer.Buffer).from(txnForEnc.grp);
        if (txnForEnc.rekey !== undefined) txn.reKeyTo = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.rekey)));
        if (txnForEnc.type === "pay") {
            txn.amount = txnForEnc.amt;
            txn.to = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.rcv)));
            if (txnForEnc.close !== undefined) txn.closeRemainderTo = _address.decodeAddress(_address.encodeAddress(txnForEnc.close));
        } else if (txnForEnc.type === "keyreg") {
            if (txnForEnc.votekey !== undefined) txn.voteKey = (0, _buffer.Buffer).from(txnForEnc.votekey);
            if (txnForEnc.selkey !== undefined) txn.selectionKey = (0, _buffer.Buffer).from(txnForEnc.selkey);
            if (txnForEnc.sprfkey !== undefined) txn.stateProofKey = (0, _buffer.Buffer).from(txnForEnc.sprfkey);
            if (txnForEnc.votekd !== undefined) txn.voteKeyDilution = txnForEnc.votekd;
            if (txnForEnc.votefst !== undefined) txn.voteFirst = txnForEnc.votefst;
            if (txnForEnc.votelst !== undefined) txn.voteLast = txnForEnc.votelst;
            if (txnForEnc.nonpart !== undefined) txn.nonParticipation = txnForEnc.nonpart;
        } else if (txnForEnc.type === "acfg") {
            // asset creation, or asset reconfigure, or asset destruction
            if (txnForEnc.caid !== undefined) txn.assetIndex = txnForEnc.caid;
            if (txnForEnc.apar !== undefined) {
                txn.assetTotal = txnForEnc.apar.t;
                txn.assetDefaultFrozen = txnForEnc.apar.df;
                if (txnForEnc.apar.dc !== undefined) txn.assetDecimals = txnForEnc.apar.dc;
                if (txnForEnc.apar.m !== undefined) txn.assetManager = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.apar.m)));
                if (txnForEnc.apar.r !== undefined) txn.assetReserve = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.apar.r)));
                if (txnForEnc.apar.f !== undefined) txn.assetFreeze = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.apar.f)));
                if (txnForEnc.apar.c !== undefined) txn.assetClawback = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.apar.c)));
                if (txnForEnc.apar.un !== undefined) txn.assetUnitName = txnForEnc.apar.un;
                if (txnForEnc.apar.an !== undefined) txn.assetName = txnForEnc.apar.an;
                if (txnForEnc.apar.au !== undefined) txn.assetURL = txnForEnc.apar.au;
                if (txnForEnc.apar.am !== undefined) txn.assetMetadataHash = txnForEnc.apar.am;
            }
        } else if (txnForEnc.type === "axfer") {
            // asset transfer, acceptance, revocation, mint, or burn
            if (txnForEnc.xaid !== undefined) txn.assetIndex = txnForEnc.xaid;
            if (txnForEnc.aamt !== undefined) txn.amount = txnForEnc.aamt;
            if (txnForEnc.aclose !== undefined) txn.closeRemainderTo = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.aclose)));
            if (txnForEnc.asnd !== undefined) txn.assetRevocationTarget = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.asnd)));
            txn.to = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.arcv)));
        } else if (txnForEnc.type === "afrz") {
            if (txnForEnc.afrz !== undefined) txn.freezeState = txnForEnc.afrz;
            if (txnForEnc.faid !== undefined) txn.assetIndex = txnForEnc.faid;
            txn.freezeAccount = _address.decodeAddress(_address.encodeAddress(new Uint8Array(txnForEnc.fadd)));
        } else if (txnForEnc.type === "appl") {
            if (txnForEnc.apid !== undefined) txn.appIndex = txnForEnc.apid;
            if (txnForEnc.apan !== undefined) txn.appOnComplete = txnForEnc.apan;
            if (txnForEnc.apls !== undefined) {
                if (txnForEnc.apls.nui !== undefined) txn.appLocalInts = txnForEnc.apls.nui;
                if (txnForEnc.apls.nbs !== undefined) txn.appLocalByteSlices = txnForEnc.apls.nbs;
            }
            if (txnForEnc.apgs !== undefined) {
                if (txnForEnc.apgs.nui !== undefined) txn.appGlobalInts = txnForEnc.apgs.nui;
                if (txnForEnc.apgs.nbs !== undefined) txn.appGlobalByteSlices = txnForEnc.apgs.nbs;
            }
            if (txnForEnc.apep !== undefined) txn.extraPages = txnForEnc.apep;
            if (txnForEnc.apap !== undefined) txn.appApprovalProgram = new Uint8Array(txnForEnc.apap);
            if (txnForEnc.apsu !== undefined) txn.appClearProgram = new Uint8Array(txnForEnc.apsu);
            if (txnForEnc.apaa !== undefined) txn.appArgs = txnForEnc.apaa.map((arg)=>new Uint8Array(arg));
            if (txnForEnc.apat !== undefined) txn.appAccounts = txnForEnc.apat.map((addressBytes)=>_address.decodeAddress(_address.encodeAddress(new Uint8Array(addressBytes))));
            if (txnForEnc.apfa !== undefined) txn.appForeignApps = txnForEnc.apfa;
            if (txnForEnc.apas !== undefined) txn.appForeignAssets = txnForEnc.apas;
            if (txnForEnc.apbx !== undefined) txn.boxes = txnForEnc.apbx.map((box)=>({
                    // We return 0 for the app ID so that it's guaranteed translateBoxReferences will
                    // translate the app index back to 0. If we instead returned the called app ID,
                    // translateBoxReferences would translate the app index to a nonzero value if the called
                    // app is also in the foreign app array.
                    appIndex: box.i ? txn.appForeignApps[box.i - 1] : 0,
                    name: box.n
                }));
        } else if (txnForEnc.type === "stpf") {
            if (txnForEnc.sptype !== undefined) txn.stateProofType = txnForEnc.sptype;
            if (txnForEnc.sp !== undefined) txn.stateProof = txnForEnc.sp;
            if (txnForEnc.spmsg !== undefined) txn.stateProofMessage = txnForEnc.spmsg;
        }
        return txn;
    }
    estimateSize() {
        return this.toByte().length + NUM_ADDL_BYTES_AFTER_SIGNING;
    }
    bytesToSign() {
        const encodedMsg = this.toByte();
        return (0, _buffer.Buffer).from(_utils.concatArrays(this.tag, encodedMsg));
    }
    toByte() {
        return _encoding.encode(this.get_obj_for_encoding());
    }
    // returns the raw signature
    rawSignTxn(sk) {
        const toBeSigned = this.bytesToSign();
        const sig = _naclWrappers.sign(toBeSigned, sk);
        return (0, _buffer.Buffer).from(sig);
    }
    signTxn(sk) {
        // construct signed message
        const sTxn = {
            sig: this.rawSignTxn(sk),
            txn: this.get_obj_for_encoding()
        };
        // add AuthAddr if signing with a different key than From indicates
        const keypair = _naclWrappers.keyPairFromSecretKey(sk);
        const pubKeyFromSk = keypair.publicKey;
        if (_address.encodeAddress(pubKeyFromSk) !== _address.encodeAddress(this.from.publicKey)) sTxn.sgnr = (0, _buffer.Buffer).from(pubKeyFromSk);
        return new Uint8Array(_encoding.encode(sTxn));
    }
    attachSignature(signerAddr, signature) {
        if (!_naclWrappers.isValidSignatureLength(signature.length)) throw new Error("Invalid signature length");
        const sTxn = {
            sig: (0, _buffer.Buffer).from(signature),
            txn: this.get_obj_for_encoding()
        };
        // add AuthAddr if signing with a different key than From indicates
        if (signerAddr !== _address.encodeAddress(this.from.publicKey)) {
            const signerPublicKey = _address.decodeAddress(signerAddr).publicKey;
            sTxn.sgnr = (0, _buffer.Buffer).from(signerPublicKey);
        }
        return new Uint8Array(_encoding.encode(sTxn));
    }
    rawTxID() {
        const enMsg = this.toByte();
        const gh = (0, _buffer.Buffer).from(_utils.concatArrays(this.tag, enMsg));
        return (0, _buffer.Buffer).from(_naclWrappers.genericHash(gh));
    }
    txID() {
        const hash = this.rawTxID();
        return (0, _hiBase32Default.default).encode(hash).slice(0, ALGORAND_TRANSACTION_LENGTH);
    }
    // add a lease to a transaction not yet having
    // supply feePerByte to increment fee accordingly
    addLease(lease, feePerByte = 0) {
        let mutableLease;
        if (lease !== undefined) {
            if (lease.constructor !== Uint8Array) throw Error("lease must be a Uint8Array.");
            if (lease.length !== ALGORAND_TRANSACTION_LEASE_LENGTH) throw Error(`lease must be of length ${ALGORAND_TRANSACTION_LEASE_LENGTH.toString()}.`);
            mutableLease = new Uint8Array(lease);
        } else mutableLease = new Uint8Array(0);
        this.lease = mutableLease;
        if (feePerByte !== 0) this.fee += (ALGORAND_TRANSACTION_LEASE_LABEL_LENGTH + ALGORAND_TRANSACTION_LEASE_LENGTH) * feePerByte;
    }
    // add the rekey-to field to a transaction not yet having it
    // supply feePerByte to increment fee accordingly
    addRekey(reKeyTo, feePerByte = 0) {
        if (reKeyTo !== undefined) this.reKeyTo = _address.decodeAddress(reKeyTo);
        if (feePerByte !== 0) this.fee += (ALGORAND_TRANSACTION_REKEY_LABEL_LENGTH + ALGORAND_TRANSACTION_ADDRESS_LENGTH) * feePerByte;
    }
    // build display dict for prettyPrint and toString
    // eslint-disable-next-line no-underscore-dangle
    _getDictForDisplay() {
        const forPrinting = {
            ...this
        };
        forPrinting.tag = forPrinting.tag.toString();
        forPrinting.from = _address.encodeAddress(forPrinting.from.publicKey);
        if (forPrinting.to !== undefined) forPrinting.to = _address.encodeAddress(forPrinting.to.publicKey);
        // things that need fixing:
        if (forPrinting.freezeAccount !== undefined) forPrinting.freezeAccount = _address.encodeAddress(forPrinting.freezeAccount.publicKey);
        if (forPrinting.closeRemainderTo !== undefined) forPrinting.closeRemainderTo = _address.encodeAddress(forPrinting.closeRemainderTo.publicKey);
        if (forPrinting.assetManager !== undefined) forPrinting.assetManager = _address.encodeAddress(forPrinting.assetManager.publicKey);
        if (forPrinting.assetReserve !== undefined) forPrinting.assetReserve = _address.encodeAddress(forPrinting.assetReserve.publicKey);
        if (forPrinting.assetFreeze !== undefined) forPrinting.assetFreeze = _address.encodeAddress(forPrinting.assetFreeze.publicKey);
        if (forPrinting.assetClawback !== undefined) forPrinting.assetClawback = _address.encodeAddress(forPrinting.assetClawback.publicKey);
        if (forPrinting.assetRevocationTarget !== undefined) forPrinting.assetRevocationTarget = _address.encodeAddress(forPrinting.assetRevocationTarget.publicKey);
        if (forPrinting.reKeyTo !== undefined) forPrinting.reKeyTo = _address.encodeAddress(forPrinting.reKeyTo.publicKey);
        forPrinting.genesisHash = forPrinting.genesisHash.toString("base64");
        return forPrinting;
    }
    // pretty print the transaction to console
    prettyPrint() {
        // eslint-disable-next-line no-underscore-dangle,no-console
        console.log(this._getDictForDisplay());
    }
    // get string representation
    toString() {
        // eslint-disable-next-line no-underscore-dangle
        return JSON.stringify(this._getDictForDisplay());
    }
}
function encodeUnsignedSimulateTransaction(transactionObject) {
    const objToEncode = {
        txn: transactionObject.get_obj_for_encoding()
    };
    return _encoding.encode(objToEncode);
}
function encodeUnsignedTransaction(transactionObject) {
    const objToEncode = transactionObject.get_obj_for_encoding();
    return _encoding.encode(objToEncode);
}
function decodeUnsignedTransaction(transactionBuffer) {
    const partlyDecodedObject = _encoding.decode(transactionBuffer);
    return Transaction.from_obj_for_encoding(partlyDecodedObject);
}
function decodeSignedTransaction(transactionBuffer) {
    const stxnDecoded = _encoding.decode(transactionBuffer);
    const stxn = {
        ...stxnDecoded,
        txn: Transaction.from_obj_for_encoding(stxnDecoded.txn)
    };
    return stxn;
}
function instantiateTxnIfNeeded(transactionLike) {
    return transactionLike instanceof Transaction ? transactionLike : new Transaction(transactionLike);
}
exports.default = Transaction;

},{"buffer":"jlSk7","hi-base32":"7wgAP","./encoding/address":"7lw2f","./encoding/encoding":"1Yg70","./nacl/naclWrappers":"hIiu2","./utils/utils":"izzsC","./boxStorage":"9AXxh","./types/transactions/base":"k2yip","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9AXxh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * translateBoxReferences translates an array of BoxReferences with app IDs
 * into an array of EncodedBoxReferences with foreign indices.
 */ parcelHelpers.export(exports, "translateBoxReferences", ()=>translateBoxReferences);
function translateBoxReference(reference, foreignApps, appIndex) {
    const referenceId = reference.appIndex;
    const referenceName = reference.name;
    const isOwnReference = referenceId === 0 || referenceId === appIndex;
    let index = 0;
    if (foreignApps != null) // Foreign apps start from index 1; index 0 is its own app ID.
    index = foreignApps.indexOf(referenceId) + 1;
    // Check if the app referenced is itself after checking the foreign apps array.
    // If index is zero, then the app ID was not found in the foreign apps array
    // or the foreign apps array was null.
    if (index === 0 && !isOwnReference) // Error if the app is trying to reference a foreign app that was not in
    // its own foreign apps array.
    throw new Error(`Box ref with appId ${referenceId} not in foreign-apps`);
    return {
        i: index,
        n: referenceName
    };
}
function translateBoxReferences(references, foreignApps, appIndex) {
    if (references == null) return [];
    return references.map((bx)=>translateBoxReference(bx, foreignApps, appIndex));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2yip":[function(require,module,exports) {
/**
 * Enum for application transaction types.
 *
 * The full list is available at https://developer.algorand.org/docs/reference/transactions/
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionType", ()=>TransactionType);
parcelHelpers.export(exports, "isTransactionType", ()=>isTransactionType);
parcelHelpers.export(exports, "OnApplicationComplete", ()=>OnApplicationComplete);
var TransactionType;
(function(TransactionType) {
    /**
     * Payment transaction
     */ TransactionType["pay"] = "pay";
    /**
     * Key registration transaction
     */ TransactionType["keyreg"] = "keyreg";
    /**
     * Asset configuration transaction
     */ TransactionType["acfg"] = "acfg";
    /**
     * Asset transfer transaction
     */ TransactionType["axfer"] = "axfer";
    /**
     * Asset freeze transaction
     */ TransactionType["afrz"] = "afrz";
    /**
     * Application transaction
     */ TransactionType["appl"] = "appl";
    /**
     * State proof transaction
     */ TransactionType["stpf"] = "stpf";
})(TransactionType || (TransactionType = {}));
function isTransactionType(s) {
    return s === TransactionType.pay || s === TransactionType.keyreg || s === TransactionType.acfg || s === TransactionType.axfer || s === TransactionType.afrz || s === TransactionType.appl || s === TransactionType.stpf;
}
var OnApplicationComplete;
(function(OnApplicationComplete) {
    /**
     * NoOpOC indicates that an application transaction will simply call its
     * ApprovalProgram
     */ OnApplicationComplete[OnApplicationComplete["NoOpOC"] = 0] = "NoOpOC";
    /**
     * OptInOC indicates that an application transaction will allocate some
     * LocalState for the application in the sender's account
     */ OnApplicationComplete[OnApplicationComplete["OptInOC"] = 1] = "OptInOC";
    /**
     * CloseOutOC indicates that an application transaction will deallocate
     * some LocalState for the application from the user's account
     */ OnApplicationComplete[OnApplicationComplete["CloseOutOC"] = 2] = "CloseOutOC";
    /**
     * ClearStateOC is similar to CloseOutOC, but may never fail. This
     * allows users to reclaim their minimum balance from an application
     * they no longer wish to opt in to.
     */ OnApplicationComplete[OnApplicationComplete["ClearStateOC"] = 3] = "ClearStateOC";
    /**
     * UpdateApplicationOC indicates that an application transaction will
     * update the ApprovalProgram and ClearStateProgram for the application
     */ OnApplicationComplete[OnApplicationComplete["UpdateApplicationOC"] = 4] = "UpdateApplicationOC";
    /**
     * DeleteApplicationOC indicates that an application transaction will
     * delete the AppParams for the application from the creator's balance
     * record
     */ OnApplicationComplete[OnApplicationComplete["DeleteApplicationOC"] = 5] = "DeleteApplicationOC";
})(OnApplicationComplete || (OnApplicationComplete = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kz1L0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
var _address = require("./encoding/address");
var _encoding = require("./encoding/encoding");
var _naclWrappers = require("./nacl/naclWrappers");
var _utils = require("./utils/utils");
class Bid {
    constructor({ bidderKey , bidAmount , bidID , auctionKey , auctionID , maxPrice  }){
        this.name = "Bid";
        this.tag = (0, _buffer.Buffer).from([
            97,
            66
        ]); // "aB"
        const decodedBidderKey = _address.decodeAddress(bidderKey);
        const decodedAuctionKey = _address.decodeAddress(auctionKey);
        if (!Number.isSafeInteger(bidAmount) || bidAmount < 0) throw Error("Bid amount must be positive and 2^53-1");
        if (!Number.isSafeInteger(bidID) || bidID < 0) throw Error("BidID must be positive and 2^53-1");
        if (!Number.isSafeInteger(auctionID) || auctionID < 0) throw Error("auctionID must be positive");
        Object.assign(this, {
            bidderKey: decodedBidderKey,
            bidAmount,
            bidID,
            auctionKey: decodedAuctionKey,
            auctionID,
            maxPrice
        });
    }
    // eslint-disable-next-line camelcase
    get_obj_for_encoding() {
        return {
            bidder: (0, _buffer.Buffer).from(this.bidderKey.publicKey),
            cur: this.bidAmount,
            price: this.maxPrice,
            id: this.bidID,
            auc: (0, _buffer.Buffer).from(this.auctionKey.publicKey),
            aid: this.auctionID
        };
    }
    signBid(sk) {
        const encodedMsg = _encoding.encode(this.get_obj_for_encoding());
        const toBeSigned = (0, _buffer.Buffer).from(_utils.concatArrays(this.tag, encodedMsg));
        const sig = _naclWrappers.sign(toBeSigned, sk);
        // construct signed message
        const sBid = {
            sig: (0, _buffer.Buffer).from(sig),
            bid: this.get_obj_for_encoding()
        };
        const note = {
            t: "b",
            b: sBid
        };
        return new Uint8Array(_encoding.encode(note));
    }
}
exports.default = Bid;

},{"buffer":"jlSk7","./encoding/address":"7lw2f","./encoding/encoding":"1Yg70","./nacl/naclWrappers":"hIiu2","./utils/utils":"izzsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29i3t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INVALID_MICROALGOS_ERROR_MSG", ()=>INVALID_MICROALGOS_ERROR_MSG);
/**
 * microalgosToAlgos converts microalgos to algos
 * @param microalgos - number
 * @returns number
 */ parcelHelpers.export(exports, "microalgosToAlgos", ()=>microalgosToAlgos);
/**
 * algosToMicroalgos converts algos to microalgos
 * @param algos - number
 * @returns number
 */ parcelHelpers.export(exports, "algosToMicroalgos", ()=>algosToMicroalgos);
const MICROALGOS_TO_ALGOS_RATIO = 1e6;
const INVALID_MICROALGOS_ERROR_MSG = "Microalgos should be positive and less than 2^53 - 1.";
function microalgosToAlgos(microalgos) {
    if (microalgos < 0 || !Number.isSafeInteger(microalgos)) throw new Error(INVALID_MICROALGOS_ERROR_MSG);
    return microalgos / MICROALGOS_TO_ALGOS_RATIO;
}
function algosToMicroalgos(algos) {
    const microalgos = algos * MICROALGOS_TO_ALGOS_RATIO;
    return Math.round(microalgos);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wbp5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _serviceClient = require("../serviceClient");
var _serviceClientDefault = parcelHelpers.interopDefault(_serviceClient);
var _types = require("./models/types");
var _accountInformation = require("./accountInformation");
var _accountInformationDefault = parcelHelpers.interopDefault(_accountInformation);
var _accountAssetInformation = require("./accountAssetInformation");
var _accountAssetInformationDefault = parcelHelpers.interopDefault(_accountAssetInformation);
var _accountApplicationInformation = require("./accountApplicationInformation");
var _accountApplicationInformationDefault = parcelHelpers.interopDefault(_accountApplicationInformation);
var _block = require("./block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _compile = require("./compile");
var _compileDefault = parcelHelpers.interopDefault(_compile);
var _dryrun = require("./dryrun");
var _dryrunDefault = parcelHelpers.interopDefault(_dryrun);
var _genesis = require("./genesis");
var _genesisDefault = parcelHelpers.interopDefault(_genesis);
var _getAssetByID = require("./getAssetByID");
var _getAssetByIDDefault = parcelHelpers.interopDefault(_getAssetByID);
var _getApplicationByID = require("./getApplicationByID");
var _getApplicationByIDDefault = parcelHelpers.interopDefault(_getApplicationByID);
var _getBlockHash = require("./getBlockHash");
var _getBlockHashDefault = parcelHelpers.interopDefault(_getBlockHash);
var _getApplicationBoxByName = require("./getApplicationBoxByName");
var _getApplicationBoxByNameDefault = parcelHelpers.interopDefault(_getApplicationBoxByName);
var _getApplicationBoxes = require("./getApplicationBoxes");
var _getApplicationBoxesDefault = parcelHelpers.interopDefault(_getApplicationBoxes);
var _healthCheck = require("./healthCheck");
var _healthCheckDefault = parcelHelpers.interopDefault(_healthCheck);
var _pendingTransactionInformation = require("./pendingTransactionInformation");
var _pendingTransactionInformationDefault = parcelHelpers.interopDefault(_pendingTransactionInformation);
var _pendingTransactions = require("./pendingTransactions");
var _pendingTransactionsDefault = parcelHelpers.interopDefault(_pendingTransactions);
var _pendingTransactionsByAddress = require("./pendingTransactionsByAddress");
var _pendingTransactionsByAddressDefault = parcelHelpers.interopDefault(_pendingTransactionsByAddress);
var _getTransactionProof = require("./getTransactionProof");
var _getTransactionProofDefault = parcelHelpers.interopDefault(_getTransactionProof);
var _sendRawTransaction = require("./sendRawTransaction");
var _sendRawTransactionDefault = parcelHelpers.interopDefault(_sendRawTransaction);
var _status = require("./status");
var _statusDefault = parcelHelpers.interopDefault(_status);
var _statusAfterBlock = require("./statusAfterBlock");
var _statusAfterBlockDefault = parcelHelpers.interopDefault(_statusAfterBlock);
var _suggestedParams = require("./suggestedParams");
var _suggestedParamsDefault = parcelHelpers.interopDefault(_suggestedParams);
var _supply = require("./supply");
var _supplyDefault = parcelHelpers.interopDefault(_supply);
var _versions = require("./versions");
var _versionsDefault = parcelHelpers.interopDefault(_versions);
var _lightBlockHeaderProof = require("./lightBlockHeaderProof");
var _lightBlockHeaderProofDefault = parcelHelpers.interopDefault(_lightBlockHeaderProof);
var _stateproof = require("./stateproof");
var _stateproofDefault = parcelHelpers.interopDefault(_stateproof);
var _setSyncRound = require("./setSyncRound");
var _setSyncRoundDefault = parcelHelpers.interopDefault(_setSyncRound);
var _getSyncRound = require("./getSyncRound");
var _getSyncRoundDefault = parcelHelpers.interopDefault(_getSyncRound);
var _setBlockOffsetTimestamp = require("./setBlockOffsetTimestamp");
var _setBlockOffsetTimestampDefault = parcelHelpers.interopDefault(_setBlockOffsetTimestamp);
var _getBlockOffsetTimestamp = require("./getBlockOffsetTimestamp");
var _getBlockOffsetTimestampDefault = parcelHelpers.interopDefault(_getBlockOffsetTimestamp);
var _disassemble = require("./disassemble");
var _disassembleDefault = parcelHelpers.interopDefault(_disassemble);
var _simulateTransaction = require("./simulateTransaction");
var _simulateTransactionDefault = parcelHelpers.interopDefault(_simulateTransaction);
var _encoding = require("../../../encoding/encoding");
var _ready = require("./ready");
var _readyDefault = parcelHelpers.interopDefault(_ready);
var _unsetSyncRound = require("./unsetSyncRound");
var _unsetSyncRoundDefault = parcelHelpers.interopDefault(_unsetSyncRound);
class AlgodClient extends (0, _serviceClientDefault.default) {
    /**
     * Create an AlgodClient from
     * * either a token, baseServer, port, and optional headers
     * * or a base client server for interoperability with external dApp wallets
     *
     * #### Example
     * ```typescript
     * const token  = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
     * const server = "http://localhost";
     * const port   = 4001;
     * const algodClient = new algosdk.Algodv2(token, server, port);
     * ```
     * @remarks
     * The above configuration is for a sandbox private network.
     * For applications on production, you are encouraged to run your own node, or use an Algorand REST API provider with a dedicated API key.
     *
     * @param tokenOrBaseClient - The algod token from the Algorand node you are interacting with
     * @param baseServer - REST endpoint
     * @param port - Port number if specifically configured by the server
     * @param headers - Optional headers
     */ constructor(tokenOrBaseClient, baseServer, port, headers = {}){
        super("X-Algo-API-Token", tokenOrBaseClient, baseServer, port, headers);
    }
    /**
     * Returns OK if healthy.
     *
     * #### Example
     * ```typescript
     * const health = await algodClient.healthCheck().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-health)
     * @category GET
     */ healthCheck() {
        return new (0, _healthCheckDefault.default)(this.c);
    }
    /**
     * Retrieves the supported API versions, binary build versions, and genesis information.
     *
     * #### Example
     * ```typescript
     * const versionsDetails = await algodClient.versionsCheck().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-versions)
     * @category GET
     */ versionsCheck() {
        return new (0, _versionsDefault.default)(this.c);
    }
    /**
     * Broadcasts a raw transaction to the network.
     *
     * #### Example
     * ```typescript
     * const { txId } = await algodClient.sendRawTransaction(signedTxns).do();
     * const result = await waitForConfirmation(algodClient, txid, 3);
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2transactions)
     *
     * @remarks
     * Often used with {@linkcode waitForConfirmation}
     * @param stxOrStxs - Signed transactions
     * @category POST
     */ sendRawTransaction(stxOrStxs) {
        return new (0, _sendRawTransactionDefault.default)(this.c, stxOrStxs);
    }
    /**
     * Returns the given account's status, balance and spendable amounts.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await algodClient.accountInformation(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddress)
     * @param account - The address of the account to look up.
     * @category GET
     */ accountInformation(account) {
        return new (0, _accountInformationDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns the given account's asset information for a specific asset.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const index = 60553466;
     * const accountAssetInfo = await algodClient.accountAssetInformation(address, index).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddress)
     * @param account - The address of the account to look up.
     * @param index - The asset ID to look up.
     * @category GET
     */ accountAssetInformation(account, index) {
        return new (0, _accountAssetInformationDefault.default)(this.c, this.intDecoding, account, index);
    }
    /**
     * Returns the given account's application information for a specific application.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const index = 60553466;
     * const accountInfo = await algodClient.accountApplicationInformation(address, index).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddress)
     * @param account - The address of the account to look up.
     * @param index - The application ID to look up.
     * @category GET
     */ accountApplicationInformation(account, index) {
        return new (0, _accountApplicationInformationDefault.default)(this.c, this.intDecoding, account, index);
    }
    /**
     * Gets the block info for the given round.
     *
     * #### Example
     * ```typescript
     * const roundNumber = 18038133;
     * const block = await algodClient.block(roundNumber).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksround)
     * @param roundNumber - The round number of the block to get.
     * @category GET
     */ block(roundNumber) {
        return new (0, _blockDefault.default)(this.c, roundNumber);
    }
    /**
     * Get the block hash for the block on the given round.
     *
     * #### Example
     * ```typescript
     * const roundNumber = 18038133;
     * const block = await algodClient.getBlockHash(roundNumber).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksroundhash)
     * @param roundNumber - The round number of the block to get.
     * @category GET
     */ getBlockHash(roundNumber) {
        return new (0, _getBlockHashDefault.default)(this.c, this.intDecoding, roundNumber);
    }
    /**
     * Returns the transaction information for a specific pending transaction.
     *
     * #### Example
     * ```typescript
     * const txId = "DRJS6R745A7GFVMXEXWP4TGVDGKW7VILFTA7HC2BR2GRLHNY5CTA";
     * const pending = await algodClient.pendingTransactionInformation(txId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2transactionspendingtxid)
     *
     * @remarks
     * <br><br>
     * There are several cases when this might succeed:
     * - transaction committed (committed round > 0)
     * - transaction still in the pool (committed round = 0, pool error = "")
     * - transaction removed from pool due to error (committed round = 0, pool error != "")
     *
     * Or the transaction may have happened sufficiently long ago that the node no longer remembers it, and this will return an error.
     *
     * @param txid - The TxID string of the pending transaction to look up.
     * @category GET
     */ pendingTransactionInformation(txid) {
        return new (0, _pendingTransactionInformationDefault.default)(this.c, txid);
    }
    /**
     * Returns the list of pending transactions in the pool, sorted by priority, in decreasing order, truncated at the end at MAX.
     * If MAX = 0, returns all pending transactions.
     *
     * #### Example 1
     * ```typescript
     * const pendingTxns = await algodClient.pendingTransactionsInformation().do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const maxTxns = 5;
     * const pendingTxns = await algodClient
     *     .pendingTransactionsInformation()
     *     .max(maxTxns)
     *     .do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2transactionspending)
     * @category GET
     */ pendingTransactionsInformation() {
        return new (0, _pendingTransactionsDefault.default)(this.c);
    }
    /**
     * Returns the list of pending transactions sent by the address, sorted by priority, in decreasing order, truncated at the end at MAX.
     * If MAX = 0, returns all pending transactions.
     *
     * #### Example 1
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const pendingTxnsByAddr = await algodClient.pendingTransactionByAddress(address).do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const maxTxns = 5;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const pendingTxns = await algodClient
     *     .pendingTransactionByAddress(address)
     *     .max(maxTxns)
     *     .do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddresstransactionspending)
     * @param address - The address of the sender.
     * @category GET
     */ pendingTransactionByAddress(address) {
        return new (0, _pendingTransactionsByAddressDefault.default)(this.c, address);
    }
    /**
     * Retrieves the StatusResponse from the running node.
     *
     * #### Example
     * ```typescript
     * const status = await algodClient.status().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2status)
     * @category GET
     */ status() {
        return new (0, _statusDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Waits for a specific round to occur then returns the `StatusResponse` for that round.
     *
     * #### Example
     * ```typescript
     * const round = 18038133;
     * const statusAfterBlock = await algodClient.statusAfterBlock(round).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2statuswait-for-block-afterround)
     * @param round - The number of the round to wait for.
     * @category GET
     */ statusAfterBlock(round) {
        return new (0, _statusAfterBlockDefault.default)(this.c, this.intDecoding, round);
    }
    /**
     * Returns the common needed parameters for a new transaction.
     *
     * #### Example
     * ```typescript
     * const suggestedParams = await algodClient.getTransactionParams().do();
     * const amountInMicroAlgos = algosdk.algosToMicroalgos(2); // 2 Algos
     * const unsignedTxn = algosdk.makePaymentTxnWithSuggestedParamsFromObject({
     *   from: senderAddress,
     *   to: receiverAddress,
     *   amount: amountInMicroAlgos,
     *   suggestedParams: suggestedParams,
     * });
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2transactionsparams)
     *
     * @remarks
     * Often used with
     * {@linkcode makePaymentTxnWithSuggestedParamsFromObject}, {@linkcode algosToMicroalgos}
     * @category GET
     */ getTransactionParams() {
        return new (0, _suggestedParamsDefault.default)(this.c);
    }
    /**
     * Returns the supply details for the specified node's ledger.
     *
     * #### Example
     * ```typescript
     * const supplyDetails = await algodClient.supply().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2ledgersupply)
     * @category GET
     */ supply() {
        return new (0, _supplyDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Compiles TEAL source code to binary, returns base64 encoded program bytes and base32 SHA512_256 hash of program bytes (Address style).
     *
     * #### Example
     * ```typescript
     * const source = "TEAL SOURCE CODE";
     * const compiledSmartContract = await algodClient.compile(source).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2tealcompile)
     * @remarks
     * This endpoint is only enabled when a node's configuration file sets `EnableDeveloperAPI` to true.
     * @param source
     * @category POST
     */ compile(source) {
        return new (0, _compileDefault.default)(this.c, source);
    }
    /**
     * Given the program bytes, return the TEAL source code in plain text.
     *
     * #### Example
     * ```typescript
     * const bytecode = "TEAL bytecode";
     * const disassembledSource = await algodClient.disassemble(bytecode).do();
     * ```
     *
     * @remarks This endpoint is only enabled when a node's configuration file sets EnableDeveloperAPI to true.
     * @param source
     */ disassemble(source) {
        return new (0, _disassembleDefault.default)(this.c, source);
    }
    /**
     * Provides debugging information for a transaction (or group).
     *
     * Executes TEAL program(s) in context and returns debugging information about the execution. This endpoint is only enabled when a node's configureation file sets `EnableDeveloperAPI` to true.
     *
     * #### Example
     * ```typescript
     * const dryRunResult = await algodClient.dryrun(dr).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2tealdryrun)
     * @param dr
     * @category POST
     */ dryrun(dr) {
        return new (0, _dryrunDefault.default)(this.c, dr);
    }
    /**
     * Given an asset ID, return asset information including creator, name, total supply and
     * special addresses.
     *
     * #### Example
     * ```typescript
     * const asset_id = 163650;
     * const asset = await algodClient.getAssetByID(asset_id).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2assetsasset-id)
     * @param index - The asset ID to look up.
     * @category GET
     */ getAssetByID(index) {
        return new (0, _getAssetByIDDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Given an application ID, return the application information including creator, approval
     * and clear programs, global and local schemas, and global state.
     *
     * #### Example
     * ```typescript
     * const index = 60553466;
     * const app = await algodClient.getApplicationByID(index).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2applicationsapplication-id)
     * @param index - The application ID to look up.
     * @category GET
     */ getApplicationByID(index) {
        return new (0, _getApplicationByIDDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Given an application ID and the box name (key), return the value stored in the box.
     *
     * #### Example
     * ```typescript
     * const index = 60553466;
     * const boxName = Buffer.from("foo");
     * const boxResponse = await algodClient.getApplicationBoxByName(index, boxName).do();
     * const boxValue = boxResponse.value;
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2applicationsapplication-idbox)
     * @param index - The application ID to look up.
     * @category GET
     */ getApplicationBoxByName(index, boxName) {
        return new (0, _getApplicationBoxByNameDefault.default)(this.c, this.intDecoding, index, boxName);
    }
    /**
     * Given an application ID, return all the box names associated with the app.
     *
     * #### Example
     * ```typescript
     * const index = 60553466;
     * const boxesResponse = await algodClient.getApplicationBoxes(index).max(3).do();
     * const boxNames = boxesResponse.boxes.map(box => box.name);
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2applicationsapplication-idboxes)
     * @param index - The application ID to look up.
     * @category GET
     */ getApplicationBoxes(index) {
        return new (0, _getApplicationBoxesDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Returns the entire genesis file.
     *
     * #### Example
     * ```typescript
     * const genesis = await algodClient.genesis().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-genesis)
     * @category GET
     */ genesis() {
        return new (0, _genesisDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Returns a Merkle proof for a given transaction in a block.
     *
     * #### Example
     * ```typescript
     * const round = 18038133;
     * const txId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const proof = await algodClient.getTransactionProof(round, txId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksroundtransactionstxidproof)
     * @param round - The round in which the transaction appears.
     * @param txID - The transaction ID for which to generate a proof.
     * @category GET
     */ getTransactionProof(round, txID) {
        return new (0, _getTransactionProofDefault.default)(this.c, this.intDecoding, round, txID);
    }
    /**
     * Gets a proof for a given light block header inside a state proof commitment.
     *
     * #### Example
     * ```typescript
     * const round = 11111111;
     * const lightBlockHeaderProof = await algodClient.getLightBlockHeaderProof(round).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/v2#get-v2blocksroundlightheaderproof)
     * @param round
     */ getLightBlockHeaderProof(round) {
        return new (0, _lightBlockHeaderProofDefault.default)(this.c, this.intDecoding, round);
    }
    /**
     * Gets a state proof that covers a given round.
     *
     * #### Example
     * ```typescript
     * const round = 11111111;
     * const stateProof = await algodClient.getStateProof(round).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/v2#get-v2stateproofsround)
     * @param round
     */ getStateProof(round) {
        return new (0, _stateproofDefault.default)(this.c, this.intDecoding, round);
    }
    /**
     * Simulate a list of a signed transaction objects being sent to the network.
     *
     * #### Example
     * ```typescript
     * const txn1 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn1Params);
     * const txn2 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn2Params);
     * const txgroup = algosdk.assignGroupID([txn1, txn2]);
     *
     * // Actually sign the first transaction
     * const signedTxn1 = txgroup[0].signTxn(senderSk).blob;
     * // Simulate does not require signed transactions -- use this method to encode an unsigned transaction
     * const signedTxn2 = algosdk.encodeUnsignedSimulateTransaction(txgroup[1]);
     *
     * const resp = await client.simulateRawTransactions([signedTxn1, signedTxn2]).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2transactionssimulate)
     * @param stxOrStxs
     * @category POST
     */ simulateRawTransactions(stxOrStxs) {
        const txnObjects = [];
        if (Array.isArray(stxOrStxs)) for (const stxn of stxOrStxs)txnObjects.push(_encoding.decode(stxn));
        else txnObjects.push(_encoding.decode(stxOrStxs));
        const request = new _types.SimulateRequest({
            txnGroups: [
                new _types.SimulateRequestTransactionGroup({
                    txns: txnObjects
                })
            ]
        });
        return this.simulateTransactions(request);
    }
    /**
     * Simulate transactions being sent to the network.
     *
     * #### Example
     * ```typescript
     * const txn1 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn1Params);
     * const txn2 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn2Params);
     * const txgroup = algosdk.assignGroupID([txn1, txn2]);
     *
     * // Actually sign the first transaction
     * const signedTxn1 = txgroup[0].signTxn(senderSk).blob;
     * // Simulate does not require signed transactions -- use this method to encode an unsigned transaction
     * const signedTxn2 = algosdk.encodeUnsignedSimulateTransaction(txgroup[1]);
     *
     * const request = new modelsv2.SimulateRequest({
     *  txnGroups: [
     *    new modelsv2.SimulateRequestTransactionGroup({
     *       // Must decode the signed txn bytes into an object
     *       txns: [algosdk.decodeObj(signedTxn1), algosdk.decodeObj(signedTxn2)]
     *     }),
     *   ],
     * });
     * const resp = await client.simulateRawTransactions(request).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2transactionssimulate)
     * @param request
     * @category POST
     */ simulateTransactions(request) {
        return new (0, _simulateTransactionDefault.default)(this.c, request);
    }
    /**
     * Set the offset (in seconds) applied to the block timestamp when creating new blocks in devmode.
     *
     *  #### Example
     *  ```typesecript
     *  const offset = 60
     *  await client.setBlockOffsetTimestamp(offset).do();
     *  ```
     *
     [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2devmodeblocksoffsetoffset)
     * @param offset
     * @category POST
     */ setBlockOffsetTimestamp(offset) {
        return new (0, _setBlockOffsetTimestampDefault.default)(this.c, this.intDecoding, offset);
    }
    /**
     * Get the offset (in seconds) applied to the block timestamp when creating new blocks in devmode.
     *
     *  #### Example
     *  ```typesecript
     *  const currentOffset = await client.getBlockOffsetTimestamp().do();
     *  ```
     *
     [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2devmodeblocksoffset)
     * @category GET
     */ getBlockOffsetTimestamp() {
        return new (0, _getBlockOffsetTimestampDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Set the sync round on the ledger (algod must have EnableFollowMode: true), restricting catchup.
     *
     *  #### Example
     *  ```typesecript
     *  const round = 10000
     *  await client.setSyncRound(round).do();
     *  ```
     *
     [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2ledgersyncround)
     * @param round
     * @category POST
     */ setSyncRound(round) {
        return new (0, _setSyncRoundDefault.default)(this.c, this.intDecoding, round);
    }
    /**
     * Un-Set the sync round on the ledger (algod must have EnableFollowMode: true), removing the restriction on catchup.
     *
     *  #### Example
     *  ```typesecript
     *  await client.unsetSyncRound().do();
     *  ```
     *
     [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#delete-v2ledgersync)
     * @category DELETE
     */ unsetSyncRound() {
        return new (0, _unsetSyncRoundDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Get the current sync round on the ledger (algod must have EnableFollowMode: true).
     *
     *  #### Example
     *  ```typesecript
     *  const currentSyncRound = await client.getSyncRound().do();
     *  ```
     *
     [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2ledgersync)
     * @category GET
     */ getSyncRound() {
        return new (0, _getSyncRoundDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Ready check which returns 200 OK if algod is healthy and caught up
     *
     *  #### Example
     *  ```typesecript
     *  await client.ready().do();
     *  ```
     *
     [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-ready)
     * @category GET
     */ ready() {
        return new (0, _readyDefault.default)(this.c, this.intDecoding);
    }
}
exports.default = AlgodClient;

},{"../serviceClient":"6EvhN","./models/types":"5YZy0","./accountInformation":"bOvRZ","./accountAssetInformation":"l0gVD","./accountApplicationInformation":"2LWKA","./block":"cPBVj","./compile":"etJKB","./dryrun":"l6Xme","./genesis":"iHnpa","./getAssetByID":"jZ0Vs","./getApplicationByID":"643kt","./getBlockHash":"dudfk","./getApplicationBoxByName":"dDoso","./getApplicationBoxes":"rXGgX","./healthCheck":"8FNTd","./pendingTransactionInformation":"3DZvg","./pendingTransactions":"8tBDc","./pendingTransactionsByAddress":"kfRxL","./getTransactionProof":"iDqAy","./sendRawTransaction":"fAbv9","./status":"gO8ow","./statusAfterBlock":"ae81N","./suggestedParams":"cjePO","./supply":"4A5uA","./versions":"4Bi8d","./lightBlockHeaderProof":"aFPKW","./stateproof":"cxC9Z","./setSyncRound":"2Rj7r","./getSyncRound":"eZhFJ","./setBlockOffsetTimestamp":"6NBDU","./getBlockOffsetTimestamp":"bfexT","./disassemble":"9CPqP","./simulateTransaction":"2UFfr","../../../encoding/encoding":"1Yg70","./ready":"4Crin","./unsetSyncRound":"ip7JP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6EvhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("../client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _intDecoding = require("../../types/intDecoding");
var _intDecodingDefault = parcelHelpers.interopDefault(_intDecoding);
/**
 * Convert a token string to a token header
 * @param token - The token string
 * @param headerIdentifier - An identifier for the token header
 */ function convertTokenStringToTokenHeader(token = "", headerIdentifier) {
    const tokenHeader = {};
    tokenHeader[headerIdentifier] = token;
    return tokenHeader;
}
function isBaseHTTPClient(tbc) {
    return typeof tbc.get === "function";
}
class ServiceClient {
    constructor(tokenHeaderIdentifier, tokenHeaderOrStrOrBaseClient, baseServer, port, defaultHeaders = {}){
        if (isBaseHTTPClient(tokenHeaderOrStrOrBaseClient)) // we are using a base client
        this.c = new (0, _clientDefault.default)(tokenHeaderOrStrOrBaseClient);
        else {
            // Accept token header as string or object
            // - workaround to allow backwards compatibility for multiple headers
            let tokenHeader;
            if (typeof tokenHeaderOrStrOrBaseClient === "string") tokenHeader = convertTokenStringToTokenHeader(tokenHeaderOrStrOrBaseClient, tokenHeaderIdentifier);
            else tokenHeader = tokenHeaderOrStrOrBaseClient;
            this.c = new (0, _clientDefault.default)(tokenHeader, baseServer, port, defaultHeaders);
        }
        this.intDecoding = (0, _intDecodingDefault.default).DEFAULT;
    }
    /**
     * Set the default int decoding method for all JSON requests this client creates.
     * @param method - \{"default" | "safe" | "mixed" | "bigint"\} method The method to use when parsing the
     *   response for request. Must be one of "default", "safe", "mixed", or "bigint". See
     *   JSONRequest.setIntDecoding for more details about what each method does.
     */ setIntEncoding(method) {
        this.intDecoding = method;
    }
    /**
     * Get the default int decoding method for all JSON requests this client creates.
     */ getIntEncoding() {
        return this.intDecoding;
    }
}
exports.default = ServiceClient;

},{"../client":"jghir","../../types/intDecoding":"bwLkl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jghir":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
var _utils = require("../utils/utils");
var _urlTokenBaseHTTPClient = require("./urlTokenBaseHTTPClient");
/**
 * Remove falsy values or values with a length of 0 from an object.
 */ function removeFalsyOrEmpty(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // eslint-disable-next-line no-param-reassign
        {
            if (!obj[key] || obj[key].length === 0) delete obj[key];
        }
    }
    return obj;
}
/**
 * Create a new object with lower-case keys
 * See https://codereview.stackexchange.com/a/162418
 * Used to ensure all headers are lower-case and to work more easily with them
 */ function tolowerCaseKeys(o) {
    /* eslint-disable no-param-reassign,no-return-assign,no-sequences */ return Object.keys(o).reduce((c, k)=>(c[k.toLowerCase()] = o[k], c), {});
/* eslint-enable no-param-reassign,no-return-assign,no-sequences */ }
/**
 * getAcceptFormat returns the correct Accept header depending on the
 * requested format.
 */ function getAcceptFormat(query) {
    if (query !== undefined && Object.prototype.hasOwnProperty.call(query, "format")) switch(query.format){
        case "msgpack":
            return "application/msgpack";
        case "json":
        default:
            return "application/json";
    }
    else return "application/json";
}
class HTTPClient {
    constructor(bcOrTokenHeader, baseServer, port, defaultHeaders = {}){
        if (baseServer !== undefined) this.bc = new (0, _urlTokenBaseHTTPClient.URLTokenBaseHTTPClient)(bcOrTokenHeader, baseServer, port, defaultHeaders);
        else this.bc = bcOrTokenHeader;
    }
    /**
     * Parse JSON using either the built-in JSON.parse or utils.parseJSON
     * depending on whether jsonOptions are provided or not
     *
     * @param text - JSON data
     * @param status - Status of the response (used in case parseJSON fails)
     * @param jsonOptions - Options object to use to decode JSON responses. See
     *   utils.parseJSON for the options available.
     */ static parseJSON(text, status, jsonOptions = {}) {
        try {
            if (Object.keys(jsonOptions).length === 0) return text && JSON.parse(text);
            return text && _utils.parseJSON(text, jsonOptions);
        } catch (err_) {
            const err = err_;
            // return the raw response if the response parsing fails
            err.rawResponse = text || null;
            // return the http status code if the response parsing fails
            err.statusCode = status;
            throw err;
        }
    }
    /**
     * Serialize the data according to the requestHeaders
     * Assumes that requestHeaders contain a key "content-type"
     * If the content-type is "application/json", data is JSON serialized
     * Otherwise, data needs to be either an UTF-8 string that is converted to an Uint8Array
     * or an Uint8Array
     * @private
     */ static serializeData(data, requestHeaders) {
        if (!data) return new Uint8Array(0); // empty Uint8Array
        if (requestHeaders["content-type"] === "application/json") return new Uint8Array((0, _buffer.Buffer).from(JSON.stringify(data)));
        if (typeof data === "string") return new Uint8Array((0, _buffer.Buffer).from(data));
        if (data instanceof Uint8Array) return data;
        throw new Error("provided data is neither a string nor a Uint8Array and content-type is not application/json");
    }
    /**
     * Convert a BaseHTTPClientResponse into a full HTTPClientResponse
     * Parse the body in
     * Modifies in place res and return the result
     */ static prepareResponse(res, format, parseBody, jsonOptions = {}) {
        let { body  } = res;
        let text;
        if (format !== "application/msgpack") text = body && (0, _buffer.Buffer).from(body).toString() || "";
        if (parseBody && format === "application/json") body = HTTPClient.parseJSON(text, res.status, jsonOptions);
        return {
            ...res,
            body,
            text,
            ok: Math.trunc(res.status / 100) === 2
        };
    }
    /**
     * Prepare an error with a response
     * (the type of errors BaseHTTPClient are supposed to throw)
     * by adding the status and preparing the internal response
     * @private
     */ static prepareResponseError(err) {
        if (err.response) {
            // eslint-disable-next-line no-param-reassign
            err.response = HTTPClient.prepareResponse(err.response, "application/json", true);
            // eslint-disable-next-line no-param-reassign
            err.status = err.response.status;
        }
        return err;
    }
    /**
     * Send a GET request.
     * @param relativePath - The path of the request.
     * @param query - An object containing the query parameters of the request.
     * @param requestHeaders - An object containing additional request headers to use.
     * @param jsonOptions - Options object to use to decode JSON responses. See
     *   utils.parseJSON for the options available.
     * @param parseBody - An optional boolean indicating whether the response body should be parsed
     *   or not.
     * @returns Response object.
     */ async get(relativePath, query, requestHeaders = {}, jsonOptions = {}, parseBody = true) {
        const format = getAcceptFormat(query);
        const fullHeaders = {
            ...requestHeaders,
            accept: format
        };
        try {
            const res = await this.bc.get(relativePath, removeFalsyOrEmpty(query), fullHeaders);
            return HTTPClient.prepareResponse(res, format, parseBody, jsonOptions);
        } catch (err) {
            throw HTTPClient.prepareResponseError(err);
        }
    }
    /**
     * Send a POST request.
     * If no content-type present, adds the header "content-type: application/json"
     * and data is serialized in JSON (if not empty)
     */ async post(relativePath, data, requestHeaders = {}, query, parseBody = true) {
        const fullHeaders = {
            "content-type": "application/json",
            ...tolowerCaseKeys(requestHeaders)
        };
        try {
            const res = await this.bc.post(relativePath, HTTPClient.serializeData(data, fullHeaders), query, fullHeaders);
            return HTTPClient.prepareResponse(res, "application/json", parseBody);
        } catch (err) {
            throw HTTPClient.prepareResponseError(err);
        }
    }
    /**
     * Send a DELETE request.
     * If no content-type present, adds the header "content-type: application/json"
     * and data is serialized in JSON (if not empty)
     */ async delete(relativePath, data, requestHeaders = {}, parseBody = true) {
        const fullHeaders = {
            "content-type": "application/json",
            ...tolowerCaseKeys(requestHeaders)
        };
        const res = await this.bc.delete(relativePath, HTTPClient.serializeData(data, fullHeaders), undefined, fullHeaders);
        return HTTPClient.prepareResponse(res, "application/json", parseBody);
    }
}
exports.default = HTTPClient;

},{"buffer":"jlSk7","../utils/utils":"izzsC","./urlTokenBaseHTTPClient":"kXJi3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXJi3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Implementation of BaseHTTPClient that uses a URL and a token
 * and make the REST queries using fetch.
 * This is the default implementation of BaseHTTPClient.
 */ parcelHelpers.export(exports, "URLTokenBaseHTTPClient", ()=>URLTokenBaseHTTPClient);
var _buffer = require("buffer");
var _crossFetch = require("cross-fetch");
class URLTokenBaseHTTPError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
        this.name = "URLTokenBaseHTTPError";
        this.response = response;
    }
}
class URLTokenBaseHTTPClient {
    constructor(tokenHeader, baseServer, port, defaultHeaders = {}){
        this.defaultHeaders = defaultHeaders;
        // Append a trailing slash so we can use relative paths. Without the trailing
        // slash, the last path segment will be replaced by the relative path. See
        // usage in `addressWithPath`.
        const fixedBaseServer = baseServer.endsWith("/") ? baseServer : `${baseServer}/`;
        const baseServerURL = new URL(fixedBaseServer);
        if (typeof port !== "undefined") baseServerURL.port = port.toString();
        if (baseServerURL.protocol.length === 0) throw new Error("Invalid base server URL, protocol must be defined.");
        this.baseURL = baseServerURL;
        this.tokenHeader = tokenHeader;
    }
    /**
     * Compute the URL for a path relative to the instance's address
     * @param relativePath - A path string
     * @param query - An optional key-value object of query parameters to add to the URL. If the
     *   relativePath already has query parameters on it, the additional parameters defined here will
     *   be added to the URL without modifying those (unless a key collision occurs).
     * @returns A URL string
     */ getURL(relativePath, query) {
        let fixedRelativePath;
        if (relativePath.startsWith("./")) fixedRelativePath = relativePath;
        else if (relativePath.startsWith("/")) fixedRelativePath = `.${relativePath}`;
        else fixedRelativePath = `./${relativePath}`;
        const address = new URL(fixedRelativePath, this.baseURL);
        if (query) for (const [key, value] of Object.entries(query))address.searchParams.set(key, value);
        return address.toString();
    }
    static formatFetchResponseHeaders(headers) {
        const headersObj = {};
        headers.forEach((key, value)=>{
            headersObj[key] = value;
        });
        return headersObj;
    }
    static async checkHttpError(res) {
        if (res.ok) return;
        let body = null;
        let bodyErrorMessage = null;
        try {
            body = new Uint8Array(await res.arrayBuffer());
            const decoded = JSON.parse((0, _buffer.Buffer).from(body).toString());
            if (decoded.message) bodyErrorMessage = decoded.message;
        } catch (_) {
        // ignore any error that happened while we are parsing the error response
        }
        let message = `Network request error. Received status ${res.status} (${res.statusText})`;
        if (bodyErrorMessage) message += `: ${bodyErrorMessage}`;
        throw new URLTokenBaseHTTPError(message, {
            body,
            status: res.status,
            headers: URLTokenBaseHTTPClient.formatFetchResponseHeaders(res.headers)
        });
    }
    static async formatFetchResponse(res) {
        await this.checkHttpError(res);
        return {
            body: new Uint8Array(await res.arrayBuffer()),
            status: res.status,
            headers: URLTokenBaseHTTPClient.formatFetchResponseHeaders(res.headers)
        };
    }
    async get(relativePath, query, requestHeaders = {}) {
        // Expand headers for use in fetch
        const headers = {
            ...this.tokenHeader,
            ...this.defaultHeaders,
            ...requestHeaders
        };
        const res = await (0, _crossFetch.fetch)(this.getURL(relativePath, query), {
            mode: "cors",
            headers
        });
        return URLTokenBaseHTTPClient.formatFetchResponse(res);
    }
    async post(relativePath, data, query, requestHeaders = {}) {
        // Expand headers for use in fetch
        const headers = {
            ...this.tokenHeader,
            ...this.defaultHeaders,
            ...requestHeaders
        };
        const res = await (0, _crossFetch.fetch)(this.getURL(relativePath, query), {
            method: "POST",
            mode: "cors",
            body: data,
            headers
        });
        return URLTokenBaseHTTPClient.formatFetchResponse(res);
    }
    async delete(relativePath, data, query, requestHeaders = {}) {
        // Expand headers for use in fetch
        const headers = {
            ...this.tokenHeader,
            ...this.defaultHeaders,
            ...requestHeaders
        };
        const res = await (0, _crossFetch.fetch)(this.getURL(relativePath, query), {
            method: "DELETE",
            mode: "cors",
            body: data,
            headers
        });
        return URLTokenBaseHTTPClient.formatFetchResponse(res);
    }
}

},{"buffer":"jlSk7","cross-fetch":"4rJhH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4rJhH":[function(require,module,exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

},{}],"5YZy0":[function(require,module,exports) {
/**
 * NOTICE: This file was generated. Editing this file manually is not recommended.
 */ /* eslint-disable no-use-before-define */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Account information at a given round.
 * Definition:
 * data/basics/userBalance.go : AccountData
 */ parcelHelpers.export(exports, "Account", ()=>Account);
/**
 * AccountApplicationResponse describes the account's application local state and
 * global state (AppLocalState and AppParams, if either exists) for a specific
 * application ID. Global state will only be returned if the provided address is
 * the application's creator.
 */ parcelHelpers.export(exports, "AccountApplicationResponse", ()=>AccountApplicationResponse);
/**
 * AccountAssetResponse describes the account's asset holding and asset parameters
 * (if either exist) for a specific asset ID. Asset parameters will only be
 * returned if the provided address is the asset's creator.
 */ parcelHelpers.export(exports, "AccountAssetResponse", ()=>AccountAssetResponse);
/**
 * AccountParticipation describes the parameters used by this account in consensus
 * protocol.
 */ parcelHelpers.export(exports, "AccountParticipation", ()=>AccountParticipation);
/**
 * Application state delta.
 */ parcelHelpers.export(exports, "AccountStateDelta", ()=>AccountStateDelta);
/**
 * Application index and its parameters
 */ parcelHelpers.export(exports, "Application", ()=>Application);
/**
 * Stores local state associated with an application.
 */ parcelHelpers.export(exports, "ApplicationLocalState", ()=>ApplicationLocalState);
/**
 * Stores the global information associated with an application.
 */ parcelHelpers.export(exports, "ApplicationParams", ()=>ApplicationParams);
/**
 * Specifies maximums on the number of each type that may be stored.
 */ parcelHelpers.export(exports, "ApplicationStateSchema", ()=>ApplicationStateSchema);
/**
 * Specifies both the unique identifier and the parameters for an asset
 */ parcelHelpers.export(exports, "Asset", ()=>Asset);
/**
 * Describes an asset held by an account.
 * Definition:
 * data/basics/userBalance.go : AssetHolding
 */ parcelHelpers.export(exports, "AssetHolding", ()=>AssetHolding);
/**
 * AssetParams specifies the parameters for an asset.
 * (apar) when part of an AssetConfig transaction.
 * Definition:
 * data/transactions/asset.go : AssetParams
 */ parcelHelpers.export(exports, "AssetParams", ()=>AssetParams);
/**
 * Hash of a block header.
 */ parcelHelpers.export(exports, "BlockHashResponse", ()=>BlockHashResponse);
/**
 * Encoded block object.
 */ parcelHelpers.export(exports, "BlockResponse", ()=>BlockResponse);
/**
 * Box name and its content.
 */ parcelHelpers.export(exports, "Box", ()=>Box);
/**
 * Box descriptor describes a Box.
 */ parcelHelpers.export(exports, "BoxDescriptor", ()=>BoxDescriptor);
/**
 * Box names of an application
 */ parcelHelpers.export(exports, "BoxesResponse", ()=>BoxesResponse);
parcelHelpers.export(exports, "BuildVersion", ()=>BuildVersion);
/**
 * Teal compile Result
 */ parcelHelpers.export(exports, "CompileResponse", ()=>CompileResponse);
/**
 * Teal disassembly Result
 */ parcelHelpers.export(exports, "DisassembleResponse", ()=>DisassembleResponse);
/**
 * Request data type for dryrun endpoint. Given the Transactions and simulated
 * ledger state upload, run TEAL scripts and return debugging information.
 */ parcelHelpers.export(exports, "DryrunRequest", ()=>DryrunRequest);
/**
 * DryrunResponse contains per-txn debug information from a dryrun.
 */ parcelHelpers.export(exports, "DryrunResponse", ()=>DryrunResponse);
/**
 * DryrunSource is TEAL source text that gets uploaded, compiled, and inserted into
 * transactions or application state.
 */ parcelHelpers.export(exports, "DryrunSource", ()=>DryrunSource);
/**
 * Stores the TEAL eval step data
 */ parcelHelpers.export(exports, "DryrunState", ()=>DryrunState);
/**
 * DryrunTxnResult contains any LogicSig or ApplicationCall program debug
 * information and state updates from a dryrun.
 */ parcelHelpers.export(exports, "DryrunTxnResult", ()=>DryrunTxnResult);
/**
 * An error response with optional data field.
 */ parcelHelpers.export(exports, "ErrorResponse", ()=>ErrorResponse);
/**
 * Represents a TEAL value delta.
 */ parcelHelpers.export(exports, "EvalDelta", ()=>EvalDelta);
/**
 * Key-value pairs for StateDelta.
 */ parcelHelpers.export(exports, "EvalDeltaKeyValue", ()=>EvalDeltaKeyValue);
/**
 * Response containing the timestamp offset in seconds
 */ parcelHelpers.export(exports, "GetBlockTimeStampOffsetResponse", ()=>GetBlockTimeStampOffsetResponse);
/**
 * Response containing the ledger's minimum sync round
 */ parcelHelpers.export(exports, "GetSyncRoundResponse", ()=>GetSyncRoundResponse);
/**
 * A single Delta containing the key, the previous value and the current value for
 * a single round.
 */ parcelHelpers.export(exports, "KvDelta", ()=>KvDelta);
/**
 * Proof of membership and position of a light block header.
 */ parcelHelpers.export(exports, "LightBlockHeaderProof", ()=>LightBlockHeaderProof);
/**
 *
 */ parcelHelpers.export(exports, "NodeStatusResponse", ()=>NodeStatusResponse);
/**
 * Details about a pending transaction. If the transaction was recently confirmed,
 * includes confirmation details like the round and reward details.
 */ parcelHelpers.export(exports, "PendingTransactionResponse", ()=>PendingTransactionResponse);
/**
 * A potentially truncated list of transactions currently in the node's transaction
 * pool. You can compute whether or not the list is truncated if the number of
 * elements in the **top-transactions** array is fewer than **total-transactions**.
 */ parcelHelpers.export(exports, "PendingTransactionsResponse", ()=>PendingTransactionsResponse);
/**
 * Transaction ID of the submission.
 */ parcelHelpers.export(exports, "PostTransactionsResponse", ()=>PostTransactionsResponse);
/**
 * Request type for simulation endpoint.
 */ parcelHelpers.export(exports, "SimulateRequest", ()=>SimulateRequest);
/**
 * A transaction group to simulate.
 */ parcelHelpers.export(exports, "SimulateRequestTransactionGroup", ()=>SimulateRequestTransactionGroup);
/**
 * Result of a transaction group simulation.
 */ parcelHelpers.export(exports, "SimulateResponse", ()=>SimulateResponse);
/**
 * Simulation result for an atomic transaction group
 */ parcelHelpers.export(exports, "SimulateTransactionGroupResult", ()=>SimulateTransactionGroupResult);
/**
 * Simulation result for an individual transaction
 */ parcelHelpers.export(exports, "SimulateTransactionResult", ()=>SimulateTransactionResult);
/**
 * The set of parameters and limits override during simulation. If this set of
 * parameters is present, then evaluation parameters may differ from standard
 * evaluation in certain ways.
 */ parcelHelpers.export(exports, "SimulationEvalOverrides", ()=>SimulationEvalOverrides);
/**
 * Represents a state proof and its corresponding message
 */ parcelHelpers.export(exports, "StateProof", ()=>StateProof);
/**
 * Represents the message that the state proofs are attesting to.
 */ parcelHelpers.export(exports, "StateProofMessage", ()=>StateProofMessage);
/**
 * Supply represents the current supply of MicroAlgos in the system.
 */ parcelHelpers.export(exports, "SupplyResponse", ()=>SupplyResponse);
/**
 * Represents a key-value pair in an application store.
 */ parcelHelpers.export(exports, "TealKeyValue", ()=>TealKeyValue);
/**
 * Represents a TEAL value.
 */ parcelHelpers.export(exports, "TealValue", ()=>TealValue);
/**
 * TransactionParams contains the parameters that help a client construct a new
 * transaction.
 */ parcelHelpers.export(exports, "TransactionParametersResponse", ()=>TransactionParametersResponse);
/**
 * Proof of transaction in a block.
 */ parcelHelpers.export(exports, "TransactionProofResponse", ()=>TransactionProofResponse);
/**
 * algod version information.
 */ parcelHelpers.export(exports, "Version", ()=>Version);
var _buffer = require("buffer");
var _basemodel = require("../../basemodel");
var _basemodelDefault = parcelHelpers.interopDefault(_basemodel);
class Account extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Account` object.
     * @param address - the account public key
     * @param amount - (algo) total number of MicroAlgos in the account
     * @param amountWithoutPendingRewards - specifies the amount of MicroAlgos in the account, without the pending rewards.
     * @param minBalance - MicroAlgo balance required by the account.
     * The requirement grows based on asset and application usage.
     * @param pendingRewards - amount of MicroAlgos of pending rewards in this account.
     * @param rewards - (ern) total rewards of MicroAlgos the account has received, including pending
     * rewards.
     * @param round - The round for which this information is relevant.
     * @param status - (onl) delegation status of the account's MicroAlgos
     * * Offline - indicates that the associated account is delegated.
     * * Online - indicates that the associated account used as part of the delegation
     * pool.
     * * NotParticipating - indicates that the associated account is neither a
     * delegator nor a delegate.
     * @param totalAppsOptedIn - The count of all applications that have been opted in, equivalent to the count
     * of application local data (AppLocalState objects) stored in this account.
     * @param totalAssetsOptedIn - The count of all assets that have been opted in, equivalent to the count of
     * AssetHolding objects held by this account.
     * @param totalCreatedApps - The count of all apps (AppParams objects) created by this account.
     * @param totalCreatedAssets - The count of all assets (AssetParams objects) created by this account.
     * @param appsLocalState - (appl) applications local data stored in this account.
     * Note the raw object uses `map[int] -> AppLocalState` for this type.
     * @param appsTotalExtraPages - (teap) the sum of all extra application program pages for this account.
     * @param appsTotalSchema - (tsch) stores the sum of all of the local schemas and global schemas in this
     * account.
     * Note: the raw account uses `StateSchema` for this type.
     * @param assets - (asset) assets held by this account.
     * Note the raw object uses `map[int] -> AssetHolding` for this type.
     * @param authAddr - (spend) the address against which signing should be checked. If empty, the
     * address of the current account is used. This field can be updated in any
     * transaction by setting the RekeyTo field.
     * @param createdApps - (appp) parameters of applications created by this account including app global
     * data.
     * Note: the raw account uses `map[int] -> AppParams` for this type.
     * @param createdAssets - (apar) parameters of assets created by this account.
     * Note: the raw account uses `map[int] -> Asset` for this type.
     * @param participation - AccountParticipation describes the parameters used by this account in consensus
     * protocol.
     * @param rewardBase - (ebase) used as part of the rewards computation. Only applicable to accounts
     * which are participating.
     * @param sigType - Indicates what type of signature is used by this account, must be one of:
     * * sig
     * * msig
     * * lsig
     * @param totalBoxBytes - (tbxb) The total number of bytes used by this account's app's box keys and
     * values.
     * @param totalBoxes - (tbx) The number of existing boxes created by this account's app.
     */ constructor({ address , amount , amountWithoutPendingRewards , minBalance , pendingRewards , rewards , round , status , totalAppsOptedIn , totalAssetsOptedIn , totalCreatedApps , totalCreatedAssets , appsLocalState , appsTotalExtraPages , appsTotalSchema , assets , authAddr , createdApps , createdAssets , participation , rewardBase , sigType , totalBoxBytes , totalBoxes  }){
        super();
        this.address = address;
        this.amount = amount;
        this.amountWithoutPendingRewards = amountWithoutPendingRewards;
        this.minBalance = minBalance;
        this.pendingRewards = pendingRewards;
        this.rewards = rewards;
        this.round = round;
        this.status = status;
        this.totalAppsOptedIn = totalAppsOptedIn;
        this.totalAssetsOptedIn = totalAssetsOptedIn;
        this.totalCreatedApps = totalCreatedApps;
        this.totalCreatedAssets = totalCreatedAssets;
        this.appsLocalState = appsLocalState;
        this.appsTotalExtraPages = appsTotalExtraPages;
        this.appsTotalSchema = appsTotalSchema;
        this.assets = assets;
        this.authAddr = authAddr;
        this.createdApps = createdApps;
        this.createdAssets = createdAssets;
        this.participation = participation;
        this.rewardBase = rewardBase;
        this.sigType = sigType;
        this.totalBoxBytes = totalBoxBytes;
        this.totalBoxes = totalBoxes;
        this.attribute_map = {
            address: "address",
            amount: "amount",
            amountWithoutPendingRewards: "amount-without-pending-rewards",
            minBalance: "min-balance",
            pendingRewards: "pending-rewards",
            rewards: "rewards",
            round: "round",
            status: "status",
            totalAppsOptedIn: "total-apps-opted-in",
            totalAssetsOptedIn: "total-assets-opted-in",
            totalCreatedApps: "total-created-apps",
            totalCreatedAssets: "total-created-assets",
            appsLocalState: "apps-local-state",
            appsTotalExtraPages: "apps-total-extra-pages",
            appsTotalSchema: "apps-total-schema",
            assets: "assets",
            authAddr: "auth-addr",
            createdApps: "created-apps",
            createdAssets: "created-assets",
            participation: "participation",
            rewardBase: "reward-base",
            sigType: "sig-type",
            totalBoxBytes: "total-box-bytes",
            totalBoxes: "total-boxes"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["address"] === "undefined") throw new Error(`Response is missing required field 'address': ${data}`);
        if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["amount-without-pending-rewards"] === "undefined") throw new Error(`Response is missing required field 'amount-without-pending-rewards': ${data}`);
        if (typeof data["min-balance"] === "undefined") throw new Error(`Response is missing required field 'min-balance': ${data}`);
        if (typeof data["pending-rewards"] === "undefined") throw new Error(`Response is missing required field 'pending-rewards': ${data}`);
        if (typeof data["rewards"] === "undefined") throw new Error(`Response is missing required field 'rewards': ${data}`);
        if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        if (typeof data["status"] === "undefined") throw new Error(`Response is missing required field 'status': ${data}`);
        if (typeof data["total-apps-opted-in"] === "undefined") throw new Error(`Response is missing required field 'total-apps-opted-in': ${data}`);
        if (typeof data["total-assets-opted-in"] === "undefined") throw new Error(`Response is missing required field 'total-assets-opted-in': ${data}`);
        if (typeof data["total-created-apps"] === "undefined") throw new Error(`Response is missing required field 'total-created-apps': ${data}`);
        if (typeof data["total-created-assets"] === "undefined") throw new Error(`Response is missing required field 'total-created-assets': ${data}`);
        return new Account({
            address: data["address"],
            amount: data["amount"],
            amountWithoutPendingRewards: data["amount-without-pending-rewards"],
            minBalance: data["min-balance"],
            pendingRewards: data["pending-rewards"],
            rewards: data["rewards"],
            round: data["round"],
            status: data["status"],
            totalAppsOptedIn: data["total-apps-opted-in"],
            totalAssetsOptedIn: data["total-assets-opted-in"],
            totalCreatedApps: data["total-created-apps"],
            totalCreatedAssets: data["total-created-assets"],
            appsLocalState: typeof data["apps-local-state"] !== "undefined" ? data["apps-local-state"].map(ApplicationLocalState.from_obj_for_encoding) : undefined,
            appsTotalExtraPages: data["apps-total-extra-pages"],
            appsTotalSchema: typeof data["apps-total-schema"] !== "undefined" ? ApplicationStateSchema.from_obj_for_encoding(data["apps-total-schema"]) : undefined,
            assets: typeof data["assets"] !== "undefined" ? data["assets"].map(AssetHolding.from_obj_for_encoding) : undefined,
            authAddr: data["auth-addr"],
            createdApps: typeof data["created-apps"] !== "undefined" ? data["created-apps"].map(Application.from_obj_for_encoding) : undefined,
            createdAssets: typeof data["created-assets"] !== "undefined" ? data["created-assets"].map(Asset.from_obj_for_encoding) : undefined,
            participation: typeof data["participation"] !== "undefined" ? AccountParticipation.from_obj_for_encoding(data["participation"]) : undefined,
            rewardBase: data["reward-base"],
            sigType: data["sig-type"],
            totalBoxBytes: data["total-box-bytes"],
            totalBoxes: data["total-boxes"]
        });
    /* eslint-enable dot-notation */ }
}
class AccountApplicationResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountApplicationResponse` object.
     * @param round - The round for which this information is relevant.
     * @param appLocalState - (appl) the application local data stored in this account.
     * The raw account uses `AppLocalState` for this type.
     * @param createdApp - (appp) parameters of the application created by this account including app
     * global data.
     * The raw account uses `AppParams` for this type.
     */ constructor({ round , appLocalState , createdApp  }){
        super();
        this.round = round;
        this.appLocalState = appLocalState;
        this.createdApp = createdApp;
        this.attribute_map = {
            round: "round",
            appLocalState: "app-local-state",
            createdApp: "created-app"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        return new AccountApplicationResponse({
            round: data["round"],
            appLocalState: typeof data["app-local-state"] !== "undefined" ? ApplicationLocalState.from_obj_for_encoding(data["app-local-state"]) : undefined,
            createdApp: typeof data["created-app"] !== "undefined" ? ApplicationParams.from_obj_for_encoding(data["created-app"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class AccountAssetResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountAssetResponse` object.
     * @param round - The round for which this information is relevant.
     * @param assetHolding - (asset) Details about the asset held by this account.
     * The raw account uses `AssetHolding` for this type.
     * @param createdAsset - (apar) parameters of the asset created by this account.
     * The raw account uses `AssetParams` for this type.
     */ constructor({ round , assetHolding , createdAsset  }){
        super();
        this.round = round;
        this.assetHolding = assetHolding;
        this.createdAsset = createdAsset;
        this.attribute_map = {
            round: "round",
            assetHolding: "asset-holding",
            createdAsset: "created-asset"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        return new AccountAssetResponse({
            round: data["round"],
            assetHolding: typeof data["asset-holding"] !== "undefined" ? AssetHolding.from_obj_for_encoding(data["asset-holding"]) : undefined,
            createdAsset: typeof data["created-asset"] !== "undefined" ? AssetParams.from_obj_for_encoding(data["created-asset"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class AccountParticipation extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountParticipation` object.
     * @param selectionParticipationKey - (sel) Selection public key (if any) currently registered for this round.
     * @param voteFirstValid - (voteFst) First round for which this participation is valid.
     * @param voteKeyDilution - (voteKD) Number of subkeys in each batch of participation keys.
     * @param voteLastValid - (voteLst) Last round for which this participation is valid.
     * @param voteParticipationKey - (vote) root participation public key (if any) currently registered for this
     * round.
     * @param stateProofKey - (stprf) Root of the state proof key (if any)
     */ constructor({ selectionParticipationKey , voteFirstValid , voteKeyDilution , voteLastValid , voteParticipationKey , stateProofKey  }){
        super();
        this.selectionParticipationKey = typeof selectionParticipationKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(selectionParticipationKey, "base64")) : selectionParticipationKey;
        this.voteFirstValid = voteFirstValid;
        this.voteKeyDilution = voteKeyDilution;
        this.voteLastValid = voteLastValid;
        this.voteParticipationKey = typeof voteParticipationKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(voteParticipationKey, "base64")) : voteParticipationKey;
        this.stateProofKey = typeof stateProofKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(stateProofKey, "base64")) : stateProofKey;
        this.attribute_map = {
            selectionParticipationKey: "selection-participation-key",
            voteFirstValid: "vote-first-valid",
            voteKeyDilution: "vote-key-dilution",
            voteLastValid: "vote-last-valid",
            voteParticipationKey: "vote-participation-key",
            stateProofKey: "state-proof-key"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["selection-participation-key"] === "undefined") throw new Error(`Response is missing required field 'selection-participation-key': ${data}`);
        if (typeof data["vote-first-valid"] === "undefined") throw new Error(`Response is missing required field 'vote-first-valid': ${data}`);
        if (typeof data["vote-key-dilution"] === "undefined") throw new Error(`Response is missing required field 'vote-key-dilution': ${data}`);
        if (typeof data["vote-last-valid"] === "undefined") throw new Error(`Response is missing required field 'vote-last-valid': ${data}`);
        if (typeof data["vote-participation-key"] === "undefined") throw new Error(`Response is missing required field 'vote-participation-key': ${data}`);
        return new AccountParticipation({
            selectionParticipationKey: data["selection-participation-key"],
            voteFirstValid: data["vote-first-valid"],
            voteKeyDilution: data["vote-key-dilution"],
            voteLastValid: data["vote-last-valid"],
            voteParticipationKey: data["vote-participation-key"],
            stateProofKey: data["state-proof-key"]
        });
    /* eslint-enable dot-notation */ }
}
class AccountStateDelta extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountStateDelta` object.
     * @param address -
     * @param delta - Application state delta.
     */ constructor({ address , delta  }){
        super();
        this.address = address;
        this.delta = delta;
        this.attribute_map = {
            address: "address",
            delta: "delta"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["address"] === "undefined") throw new Error(`Response is missing required field 'address': ${data}`);
        if (!Array.isArray(data["delta"])) throw new Error(`Response is missing required array field 'delta': ${data}`);
        return new AccountStateDelta({
            address: data["address"],
            delta: data["delta"].map(EvalDeltaKeyValue.from_obj_for_encoding)
        });
    /* eslint-enable dot-notation */ }
}
class Application extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Application` object.
     * @param id - (appidx) application index.
     * @param params - (appparams) application parameters.
     */ constructor({ id , params  }){
        super();
        this.id = id;
        this.params = params;
        this.attribute_map = {
            id: "id",
            params: "params"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["id"] === "undefined") throw new Error(`Response is missing required field 'id': ${data}`);
        if (typeof data["params"] === "undefined") throw new Error(`Response is missing required field 'params': ${data}`);
        return new Application({
            id: data["id"],
            params: ApplicationParams.from_obj_for_encoding(data["params"])
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationLocalState extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationLocalState` object.
     * @param id - The application which this local state is for.
     * @param schema - (hsch) schema.
     * @param keyValue - (tkv) storage.
     */ constructor({ id , schema , keyValue  }){
        super();
        this.id = id;
        this.schema = schema;
        this.keyValue = keyValue;
        this.attribute_map = {
            id: "id",
            schema: "schema",
            keyValue: "key-value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["id"] === "undefined") throw new Error(`Response is missing required field 'id': ${data}`);
        if (typeof data["schema"] === "undefined") throw new Error(`Response is missing required field 'schema': ${data}`);
        return new ApplicationLocalState({
            id: data["id"],
            schema: ApplicationStateSchema.from_obj_for_encoding(data["schema"]),
            keyValue: typeof data["key-value"] !== "undefined" ? data["key-value"].map(TealKeyValue.from_obj_for_encoding) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationParams extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationParams` object.
     * @param approvalProgram - (approv) approval program.
     * @param clearStateProgram - (clearp) approval program.
     * @param creator - The address that created this application. This is the address where the
     * parameters and global state for this application can be found.
     * @param extraProgramPages - (epp) the amount of extra program pages available to this app.
     * @param globalState - (gs) global state
     * @param globalStateSchema - (gsch) global schema
     * @param localStateSchema - (lsch) local schema
     */ constructor({ approvalProgram , clearStateProgram , creator , extraProgramPages , globalState , globalStateSchema , localStateSchema  }){
        super();
        this.approvalProgram = typeof approvalProgram === "string" ? new Uint8Array((0, _buffer.Buffer).from(approvalProgram, "base64")) : approvalProgram;
        this.clearStateProgram = typeof clearStateProgram === "string" ? new Uint8Array((0, _buffer.Buffer).from(clearStateProgram, "base64")) : clearStateProgram;
        this.creator = creator;
        this.extraProgramPages = extraProgramPages;
        this.globalState = globalState;
        this.globalStateSchema = globalStateSchema;
        this.localStateSchema = localStateSchema;
        this.attribute_map = {
            approvalProgram: "approval-program",
            clearStateProgram: "clear-state-program",
            creator: "creator",
            extraProgramPages: "extra-program-pages",
            globalState: "global-state",
            globalStateSchema: "global-state-schema",
            localStateSchema: "local-state-schema"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["approval-program"] === "undefined") throw new Error(`Response is missing required field 'approval-program': ${data}`);
        if (typeof data["clear-state-program"] === "undefined") throw new Error(`Response is missing required field 'clear-state-program': ${data}`);
        if (typeof data["creator"] === "undefined") throw new Error(`Response is missing required field 'creator': ${data}`);
        return new ApplicationParams({
            approvalProgram: data["approval-program"],
            clearStateProgram: data["clear-state-program"],
            creator: data["creator"],
            extraProgramPages: data["extra-program-pages"],
            globalState: typeof data["global-state"] !== "undefined" ? data["global-state"].map(TealKeyValue.from_obj_for_encoding) : undefined,
            globalStateSchema: typeof data["global-state-schema"] !== "undefined" ? ApplicationStateSchema.from_obj_for_encoding(data["global-state-schema"]) : undefined,
            localStateSchema: typeof data["local-state-schema"] !== "undefined" ? ApplicationStateSchema.from_obj_for_encoding(data["local-state-schema"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationStateSchema extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationStateSchema` object.
     * @param numUint - (nui) num of uints.
     * @param numByteSlice - (nbs) num of byte slices.
     */ constructor({ numUint , numByteSlice  }){
        super();
        this.numUint = numUint;
        this.numByteSlice = numByteSlice;
        this.attribute_map = {
            numUint: "num-uint",
            numByteSlice: "num-byte-slice"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["num-uint"] === "undefined") throw new Error(`Response is missing required field 'num-uint': ${data}`);
        if (typeof data["num-byte-slice"] === "undefined") throw new Error(`Response is missing required field 'num-byte-slice': ${data}`);
        return new ApplicationStateSchema({
            numUint: data["num-uint"],
            numByteSlice: data["num-byte-slice"]
        });
    /* eslint-enable dot-notation */ }
}
class Asset extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Asset` object.
     * @param index - unique asset identifier
     * @param params - AssetParams specifies the parameters for an asset.
     * (apar) when part of an AssetConfig transaction.
     * Definition:
     * data/transactions/asset.go : AssetParams
     */ constructor({ index , params  }){
        super();
        this.index = index;
        this.params = params;
        this.attribute_map = {
            index: "index",
            params: "params"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["index"] === "undefined") throw new Error(`Response is missing required field 'index': ${data}`);
        if (typeof data["params"] === "undefined") throw new Error(`Response is missing required field 'params': ${data}`);
        return new Asset({
            index: data["index"],
            params: AssetParams.from_obj_for_encoding(data["params"])
        });
    /* eslint-enable dot-notation */ }
}
class AssetHolding extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetHolding` object.
     * @param amount - (a) number of units held.
     * @param assetId - Asset ID of the holding.
     * @param isFrozen - (f) whether or not the holding is frozen.
     */ constructor({ amount , assetId , isFrozen  }){
        super();
        this.amount = amount;
        this.assetId = assetId;
        this.isFrozen = isFrozen;
        this.attribute_map = {
            amount: "amount",
            assetId: "asset-id",
            isFrozen: "is-frozen"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["asset-id"] === "undefined") throw new Error(`Response is missing required field 'asset-id': ${data}`);
        if (typeof data["is-frozen"] === "undefined") throw new Error(`Response is missing required field 'is-frozen': ${data}`);
        return new AssetHolding({
            amount: data["amount"],
            assetId: data["asset-id"],
            isFrozen: data["is-frozen"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetParams extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetParams` object.
     * @param creator - The address that created this asset. This is the address where the parameters
     * for this asset can be found, and also the address where unwanted asset units can
     * be sent in the worst case.
     * @param decimals - (dc) The number of digits to use after the decimal point when displaying this
     * asset. If 0, the asset is not divisible. If 1, the base unit of the asset is in
     * tenths. If 2, the base unit of the asset is in hundredths, and so on. This value
     * must be between 0 and 19 (inclusive).
     * @param total - (t) The total number of units of this asset.
     * @param clawback - (c) Address of account used to clawback holdings of this asset. If empty,
     * clawback is not permitted.
     * @param defaultFrozen - (df) Whether holdings of this asset are frozen by default.
     * @param freeze - (f) Address of account used to freeze holdings of this asset. If empty, freezing
     * is not permitted.
     * @param manager - (m) Address of account used to manage the keys of this asset and to destroy it.
     * @param metadataHash - (am) A commitment to some unspecified asset metadata. The format of this
     * metadata is up to the application.
     * @param name - (an) Name of this asset, as supplied by the creator. Included only when the
     * asset name is composed of printable utf-8 characters.
     * @param nameB64 - Base64 encoded name of this asset, as supplied by the creator.
     * @param reserve - (r) Address of account holding reserve (non-minted) units of this asset.
     * @param unitName - (un) Name of a unit of this asset, as supplied by the creator. Included only
     * when the name of a unit of this asset is composed of printable utf-8 characters.
     * @param unitNameB64 - Base64 encoded name of a unit of this asset, as supplied by the creator.
     * @param url - (au) URL where more information about the asset can be retrieved. Included only
     * when the URL is composed of printable utf-8 characters.
     * @param urlB64 - Base64 encoded URL where more information about the asset can be retrieved.
     */ constructor({ creator , decimals , total , clawback , defaultFrozen , freeze , manager , metadataHash , name , nameB64 , reserve , unitName , unitNameB64 , url , urlB64  }){
        super();
        this.creator = creator;
        this.decimals = decimals;
        this.total = total;
        this.clawback = clawback;
        this.defaultFrozen = defaultFrozen;
        this.freeze = freeze;
        this.manager = manager;
        this.metadataHash = typeof metadataHash === "string" ? new Uint8Array((0, _buffer.Buffer).from(metadataHash, "base64")) : metadataHash;
        this.name = name;
        this.nameB64 = typeof nameB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(nameB64, "base64")) : nameB64;
        this.reserve = reserve;
        this.unitName = unitName;
        this.unitNameB64 = typeof unitNameB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(unitNameB64, "base64")) : unitNameB64;
        this.url = url;
        this.urlB64 = typeof urlB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(urlB64, "base64")) : urlB64;
        this.attribute_map = {
            creator: "creator",
            decimals: "decimals",
            total: "total",
            clawback: "clawback",
            defaultFrozen: "default-frozen",
            freeze: "freeze",
            manager: "manager",
            metadataHash: "metadata-hash",
            name: "name",
            nameB64: "name-b64",
            reserve: "reserve",
            unitName: "unit-name",
            unitNameB64: "unit-name-b64",
            url: "url",
            urlB64: "url-b64"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["creator"] === "undefined") throw new Error(`Response is missing required field 'creator': ${data}`);
        if (typeof data["decimals"] === "undefined") throw new Error(`Response is missing required field 'decimals': ${data}`);
        if (typeof data["total"] === "undefined") throw new Error(`Response is missing required field 'total': ${data}`);
        return new AssetParams({
            creator: data["creator"],
            decimals: data["decimals"],
            total: data["total"],
            clawback: data["clawback"],
            defaultFrozen: data["default-frozen"],
            freeze: data["freeze"],
            manager: data["manager"],
            metadataHash: data["metadata-hash"],
            name: data["name"],
            nameB64: data["name-b64"],
            reserve: data["reserve"],
            unitName: data["unit-name"],
            unitNameB64: data["unit-name-b64"],
            url: data["url"],
            urlB64: data["url-b64"]
        });
    /* eslint-enable dot-notation */ }
}
class BlockHashResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BlockHashResponse` object.
     * @param blockhash - Block header hash.
     */ constructor({ blockhash  }){
        super();
        this.blockhash = blockhash;
        this.attribute_map = {
            blockhash: "blockHash"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["blockHash"] === "undefined") throw new Error(`Response is missing required field 'blockHash': ${data}`);
        return new BlockHashResponse({
            blockhash: data["blockHash"]
        });
    /* eslint-enable dot-notation */ }
}
class BlockResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BlockResponse` object.
     * @param block - Block header data.
     * @param cert - Optional certificate object. This is only included when the format is set to
     * message pack.
     */ constructor({ block , cert  }){
        super();
        this.block = block;
        this.cert = cert;
        this.attribute_map = {
            block: "block",
            cert: "cert"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["block"] === "undefined") throw new Error(`Response is missing required field 'block': ${data}`);
        return new BlockResponse({
            block: data["block"],
            cert: data["cert"]
        });
    /* eslint-enable dot-notation */ }
}
class Box extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Box` object.
     * @param name - (name) box name, base64 encoded
     * @param value - (value) box value, base64 encoded.
     */ constructor({ name , value  }){
        super();
        this.name = typeof name === "string" ? new Uint8Array((0, _buffer.Buffer).from(name, "base64")) : name;
        this.value = typeof value === "string" ? new Uint8Array((0, _buffer.Buffer).from(value, "base64")) : value;
        this.attribute_map = {
            name: "name",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["name"] === "undefined") throw new Error(`Response is missing required field 'name': ${data}`);
        if (typeof data["value"] === "undefined") throw new Error(`Response is missing required field 'value': ${data}`);
        return new Box({
            name: data["name"],
            value: data["value"]
        });
    /* eslint-enable dot-notation */ }
}
class BoxDescriptor extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BoxDescriptor` object.
     * @param name - Base64 encoded box name
     */ constructor({ name  }){
        super();
        this.name = typeof name === "string" ? new Uint8Array((0, _buffer.Buffer).from(name, "base64")) : name;
        this.attribute_map = {
            name: "name"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["name"] === "undefined") throw new Error(`Response is missing required field 'name': ${data}`);
        return new BoxDescriptor({
            name: data["name"]
        });
    /* eslint-enable dot-notation */ }
}
class BoxesResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BoxesResponse` object.
     * @param boxes -
     */ constructor({ boxes  }){
        super();
        this.boxes = boxes;
        this.attribute_map = {
            boxes: "boxes"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["boxes"])) throw new Error(`Response is missing required array field 'boxes': ${data}`);
        return new BoxesResponse({
            boxes: data["boxes"].map(BoxDescriptor.from_obj_for_encoding)
        });
    /* eslint-enable dot-notation */ }
}
class BuildVersion extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BuildVersion` object.
     * @param branch -
     * @param buildNumber -
     * @param channel -
     * @param commitHash -
     * @param major -
     * @param minor -
     */ constructor({ branch , buildNumber , channel , commitHash , major , minor  }){
        super();
        this.branch = branch;
        this.buildNumber = buildNumber;
        this.channel = channel;
        this.commitHash = commitHash;
        this.major = major;
        this.minor = minor;
        this.attribute_map = {
            branch: "branch",
            buildNumber: "build_number",
            channel: "channel",
            commitHash: "commit_hash",
            major: "major",
            minor: "minor"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["branch"] === "undefined") throw new Error(`Response is missing required field 'branch': ${data}`);
        if (typeof data["build_number"] === "undefined") throw new Error(`Response is missing required field 'build_number': ${data}`);
        if (typeof data["channel"] === "undefined") throw new Error(`Response is missing required field 'channel': ${data}`);
        if (typeof data["commit_hash"] === "undefined") throw new Error(`Response is missing required field 'commit_hash': ${data}`);
        if (typeof data["major"] === "undefined") throw new Error(`Response is missing required field 'major': ${data}`);
        if (typeof data["minor"] === "undefined") throw new Error(`Response is missing required field 'minor': ${data}`);
        return new BuildVersion({
            branch: data["branch"],
            buildNumber: data["build_number"],
            channel: data["channel"],
            commitHash: data["commit_hash"],
            major: data["major"],
            minor: data["minor"]
        });
    /* eslint-enable dot-notation */ }
}
class CompileResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `CompileResponse` object.
     * @param hash - base32 SHA512_256 of program bytes (Address style)
     * @param result - base64 encoded program bytes
     * @param sourcemap - JSON of the source map
     */ constructor({ hash , result , sourcemap  }){
        super();
        this.hash = hash;
        this.result = result;
        this.sourcemap = sourcemap;
        this.attribute_map = {
            hash: "hash",
            result: "result",
            sourcemap: "sourcemap"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["hash"] === "undefined") throw new Error(`Response is missing required field 'hash': ${data}`);
        if (typeof data["result"] === "undefined") throw new Error(`Response is missing required field 'result': ${data}`);
        return new CompileResponse({
            hash: data["hash"],
            result: data["result"],
            sourcemap: data["sourcemap"]
        });
    /* eslint-enable dot-notation */ }
}
class DisassembleResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `DisassembleResponse` object.
     * @param result - disassembled Teal code
     */ constructor({ result  }){
        super();
        this.result = result;
        this.attribute_map = {
            result: "result"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["result"] === "undefined") throw new Error(`Response is missing required field 'result': ${data}`);
        return new DisassembleResponse({
            result: data["result"]
        });
    /* eslint-enable dot-notation */ }
}
class DryrunRequest extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `DryrunRequest` object.
     * @param accounts -
     * @param apps -
     * @param latestTimestamp - LatestTimestamp is available to some TEAL scripts. Defaults to the latest
     * confirmed timestamp this algod is attached to.
     * @param protocolVersion - ProtocolVersion specifies a specific version string to operate under, otherwise
     * whatever the current protocol of the network this algod is running in.
     * @param round - Round is available to some TEAL scripts. Defaults to the current round on the
     * network this algod is attached to.
     * @param sources -
     * @param txns -
     */ constructor({ accounts , apps , latestTimestamp , protocolVersion , round , sources , txns  }){
        super();
        this.accounts = accounts;
        this.apps = apps;
        this.latestTimestamp = latestTimestamp;
        this.protocolVersion = protocolVersion;
        this.round = round;
        this.sources = sources;
        this.txns = txns;
        this.attribute_map = {
            accounts: "accounts",
            apps: "apps",
            latestTimestamp: "latest-timestamp",
            protocolVersion: "protocol-version",
            round: "round",
            sources: "sources",
            txns: "txns"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["accounts"])) throw new Error(`Response is missing required array field 'accounts': ${data}`);
        if (!Array.isArray(data["apps"])) throw new Error(`Response is missing required array field 'apps': ${data}`);
        if (typeof data["latest-timestamp"] === "undefined") throw new Error(`Response is missing required field 'latest-timestamp': ${data}`);
        if (typeof data["protocol-version"] === "undefined") throw new Error(`Response is missing required field 'protocol-version': ${data}`);
        if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        if (!Array.isArray(data["sources"])) throw new Error(`Response is missing required array field 'sources': ${data}`);
        if (!Array.isArray(data["txns"])) throw new Error(`Response is missing required array field 'txns': ${data}`);
        return new DryrunRequest({
            accounts: data["accounts"].map(Account.from_obj_for_encoding),
            apps: data["apps"].map(Application.from_obj_for_encoding),
            latestTimestamp: data["latest-timestamp"],
            protocolVersion: data["protocol-version"],
            round: data["round"],
            sources: data["sources"].map(DryrunSource.from_obj_for_encoding),
            txns: data["txns"]
        });
    /* eslint-enable dot-notation */ }
}
class DryrunResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `DryrunResponse` object.
     * @param error -
     * @param protocolVersion - Protocol version is the protocol version Dryrun was operated under.
     * @param txns -
     */ constructor({ error , protocolVersion , txns  }){
        super();
        this.error = error;
        this.protocolVersion = protocolVersion;
        this.txns = txns;
        this.attribute_map = {
            error: "error",
            protocolVersion: "protocol-version",
            txns: "txns"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["error"] === "undefined") throw new Error(`Response is missing required field 'error': ${data}`);
        if (typeof data["protocol-version"] === "undefined") throw new Error(`Response is missing required field 'protocol-version': ${data}`);
        if (!Array.isArray(data["txns"])) throw new Error(`Response is missing required array field 'txns': ${data}`);
        return new DryrunResponse({
            error: data["error"],
            protocolVersion: data["protocol-version"],
            txns: data["txns"].map(DryrunTxnResult.from_obj_for_encoding)
        });
    /* eslint-enable dot-notation */ }
}
class DryrunSource extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `DryrunSource` object.
     * @param fieldName - FieldName is what kind of sources this is. If lsig then it goes into the
     * transactions[this.TxnIndex].LogicSig. If approv or clearp it goes into the
     * Approval Program or Clear State Program of application[this.AppIndex].
     * @param source -
     * @param txnIndex -
     * @param appIndex -
     */ constructor({ fieldName , source , txnIndex , appIndex  }){
        super();
        this.fieldName = fieldName;
        this.source = source;
        this.txnIndex = txnIndex;
        this.appIndex = appIndex;
        this.attribute_map = {
            fieldName: "field-name",
            source: "source",
            txnIndex: "txn-index",
            appIndex: "app-index"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["field-name"] === "undefined") throw new Error(`Response is missing required field 'field-name': ${data}`);
        if (typeof data["source"] === "undefined") throw new Error(`Response is missing required field 'source': ${data}`);
        if (typeof data["txn-index"] === "undefined") throw new Error(`Response is missing required field 'txn-index': ${data}`);
        if (typeof data["app-index"] === "undefined") throw new Error(`Response is missing required field 'app-index': ${data}`);
        return new DryrunSource({
            fieldName: data["field-name"],
            source: data["source"],
            txnIndex: data["txn-index"],
            appIndex: data["app-index"]
        });
    /* eslint-enable dot-notation */ }
}
class DryrunState extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `DryrunState` object.
     * @param line - Line number
     * @param pc - Program counter
     * @param stack -
     * @param error - Evaluation error if any
     * @param scratch -
     */ constructor({ line , pc , stack , error , scratch  }){
        super();
        this.line = line;
        this.pc = pc;
        this.stack = stack;
        this.error = error;
        this.scratch = scratch;
        this.attribute_map = {
            line: "line",
            pc: "pc",
            stack: "stack",
            error: "error",
            scratch: "scratch"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["line"] === "undefined") throw new Error(`Response is missing required field 'line': ${data}`);
        if (typeof data["pc"] === "undefined") throw new Error(`Response is missing required field 'pc': ${data}`);
        if (!Array.isArray(data["stack"])) throw new Error(`Response is missing required array field 'stack': ${data}`);
        return new DryrunState({
            line: data["line"],
            pc: data["pc"],
            stack: data["stack"].map(TealValue.from_obj_for_encoding),
            error: data["error"],
            scratch: typeof data["scratch"] !== "undefined" ? data["scratch"].map(TealValue.from_obj_for_encoding) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class DryrunTxnResult extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `DryrunTxnResult` object.
     * @param disassembly - Disassembled program line by line.
     * @param appCallMessages -
     * @param appCallTrace -
     * @param budgetAdded - Budget added during execution of app call transaction.
     * @param budgetConsumed - Budget consumed during execution of app call transaction.
     * @param globalDelta - Application state delta.
     * @param localDeltas -
     * @param logicSigDisassembly - Disassembled lsig program line by line.
     * @param logicSigMessages -
     * @param logicSigTrace -
     * @param logs -
     */ constructor({ disassembly , appCallMessages , appCallTrace , budgetAdded , budgetConsumed , globalDelta , localDeltas , logicSigDisassembly , logicSigMessages , logicSigTrace , logs  }){
        super();
        this.disassembly = disassembly;
        this.appCallMessages = appCallMessages;
        this.appCallTrace = appCallTrace;
        this.budgetAdded = budgetAdded;
        this.budgetConsumed = budgetConsumed;
        this.globalDelta = globalDelta;
        this.localDeltas = localDeltas;
        this.logicSigDisassembly = logicSigDisassembly;
        this.logicSigMessages = logicSigMessages;
        this.logicSigTrace = logicSigTrace;
        this.logs = logs;
        this.attribute_map = {
            disassembly: "disassembly",
            appCallMessages: "app-call-messages",
            appCallTrace: "app-call-trace",
            budgetAdded: "budget-added",
            budgetConsumed: "budget-consumed",
            globalDelta: "global-delta",
            localDeltas: "local-deltas",
            logicSigDisassembly: "logic-sig-disassembly",
            logicSigMessages: "logic-sig-messages",
            logicSigTrace: "logic-sig-trace",
            logs: "logs"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["disassembly"])) throw new Error(`Response is missing required array field 'disassembly': ${data}`);
        return new DryrunTxnResult({
            disassembly: data["disassembly"],
            appCallMessages: data["app-call-messages"],
            appCallTrace: typeof data["app-call-trace"] !== "undefined" ? data["app-call-trace"].map(DryrunState.from_obj_for_encoding) : undefined,
            budgetAdded: data["budget-added"],
            budgetConsumed: data["budget-consumed"],
            globalDelta: typeof data["global-delta"] !== "undefined" ? data["global-delta"].map(EvalDeltaKeyValue.from_obj_for_encoding) : undefined,
            localDeltas: typeof data["local-deltas"] !== "undefined" ? data["local-deltas"].map(AccountStateDelta.from_obj_for_encoding) : undefined,
            logicSigDisassembly: data["logic-sig-disassembly"],
            logicSigMessages: data["logic-sig-messages"],
            logicSigTrace: typeof data["logic-sig-trace"] !== "undefined" ? data["logic-sig-trace"].map(DryrunState.from_obj_for_encoding) : undefined,
            logs: data["logs"]
        });
    /* eslint-enable dot-notation */ }
}
class ErrorResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ErrorResponse` object.
     * @param message -
     * @param data -
     */ constructor({ message , data  }){
        super();
        this.message = message;
        this.data = data;
        this.attribute_map = {
            message: "message",
            data: "data"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["message"] === "undefined") throw new Error(`Response is missing required field 'message': ${data}`);
        return new ErrorResponse({
            message: data["message"],
            data: data["data"]
        });
    /* eslint-enable dot-notation */ }
}
class EvalDelta extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `EvalDelta` object.
     * @param action - (at) delta action.
     * @param bytes - (bs) bytes value.
     * @param uint - (ui) uint value.
     */ constructor({ action , bytes , uint  }){
        super();
        this.action = action;
        this.bytes = bytes;
        this.uint = uint;
        this.attribute_map = {
            action: "action",
            bytes: "bytes",
            uint: "uint"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["action"] === "undefined") throw new Error(`Response is missing required field 'action': ${data}`);
        return new EvalDelta({
            action: data["action"],
            bytes: data["bytes"],
            uint: data["uint"]
        });
    /* eslint-enable dot-notation */ }
}
class EvalDeltaKeyValue extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `EvalDeltaKeyValue` object.
     * @param key -
     * @param value - Represents a TEAL value delta.
     */ constructor({ key , value  }){
        super();
        this.key = key;
        this.value = value;
        this.attribute_map = {
            key: "key",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["key"] === "undefined") throw new Error(`Response is missing required field 'key': ${data}`);
        if (typeof data["value"] === "undefined") throw new Error(`Response is missing required field 'value': ${data}`);
        return new EvalDeltaKeyValue({
            key: data["key"],
            value: EvalDelta.from_obj_for_encoding(data["value"])
        });
    /* eslint-enable dot-notation */ }
}
class GetBlockTimeStampOffsetResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `GetBlockTimeStampOffsetResponse` object.
     * @param offset - Timestamp offset in seconds.
     */ constructor({ offset  }){
        super();
        this.offset = offset;
        this.attribute_map = {
            offset: "offset"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["offset"] === "undefined") throw new Error(`Response is missing required field 'offset': ${data}`);
        return new GetBlockTimeStampOffsetResponse({
            offset: data["offset"]
        });
    /* eslint-enable dot-notation */ }
}
class GetSyncRoundResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `GetSyncRoundResponse` object.
     * @param round - The minimum sync round for the ledger.
     */ constructor({ round  }){
        super();
        this.round = round;
        this.attribute_map = {
            round: "round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        return new GetSyncRoundResponse({
            round: data["round"]
        });
    /* eslint-enable dot-notation */ }
}
class KvDelta extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `KvDelta` object.
     * @param key - The key, base64 encoded.
     * @param value - The new value of the KV store entry, base64 encoded.
     */ constructor({ key , value  }){
        super();
        this.key = typeof key === "string" ? new Uint8Array((0, _buffer.Buffer).from(key, "base64")) : key;
        this.value = typeof value === "string" ? new Uint8Array((0, _buffer.Buffer).from(value, "base64")) : value;
        this.attribute_map = {
            key: "key",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new KvDelta({
            key: data["key"],
            value: data["value"]
        });
    /* eslint-enable dot-notation */ }
}
class LightBlockHeaderProof extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `LightBlockHeaderProof` object.
     * @param index - The index of the light block header in the vector commitment tree
     * @param proof - The encoded proof.
     * @param treedepth - Represents the depth of the tree that is being proven, i.e. the number of edges
     * from a leaf to the root.
     */ constructor({ index , proof , treedepth  }){
        super();
        this.index = index;
        this.proof = typeof proof === "string" ? new Uint8Array((0, _buffer.Buffer).from(proof, "base64")) : proof;
        this.treedepth = treedepth;
        this.attribute_map = {
            index: "index",
            proof: "proof",
            treedepth: "treedepth"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["index"] === "undefined") throw new Error(`Response is missing required field 'index': ${data}`);
        if (typeof data["proof"] === "undefined") throw new Error(`Response is missing required field 'proof': ${data}`);
        if (typeof data["treedepth"] === "undefined") throw new Error(`Response is missing required field 'treedepth': ${data}`);
        return new LightBlockHeaderProof({
            index: data["index"],
            proof: data["proof"],
            treedepth: data["treedepth"]
        });
    /* eslint-enable dot-notation */ }
}
class NodeStatusResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `NodeStatusResponse` object.
     * @param catchupTime - CatchupTime in nanoseconds
     * @param lastRound - LastRound indicates the last round seen
     * @param lastVersion - LastVersion indicates the last consensus version supported
     * @param nextVersion - NextVersion of consensus protocol to use
     * @param nextVersionRound - NextVersionRound is the round at which the next consensus version will apply
     * @param nextVersionSupported - NextVersionSupported indicates whether the next consensus version is supported
     * by this node
     * @param stoppedAtUnsupportedRound - StoppedAtUnsupportedRound indicates that the node does not support the new
     * rounds and has stopped making progress
     * @param timeSinceLastRound - TimeSinceLastRound in nanoseconds
     * @param catchpoint - The current catchpoint that is being caught up to
     * @param catchpointAcquiredBlocks - The number of blocks that have already been obtained by the node as part of the
     * catchup
     * @param catchpointProcessedAccounts - The number of accounts from the current catchpoint that have been processed so
     * far as part of the catchup
     * @param catchpointProcessedKvs - The number of key-values (KVs) from the current catchpoint that have been
     * processed so far as part of the catchup
     * @param catchpointTotalAccounts - The total number of accounts included in the current catchpoint
     * @param catchpointTotalBlocks - The total number of blocks that are required to complete the current catchpoint
     * catchup
     * @param catchpointTotalKvs - The total number of key-values (KVs) included in the current catchpoint
     * @param catchpointVerifiedAccounts - The number of accounts from the current catchpoint that have been verified so
     * far as part of the catchup
     * @param catchpointVerifiedKvs - The number of key-values (KVs) from the current catchpoint that have been
     * verified so far as part of the catchup
     * @param lastCatchpoint - The last catchpoint seen by the node
     * @param upgradeDelay - Upgrade delay
     * @param upgradeNextProtocolVoteBefore - Next protocol round
     * @param upgradeNoVotes - No votes cast for consensus upgrade
     * @param upgradeNodeVote - This node's upgrade vote
     * @param upgradeVoteRounds - Total voting rounds for current upgrade
     * @param upgradeVotes - Total votes cast for consensus upgrade
     * @param upgradeVotesRequired - Yes votes required for consensus upgrade
     * @param upgradeYesVotes - Yes votes cast for consensus upgrade
     */ constructor({ catchupTime , lastRound , lastVersion , nextVersion , nextVersionRound , nextVersionSupported , stoppedAtUnsupportedRound , timeSinceLastRound , catchpoint , catchpointAcquiredBlocks , catchpointProcessedAccounts , catchpointProcessedKvs , catchpointTotalAccounts , catchpointTotalBlocks , catchpointTotalKvs , catchpointVerifiedAccounts , catchpointVerifiedKvs , lastCatchpoint , upgradeDelay , upgradeNextProtocolVoteBefore , upgradeNoVotes , upgradeNodeVote , upgradeVoteRounds , upgradeVotes , upgradeVotesRequired , upgradeYesVotes  }){
        super();
        this.catchupTime = catchupTime;
        this.lastRound = lastRound;
        this.lastVersion = lastVersion;
        this.nextVersion = nextVersion;
        this.nextVersionRound = nextVersionRound;
        this.nextVersionSupported = nextVersionSupported;
        this.stoppedAtUnsupportedRound = stoppedAtUnsupportedRound;
        this.timeSinceLastRound = timeSinceLastRound;
        this.catchpoint = catchpoint;
        this.catchpointAcquiredBlocks = catchpointAcquiredBlocks;
        this.catchpointProcessedAccounts = catchpointProcessedAccounts;
        this.catchpointProcessedKvs = catchpointProcessedKvs;
        this.catchpointTotalAccounts = catchpointTotalAccounts;
        this.catchpointTotalBlocks = catchpointTotalBlocks;
        this.catchpointTotalKvs = catchpointTotalKvs;
        this.catchpointVerifiedAccounts = catchpointVerifiedAccounts;
        this.catchpointVerifiedKvs = catchpointVerifiedKvs;
        this.lastCatchpoint = lastCatchpoint;
        this.upgradeDelay = upgradeDelay;
        this.upgradeNextProtocolVoteBefore = upgradeNextProtocolVoteBefore;
        this.upgradeNoVotes = upgradeNoVotes;
        this.upgradeNodeVote = upgradeNodeVote;
        this.upgradeVoteRounds = upgradeVoteRounds;
        this.upgradeVotes = upgradeVotes;
        this.upgradeVotesRequired = upgradeVotesRequired;
        this.upgradeYesVotes = upgradeYesVotes;
        this.attribute_map = {
            catchupTime: "catchup-time",
            lastRound: "last-round",
            lastVersion: "last-version",
            nextVersion: "next-version",
            nextVersionRound: "next-version-round",
            nextVersionSupported: "next-version-supported",
            stoppedAtUnsupportedRound: "stopped-at-unsupported-round",
            timeSinceLastRound: "time-since-last-round",
            catchpoint: "catchpoint",
            catchpointAcquiredBlocks: "catchpoint-acquired-blocks",
            catchpointProcessedAccounts: "catchpoint-processed-accounts",
            catchpointProcessedKvs: "catchpoint-processed-kvs",
            catchpointTotalAccounts: "catchpoint-total-accounts",
            catchpointTotalBlocks: "catchpoint-total-blocks",
            catchpointTotalKvs: "catchpoint-total-kvs",
            catchpointVerifiedAccounts: "catchpoint-verified-accounts",
            catchpointVerifiedKvs: "catchpoint-verified-kvs",
            lastCatchpoint: "last-catchpoint",
            upgradeDelay: "upgrade-delay",
            upgradeNextProtocolVoteBefore: "upgrade-next-protocol-vote-before",
            upgradeNoVotes: "upgrade-no-votes",
            upgradeNodeVote: "upgrade-node-vote",
            upgradeVoteRounds: "upgrade-vote-rounds",
            upgradeVotes: "upgrade-votes",
            upgradeVotesRequired: "upgrade-votes-required",
            upgradeYesVotes: "upgrade-yes-votes"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["catchup-time"] === "undefined") throw new Error(`Response is missing required field 'catchup-time': ${data}`);
        if (typeof data["last-round"] === "undefined") throw new Error(`Response is missing required field 'last-round': ${data}`);
        if (typeof data["last-version"] === "undefined") throw new Error(`Response is missing required field 'last-version': ${data}`);
        if (typeof data["next-version"] === "undefined") throw new Error(`Response is missing required field 'next-version': ${data}`);
        if (typeof data["next-version-round"] === "undefined") throw new Error(`Response is missing required field 'next-version-round': ${data}`);
        if (typeof data["next-version-supported"] === "undefined") throw new Error(`Response is missing required field 'next-version-supported': ${data}`);
        if (typeof data["stopped-at-unsupported-round"] === "undefined") throw new Error(`Response is missing required field 'stopped-at-unsupported-round': ${data}`);
        if (typeof data["time-since-last-round"] === "undefined") throw new Error(`Response is missing required field 'time-since-last-round': ${data}`);
        return new NodeStatusResponse({
            catchupTime: data["catchup-time"],
            lastRound: data["last-round"],
            lastVersion: data["last-version"],
            nextVersion: data["next-version"],
            nextVersionRound: data["next-version-round"],
            nextVersionSupported: data["next-version-supported"],
            stoppedAtUnsupportedRound: data["stopped-at-unsupported-round"],
            timeSinceLastRound: data["time-since-last-round"],
            catchpoint: data["catchpoint"],
            catchpointAcquiredBlocks: data["catchpoint-acquired-blocks"],
            catchpointProcessedAccounts: data["catchpoint-processed-accounts"],
            catchpointProcessedKvs: data["catchpoint-processed-kvs"],
            catchpointTotalAccounts: data["catchpoint-total-accounts"],
            catchpointTotalBlocks: data["catchpoint-total-blocks"],
            catchpointTotalKvs: data["catchpoint-total-kvs"],
            catchpointVerifiedAccounts: data["catchpoint-verified-accounts"],
            catchpointVerifiedKvs: data["catchpoint-verified-kvs"],
            lastCatchpoint: data["last-catchpoint"],
            upgradeDelay: data["upgrade-delay"],
            upgradeNextProtocolVoteBefore: data["upgrade-next-protocol-vote-before"],
            upgradeNoVotes: data["upgrade-no-votes"],
            upgradeNodeVote: data["upgrade-node-vote"],
            upgradeVoteRounds: data["upgrade-vote-rounds"],
            upgradeVotes: data["upgrade-votes"],
            upgradeVotesRequired: data["upgrade-votes-required"],
            upgradeYesVotes: data["upgrade-yes-votes"]
        });
    /* eslint-enable dot-notation */ }
}
class PendingTransactionResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `PendingTransactionResponse` object.
     * @param poolError - Indicates that the transaction was kicked out of this node's transaction pool
     * (and specifies why that happened). An empty string indicates the transaction
     * wasn't kicked out of this node's txpool due to an error.
     * @param txn - The raw signed transaction.
     * @param applicationIndex - The application index if the transaction was found and it created an
     * application.
     * @param assetClosingAmount - The number of the asset's unit that were transferred to the close-to address.
     * @param assetIndex - The asset index if the transaction was found and it created an asset.
     * @param closeRewards - Rewards in microalgos applied to the close remainder to account.
     * @param closingAmount - Closing amount for the transaction.
     * @param confirmedRound - The round where this transaction was confirmed, if present.
     * @param globalStateDelta - Global state key/value changes for the application being executed by this
     * transaction.
     * @param innerTxns - Inner transactions produced by application execution.
     * @param localStateDelta - Local state key/value changes for the application being executed by this
     * transaction.
     * @param logs - Logs for the application being executed by this transaction.
     * @param receiverRewards - Rewards in microalgos applied to the receiver account.
     * @param senderRewards - Rewards in microalgos applied to the sender account.
     */ constructor({ poolError , txn , applicationIndex , assetClosingAmount , assetIndex , closeRewards , closingAmount , confirmedRound , globalStateDelta , innerTxns , localStateDelta , logs , receiverRewards , senderRewards  }){
        super();
        this.poolError = poolError;
        this.txn = txn;
        this.applicationIndex = applicationIndex;
        this.assetClosingAmount = assetClosingAmount;
        this.assetIndex = assetIndex;
        this.closeRewards = closeRewards;
        this.closingAmount = closingAmount;
        this.confirmedRound = confirmedRound;
        this.globalStateDelta = globalStateDelta;
        this.innerTxns = innerTxns;
        this.localStateDelta = localStateDelta;
        this.logs = logs;
        this.receiverRewards = receiverRewards;
        this.senderRewards = senderRewards;
        this.attribute_map = {
            poolError: "pool-error",
            txn: "txn",
            applicationIndex: "application-index",
            assetClosingAmount: "asset-closing-amount",
            assetIndex: "asset-index",
            closeRewards: "close-rewards",
            closingAmount: "closing-amount",
            confirmedRound: "confirmed-round",
            globalStateDelta: "global-state-delta",
            innerTxns: "inner-txns",
            localStateDelta: "local-state-delta",
            logs: "logs",
            receiverRewards: "receiver-rewards",
            senderRewards: "sender-rewards"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["pool-error"] === "undefined") throw new Error(`Response is missing required field 'pool-error': ${data}`);
        if (typeof data["txn"] === "undefined") throw new Error(`Response is missing required field 'txn': ${data}`);
        return new PendingTransactionResponse({
            poolError: data["pool-error"],
            txn: data["txn"],
            applicationIndex: data["application-index"],
            assetClosingAmount: data["asset-closing-amount"],
            assetIndex: data["asset-index"],
            closeRewards: data["close-rewards"],
            closingAmount: data["closing-amount"],
            confirmedRound: data["confirmed-round"],
            globalStateDelta: typeof data["global-state-delta"] !== "undefined" ? data["global-state-delta"].map(EvalDeltaKeyValue.from_obj_for_encoding) : undefined,
            innerTxns: typeof data["inner-txns"] !== "undefined" ? data["inner-txns"].map(PendingTransactionResponse.from_obj_for_encoding) : undefined,
            localStateDelta: typeof data["local-state-delta"] !== "undefined" ? data["local-state-delta"].map(AccountStateDelta.from_obj_for_encoding) : undefined,
            logs: data["logs"],
            receiverRewards: data["receiver-rewards"],
            senderRewards: data["sender-rewards"]
        });
    /* eslint-enable dot-notation */ }
}
class PendingTransactionsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `PendingTransactionsResponse` object.
     * @param topTransactions - An array of signed transaction objects.
     * @param totalTransactions - Total number of transactions in the pool.
     */ constructor({ topTransactions , totalTransactions  }){
        super();
        this.topTransactions = topTransactions;
        this.totalTransactions = totalTransactions;
        this.attribute_map = {
            topTransactions: "top-transactions",
            totalTransactions: "total-transactions"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["top-transactions"])) throw new Error(`Response is missing required array field 'top-transactions': ${data}`);
        if (typeof data["total-transactions"] === "undefined") throw new Error(`Response is missing required field 'total-transactions': ${data}`);
        return new PendingTransactionsResponse({
            topTransactions: data["top-transactions"],
            totalTransactions: data["total-transactions"]
        });
    /* eslint-enable dot-notation */ }
}
class PostTransactionsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `PostTransactionsResponse` object.
     * @param txid - encoding of the transaction hash.
     */ constructor({ txid  }){
        super();
        this.txid = txid;
        this.attribute_map = {
            txid: "txId"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["txId"] === "undefined") throw new Error(`Response is missing required field 'txId': ${data}`);
        return new PostTransactionsResponse({
            txid: data["txId"]
        });
    /* eslint-enable dot-notation */ }
}
class SimulateRequest extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SimulateRequest` object.
     * @param txnGroups - The transaction groups to simulate.
     * @param allowEmptySignatures - Allow transactions without signatures to be simulated as if they had correct
     * signatures.
     * @param allowMoreLogging - Lifts limits on log opcode usage during simulation.
     */ constructor({ txnGroups , allowEmptySignatures , allowMoreLogging  }){
        super();
        this.txnGroups = txnGroups;
        this.allowEmptySignatures = allowEmptySignatures;
        this.allowMoreLogging = allowMoreLogging;
        this.attribute_map = {
            txnGroups: "txn-groups",
            allowEmptySignatures: "allow-empty-signatures",
            allowMoreLogging: "allow-more-logging"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["txn-groups"])) throw new Error(`Response is missing required array field 'txn-groups': ${data}`);
        return new SimulateRequest({
            txnGroups: data["txn-groups"].map(SimulateRequestTransactionGroup.from_obj_for_encoding),
            allowEmptySignatures: data["allow-empty-signatures"],
            allowMoreLogging: data["allow-more-logging"]
        });
    /* eslint-enable dot-notation */ }
}
class SimulateRequestTransactionGroup extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SimulateRequestTransactionGroup` object.
     * @param txns - An atomic transaction group.
     */ constructor({ txns  }){
        super();
        this.txns = txns;
        this.attribute_map = {
            txns: "txns"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["txns"])) throw new Error(`Response is missing required array field 'txns': ${data}`);
        return new SimulateRequestTransactionGroup({
            txns: data["txns"]
        });
    /* eslint-enable dot-notation */ }
}
class SimulateResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SimulateResponse` object.
     * @param lastRound - The round immediately preceding this simulation. State changes through this
     * round were used to run this simulation.
     * @param txnGroups - A result object for each transaction group that was simulated.
     * @param version - The version of this response object.
     * @param evalOverrides - The set of parameters and limits override during simulation. If this set of
     * parameters is present, then evaluation parameters may differ from standard
     * evaluation in certain ways.
     */ constructor({ lastRound , txnGroups , version , evalOverrides  }){
        super();
        this.lastRound = lastRound;
        this.txnGroups = txnGroups;
        this.version = version;
        this.evalOverrides = evalOverrides;
        this.attribute_map = {
            lastRound: "last-round",
            txnGroups: "txn-groups",
            version: "version",
            evalOverrides: "eval-overrides"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["last-round"] === "undefined") throw new Error(`Response is missing required field 'last-round': ${data}`);
        if (!Array.isArray(data["txn-groups"])) throw new Error(`Response is missing required array field 'txn-groups': ${data}`);
        if (typeof data["version"] === "undefined") throw new Error(`Response is missing required field 'version': ${data}`);
        return new SimulateResponse({
            lastRound: data["last-round"],
            txnGroups: data["txn-groups"].map(SimulateTransactionGroupResult.from_obj_for_encoding),
            version: data["version"],
            evalOverrides: typeof data["eval-overrides"] !== "undefined" ? SimulationEvalOverrides.from_obj_for_encoding(data["eval-overrides"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class SimulateTransactionGroupResult extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SimulateTransactionGroupResult` object.
     * @param txnResults - Simulation result for individual transactions
     * @param appBudgetAdded - Total budget added during execution of app calls in the transaction group.
     * @param appBudgetConsumed - Total budget consumed during execution of app calls in the transaction group.
     * @param failedAt - If present, indicates which transaction in this group caused the failure. This
     * array represents the path to the failing transaction. Indexes are zero based,
     * the first element indicates the top-level transaction, and successive elements
     * indicate deeper inner transactions.
     * @param failureMessage - If present, indicates that the transaction group failed and specifies why that
     * happened
     */ constructor({ txnResults , appBudgetAdded , appBudgetConsumed , failedAt , failureMessage  }){
        super();
        this.txnResults = txnResults;
        this.appBudgetAdded = appBudgetAdded;
        this.appBudgetConsumed = appBudgetConsumed;
        this.failedAt = failedAt;
        this.failureMessage = failureMessage;
        this.attribute_map = {
            txnResults: "txn-results",
            appBudgetAdded: "app-budget-added",
            appBudgetConsumed: "app-budget-consumed",
            failedAt: "failed-at",
            failureMessage: "failure-message"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["txn-results"])) throw new Error(`Response is missing required array field 'txn-results': ${data}`);
        return new SimulateTransactionGroupResult({
            txnResults: data["txn-results"].map(SimulateTransactionResult.from_obj_for_encoding),
            appBudgetAdded: data["app-budget-added"],
            appBudgetConsumed: data["app-budget-consumed"],
            failedAt: data["failed-at"],
            failureMessage: data["failure-message"]
        });
    /* eslint-enable dot-notation */ }
}
class SimulateTransactionResult extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SimulateTransactionResult` object.
     * @param txnResult - Details about a pending transaction. If the transaction was recently confirmed,
     * includes confirmation details like the round and reward details.
     * @param appBudgetConsumed - Budget used during execution of an app call transaction. This value includes
     * budged used by inner app calls spawned by this transaction.
     * @param logicSigBudgetConsumed - Budget used during execution of a logic sig transaction.
     */ constructor({ txnResult , appBudgetConsumed , logicSigBudgetConsumed  }){
        super();
        this.txnResult = txnResult;
        this.appBudgetConsumed = appBudgetConsumed;
        this.logicSigBudgetConsumed = logicSigBudgetConsumed;
        this.attribute_map = {
            txnResult: "txn-result",
            appBudgetConsumed: "app-budget-consumed",
            logicSigBudgetConsumed: "logic-sig-budget-consumed"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["txn-result"] === "undefined") throw new Error(`Response is missing required field 'txn-result': ${data}`);
        return new SimulateTransactionResult({
            txnResult: PendingTransactionResponse.from_obj_for_encoding(data["txn-result"]),
            appBudgetConsumed: data["app-budget-consumed"],
            logicSigBudgetConsumed: data["logic-sig-budget-consumed"]
        });
    /* eslint-enable dot-notation */ }
}
class SimulationEvalOverrides extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SimulationEvalOverrides` object.
     * @param allowEmptySignatures - If true, transactions without signatures are allowed and simulated as if they
     * were properly signed.
     * @param maxLogCalls - The maximum log calls one can make during simulation
     * @param maxLogSize - The maximum byte number to log during simulation
     */ constructor({ allowEmptySignatures , maxLogCalls , maxLogSize  }){
        super();
        this.allowEmptySignatures = allowEmptySignatures;
        this.maxLogCalls = maxLogCalls;
        this.maxLogSize = maxLogSize;
        this.attribute_map = {
            allowEmptySignatures: "allow-empty-signatures",
            maxLogCalls: "max-log-calls",
            maxLogSize: "max-log-size"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new SimulationEvalOverrides({
            allowEmptySignatures: data["allow-empty-signatures"],
            maxLogCalls: data["max-log-calls"],
            maxLogSize: data["max-log-size"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProof extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProof` object.
     * @param message - Represents the message that the state proofs are attesting to.
     * @param stateproof - The encoded StateProof for the message.
     */ constructor({ message , stateproof  }){
        super();
        this.message = message;
        this.stateproof = typeof stateproof === "string" ? new Uint8Array((0, _buffer.Buffer).from(stateproof, "base64")) : stateproof;
        this.attribute_map = {
            message: "Message",
            stateproof: "StateProof"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["Message"] === "undefined") throw new Error(`Response is missing required field 'Message': ${data}`);
        if (typeof data["StateProof"] === "undefined") throw new Error(`Response is missing required field 'StateProof': ${data}`);
        return new StateProof({
            message: StateProofMessage.from_obj_for_encoding(data["Message"]),
            stateproof: data["StateProof"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProofMessage extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofMessage` object.
     * @param blockheaderscommitment - The vector commitment root on all light block headers within a state proof
     * interval.
     * @param firstattestedround - The first round the message attests to.
     * @param lastattestedround - The last round the message attests to.
     * @param lnprovenweight - An integer value representing the natural log of the proven weight with 16 bits
     * of precision. This value would be used to verify the next state proof.
     * @param voterscommitment - The vector commitment root of the top N accounts to sign the next StateProof.
     */ constructor({ blockheaderscommitment , firstattestedround , lastattestedround , lnprovenweight , voterscommitment  }){
        super();
        this.blockheaderscommitment = typeof blockheaderscommitment === "string" ? new Uint8Array((0, _buffer.Buffer).from(blockheaderscommitment, "base64")) : blockheaderscommitment;
        this.firstattestedround = firstattestedround;
        this.lastattestedround = lastattestedround;
        this.lnprovenweight = lnprovenweight;
        this.voterscommitment = typeof voterscommitment === "string" ? new Uint8Array((0, _buffer.Buffer).from(voterscommitment, "base64")) : voterscommitment;
        this.attribute_map = {
            blockheaderscommitment: "BlockHeadersCommitment",
            firstattestedround: "FirstAttestedRound",
            lastattestedround: "LastAttestedRound",
            lnprovenweight: "LnProvenWeight",
            voterscommitment: "VotersCommitment"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["BlockHeadersCommitment"] === "undefined") throw new Error(`Response is missing required field 'BlockHeadersCommitment': ${data}`);
        if (typeof data["FirstAttestedRound"] === "undefined") throw new Error(`Response is missing required field 'FirstAttestedRound': ${data}`);
        if (typeof data["LastAttestedRound"] === "undefined") throw new Error(`Response is missing required field 'LastAttestedRound': ${data}`);
        if (typeof data["LnProvenWeight"] === "undefined") throw new Error(`Response is missing required field 'LnProvenWeight': ${data}`);
        if (typeof data["VotersCommitment"] === "undefined") throw new Error(`Response is missing required field 'VotersCommitment': ${data}`);
        return new StateProofMessage({
            blockheaderscommitment: data["BlockHeadersCommitment"],
            firstattestedround: data["FirstAttestedRound"],
            lastattestedround: data["LastAttestedRound"],
            lnprovenweight: data["LnProvenWeight"],
            voterscommitment: data["VotersCommitment"]
        });
    /* eslint-enable dot-notation */ }
}
class SupplyResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `SupplyResponse` object.
     * @param currentRound - Round
     * @param onlineMoney - OnlineMoney
     * @param totalMoney - TotalMoney
     */ constructor({ currentRound , onlineMoney , totalMoney  }){
        super();
        this.currentRound = currentRound;
        this.onlineMoney = onlineMoney;
        this.totalMoney = totalMoney;
        this.attribute_map = {
            currentRound: "current_round",
            onlineMoney: "online-money",
            totalMoney: "total-money"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["current_round"] === "undefined") throw new Error(`Response is missing required field 'current_round': ${data}`);
        if (typeof data["online-money"] === "undefined") throw new Error(`Response is missing required field 'online-money': ${data}`);
        if (typeof data["total-money"] === "undefined") throw new Error(`Response is missing required field 'total-money': ${data}`);
        return new SupplyResponse({
            currentRound: data["current_round"],
            onlineMoney: data["online-money"],
            totalMoney: data["total-money"]
        });
    /* eslint-enable dot-notation */ }
}
class TealKeyValue extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TealKeyValue` object.
     * @param key -
     * @param value - Represents a TEAL value.
     */ constructor({ key , value  }){
        super();
        this.key = key;
        this.value = value;
        this.attribute_map = {
            key: "key",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["key"] === "undefined") throw new Error(`Response is missing required field 'key': ${data}`);
        if (typeof data["value"] === "undefined") throw new Error(`Response is missing required field 'value': ${data}`);
        return new TealKeyValue({
            key: data["key"],
            value: TealValue.from_obj_for_encoding(data["value"])
        });
    /* eslint-enable dot-notation */ }
}
class TealValue extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TealValue` object.
     * @param type - (tt) value type. Value `1` refers to **bytes**, value `2` refers to **uint**
     * @param bytes - (tb) bytes value.
     * @param uint - (ui) uint value.
     */ constructor({ type , bytes , uint  }){
        super();
        this.type = type;
        this.bytes = bytes;
        this.uint = uint;
        this.attribute_map = {
            type: "type",
            bytes: "bytes",
            uint: "uint"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["type"] === "undefined") throw new Error(`Response is missing required field 'type': ${data}`);
        if (typeof data["bytes"] === "undefined") throw new Error(`Response is missing required field 'bytes': ${data}`);
        if (typeof data["uint"] === "undefined") throw new Error(`Response is missing required field 'uint': ${data}`);
        return new TealValue({
            type: data["type"],
            bytes: data["bytes"],
            uint: data["uint"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionParametersResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionParametersResponse` object.
     * @param consensusVersion - ConsensusVersion indicates the consensus protocol version
     * as of LastRound.
     * @param fee - Fee is the suggested transaction fee
     * Fee is in units of micro-Algos per byte.
     * Fee may fall to zero but transactions must still have a fee of
     * at least MinTxnFee for the current network protocol.
     * @param genesisHash - GenesisHash is the hash of the genesis block.
     * @param genesisId - GenesisID is an ID listed in the genesis block.
     * @param lastRound - LastRound indicates the last round seen
     * @param minFee - The minimum transaction fee (not per byte) required for the
     * txn to validate for the current network protocol.
     */ constructor({ consensusVersion , fee , genesisHash , genesisId , lastRound , minFee  }){
        super();
        this.consensusVersion = consensusVersion;
        this.fee = fee;
        this.genesisHash = typeof genesisHash === "string" ? new Uint8Array((0, _buffer.Buffer).from(genesisHash, "base64")) : genesisHash;
        this.genesisId = genesisId;
        this.lastRound = lastRound;
        this.minFee = minFee;
        this.attribute_map = {
            consensusVersion: "consensus-version",
            fee: "fee",
            genesisHash: "genesis-hash",
            genesisId: "genesis-id",
            lastRound: "last-round",
            minFee: "min-fee"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["consensus-version"] === "undefined") throw new Error(`Response is missing required field 'consensus-version': ${data}`);
        if (typeof data["fee"] === "undefined") throw new Error(`Response is missing required field 'fee': ${data}`);
        if (typeof data["genesis-hash"] === "undefined") throw new Error(`Response is missing required field 'genesis-hash': ${data}`);
        if (typeof data["genesis-id"] === "undefined") throw new Error(`Response is missing required field 'genesis-id': ${data}`);
        if (typeof data["last-round"] === "undefined") throw new Error(`Response is missing required field 'last-round': ${data}`);
        if (typeof data["min-fee"] === "undefined") throw new Error(`Response is missing required field 'min-fee': ${data}`);
        return new TransactionParametersResponse({
            consensusVersion: data["consensus-version"],
            fee: data["fee"],
            genesisHash: data["genesis-hash"],
            genesisId: data["genesis-id"],
            lastRound: data["last-round"],
            minFee: data["min-fee"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionProofResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionProofResponse` object.
     * @param idx - Index of the transaction in the block's payset.
     * @param proof - Proof of transaction membership.
     * @param stibhash - Hash of SignedTxnInBlock for verifying proof.
     * @param treedepth - Represents the depth of the tree that is being proven, i.e. the number of edges
     * from a leaf to the root.
     * @param hashtype - The type of hash function used to create the proof, must be one of:
     * * sha512_256
     * * sha256
     */ constructor({ idx , proof , stibhash , treedepth , hashtype  }){
        super();
        this.idx = idx;
        this.proof = typeof proof === "string" ? new Uint8Array((0, _buffer.Buffer).from(proof, "base64")) : proof;
        this.stibhash = typeof stibhash === "string" ? new Uint8Array((0, _buffer.Buffer).from(stibhash, "base64")) : stibhash;
        this.treedepth = treedepth;
        this.hashtype = hashtype;
        this.attribute_map = {
            idx: "idx",
            proof: "proof",
            stibhash: "stibhash",
            treedepth: "treedepth",
            hashtype: "hashtype"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["idx"] === "undefined") throw new Error(`Response is missing required field 'idx': ${data}`);
        if (typeof data["proof"] === "undefined") throw new Error(`Response is missing required field 'proof': ${data}`);
        if (typeof data["stibhash"] === "undefined") throw new Error(`Response is missing required field 'stibhash': ${data}`);
        if (typeof data["treedepth"] === "undefined") throw new Error(`Response is missing required field 'treedepth': ${data}`);
        return new TransactionProofResponse({
            idx: data["idx"],
            proof: data["proof"],
            stibhash: data["stibhash"],
            treedepth: data["treedepth"],
            hashtype: data["hashtype"]
        });
    /* eslint-enable dot-notation */ }
}
class Version extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Version` object.
     * @param build -
     * @param genesisHashB64 -
     * @param genesisId -
     * @param versions -
     */ constructor({ build , genesisHashB64 , genesisId , versions  }){
        super();
        this.build = build;
        this.genesisHashB64 = typeof genesisHashB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(genesisHashB64, "base64")) : genesisHashB64;
        this.genesisId = genesisId;
        this.versions = versions;
        this.attribute_map = {
            build: "build",
            genesisHashB64: "genesis_hash_b64",
            genesisId: "genesis_id",
            versions: "versions"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["build"] === "undefined") throw new Error(`Response is missing required field 'build': ${data}`);
        if (typeof data["genesis_hash_b64"] === "undefined") throw new Error(`Response is missing required field 'genesis_hash_b64': ${data}`);
        if (typeof data["genesis_id"] === "undefined") throw new Error(`Response is missing required field 'genesis_id': ${data}`);
        if (!Array.isArray(data["versions"])) throw new Error(`Response is missing required array field 'versions': ${data}`);
        return new Version({
            build: BuildVersion.from_obj_for_encoding(data["build"]),
            genesisHashB64: data["genesis_hash_b64"],
            genesisId: data["genesis_id"],
            versions: data["versions"]
        });
    /* eslint-enable dot-notation */ }
}

},{"buffer":"jlSk7","../../basemodel":"9uRuH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9uRuH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
/**
 * Base class for models
 */ /* eslint-disable no-underscore-dangle,camelcase */ function _is_primitive(val) {
    /* eslint-enable no-underscore-dangle,camelcase */ return val === undefined || val == null || typeof val !== "object" && typeof val !== "function";
}
function _get_obj_for_encoding(val, binary) {
    /* eslint-enable no-underscore-dangle,camelcase,no-redeclare,no-unused-vars */ let targetPropValue;
    if (val instanceof Uint8Array) targetPropValue = binary ? val : (0, _buffer.Buffer).from(val).toString("base64");
    else if (typeof val.get_obj_for_encoding === "function") targetPropValue = val.get_obj_for_encoding(binary);
    else if (Array.isArray(val)) {
        targetPropValue = [];
        for (const elem of val)targetPropValue.push(_get_obj_for_encoding(elem, binary));
    } else if (typeof val === "object") {
        const obj = {};
        for (const prop of Object.keys(val))obj[prop] = _get_obj_for_encoding(val[prop], binary);
        targetPropValue = obj;
    } else if (_is_primitive(val)) targetPropValue = val;
    else throw new Error(`Unsupported value: ${String(val)}`);
    return targetPropValue;
}
class BaseModel {
    /**
     * Get an object ready for encoding to either JSON or msgpack.
     * @param binary - Use true to indicate that the encoding can handle raw binary objects
     *   (Uint8Arrays). Use false to indicate that raw binary objects should be converted to base64
     *   strings. True should be used for objects that will be encoded with msgpack, and false should
     *   be used for objects that will be encoded with JSON.
     */ get_obj_for_encoding(binary = false) {
        /* eslint-enable no-underscore-dangle,camelcase */ const obj = {};
        for (const prop of Object.keys(this.attribute_map)){
            const name = this.attribute_map[prop];
            const value = this[prop];
            if (typeof value !== "undefined") obj[name] = value === null ? null : _get_obj_for_encoding(value, binary);
        }
        return obj;
    }
}
exports.default = BaseModel;

},{"buffer":"jlSk7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bOvRZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class AccountInformation extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    path() {
        return `/v2/accounts/${this.account}`;
    }
    /**
     * Exclude assets and application data from results
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await algodClient.accountInformation(address)
     *        .exclude('all')
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ exclude(exclude) {
        this.query.exclude = exclude;
        return this;
    }
}
exports.default = AccountInformation;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eWgGi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _intDecoding = require("../../types/intDecoding");
var _intDecodingDefault = parcelHelpers.interopDefault(_intDecoding);
class JSONRequest {
    /**
     * @param client - HTTPClient object.
     * @param intDecoding - The method to use
     *   for decoding integers from this request's response. See the setIntDecoding method for more
     *   details.
     */ constructor(client, intDecoding){
        this.c = client;
        this.query = {};
        this.intDecoding = intDecoding || (0, _intDecodingDefault.default).DEFAULT;
    }
    /**
     * Prepare a JSON response before returning it.
     *
     * Use this method to change and restructure response
     * data as needed after receiving it from the `do()` method.
     * @param body - Response body received
     * @category JSONRequest
     */ // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return body;
    }
    /**
     * Execute the request.
     * @param headers - Additional headers to send in the request. Optional.
     * @returns A promise which resolves to the parsed response data.
     * @category JSONRequest
     */ async do(headers = {}) {
        const jsonOptions = {};
        if (this.intDecoding !== "default") jsonOptions.intDecoding = this.intDecoding;
        const res = await this.c.get(this.path(), this.query, headers, jsonOptions);
        return this.prepare(res.body);
    }
    /**
     * Execute the request, but do not process the response data in any way.
     * @param headers - Additional headers to send in the request. Optional.
     * @returns A promise which resolves to the raw response data, exactly as returned by the server.
     * @category JSONRequest
     */ async doRaw(headers = {}) {
        const res = await this.c.get(this.path(), this.query, headers, {}, false);
        return res.body;
    }
    /**
     * Configure how integers in this request's JSON response will be decoded.
     *
     * The options are:
     * * "default": Integers will be decoded according to JSON.parse, meaning they will all be
     *   Numbers and any values greater than Number.MAX_SAFE_INTEGER will lose precision.
     * * "safe": All integers will be decoded as Numbers, but if any values are greater than
     *   Number.MAX_SAFE_INTEGER an error will be thrown.
     * * "mixed": Integers will be decoded as Numbers if they are less than or equal to
     *   Number.MAX_SAFE_INTEGER, otherwise they will be decoded as BigInts.
     * * "bigint": All integers will be decoded as BigInts.
     *
     * @param method - The method to use when parsing the
     *   response for this request. Must be one of "default", "safe", "mixed", or "bigint".
     * @category JSONRequest
     */ setIntDecoding(method) {
        if (method !== "default" && method !== "safe" && method !== "mixed" && method !== "bigint") throw new Error(`Invalid method for int decoding: ${method}`);
        this.intDecoding = method;
        return this;
    }
}
exports.default = JSONRequest;

},{"../../types/intDecoding":"bwLkl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l0gVD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class AccountAssetInformation extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, account, assetID){
        super(c, intDecoding);
        this.account = account;
        this.assetID = assetID;
        this.account = account;
        this.assetID = assetID;
    }
    path() {
        return `/v2/accounts/${this.account}/assets/${this.assetID}`;
    }
}
exports.default = AccountAssetInformation;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2LWKA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class AccountApplicationInformation extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, account, applicationID){
        super(c, intDecoding);
        this.account = account;
        this.applicationID = applicationID;
        this.account = account;
        this.applicationID = applicationID;
    }
    path() {
        return `/v2/accounts/${this.account}/applications/${this.applicationID}`;
    }
}
exports.default = AccountApplicationInformation;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cPBVj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _encoding = require("../../../encoding/encoding");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class Block extends (0, _jsonrequestDefault.default) {
    constructor(c, roundNumber){
        super(c);
        if (!Number.isInteger(roundNumber)) throw Error("roundNumber should be an integer");
        this.round = roundNumber;
        this.query = {
            format: "msgpack"
        };
    }
    path() {
        return `/v2/blocks/${this.round}`;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        if (body && body.byteLength > 0) return _encoding.decode(body);
        return undefined;
    }
}
exports.default = Block;

},{"../../../encoding/encoding":"1Yg70","../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"etJKB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the default header (if not previously set)
 * @param headers - A headers object
 */ parcelHelpers.export(exports, "setHeaders", ()=>setHeaders);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
function setHeaders(headers = {}) {
    let hdrs = headers;
    if (Object.keys(hdrs).every((key)=>key.toLowerCase() !== "content-type")) {
        hdrs = {
            ...headers
        };
        hdrs["Content-Type"] = "text/plain";
    }
    return hdrs;
}
class Compile extends (0, _jsonrequestDefault.default) {
    constructor(c, source){
        super(c);
        this.source = source;
        this.source = source;
    }
    // eslint-disable-next-line class-methods-use-this
    path() {
        return `/v2/teal/compile`;
    }
    sourcemap(map = true) {
        this.query.sourcemap = map;
        return this;
    }
    /**
     * Executes compile
     * @param headers - A headers object
     */ async do(headers = {}) {
        const txHeaders = setHeaders(headers);
        const res = await this.c.post(this.path(), (0, _buffer.Buffer).from(this.source), txHeaders, this.query);
        return res.body;
    }
}
exports.default = Compile;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l6Xme":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _encoding = require("../../../encoding/encoding");
var _compile = require("./compile");
class Dryrun extends (0, _jsonrequestDefault.default) {
    constructor(c, dr){
        super(c);
        this.blob = _encoding.encode(dr.get_obj_for_encoding(true));
    }
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/teal/dryrun";
    }
    /**
     * Executes dryrun
     * @param headers - A headers object
     */ async do(headers = {}) {
        const txHeaders = (0, _compile.setHeaders)(headers);
        const res = await this.c.post(this.path(), (0, _buffer.Buffer).from(this.blob), txHeaders);
        return res.body;
    }
}
exports.default = Dryrun;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","../../../encoding/encoding":"1Yg70","./compile":"etJKB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHnpa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class Genesis extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/genesis";
    }
}
exports.default = Genesis;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZ0Vs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class GetAssetByID extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    path() {
        return `/v2/assets/${this.index}`;
    }
}
exports.default = GetAssetByID;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"643kt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class GetApplicationByID extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    path() {
        return `/v2/applications/${this.index}`;
    }
}
exports.default = GetApplicationByID;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dudfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class GetBlockHash extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, roundNumber){
        super(c, intDecoding);
        if (!Number.isInteger(roundNumber)) throw Error("roundNumber should be an integer");
        this.round = roundNumber;
    }
    path() {
        return `/v2/blocks/${this.round}/hash`;
    }
}
exports.default = GetBlockHash;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dDoso":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
class GetApplicationBoxByName extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, index, name){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
        // Encode name in base64 format and append the encoding prefix.
        const encodedName = (0, _buffer.Buffer).from(name).toString("base64");
        this.query.name = encodeURI(`b64:${encodedName}`);
    }
    /**
     * @returns `/v2/applications/${index}/box`
     */ path() {
        return `/v2/applications/${this.index}/box`;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return (0, _types.Box).from_obj_for_encoding(body);
    }
}
exports.default = GetApplicationBoxByName;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","./models/types":"5YZy0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"rXGgX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
class GetApplicationBoxes extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
        this.query.max = 0;
    }
    /**
     * @returns `/v2/applications/${index}/boxes`
     */ path() {
        return `/v2/applications/${this.index}/boxes`;
    }
    /**
     * Limit results for pagination.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const boxesResult = await algodClient
     *        .GetApplicationBoxes(1234)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ max(max) {
        this.query.max = max;
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return (0, _types.BoxesResponse).from_obj_for_encoding(body);
    }
}
exports.default = GetApplicationBoxes;

},{"../jsonrequest":"eWgGi","./models/types":"5YZy0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8FNTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class HealthCheck extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/health";
    }
    async do(headers = {}) {
        const res = await this.c.get(this.path(), {}, headers);
        if (!res.ok) throw new Error(`Health response: ${res.status}`);
        return {};
    }
}
exports.default = HealthCheck;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3DZvg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _encoding = require("../../../encoding/encoding");
class PendingTransactionInformation extends (0, _jsonrequestDefault.default) {
    constructor(c, txid){
        super(c);
        this.txid = txid;
        this.txid = txid;
        this.query.format = "msgpack";
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        if (body && body.byteLength > 0) return _encoding.decode(body);
        return undefined;
    }
    path() {
        return `/v2/transactions/pending/${this.txid}`;
    }
    // max sets the maximum number of txs to return
    max(max) {
        this.query.max = max;
        return this;
    }
}
exports.default = PendingTransactionInformation;

},{"../jsonrequest":"eWgGi","../../../encoding/encoding":"1Yg70","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tBDc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _encoding = require("../../../encoding/encoding");
class PendingTransactions extends (0, _jsonrequestDefault.default) {
    constructor(c){
        super(c);
        this.query.format = "msgpack";
    }
    /* eslint-disable class-methods-use-this */ path() {
        return "/v2/transactions/pending";
    }
    prepare(body) {
        if (body && body.byteLength > 0) return _encoding.decode(body);
        return undefined;
    }
    /* eslint-enable class-methods-use-this */ // max sets the maximum number of txs to return
    max(max) {
        this.query.max = max;
        return this;
    }
}
exports.default = PendingTransactions;

},{"../jsonrequest":"eWgGi","../../../encoding/encoding":"1Yg70","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfRxL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _encoding = require("../../../encoding/encoding");
class PendingTransactionsByAddress extends (0, _jsonrequestDefault.default) {
    constructor(c, address){
        super(c);
        this.address = address;
        this.address = address;
        this.query.format = "msgpack";
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        if (body && body.byteLength > 0) return _encoding.decode(body);
        return undefined;
    }
    path() {
        return `/v2/accounts/${this.address}/transactions/pending`;
    }
    // max sets the maximum number of txs to return
    max(max) {
        this.query.max = max;
        return this;
    }
}
exports.default = PendingTransactionsByAddress;

},{"../jsonrequest":"eWgGi","../../../encoding/encoding":"1Yg70","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iDqAy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class GetTransactionProof extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, round, txID){
        super(c, intDecoding);
        this.round = round;
        this.txID = txID;
        this.round = round;
        this.txID = txID;
    }
    path() {
        return `/v2/blocks/${this.round}/transactions/${this.txID}/proof`;
    }
    /**
     * Exclude assets and application data from results
     * The type of hash function used to create the proof, must be one of: "sha512_256", "sha256"
     *
     * #### Example
     * ```typescript
     * const hashType = "sha256";
     * const round = 123456;
     * const txId = "abc123;
     * const txProof = await algodClient.getTransactionProof(round, txId)
     *        .hashType(hashType)
     *        .do();
     * ```
     *
     * @param hashType
     * @category query
     */ hashType(hashType) {
        this.query.hashtype = hashType;
        return this;
    }
}
exports.default = GetTransactionProof;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAbv9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the default header (if not previously set) for sending a raw
 * transaction.
 * @param headers - A headers object
 */ parcelHelpers.export(exports, "setSendTransactionHeaders", ()=>setSendTransactionHeaders);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _utils = require("../../../utils/utils");
function setSendTransactionHeaders(headers = {}) {
    let hdrs = headers;
    if (Object.keys(hdrs).every((key)=>key.toLowerCase() !== "content-type")) {
        hdrs = {
            ...headers
        };
        hdrs["Content-Type"] = "application/x-binary";
    }
    return hdrs;
}
function isByteArray(array) {
    return array && array.byteLength !== undefined;
}
class SendRawTransaction extends (0, _jsonrequestDefault.default) {
    constructor(c, stxOrStxs){
        super(c);
        let forPosting = stxOrStxs;
        if (Array.isArray(stxOrStxs)) {
            if (!stxOrStxs.every(isByteArray)) throw new TypeError("Array elements must be byte arrays");
            // Flatten into a single Uint8Array
            forPosting = (0, _utils.concatArrays)(...stxOrStxs);
        } else if (!isByteArray(forPosting)) throw new TypeError("Argument must be byte array");
        this.txnBytesToPost = forPosting;
    }
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/transactions";
    }
    async do(headers = {}) {
        const txHeaders = setSendTransactionHeaders(headers);
        const res = await this.c.post(this.path(), (0, _buffer.Buffer).from(this.txnBytesToPost), txHeaders);
        return res.body;
    }
}
exports.default = SendRawTransaction;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","../../../utils/utils":"izzsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gO8ow":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class Status extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/status";
    }
}
exports.default = Status;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ae81N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class StatusAfterBlock extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, round){
        super(c, intDecoding);
        this.round = round;
        if (!Number.isInteger(round)) throw Error("round should be an integer");
        this.round = round;
    }
    path() {
        return `/v2/status/wait-for-block-after/${this.round}`;
    }
}
exports.default = StatusAfterBlock;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjePO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class SuggestedParamsRequest extends (0, _jsonrequestDefault.default) {
    /* eslint-disable class-methods-use-this */ path() {
        return "/v2/transactions/params";
    }
    prepare(body) {
        return {
            flatFee: false,
            fee: body.fee,
            firstRound: body["last-round"],
            lastRound: body["last-round"] + 1000,
            genesisID: body["genesis-id"],
            genesisHash: body["genesis-hash"],
            minFee: body["min-fee"]
        };
    }
}
exports.default = SuggestedParamsRequest;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4A5uA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class Supply extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/ledger/supply";
    }
}
exports.default = Supply;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Bi8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class Versions extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/versions";
    }
}
exports.default = Versions;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aFPKW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LightBlockHeaderProof extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, round){
        super(c, intDecoding);
        this.round = round;
        this.round = round;
    }
    path() {
        return `/v2/blocks/${this.round}/lightheader/proof`;
    }
}
exports.default = LightBlockHeaderProof;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cxC9Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class StateProof extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, round){
        super(c, intDecoding);
        this.round = round;
        this.round = round;
    }
    path() {
        return `/v2/stateproofs/${this.round}`;
    }
}
exports.default = StateProof;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Rj7r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class SetSyncRound extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, round){
        super(c, intDecoding);
        this.round = round;
        this.round = round;
    }
    path() {
        return `/v2/ledger/sync/${this.round}`;
    }
    async do(headers = {}) {
        const res = await this.c.post(this.path(), headers);
        return res.body;
    }
}
exports.default = SetSyncRound;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZhFJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
class GetSyncRound extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return `/v2/ledger/sync`;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return (0, _types.GetSyncRoundResponse).from_obj_for_encoding(body);
    }
}
exports.default = GetSyncRound;

},{"../jsonrequest":"eWgGi","./models/types":"5YZy0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6NBDU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class SetBlockOffsetTimestamp extends (0, _jsonrequestDefault.default) {
    constructor(c, intDecoding, offset){
        super(c, intDecoding);
        this.offset = offset;
        this.offset = offset;
    }
    path() {
        return `/v2/devmode/blocks/offset/${this.offset}`;
    }
    async do(headers = {}) {
        const res = await this.c.post(this.path(), headers);
        return res.body;
    }
}
exports.default = SetBlockOffsetTimestamp;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfexT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
class GetBlockOffsetTimestamp extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return `/v2/devmode/blocks/offset`;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return (0, _types.GetBlockTimeStampOffsetResponse).from_obj_for_encoding(body);
    }
}
exports.default = GetBlockOffsetTimestamp;

},{"../jsonrequest":"eWgGi","./models/types":"5YZy0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CPqP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the default header (if not previously set)
 * @param headers - A headers object
 */ parcelHelpers.export(exports, "setHeaders", ()=>setHeaders);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
function setHeaders(headers = {}) {
    let hdrs = headers;
    if (Object.keys(hdrs).every((key)=>key.toLowerCase() !== "content-type")) {
        hdrs = {
            ...headers
        };
        hdrs["Content-Type"] = "text/plain";
    }
    return hdrs;
}
class Disassemble extends (0, _jsonrequestDefault.default) {
    constructor(c, source){
        super(c);
        this.source = source;
        this.source = source;
    }
    // eslint-disable-next-line class-methods-use-this
    path() {
        return `/v2/teal/disassemble`;
    }
    /**
     * Executes disassemble
     * @param headers - A headers object
     */ async do(headers = {}) {
        const txHeaders = setHeaders(headers);
        const res = await this.c.post(this.path(), (0, _buffer.Buffer).from(this.source), txHeaders, this.query);
        return res.body;
    }
}
exports.default = Disassemble;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2UFfr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the default header (if not previously set) for simulating a raw
 * transaction.
 * @param headers - A headers object
 */ parcelHelpers.export(exports, "setSimulateTransactionsHeaders", ()=>setSimulateTransactionsHeaders);
var _buffer = require("buffer");
var _encoding = require("../../../encoding/encoding");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
function setSimulateTransactionsHeaders(headers = {}) {
    let hdrs = headers;
    if (Object.keys(hdrs).every((key)=>key.toLowerCase() !== "content-type")) {
        hdrs = {
            ...headers
        };
        hdrs["Content-Type"] = "application/msgpack";
    }
    return hdrs;
}
class SimulateRawTransactions extends (0, _jsonrequestDefault.default) {
    constructor(c, request){
        super(c);
        this.query.format = "msgpack";
        this.requestBytes = _encoding.rawEncode(request.get_obj_for_encoding(true));
    }
    // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/transactions/simulate";
    }
    async do(headers = {}) {
        const txHeaders = setSimulateTransactionsHeaders(headers);
        const res = await this.c.post(this.path(), (0, _buffer.Buffer).from(this.requestBytes), txHeaders, this.query, false);
        return this.prepare(res.body);
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        const decoded = _encoding.decode(body);
        return (0, _types.SimulateResponse).from_obj_for_encoding(decoded);
    }
}
exports.default = SimulateRawTransactions;

},{"buffer":"jlSk7","../../../encoding/encoding":"1Yg70","../jsonrequest":"eWgGi","./models/types":"5YZy0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Crin":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class Ready extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return `/ready`;
    }
}
exports.default = Ready;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ip7JP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class UnsetSyncRound extends (0, _jsonrequestDefault.default) {
    // eslint-disable-next-line class-methods-use-this
    path() {
        return `/v2/ledger/sync`;
    }
    async do(headers = {}) {
        const res = await this.c.delete(this.path(), headers);
        return res.body;
    }
}
exports.default = UnsetSyncRound;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l0X2i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
var _serviceClient = require("./v2/serviceClient");
var _serviceClientDefault = parcelHelpers.interopDefault(_serviceClient);
var _transaction = require("../transaction");
class Kmd extends (0, _serviceClientDefault.default) {
    constructor(token, baseServer = "http://127.0.0.1", port = 7833, headers = {}){
        super("X-KMD-API-Token", token, baseServer, port, headers);
    }
    /**
     * version returns a VersionResponse containing a list of kmd API versions supported by this running kmd instance.
     */ async versions() {
        const res = await this.c.get("/versions");
        return res.body;
    }
    /**
     * listWallets returns a ListWalletsResponse containing the list of wallets known to kmd. Using a wallet ID
     * returned from this endpoint, you can initialize a wallet handle with client.InitWalletHandle
     */ async listWallets() {
        const res = await this.c.get("/v1/wallets");
        return res.body;
    }
    /**
     * createWallet creates a wallet with the specified name, password, driver,
     * and master derivation key. If the master derivation key is blank, one is
     * generated internally to kmd. CreateWallet returns a CreateWalletResponse
     * containing information about the new wallet.
     * @param walletName
     * @param walletPassword
     * @param walletDriverName
     * @param walletMDK
     */ async createWallet(walletName, walletPassword, walletMDK = new Uint8Array(), walletDriverName = "sqlite") {
        const req = {
            wallet_name: walletName,
            wallet_driver_name: walletDriverName,
            wallet_password: walletPassword,
            master_derivation_key: (0, _buffer.Buffer).from(walletMDK).toString("base64")
        };
        const res = await this.c.post("/v1/wallet", req);
        return res.body;
    }
    /**
     * initWalletHandle accepts a wallet ID and a wallet password, and returns an
     * initWalletHandleResponse containing a wallet handle token. This wallet
     * handle token can be used for subsequent operations on this wallet, like key
     * generation, transaction signing, etc.. WalletHandleTokens expire after a
     * configurable number of seconds, and must be renewed periodically with
     * RenewWalletHandle. It is good practice to call ReleaseWalletHandle when
     * you're done interacting with this wallet.
     * @param walletID
     * @param walletPassword
     */ async initWalletHandle(walletID, walletPassword) {
        const req = {
            wallet_id: walletID,
            wallet_password: walletPassword
        };
        const res = await this.c.post("/v1/wallet/init", req);
        return res.body;
    }
    /**
     * releaseWalletHandle invalidates the passed wallet handle token, making
     * it unusuable for subsequent wallet operations.
     * @param walletHandle
     */ async releaseWalletHandle(walletHandle) {
        const req = {
            wallet_handle_token: walletHandle
        };
        const res = await this.c.post("/v1/wallet/release", req);
        return res.body;
    }
    /**
     * renewWalletHandle accepts a wallet handle and attempts to renew it, moving
     * the expiration time to some number of seconds in the future. It returns a
     * RenewWalletHandleResponse containing the walletHandle and the number of
     * seconds until expiration
     * @param walletHandle
     */ async renewWalletHandle(walletHandle) {
        const req = {
            wallet_handle_token: walletHandle
        };
        const res = await this.c.post("/v1/wallet/renew", req);
        return res.body;
    }
    /**
     * renameWallet accepts a wallet ID, wallet password, and a new wallet name,
     * and renames the underlying wallet.
     * @param walletID
     * @param walletPassword
     * @param newWalletName
     */ async renameWallet(walletID, walletPassword, newWalletName) {
        const req = {
            wallet_id: walletID,
            wallet_password: walletPassword,
            wallet_name: newWalletName
        };
        const res = await this.c.post("/v1/wallet/rename", req);
        return res.body;
    }
    /**
     * getWallet accepts a wallet handle and returns high level information about
     * this wallet in a GetWalletResponse.
     * @param walletHandle
     */ async getWallet(walletHandle) {
        const req = {
            wallet_handle_token: walletHandle
        };
        const res = await this.c.post("/v1/wallet/info", req);
        return res.body;
    }
    /**
     * exportMasterDerivationKey accepts a wallet handle and a wallet password, and
     * returns an ExportMasterDerivationKeyResponse containing the master
     * derivation key. This key can be used as an argument to CreateWallet in
     * order to recover the keys generated by this wallet. The master derivation
     * key can be encoded as a sequence of words using the mnemonic library, and
     * @param walletHandle
     * @param walletPassword
     */ async exportMasterDerivationKey(walletHandle, walletPassword) {
        const req = {
            wallet_handle_token: walletHandle,
            wallet_password: walletPassword
        };
        const res = await this.c.post("/v1/master-key/export", req);
        return {
            master_derivation_key: (0, _buffer.Buffer).from(res.body.master_derivation_key, "base64")
        };
    }
    /**
     * importKey accepts a wallet handle and an ed25519 private key, and imports
     * the key into the wallet. It returns an ImportKeyResponse containing the
     * address corresponding to this private key.
     * @param walletHandle
     * @param secretKey
     */ async importKey(walletHandle, secretKey) {
        const req = {
            wallet_handle_token: walletHandle,
            private_key: (0, _buffer.Buffer).from(secretKey).toString("base64")
        };
        const res = await this.c.post("/v1/key/import", req);
        return res.body;
    }
    /**
     * exportKey accepts a wallet handle, wallet password, and address, and returns
     * an ExportKeyResponse containing the ed25519 private key corresponding to the
     * address stored in the wallet.
     * @param walletHandle
     * @param walletPassword
     * @param addr
     */ async exportKey(walletHandle, walletPassword, addr) {
        const req = {
            wallet_handle_token: walletHandle,
            address: addr,
            wallet_password: walletPassword
        };
        const res = await this.c.post("/v1/key/export", req);
        return {
            private_key: (0, _buffer.Buffer).from(res.body.private_key, "base64")
        };
    }
    /**
     * generateKey accepts a wallet handle, and then generates the next key in the
     * wallet using its internal master derivation key. Two wallets with the same
     * master derivation key will generate the same sequence of keys.
     * @param walletHandle
     */ async generateKey(walletHandle) {
        const req = {
            wallet_handle_token: walletHandle,
            display_mnemonic: false
        };
        const res = await this.c.post("/v1/key", req);
        return res.body;
    }
    /**
     * deleteKey accepts a wallet handle, wallet password, and address, and deletes
     * the information about this address from the wallet (including address and
     * secret key). If DeleteKey is called on a key generated using GenerateKey,
     * the same key will not be generated again. However, if a wallet is recovered
     * using the master derivation key, a key generated in this way can be
     * recovered.
     * @param walletHandle
     * @param walletPassword
     * @param addr
     */ async deleteKey(walletHandle, walletPassword, addr) {
        const req = {
            wallet_handle_token: walletHandle,
            address: addr,
            wallet_password: walletPassword
        };
        const res = await this.c.delete("/v1/key", req);
        return res.body;
    }
    /**
     * ListKeys accepts a wallet handle and returns a ListKeysResponse containing
     * all of the addresses for which this wallet contains secret keys.
     * @param walletHandle
     */ async listKeys(walletHandle) {
        const req = {
            wallet_handle_token: walletHandle
        };
        const res = await this.c.post("/v1/key/list", req);
        return res.body;
    }
    /**
     * signTransaction accepts a wallet handle, wallet password, and a transaction,
     * and returns and SignTransactionResponse containing an encoded, signed
     * transaction. The transaction is signed using the key corresponding to the
     * Sender field.
     * @param walletHandle
     * @param walletPassword
     * @param transaction
     */ async signTransaction(walletHandle, walletPassword, transaction) {
        const tx = _transaction.instantiateTxnIfNeeded(transaction);
        const req = {
            wallet_handle_token: walletHandle,
            wallet_password: walletPassword,
            transaction: (0, _buffer.Buffer).from(tx.toByte()).toString("base64")
        };
        const res = await this.c.post("/v1/transaction/sign", req);
        if (res.status === 200) return (0, _buffer.Buffer).from(res.body.signed_transaction, "base64");
        return res.body;
    }
    /**
     * signTransactionWithSpecificPublicKey accepts a wallet handle, wallet password, a transaction, and a public key,
     * and returns and SignTransactionResponse containing an encoded, signed
     * transaction. The transaction is signed using the key corresponding to the
     * publicKey arg.
     * @param walletHandle
     * @param walletPassword
     * @param transaction
     * @param publicKey - sign the txn with the key corresponding to publicKey (used for working with a rekeyed addr)
     */ async signTransactionWithSpecificPublicKey(walletHandle, walletPassword, transaction, publicKey) {
        const tx = _transaction.instantiateTxnIfNeeded(transaction);
        const req = {
            wallet_handle_token: walletHandle,
            wallet_password: walletPassword,
            transaction: (0, _buffer.Buffer).from(tx.toByte()).toString("base64"),
            public_key: (0, _buffer.Buffer).from(publicKey).toString("base64")
        };
        const res = await this.c.post("/v1/transaction/sign", req);
        if (res.status === 200) return (0, _buffer.Buffer).from(res.body.signed_transaction, "base64");
        return res.body;
    }
    /**
     * listMultisig accepts a wallet handle and returns a ListMultisigResponse
     * containing the multisig addresses whose preimages are stored in this wallet.
     * A preimage is the information needed to reconstruct this multisig address,
     * including multisig version information, threshold information, and a list
     * of public keys.
     * @param walletHandle
     */ async listMultisig(walletHandle) {
        const req = {
            wallet_handle_token: walletHandle
        };
        const res = await this.c.post("/v1/multisig/list", req);
        return res.body;
    }
    /**
     * importMultisig accepts a wallet handle and the information required to
     * generate a multisig address. It derives this address, and stores all of the
     * information within the wallet. It returns a ImportMultisigResponse with the
     * derived address.
     * @param walletHandle
     * @param version
     * @param threshold
     * @param pks
     */ async importMultisig(walletHandle, version, threshold, pks) {
        const req = {
            wallet_handle_token: walletHandle,
            multisig_version: version,
            threshold,
            pks
        };
        const res = await this.c.post("/v1/multisig/import", req);
        return res.body;
    }
    /**
     * exportMultisig accepts a wallet handle, wallet password, and multisig
     * address, and returns an ExportMultisigResponse containing the stored
     * multisig preimage. The preimage contains all of the information necessary
     * to derive the multisig address, including version, threshold, and a list of
     * public keys.
     * @param walletHandle
     * @param walletPassword
     * @param addr
     */ async exportMultisig(walletHandle, addr) {
        const req = {
            wallet_handle_token: walletHandle,
            address: addr
        };
        const res = await this.c.post("/v1/multisig/export", req);
        return res.body;
    }
    /**
     * signMultisigTransaction accepts a wallet handle, wallet password,
     * transaction, public key (*not* an address), and an optional partial
     * MultisigSig. It looks up the secret key corresponding to the public key, and
     * returns a SignMultisigTransactionResponse containing a MultisigSig with a
     * signature by the secret key included.
     * @param walletHandle
     * @param pw
     * @param tx
     * @param pk
     * @param partial
     */ async signMultisigTransaction(walletHandle, pw, transaction, pk, partial) {
        const tx = _transaction.instantiateTxnIfNeeded(transaction);
        const req = {
            wallet_handle_token: walletHandle,
            transaction: (0, _buffer.Buffer).from(tx.toByte()).toString("base64"),
            public_key: (0, _buffer.Buffer).from(pk).toString("base64"),
            partial_multisig: partial,
            wallet_password: pw
        };
        const res = await this.c.post("/v1/multisig/sign", req);
        return res.body;
    }
    /**
     * deleteMultisig accepts a wallet handle, wallet password, and multisig
     * address, and deletes the information about this multisig address from the
     * wallet (including address and secret key).
     * @param walletHandle
     * @param walletPassword
     * @param addr
     */ async deleteMultisig(walletHandle, walletPassword, addr) {
        const req = {
            wallet_handle_token: walletHandle,
            address: addr,
            wallet_password: walletPassword
        };
        const res = await this.c.delete("/v1/multisig", req);
        return res.body;
    }
}
exports.default = Kmd;

},{"buffer":"jlSk7","./v2/serviceClient":"6EvhN","../transaction":"1n32l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dlJxD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _serviceClient = require("../serviceClient");
var _serviceClientDefault = parcelHelpers.interopDefault(_serviceClient);
var _makeHealthCheck = require("./makeHealthCheck");
var _makeHealthCheckDefault = parcelHelpers.interopDefault(_makeHealthCheck);
var _lookupAssetBalances = require("./lookupAssetBalances");
var _lookupAssetBalancesDefault = parcelHelpers.interopDefault(_lookupAssetBalances);
var _lookupAssetTransactions = require("./lookupAssetTransactions");
var _lookupAssetTransactionsDefault = parcelHelpers.interopDefault(_lookupAssetTransactions);
var _lookupAccountTransactions = require("./lookupAccountTransactions");
var _lookupAccountTransactionsDefault = parcelHelpers.interopDefault(_lookupAccountTransactions);
var _lookupBlock = require("./lookupBlock");
var _lookupBlockDefault = parcelHelpers.interopDefault(_lookupBlock);
var _lookupTransactionByID = require("./lookupTransactionByID");
var _lookupTransactionByIDDefault = parcelHelpers.interopDefault(_lookupTransactionByID);
var _lookupAccountByID = require("./lookupAccountByID");
var _lookupAccountByIDDefault = parcelHelpers.interopDefault(_lookupAccountByID);
var _lookupAccountAssets = require("./lookupAccountAssets");
var _lookupAccountAssetsDefault = parcelHelpers.interopDefault(_lookupAccountAssets);
var _lookupAccountCreatedAssets = require("./lookupAccountCreatedAssets");
var _lookupAccountCreatedAssetsDefault = parcelHelpers.interopDefault(_lookupAccountCreatedAssets);
var _lookupAccountAppLocalStates = require("./lookupAccountAppLocalStates");
var _lookupAccountAppLocalStatesDefault = parcelHelpers.interopDefault(_lookupAccountAppLocalStates);
var _lookupAccountCreatedApplications = require("./lookupAccountCreatedApplications");
var _lookupAccountCreatedApplicationsDefault = parcelHelpers.interopDefault(_lookupAccountCreatedApplications);
var _lookupAssetByID = require("./lookupAssetByID");
var _lookupAssetByIDDefault = parcelHelpers.interopDefault(_lookupAssetByID);
var _lookupApplications = require("./lookupApplications");
var _lookupApplicationsDefault = parcelHelpers.interopDefault(_lookupApplications);
var _lookupApplicationLogs = require("./lookupApplicationLogs");
var _lookupApplicationLogsDefault = parcelHelpers.interopDefault(_lookupApplicationLogs);
var _lookupApplicationBoxByIDandName = require("./lookupApplicationBoxByIDandName");
var _lookupApplicationBoxByIDandNameDefault = parcelHelpers.interopDefault(_lookupApplicationBoxByIDandName);
var _searchAccounts = require("./searchAccounts");
var _searchAccountsDefault = parcelHelpers.interopDefault(_searchAccounts);
var _searchForTransactions = require("./searchForTransactions");
var _searchForTransactionsDefault = parcelHelpers.interopDefault(_searchForTransactions);
var _searchForAssets = require("./searchForAssets");
var _searchForAssetsDefault = parcelHelpers.interopDefault(_searchForAssets);
var _searchForApplications = require("./searchForApplications");
var _searchForApplicationsDefault = parcelHelpers.interopDefault(_searchForApplications);
var _searchForApplicationBoxes = require("./searchForApplicationBoxes");
var _searchForApplicationBoxesDefault = parcelHelpers.interopDefault(_searchForApplicationBoxes);
class IndexerClient extends (0, _serviceClientDefault.default) {
    /**
     * Create an IndexerClient from
     * * either a token, baseServer, port, and optional headers
     * * or a base client server for interoperability with external dApp wallets
     *
     * #### Example
     * ```typescript
     * const token  = "";
     * const server = "http://localhost";
     * const port   = 8980;
     * const indexerClient = new algosdk.Indexer(token, server, port);
     * ```
     * @remarks
     * The above configuration is for a sandbox private network.
     * For applications on production, you are encouraged to run your own node with indexer, or use an Algorand REST API provider with a dedicated API key.
     *
     * @param tokenOrBaseClient - The API token for the Indexer API
     * @param baseServer - REST endpoint
     * @param port - Port number if specifically configured by the server
     * @param headers - Optional headers
     */ constructor(tokenOrBaseClient, baseServer = "http://127.0.0.1", port = 8080, headers = {}){
        super("X-Indexer-API-Token", tokenOrBaseClient, baseServer, port, headers);
    }
    /**
     * Returns the health object for the service.
     * Returns 200 if healthy.
     *
     * #### Example
     * ```typescript
     * const health = await indexerClient.makeHealthCheck().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-health)
     * @category GET
     */ makeHealthCheck() {
        return new (0, _makeHealthCheckDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Returns the list of accounts who hold the given asset and their balance.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetBalances = await indexerClient.lookupAssetBalances(assetId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assetsasset-idbalances)
     * @param index - The asset ID to look up.
     * @category GET
     */ lookupAssetBalances(index) {
        return new (0, _lookupAssetBalancesDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Returns transactions relating to the given asset.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetTxns = await indexerClient.lookupAssetTransactions(assetId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assetsasset-idtransactions)
     * @param index - The asset ID to look up.
     * @category GET
     */ lookupAssetTransactions(index) {
        return new (0, _lookupAssetTransactionsDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Returns transactions relating to the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient.lookupAccountTransactions(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idtransactions)
     * @param account - The address of the account.
     * @category GET
     */ lookupAccountTransactions(account) {
        return new (0, _lookupAccountTransactionsDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns the block for the passed round.
     *
     * #### Example
     * ```typescript
     * const targetBlock = 18309917;
     * const blockInfo = await indexerClient.lookupBlock(targetBlock).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2blocksround-number)
     * @param round - The number of the round to look up.
     * @category GET
     */ lookupBlock(round) {
        return new (0, _lookupBlockDefault.default)(this.c, this.intDecoding, round);
    }
    /**
     * Returns information about the given transaction.
     *
     * #### Example
     * ```typescript
     * const txnId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const txnInfo = await indexerClient.lookupTransactionByID(txnId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2transactionstxid)
     * @param txID - The ID of the transaction to look up.
     * @category GET
     */ lookupTransactionByID(txID) {
        return new (0, _lookupTransactionByIDDefault.default)(this.c, this.intDecoding, txID);
    }
    /**
     * Returns information about the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await indexerClient.lookupAccountByID(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-id)
     * @param account - The address of the account to look up.
     * @category GET
     */ lookupAccountByID(account) {
        return new (0, _lookupAccountByIDDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns asset about the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAssets = await indexerClient.lookupAccountAssets(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idassets)
     * @param account - The address of the account to look up.
     * @category GET
     */ lookupAccountAssets(account) {
        return new (0, _lookupAccountAssetsDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns asset information created by the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountCreatedAssets = await indexerClient.lookupAccountCreatedAssets(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idcreated-assets)
     * @param account - The address of the account to look up.
     * @category GET
     */ lookupAccountCreatedAssets(account) {
        return new (0, _lookupAccountCreatedAssetsDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns application local state about the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAppLocalStates = await indexerClient.lookupAccountAppLocalStates(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idapps-local-state)
     * @param account - The address of the account to look up.
     * @category GET
     */ lookupAccountAppLocalStates(account) {
        return new (0, _lookupAccountAppLocalStatesDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns application information created by the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountCreatedApps = await indexerClient.lookupAccountCreatedApplications(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idcreated-applications)
     * @param account - The address of the account to look up.
     * @category GET
     */ lookupAccountCreatedApplications(account) {
        return new (0, _lookupAccountCreatedApplicationsDefault.default)(this.c, this.intDecoding, account);
    }
    /**
     * Returns information about the passed asset.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetInfo = await indexerClient.lookupAssetByID(assetId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assetsasset-id)
     * @param index - The ID of the asset ot look up.
     * @category GET
     */ lookupAssetByID(index) {
        return new (0, _lookupAssetByIDDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Returns information about the passed application.
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const appInfo = await indexerClient.lookupApplications(appId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-id)
     * @param index - The ID of the application to look up.
     * @category GET
     */ lookupApplications(index) {
        return new (0, _lookupApplicationsDefault.default)(this.c, this.intDecoding, index);
    }
    /**
     * Returns log messages generated by the passed in application.
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const appLogs = await indexerClient.lookupApplicationLogs(appId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-idlogs)
     * @param appID - The ID of the application which generated the logs.
     * @category GET
     */ lookupApplicationLogs(appID) {
        return new (0, _lookupApplicationLogsDefault.default)(this.c, this.intDecoding, appID);
    }
    /**
     * Returns information about indexed accounts.
     *
     * #### Example
     * ```typescript
     * const accounts = await indexerClient.searchAccounts().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accounts)
     * @category GET
     */ searchAccounts() {
        return new (0, _searchAccountsDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Returns information about indexed transactions.
     *
     * #### Example
     * ```typescript
     * const txns = await indexerClient.searchForTransactions().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2transactions)
     * @category GET
     */ searchForTransactions() {
        return new (0, _searchForTransactionsDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Returns information about indexed assets.
     *
     * #### Example
     * ```typescript
     * const assets = await indexerClient.searchForAssets().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assets)
     * @category GET
     */ searchForAssets() {
        return new (0, _searchForAssetsDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Returns information about indexed applications.
     *
     * #### Example
     * ```typescript
     * const apps = await indexerClient.searchForApplications().do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applications)
     * @category GET
     */ searchForApplications() {
        return new (0, _searchForApplicationsDefault.default)(this.c, this.intDecoding);
    }
    /**
     * Returns information about indexed application boxes.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const appID = 1234;
     *
     * const responsePage1 = await indexerClient
     *        .searchForApplicationBoxes(appID)
     *        .limit(maxResults)
     *        .do();
     * const boxNamesPage1 = responsePage1.boxes.map(box => box.name);
     *
     * const responsePage2 = await indexerClient
     *        .searchForApplicationBoxes(appID)
     *        .limit(maxResults)
     *        .nextToken(responsePage1.nextToken)
     *        .do();
     * const boxNamesPage2 = responsePage2.boxes.map(box => box.name);
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-idboxes)
     * @param appID - The ID of the application with boxes.
     * @category GET
     */ searchForApplicationBoxes(appID) {
        return new (0, _searchForApplicationBoxesDefault.default)(this.c, this.intDecoding, appID);
    }
    /**
     * Returns information about the application box given its name.
     *
     * #### Example
     * ```typescript
     * const boxName = Buffer.from("foo");
     * const boxResponse = await indexerClient
     *        .LookupApplicationBoxByIDandName(1234, boxName)
     *        .do();
     * const boxValue = boxResponse.value;
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-idbox)
     * @param appID - The ID of the application with boxes.
     * @category GET
     */ lookupApplicationBoxByIDandName(appID, boxName) {
        return new (0, _lookupApplicationBoxByIDandNameDefault.default)(this.c, this.intDecoding, appID, boxName);
    }
}
exports.default = IndexerClient;

},{"../serviceClient":"6EvhN","./makeHealthCheck":"7VfVa","./lookupAssetBalances":"5lGhE","./lookupAssetTransactions":"hh5Gv","./lookupAccountTransactions":"2xtNn","./lookupBlock":"4dzHy","./lookupTransactionByID":"lIEKM","./lookupAccountByID":"irS3T","./lookupAccountAssets":"5Hd3p","./lookupAccountCreatedAssets":"ycwQE","./lookupAccountAppLocalStates":"23Swm","./lookupAccountCreatedApplications":"3uWwU","./lookupAssetByID":"9v74C","./lookupApplications":"9KBaX","./lookupApplicationLogs":"5iqt7","./lookupApplicationBoxByIDandName":"5C0gR","./searchAccounts":"4q133","./searchForTransactions":"kcV13","./searchForAssets":"aFuOm","./searchForApplications":"4zRJ7","./searchForApplicationBoxes":"5Wu1e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VfVa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class MakeHealthCheck extends (0, _jsonrequestDefault.default) {
    /**
     * @returns `/health`
     */ // eslint-disable-next-line class-methods-use-this
    path() {
        return "/health";
    }
}
exports.default = MakeHealthCheck;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5lGhE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAssetBalances extends (0, _jsonrequestDefault.default) {
    /**
     * Returns the list of accounts which hold the given asset and their balance.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetBalances = await indexerClient.lookupAssetBalances(assetId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assetsasset-idbalances)
     * @param index - The asset ID to look up.
     */ constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    /**
     * @returns `/v2/assets/${index}/balances`
     */ path() {
        return `/v2/assets/${this.index}/balances`;
    }
    /**
     * Limit results for pagination.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const maxResults = 20;
     * const assetBalances = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Filtered results should have an asset balance greater than this value.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const minBalance = 1000000;
     * const assetBalances = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .currencyGreaterThan(minBalance)
     *        .do();
     * ```
     * @param greater
     * @category query
     */ currencyGreaterThan(greater) {
        this.query["currency-greater-than"] = greater;
        return this;
    }
    /**
     * Filtered results should have an asset balance less than this value.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const maxBalance = 2000000;
     * const assetBalances = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .currencyLessThan(maxBalance)
     *        .do();
     * ```
     * @param lesser
     * @category query
     */ currencyLessThan(lesser) {
        this.query["currency-less-than"] = lesser;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const maxResults = 20;
     *
     * const assetBalancesPage1 = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .limit(maxResults)
     *        .do();
     *
     * const assetBalancesPage2 = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .limit(maxResults)
     *        .nextToken(assetBalancesPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Include all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates.
     *
     * #### Example 1
     * ```typescript
     * const assetId = 163650;
     * const assetBalances = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetId = 163650;
     * const assetBalances = await indexerClient
     *        .lookupAssetBalances(assetId)
     *        .includeAll()
     *        .do();
     * ```
     *
     * @param value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
}
exports.default = LookupAssetBalances;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hh5Gv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _lookupAccountTransactions = require("./lookupAccountTransactions");
class LookupAssetTransactions extends (0, _jsonrequestDefault.default) {
    /**
     * Returns transactions relating to the given asset.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetTxns = await indexerClient.lookupAssetTransactions(assetId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assetsasset-idtransactions)
     * @param index - The asset ID to look up.
     */ constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    /**
     * @returns `/v2/assets/${index}/transactions`
     */ path() {
        return `/v2/assets/${this.index}/transactions`;
    }
    /**
     * Specifies a prefix which must be contained in the note field.
     *
     * #### Example
     * ```typescript
     * const notePrefixBase64Encoded = "Y3JlYXRl";
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .notePrefix(notePrefixBase64Encoded)
     *        .do();
     * ```
     *
     * @param prefix - base64 string or uint8array
     * @category query
     */ notePrefix(prefix) {
        this.query["note-prefix"] = (0, _lookupAccountTransactions.base64StringFunnel)(prefix);
        return this;
    }
    /**
     * Type of transaction to filter with.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .txType("axfer")
     *        .do();
     * ```
     *
     * @param type - one of `pay`, `keyreg`, `acfg`, `axfer`, `afrz`, `appl`
     * @category query
     */ txType(type) {
        this.query["tx-type"] = type;
        return this;
    }
    /**
     * Type of signature to filter with.
     * - sig: Standard
     * - msig: MultiSig
     * - lsig: LogicSig
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .sigType("lsig")
     *        .do();
     * ```
     *
     * @param type - one of `sig`, `msig`, `lsig`
     * @category query
     */ sigType(type) {
        this.query["sig-type"] = type;
        return this;
    }
    /**
     * Lookup the specific transaction by ID.
     *
     * #### Example
     * ```typescript
     * const txId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .txid(txId)
     *        .do();
     * ```
     *
     * @param txid
     * @category query
     */ txid(txid) {
        this.query.txid = txid;
        return this;
    }
    /**
     * Include results for the specified round.
     *
     * #### Example
     * ```typescript
     * const targetBlock = 18309917;
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .round(targetBlock)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Include results at or after the specified min-round.
     *
     * #### Example
     * ```typescript
     * const minRound = 18309917;
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .minRound(minRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ minRound(round) {
        this.query["min-round"] = round;
        return this;
    }
    /**
     * Include results at or before the specified max-round.
     *
     * #### Example
     * ```typescript
     * const maxRound = 18309917;
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .maxRound(maxRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ maxRound(round) {
        this.query["max-round"] = round;
        return this;
    }
    /**
     * Maximum number of results to return.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Include results before the given time.
     *
     * #### Example
     * ```typescript
     * const beforeTime = "2022-02-02T20:20:22.02Z";
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .beforeTime(beforeTime)
     *        .do();
     * ```
     *
     * @param before - rfc3339 string
     * @category query
     */ beforeTime(before) {
        this.query["before-time"] = before;
        return this;
    }
    /**
     * Include results after the given time.
     *
     * #### Example
     * ```typescript
     * const afterTime = "2022-10-21T00:00:11.55Z";
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .afterTime(afterTime)
     *        .do();
     * ```
     *
     * @param after - rfc3339 string
     * @category query
     */ afterTime(after) {
        this.query["after-time"] = after;
        return this;
    }
    /**
     * Filtered results should have an amount greater than this value, as int, representing asset units.
     *
     * #### Example
     * ```typescript
     * const minBalance = 300000;
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     *
     * @remarks
     * If you are looking for transactions with the currency amount greater than 0, simply construct the query without `currencyGreaterThan` because it doesn't accept `-1`, and passing the `0` `currency-greater-than` value would exclude transactions with a 0 amount.
     *
     * @param greater
     * @category query
     */ currencyGreaterThan(greater) {
        this.query["currency-greater-than"] = greater;
        return this;
    }
    /**
     * Filtered results should have an amount less than this value, as int, representing asset units.
     *
     * #### Example
     * ```typescript
     * const maxBalance = 500000;
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * @param lesser
     * @category query
     */ currencyLessThan(lesser) {
        this.query["currency-less-than"] = lesser;
        return this;
    }
    /**
     * Combined with address, defines what address to filter on, as string.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const role = "sender";
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .address(address)
     *        .addressRole(role)
     *        .do();
     * ```
     *
     * @param role - one of `sender`, `receiver`, `freeze-target`
     * @category query
     */ addressRole(role) {
        this.query["address-role"] = role;
        return this;
    }
    /**
     * Only include transactions with this address in one of the transaction fields.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .address(address)
     *        .do();
     * ```
     *
     * @param address
     * @category query
     */ address(address) {
        this.query.address = address;
        return this;
    }
    /**
     * Whether or not to consider the `close-to` field as a receiver when filtering transactions, as bool. Set to `true` to ignore `close-to`.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .excludeCloseTo(true)
     *        .do();
     * ```
     *
     * @param exclude
     * @category query
     */ excludeCloseTo(exclude) {
        this.query["exclude-close-to"] = exclude;
        return this;
    }
    /**
     * The next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     * const assetId = 163650;
     *
     * const assetTxnsPage1 = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .limit(maxResults)
     *        .do();
     *
     * const assetTxnsPage2 = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .limit(maxResults)
     *        .nextToken(assetTxnsPage1["next-token"])
     *        .do();
     * ```
     *
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Whether or not to include rekeying transactions.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetTxns = await indexerClient
     *        .lookupAssetTransactions(assetId)
     *        .rekeyTo(false)
     *        .do();
     * ```
     *
     * @param rekeyTo
     * @category query
     */ rekeyTo(rekeyTo) {
        this.query["rekey-to"] = rekeyTo;
        return this;
    }
}
exports.default = LookupAssetTransactions;

},{"../jsonrequest":"eWgGi","./lookupAccountTransactions":"2xtNn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2xtNn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Accept base64 string or Uint8Array and output base64 string
 * @param data - Base64 string or Uint8Array
 * @returns The inputted base64 string, or a base64 string representation of the Uint8Array
 */ parcelHelpers.export(exports, "base64StringFunnel", ()=>base64StringFunnel);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
function base64StringFunnel(data) {
    if (typeof data === "string") return data;
    return (0, _buffer.Buffer).from(data).toString("base64");
}
class LookupAccountTransactions extends (0, _jsonrequestDefault.default) {
    /**
     * Returns transactions relating to the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient.lookupAccountTransactions(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idtransactions)
     * @param account - The address of the account.
     */ constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    /**
     * @returns `/v2/accounts/${account}/transactions`
     */ path() {
        return `/v2/accounts/${this.account}/transactions`;
    }
    /**
     * Specifies a prefix which must be contained in the note field.
     *
     * #### Example
     * ```typescript
     * const notePrefixBase64Encoded = "Y3JlYXRl";
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .notePrefix(notePrefixBase64Encoded)
     *        .do();
     * ```
     *
     * @param prefix - base64 string or uint8array
     * @category query
     */ notePrefix(prefix) {
        this.query["note-prefix"] = base64StringFunnel(prefix);
        return this;
    }
    /**
     * Type of transaction to filter with.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .txType("appl")
     *        .do();
     * ```
     *
     * @param type - one of `pay`, `keyreg`, `acfg`, `axfer`, `afrz`, `appl`, `stpf`
     * @category query
     */ txType(type) {
        this.query["tx-type"] = type;
        return this;
    }
    /**
     * Type of signature to filter with.
     * - sig: Standard
     * - msig: MultiSig
     * - lsig: LogicSig
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .sigType("msig")
     *        .do();
     * ```
     *
     * @param type - one of `sig`, `msig`, `lsig`
     * @category query
     */ sigType(type) {
        this.query["sig-type"] = type;
        return this;
    }
    /**
     * Lookup the specific transaction by ID.
     *
     * #### Example
     * ```typescript
     * const txId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .txid(txId)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupTransactionByID(txnId).do()`
     * @param txid
     * @category query
     */ txid(txid) {
        this.query.txid = txid;
        return this;
    }
    /**
     * Include results for the specified round.
     *
     * #### Example
     * ```typescript
     * const targetBlock = 18309917;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .round(targetBlock)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Include results at or after the specified min-round.
     *
     * #### Example
     * ```typescript
     * const minRound = 18309917;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .minRound(minRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ minRound(round) {
        this.query["min-round"] = round;
        return this;
    }
    /**
     * Include results at or before the specified max-round.
     *
     * #### Example
     * ```typescript
     * const maxRound = 18309917;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .maxRound(maxRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ maxRound(round) {
        this.query["max-round"] = round;
        return this;
    }
    /**
     * Asset ID to filter with.
     *
     * #### Example
     * ```typescript
     * const assetID = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .assetID(assetID)
     *        .do();
     * ```
     *
     * @param id
     * @category query
     */ assetID(id) {
        this.query["asset-id"] = id;
        return this;
    }
    /**
     * Maximum number of results to return.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Include results before the given time.
     *
     * #### Example
     * ```typescript
     * const beforeTime = "2022-02-02T20:20:22.02Z";
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .beforeTime(beforeTime)
     *        .do();
     * ```
     *
     * @param before - rfc3339 string
     * @category query
     */ beforeTime(before) {
        this.query["before-time"] = before;
        return this;
    }
    /**
     * Include results after the given time.
     *
     * #### Example
     * ```typescript
     * const afterTime = "2022-10-21T00:00:11.55Z";
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .afterTime(afterTime)
     *        .do();
     * ```
     *
     * @param after - rfc3339 string
     * @category query
     */ afterTime(after) {
        this.query["after-time"] = after;
        return this;
    }
    /**
     * Filtered results should have an amount greater than this value, as int, representing microAlgos, unless an asset-id is provided, in which case units are in the asset's units.
     *
     * #### Example 1
     * ```typescript
     * const minBalance = 300000;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetID = 163650;
     * const minBalance = 300000;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .assetID(assetID)
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     * @remarks
     * If you are looking for transactions with the currency amount greater than 0, simply construct the query without `currencyGreaterThan` because it doesn't accept `-1`, and passing the `0` `currency-greater-than` value would exclude transactions with a 0 amount.
     *
     * @param greater
     * @category query
     */ currencyGreaterThan(greater) {
        this.query["currency-greater-than"] = greater;
        return this;
    }
    /**
     * Filtered results should have an amount less than this value, as int, representing microAlgos, unless an asset-id is provided, in which case units are in the asset's units.
     *
     * #### Example 1
     * ```typescript
     * const maxBalance = 500000;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetID = 163650;
     * const maxBalance = 500000;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .assetID(assetID)
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * @param lesser
     * @category query
     */ currencyLessThan(lesser) {
        this.query["currency-less-than"] = lesser;
        return this;
    }
    /**
     * The next page of results. Use the next token provided by the previous results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     *
     * const accountTxnsPage1 = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .limit(maxResults)
     *        .do();
     *
     * const accountTxnsPage2 = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .limit(maxResults)
     *        .nextToken(accountTxnsPage1["next-token"])
     *        .do();
     * ```
     *
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Whether or not to include rekeying transactions.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountTxns = await indexerClient
     *        .lookupAccountTransactions(address)
     *        .rekeyTo(false)
     *        .do();
     * ```
     *
     * @param rekeyTo
     * @category query
     */ rekeyTo(rekeyTo) {
        this.query["rekey-to"] = rekeyTo;
        return this;
    }
}
exports.default = LookupAccountTransactions;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4dzHy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupBlock extends (0, _jsonrequestDefault.default) {
    /**
     * Returns the block for the passed round.
     *
     * #### Example
     * ```typescript
     * const targetBlock = 18309917;
     * const blockInfo = await indexerClient.lookupBlock(targetBlock).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2blocksround-number)
     * @param round - The number of the round to look up.
     * @category GET
     */ constructor(c, intDecoding, round){
        super(c, intDecoding);
        this.round = round;
        this.round = round;
    }
    /**
     * @returns `/v2/blocks/${round}`
     */ path() {
        return `/v2/blocks/${this.round}`;
    }
    /**
     * Header only flag. When this is set to true, returned block does not contain the
     * transactions.
     */ headerOnly(headerOnly) {
        this.query["header-only"] = headerOnly;
        return this;
    }
}
exports.default = LookupBlock;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lIEKM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupTransactionByID extends (0, _jsonrequestDefault.default) {
    /**
     * Returns information about the given transaction.
     *
     * #### Example
     * ```typescript
     * const txnId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const txnInfo = await indexerClient.lookupTransactionByID(txnId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2transactionstxid)
     * @param txID - The ID of the transaction to look up.
     * @category GET
     */ constructor(c, intDecoding, txID){
        super(c, intDecoding);
        this.txID = txID;
        this.txID = txID;
    }
    /**
     * @returns `/v2/transactions/${txID}`
     */ path() {
        return `/v2/transactions/${this.txID}`;
    }
}
exports.default = LookupTransactionByID;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irS3T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAccountByID extends (0, _jsonrequestDefault.default) {
    /**
     * Returns information about the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await indexerClient.lookupAccountByID(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-id)
     * @param account - The address of the account to look up.
     * @category GET
     */ constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    /**
     * @returns `/v2/accounts/${account}`
     */ path() {
        return `/v2/accounts/${this.account}`;
    }
    /**
     * Specify round to filter with.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const targetBlock = 18309917;
     * const accountInfo = await indexerClient
     *        .lookupAccountByID(address)
     *        .round(targetBlock)
     *        .do();
     * ```
     * @param round
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Include all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates.
     *
     * #### Example 1
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await indexerClient
     *        .lookupAccountByID(address)
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await indexerClient
     *        .lookupAccountByID(address)
     *        .includeAll()
     *        .do();
     * ```
     * @param value
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
    /**
     * Exclude additional items such as asset holdings, application local data stored for this account, asset parameters created by this account, and application parameters created by this account.
     *
     * #### Example 1
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await indexerClient
     *        .lookupAccountByID(address)
     *        .exclude("all")
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountInfo = await indexerClient
     *        .lookupAccountByID(address)
     *        .exclude("assets,created-assets")
     *        .do();
     * ```
     * @remarks By default, it behaves as exclude=none
     * @param exclude - Array of `all`, `assets`, `created-assets`, `apps-local-state`, `created-apps`, `none`
     * @category query
     */ exclude(exclude) {
        this.query.exclude = exclude;
        return this;
    }
}
exports.default = LookupAccountByID;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Hd3p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAccountAssets extends (0, _jsonrequestDefault.default) {
    /**
     * Returns asset about the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAssets = await indexerClient.lookupAccountAssets(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idassets)
     * @param account - The address of the account to look up.
     * @category GET
     */ constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    /**
     * @returns `/v2/accounts/${account}/assets`
     */ path() {
        return `/v2/accounts/${this.account}/assets`;
    }
    /**
     * Add a limit for filter.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     * const accountAssets = await indexerClient
     *        .lookupAccountAssets(address)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Specify round to filter with.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const targetBlock = 18309917;
     * const accountAssets = await indexerClient
     *        .lookupAccountAssets(address)
     *        .round(targetBlock)
     *        .do();
     * ```
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     *
     * const accountAssetsPage1 = await indexerClient
     *        .lookupAccountAssets(address)
     *        .limit(maxResults)
     *        .do();
     *
     * const accountAssetsPage2 = await indexerClient
     *        .lookupAccountAssets(address)
     *        .limit(maxResults)
     *        .next(accountAssetsPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Include all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAssets = await indexerClient
     *        .lookupAccountAssets(address)
     *        .includeAll(false)
     *        .do();
     * ```
     * @param value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
    /**
     * Specify an assetID to search for.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const assetAssets = await indexerClient
     *        .lookupAccountAssets(address)
     *        .assetId(assetId)
     *        .do();
     * ```
     * @param index - the assetID
     * @category query
     */ assetId(index) {
        this.query["asset-id"] = index;
        return this;
    }
}
exports.default = LookupAccountAssets;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ycwQE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAccountCreatedAssets extends (0, _jsonrequestDefault.default) {
    /**
     * Returns asset information created by the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountCreatedAssets = await indexerClient.lookupAccountCreatedAssets(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idcreated-assets)
     * @param account - The address of the account to look up.
     * @category GET
     */ constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    /**
     * @returns `/v2/accounts/${account}/created-assets`
     */ path() {
        return `/v2/accounts/${this.account}/created-assets`;
    }
    /**
     * Add a limit for filter.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     * const accountAssets = await indexerClient
     *        .lookupAccountCreatedAssets(address)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Specify round to filter with.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const targetBlock = 18309917;
     * const accountAssets = await indexerClient
     *        .lookupAccountCreatedAssets(address)
     *        .round(targetBlock)
     *        .do();
     * ```
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     *
     * const accountAssetsPage1 = await indexerClient
     *        .lookupAccountCreatedAssets(address)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * const accountAssetsPage2 = await indexerClient
     *        .lookupAccountCreatedAssets(address)
     *        .limit(maxResults)
     *        .next(accountAssetsPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Include all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAssets = await indexerClient
     *        .lookupAccountCreatedAssets(address)
     *        .includeAll(false)
     *        .do();
     * ```
     * @param value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
    /**
     * Specify an assetID to search for.
     *
     * #### Example
     * ```typescript
     * const assetID = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const assetAssets = await indexerClient
     *        .lookupAccountCreatedAssets(address)
     *        .assetID(assetID)
     *        .do();
     * ```
     * @param index - the assetID
     * @category query
     */ assetID(index) {
        this.query["asset-id"] = index;
        return this;
    }
}
exports.default = LookupAccountCreatedAssets;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"23Swm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAccountAppLocalStates extends (0, _jsonrequestDefault.default) {
    /**
     * Returns application local state about the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAppLocalStates = await indexerClient.lookupAccountAppLocalStates(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idapps-local-state)
     * @param account - The address of the account to look up.
     * @category GET
     */ constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    /**
     * @returns `/v2/accounts/${account}/apps-local-state`
     */ path() {
        return `/v2/accounts/${this.account}/apps-local-state`;
    }
    /**
     * Add a limit for filter.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     * const accountAssets = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Specify round to filter with.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const targetBlock = 18309917;
     * const accountAssets = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .round(targetBlock)
     *        .do();
     * ```
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     *
     * const accountAssetsPage1 = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .limit(maxResults)
     *        .do();
     *
     * const accountAssetsPage2 = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .limit(maxResults)
     *        .next(accountAssetsPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Include all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAssets = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .includeAll(false)
     *        .do();
     * ```
     * @param value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
    /**
     * Specify an applicationID to search for.
     *
     * #### Example
     * ```typescript
     * const applicationID = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountApplications = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .applicationID(applicationID)
     *        .do();
     * ```
     * @param index - the applicationID
     * @category query
     */ applicationID(index) {
        this.query["application-id"] = index;
        return this;
    }
}
exports.default = LookupAccountAppLocalStates;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3uWwU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAccountCreatedApplications extends (0, _jsonrequestDefault.default) {
    /**
     * Returns application information created by the given account.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountCreatedApps = await indexerClient.lookupAccountCreatedApplications(address).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2accountsaccount-idcreated-applications)
     * @param account - The address of the account to look up.
     * @category GET
     */ constructor(c, intDecoding, account){
        super(c, intDecoding);
        this.account = account;
        this.account = account;
    }
    /**
     * @returns `/v2/accounts/${account}/created-applications`
     */ path() {
        return `/v2/accounts/${this.account}/created-applications`;
    }
    /**
     * Add a limit for filter.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     * const accountAssets = await indexerClient
     *        .lookupAccountCreatedApplications(address)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Specify round to filter with.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const targetBlock = 18309917;
     * const accountAssets = await indexerClient
     *        .lookupAccountCreatedApplications(address)
     *        .round(targetBlock)
     *        .do();
     * ```
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const maxResults = 20;
     *
     * const accountAssetsPage1 = await indexerClient
     *        .lookupAccountCreatedApplications(address)
     *        .limit(maxResults)
     *        .do();
     *
     * const accountAssetsPage2 = await indexerClient
     *        .lookupAccountCreatedApplications(address)
     *        .limit(maxResults)
     *        .next(accountAssetsPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Include all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountAssets = await indexerClient
     *        .lookupAccountCreatedApplications(address)
     *        .includeAll(false)
     *        .do();
     * ```
     * @param value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
    /**
     * Specify an applicationID to search for.
     *
     * #### Example
     * ```typescript
     * const applicationID = 163650;
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accountApplications = await indexerClient
     *        .lookupAccountAppLocalStates(address)
     *        .applicationID(applicationID)
     *        .do();
     * ```
     * @param index - the applicationID
     * @category query
     */ applicationID(index) {
        this.query["application-id"] = index;
        return this;
    }
}
exports.default = LookupAccountCreatedApplications;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9v74C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupAssetByID extends (0, _jsonrequestDefault.default) {
    /**
     * Returns asset information of the queried asset.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assetInfo = await indexerClient.lookupAssetByID(assetId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2assetsasset-id)
     * @param index - The asset ID to look up.
     */ constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    /**
     * @returns `/v2/assets/${index}`
     */ path() {
        return `/v2/assets/${this.index}`;
    }
    /**
     * Includes all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example 1
     * ```typescript
     * const assetId = 163650;
     * const assetInfo = await indexerClient
     *        .lookupAssetByID(assetId)
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetId = 163650;
     * const assetInfo = await indexerClient
     *        .lookupAssetByID(assetId)
     *        .includeAll()
     *        .do();
     * ```
     *
     * @param value - default true when called without passing a value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
}
exports.default = LookupAssetByID;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9KBaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupApplications extends (0, _jsonrequestDefault.default) {
    /**
     * Returns information about the passed application.
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const appInfo = await indexerClient.lookupApplications(appId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-id)
     * @param index - The ID of the application to look up.
     * @category GET
     */ constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    /**
     * @returns `/v2/applications/${index}`
     */ path() {
        return `/v2/applications/${this.index}`;
    }
    /**
     * Includes all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example 1
     * ```typescript
     * const appId = 60553466;
     * const appInfo = await indexerClient
     *        .lookupApplications(appId)
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const appId = 60553466;
     * const appInfo = await indexerClient
     *        .lookupApplications(appId)
     *        .includeAll()
     *        .do();
     * ```
     *
     * @param value - default true when called without passing a value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
}
exports.default = LookupApplications;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iqt7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class LookupApplicationLogs extends (0, _jsonrequestDefault.default) {
    /**
     * Returns log messages generated by the passed in application.
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const appLogs = await indexerClient.lookupApplicationLogs(appId).do();
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-idlogs)
     * @param appID - The ID of the application which generated the logs.
     * @category GET
     */ constructor(c, intDecoding, appID){
        super(c, intDecoding);
        this.appID = appID;
        this.appID = appID;
    }
    /**
     * @returns `/v2/applications/${appID}/logs`
     */ path() {
        return `/v2/applications/${this.appID}/logs`;
    }
    /**
     * Limit results for pagination.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const appLogs = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Include results at or after the specified min-round.
     *
     * #### Example
     * ```typescript
     * const minRound = 18309917;
     * const appLogs = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .minRound(minRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ minRound(round) {
        this.query["min-round"] = round;
        return this;
    }
    /**
     * Include results at or before the specified max-round.
     *
     * #### Example
     * ```typescript
     * const maxRound = 18309917;
     * const appLogs = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .maxRound(maxRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ maxRound(round) {
        this.query["max-round"] = round;
        return this;
    }
    /**
     * The next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     *
     * const appLogsPage1 = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .limit(maxResults)
     *        .do();
     *
     * const appLogsPage2 = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .limit(maxResults)
     *        .nextToken(appLogsPage1["next-token"])
     *        .do();
     * ```
     *
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Only include transactions with this sender address.
     *
     * #### Example
     * ```typescript
     * const sender = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const appLogs = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .sender(sender)
     *        .do();
     * ```
     *
     * @param senderAddress
     * @category query
     */ sender(senderAddress) {
        this.query["sender-address"] = senderAddress;
        return this;
    }
    /**
     * Lookup the specific transaction by ID.
     *
     * #### Example
     * ```typescript
     * const txId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const appLogs = await indexerClient
     *        .lookupApplicationLogs(appId)
     *        .txid(txId)
     *        .do();
     * ```
     *
     * @param txid
     * @category query
     */ txid(txid) {
        this.query.txid = txid;
        return this;
    }
}
exports.default = LookupApplicationLogs;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5C0gR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buffer = require("buffer");
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
class LookupApplicationBoxByIDandName extends (0, _jsonrequestDefault.default) {
    /**
     * Returns information about indexed application boxes.
     *
     * #### Example
     * ```typescript
     * const boxName = Buffer.from("foo");
     * const boxResponse = await indexerClient
     *        .LookupApplicationBoxByIDandName(1234, boxName)
     *        .do();
     * const boxValue = boxResponse.value;
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-idbox)
     * @oaram index - application index.
     * @category GET
     */ constructor(c, intDecoding, index, boxName){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
        // Encode query in base64 format and append the encoding prefix.
        const encodedName = (0, _buffer.Buffer).from(boxName).toString("base64");
        this.query.name = encodeURI(`b64:${encodedName}`);
    }
    /**
     * @returns `/v2/applications/${index}/box`
     */ path() {
        return `/v2/applications/${this.index}/box`;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return (0, _types.Box).from_obj_for_encoding(body);
    }
}
exports.default = LookupApplicationBoxByIDandName;

},{"buffer":"jlSk7","../jsonrequest":"eWgGi","./models/types":"glILl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"glILl":[function(require,module,exports) {
/**
 * NOTICE: This file was generated. Editing this file manually is not recommended.
 */ /* eslint-disable no-use-before-define */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Account information at a given round.
 * Definition:
 * data/basics/userBalance.go : AccountData
 */ parcelHelpers.export(exports, "Account", ()=>Account);
/**
 * AccountParticipation describes the parameters used by this account in consensus
 * protocol.
 */ parcelHelpers.export(exports, "AccountParticipation", ()=>AccountParticipation);
/**
 *
 */ parcelHelpers.export(exports, "AccountResponse", ()=>AccountResponse);
/**
 * Application state delta.
 */ parcelHelpers.export(exports, "AccountStateDelta", ()=>AccountStateDelta);
/**
 *
 */ parcelHelpers.export(exports, "AccountsResponse", ()=>AccountsResponse);
/**
 * Application index and its parameters
 */ parcelHelpers.export(exports, "Application", ()=>Application);
/**
 * Stores local state associated with an application.
 */ parcelHelpers.export(exports, "ApplicationLocalState", ()=>ApplicationLocalState);
/**
 *
 */ parcelHelpers.export(exports, "ApplicationLocalStatesResponse", ()=>ApplicationLocalStatesResponse);
/**
 * Stores the global information associated with an application.
 */ parcelHelpers.export(exports, "ApplicationLogData", ()=>ApplicationLogData);
/**
 *
 */ parcelHelpers.export(exports, "ApplicationLogsResponse", ()=>ApplicationLogsResponse);
/**
 * Stores the global information associated with an application.
 */ parcelHelpers.export(exports, "ApplicationParams", ()=>ApplicationParams);
/**
 *
 */ parcelHelpers.export(exports, "ApplicationResponse", ()=>ApplicationResponse);
/**
 * Specifies maximums on the number of each type that may be stored.
 */ parcelHelpers.export(exports, "ApplicationStateSchema", ()=>ApplicationStateSchema);
/**
 *
 */ parcelHelpers.export(exports, "ApplicationsResponse", ()=>ApplicationsResponse);
/**
 * Specifies both the unique identifier and the parameters for an asset
 */ parcelHelpers.export(exports, "Asset", ()=>Asset);
/**
 *
 */ parcelHelpers.export(exports, "AssetBalancesResponse", ()=>AssetBalancesResponse);
/**
 * Describes an asset held by an account.
 * Definition:
 * data/basics/userBalance.go : AssetHolding
 */ parcelHelpers.export(exports, "AssetHolding", ()=>AssetHolding);
/**
 *
 */ parcelHelpers.export(exports, "AssetHoldingsResponse", ()=>AssetHoldingsResponse);
/**
 * AssetParams specifies the parameters for an asset.
 * (apar) when part of an AssetConfig transaction.
 * Definition:
 * data/transactions/asset.go : AssetParams
 */ parcelHelpers.export(exports, "AssetParams", ()=>AssetParams);
/**
 *
 */ parcelHelpers.export(exports, "AssetResponse", ()=>AssetResponse);
/**
 *
 */ parcelHelpers.export(exports, "AssetsResponse", ()=>AssetsResponse);
/**
 * Block information.
 * Definition:
 * data/bookkeeping/block.go : Block
 */ parcelHelpers.export(exports, "Block", ()=>Block);
/**
 * Fields relating to rewards,
 */ parcelHelpers.export(exports, "BlockRewards", ()=>BlockRewards);
/**
 * Fields relating to a protocol upgrade.
 */ parcelHelpers.export(exports, "BlockUpgradeState", ()=>BlockUpgradeState);
/**
 * Fields relating to voting for a protocol upgrade.
 */ parcelHelpers.export(exports, "BlockUpgradeVote", ()=>BlockUpgradeVote);
/**
 * Box name and its content.
 */ parcelHelpers.export(exports, "Box", ()=>Box);
/**
 * Box descriptor describes an app box without a value.
 */ parcelHelpers.export(exports, "BoxDescriptor", ()=>BoxDescriptor);
/**
 * Box names of an application
 */ parcelHelpers.export(exports, "BoxesResponse", ()=>BoxesResponse);
/**
 * Response for errors
 */ parcelHelpers.export(exports, "ErrorResponse", ()=>ErrorResponse);
/**
 * Represents a TEAL value delta.
 */ parcelHelpers.export(exports, "EvalDelta", ()=>EvalDelta);
/**
 * Key-value pairs for StateDelta.
 */ parcelHelpers.export(exports, "EvalDeltaKeyValue", ()=>EvalDeltaKeyValue);
parcelHelpers.export(exports, "HashFactory", ()=>HashFactory);
/**
 * A health check response.
 */ parcelHelpers.export(exports, "HealthCheck", ()=>HealthCheck);
parcelHelpers.export(exports, "IndexerStateProofMessage", ()=>IndexerStateProofMessage);
parcelHelpers.export(exports, "MerkleArrayProof", ()=>MerkleArrayProof);
/**
 * A simplified version of AssetHolding
 */ parcelHelpers.export(exports, "MiniAssetHolding", ()=>MiniAssetHolding);
/**
 * Participation account data that needs to be checked/acted on by the network.
 */ parcelHelpers.export(exports, "ParticipationUpdates", ()=>ParticipationUpdates);
/**
 * (sp) represents a state proof.
 * Definition:
 * crypto/stateproof/structs.go : StateProof
 */ parcelHelpers.export(exports, "StateProofFields", ()=>StateProofFields);
parcelHelpers.export(exports, "StateProofParticipant", ()=>StateProofParticipant);
parcelHelpers.export(exports, "StateProofReveal", ()=>StateProofReveal);
parcelHelpers.export(exports, "StateProofSigSlot", ()=>StateProofSigSlot);
parcelHelpers.export(exports, "StateProofSignature", ()=>StateProofSignature);
parcelHelpers.export(exports, "StateProofTracking", ()=>StateProofTracking);
parcelHelpers.export(exports, "StateProofVerifier", ()=>StateProofVerifier);
/**
 * Represents a (apls) local-state or (apgs) global-state schema. These schemas
 * determine how much storage may be used in a local-state or global-state for an
 * application. The more space used, the larger minimum balance must be maintained
 * in the account holding the data.
 */ parcelHelpers.export(exports, "StateSchema", ()=>StateSchema);
/**
 * Represents a key-value pair in an application store.
 */ parcelHelpers.export(exports, "TealKeyValue", ()=>TealKeyValue);
/**
 * Represents a TEAL value.
 */ parcelHelpers.export(exports, "TealValue", ()=>TealValue);
/**
 * Contains all fields common to all transactions and serves as an envelope to all
 * transactions type. Represents both regular and inner transactions.
 * Definition:
 * data/transactions/signedtxn.go : SignedTxn
 * data/transactions/transaction.go : Transaction
 */ parcelHelpers.export(exports, "Transaction", ()=>Transaction);
/**
 * Fields for application transactions.
 * Definition:
 * data/transactions/application.go : ApplicationCallTxnFields
 */ parcelHelpers.export(exports, "TransactionApplication", ()=>TransactionApplication);
/**
 * Fields for asset allocation, re-configuration, and destruction.
 * A zero value for asset-id indicates asset creation.
 * A zero value for the params indicates asset destruction.
 * Definition:
 * data/transactions/asset.go : AssetConfigTxnFields
 */ parcelHelpers.export(exports, "TransactionAssetConfig", ()=>TransactionAssetConfig);
/**
 * Fields for an asset freeze transaction.
 * Definition:
 * data/transactions/asset.go : AssetFreezeTxnFields
 */ parcelHelpers.export(exports, "TransactionAssetFreeze", ()=>TransactionAssetFreeze);
/**
 * Fields for an asset transfer transaction.
 * Definition:
 * data/transactions/asset.go : AssetTransferTxnFields
 */ parcelHelpers.export(exports, "TransactionAssetTransfer", ()=>TransactionAssetTransfer);
/**
 * Fields for a keyreg transaction.
 * Definition:
 * data/transactions/keyreg.go : KeyregTxnFields
 */ parcelHelpers.export(exports, "TransactionKeyreg", ()=>TransactionKeyreg);
/**
 * Fields for a payment transaction.
 * Definition:
 * data/transactions/payment.go : PaymentTxnFields
 */ parcelHelpers.export(exports, "TransactionPayment", ()=>TransactionPayment);
/**
 *
 */ parcelHelpers.export(exports, "TransactionResponse", ()=>TransactionResponse);
/**
 * Validation signature associated with some data. Only one of the signatures
 * should be provided.
 */ parcelHelpers.export(exports, "TransactionSignature", ()=>TransactionSignature);
/**
 * (lsig) Programatic transaction signature.
 * Definition:
 * data/transactions/logicsig.go
 */ parcelHelpers.export(exports, "TransactionSignatureLogicsig", ()=>TransactionSignatureLogicsig);
/**
 * (msig) structure holding multiple subsignatures.
 * Definition:
 * crypto/multisig.go : MultisigSig
 */ parcelHelpers.export(exports, "TransactionSignatureMultisig", ()=>TransactionSignatureMultisig);
parcelHelpers.export(exports, "TransactionSignatureMultisigSubsignature", ()=>TransactionSignatureMultisigSubsignature);
/**
 * Fields for a state proof transaction.
 * Definition:
 * data/transactions/stateproof.go : StateProofTxnFields
 */ parcelHelpers.export(exports, "TransactionStateProof", ()=>TransactionStateProof);
/**
 *
 */ parcelHelpers.export(exports, "TransactionsResponse", ()=>TransactionsResponse);
var _buffer = require("buffer");
var _basemodel = require("../../basemodel");
var _basemodelDefault = parcelHelpers.interopDefault(_basemodel);
class Account extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Account` object.
     * @param address - the account public key
     * @param amount - (algo) total number of MicroAlgos in the account
     * @param amountWithoutPendingRewards - specifies the amount of MicroAlgos in the account, without the pending rewards.
     * @param pendingRewards - amount of MicroAlgos of pending rewards in this account.
     * @param rewards - (ern) total rewards of MicroAlgos the account has received, including pending
     * rewards.
     * @param round - The round for which this information is relevant.
     * @param status - (onl) delegation status of the account's MicroAlgos
     * * Offline - indicates that the associated account is delegated.
     * * Online - indicates that the associated account used as part of the delegation
     * pool.
     * * NotParticipating - indicates that the associated account is neither a
     * delegator nor a delegate.
     * @param totalAppsOptedIn - The count of all applications that have been opted in, equivalent to the count
     * of application local data (AppLocalState objects) stored in this account.
     * @param totalAssetsOptedIn - The count of all assets that have been opted in, equivalent to the count of
     * AssetHolding objects held by this account.
     * @param totalBoxBytes - For app-accounts only. The total number of bytes allocated for the keys and
     * values of boxes which belong to the associated application.
     * @param totalBoxes - For app-accounts only. The total number of boxes which belong to the associated
     * application.
     * @param totalCreatedApps - The count of all apps (AppParams objects) created by this account.
     * @param totalCreatedAssets - The count of all assets (AssetParams objects) created by this account.
     * @param appsLocalState - (appl) applications local data stored in this account.
     * Note the raw object uses `map[int] -> AppLocalState` for this type.
     * @param appsTotalExtraPages - (teap) the sum of all extra application program pages for this account.
     * @param appsTotalSchema - (tsch) stores the sum of all of the local schemas and global schemas in this
     * account.
     * Note: the raw account uses `StateSchema` for this type.
     * @param assets - (asset) assets held by this account.
     * Note the raw object uses `map[int] -> AssetHolding` for this type.
     * @param authAddr - (spend) the address against which signing should be checked. If empty, the
     * address of the current account is used. This field can be updated in any
     * transaction by setting the RekeyTo field.
     * @param closedAtRound - Round during which this account was most recently closed.
     * @param createdApps - (appp) parameters of applications created by this account including app global
     * data.
     * Note: the raw account uses `map[int] -> AppParams` for this type.
     * @param createdAssets - (apar) parameters of assets created by this account.
     * Note: the raw account uses `map[int] -> Asset` for this type.
     * @param createdAtRound - Round during which this account first appeared in a transaction.
     * @param deleted - Whether or not this account is currently closed.
     * @param participation - AccountParticipation describes the parameters used by this account in consensus
     * protocol.
     * @param rewardBase - (ebase) used as part of the rewards computation. Only applicable to accounts
     * which are participating.
     * @param sigType - Indicates what type of signature is used by this account, must be one of:
     * * sig
     * * msig
     * * lsig
     * * or null if unknown
     */ constructor({ address , amount , amountWithoutPendingRewards , pendingRewards , rewards , round , status , totalAppsOptedIn , totalAssetsOptedIn , totalBoxBytes , totalBoxes , totalCreatedApps , totalCreatedAssets , appsLocalState , appsTotalExtraPages , appsTotalSchema , assets , authAddr , closedAtRound , createdApps , createdAssets , createdAtRound , deleted , participation , rewardBase , sigType  }){
        super();
        this.address = address;
        this.amount = amount;
        this.amountWithoutPendingRewards = amountWithoutPendingRewards;
        this.pendingRewards = pendingRewards;
        this.rewards = rewards;
        this.round = round;
        this.status = status;
        this.totalAppsOptedIn = totalAppsOptedIn;
        this.totalAssetsOptedIn = totalAssetsOptedIn;
        this.totalBoxBytes = totalBoxBytes;
        this.totalBoxes = totalBoxes;
        this.totalCreatedApps = totalCreatedApps;
        this.totalCreatedAssets = totalCreatedAssets;
        this.appsLocalState = appsLocalState;
        this.appsTotalExtraPages = appsTotalExtraPages;
        this.appsTotalSchema = appsTotalSchema;
        this.assets = assets;
        this.authAddr = authAddr;
        this.closedAtRound = closedAtRound;
        this.createdApps = createdApps;
        this.createdAssets = createdAssets;
        this.createdAtRound = createdAtRound;
        this.deleted = deleted;
        this.participation = participation;
        this.rewardBase = rewardBase;
        this.sigType = sigType;
        this.attribute_map = {
            address: "address",
            amount: "amount",
            amountWithoutPendingRewards: "amount-without-pending-rewards",
            pendingRewards: "pending-rewards",
            rewards: "rewards",
            round: "round",
            status: "status",
            totalAppsOptedIn: "total-apps-opted-in",
            totalAssetsOptedIn: "total-assets-opted-in",
            totalBoxBytes: "total-box-bytes",
            totalBoxes: "total-boxes",
            totalCreatedApps: "total-created-apps",
            totalCreatedAssets: "total-created-assets",
            appsLocalState: "apps-local-state",
            appsTotalExtraPages: "apps-total-extra-pages",
            appsTotalSchema: "apps-total-schema",
            assets: "assets",
            authAddr: "auth-addr",
            closedAtRound: "closed-at-round",
            createdApps: "created-apps",
            createdAssets: "created-assets",
            createdAtRound: "created-at-round",
            deleted: "deleted",
            participation: "participation",
            rewardBase: "reward-base",
            sigType: "sig-type"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["address"] === "undefined") throw new Error(`Response is missing required field 'address': ${data}`);
        if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["amount-without-pending-rewards"] === "undefined") throw new Error(`Response is missing required field 'amount-without-pending-rewards': ${data}`);
        if (typeof data["pending-rewards"] === "undefined") throw new Error(`Response is missing required field 'pending-rewards': ${data}`);
        if (typeof data["rewards"] === "undefined") throw new Error(`Response is missing required field 'rewards': ${data}`);
        if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        if (typeof data["status"] === "undefined") throw new Error(`Response is missing required field 'status': ${data}`);
        if (typeof data["total-apps-opted-in"] === "undefined") throw new Error(`Response is missing required field 'total-apps-opted-in': ${data}`);
        if (typeof data["total-assets-opted-in"] === "undefined") throw new Error(`Response is missing required field 'total-assets-opted-in': ${data}`);
        if (typeof data["total-box-bytes"] === "undefined") throw new Error(`Response is missing required field 'total-box-bytes': ${data}`);
        if (typeof data["total-boxes"] === "undefined") throw new Error(`Response is missing required field 'total-boxes': ${data}`);
        if (typeof data["total-created-apps"] === "undefined") throw new Error(`Response is missing required field 'total-created-apps': ${data}`);
        if (typeof data["total-created-assets"] === "undefined") throw new Error(`Response is missing required field 'total-created-assets': ${data}`);
        return new Account({
            address: data["address"],
            amount: data["amount"],
            amountWithoutPendingRewards: data["amount-without-pending-rewards"],
            pendingRewards: data["pending-rewards"],
            rewards: data["rewards"],
            round: data["round"],
            status: data["status"],
            totalAppsOptedIn: data["total-apps-opted-in"],
            totalAssetsOptedIn: data["total-assets-opted-in"],
            totalBoxBytes: data["total-box-bytes"],
            totalBoxes: data["total-boxes"],
            totalCreatedApps: data["total-created-apps"],
            totalCreatedAssets: data["total-created-assets"],
            appsLocalState: typeof data["apps-local-state"] !== "undefined" ? data["apps-local-state"].map(ApplicationLocalState.from_obj_for_encoding) : undefined,
            appsTotalExtraPages: data["apps-total-extra-pages"],
            appsTotalSchema: typeof data["apps-total-schema"] !== "undefined" ? ApplicationStateSchema.from_obj_for_encoding(data["apps-total-schema"]) : undefined,
            assets: typeof data["assets"] !== "undefined" ? data["assets"].map(AssetHolding.from_obj_for_encoding) : undefined,
            authAddr: data["auth-addr"],
            closedAtRound: data["closed-at-round"],
            createdApps: typeof data["created-apps"] !== "undefined" ? data["created-apps"].map(Application.from_obj_for_encoding) : undefined,
            createdAssets: typeof data["created-assets"] !== "undefined" ? data["created-assets"].map(Asset.from_obj_for_encoding) : undefined,
            createdAtRound: data["created-at-round"],
            deleted: data["deleted"],
            participation: typeof data["participation"] !== "undefined" ? AccountParticipation.from_obj_for_encoding(data["participation"]) : undefined,
            rewardBase: data["reward-base"],
            sigType: data["sig-type"]
        });
    /* eslint-enable dot-notation */ }
}
class AccountParticipation extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountParticipation` object.
     * @param selectionParticipationKey - (sel) Selection public key (if any) currently registered for this round.
     * @param voteFirstValid - (voteFst) First round for which this participation is valid.
     * @param voteKeyDilution - (voteKD) Number of subkeys in each batch of participation keys.
     * @param voteLastValid - (voteLst) Last round for which this participation is valid.
     * @param voteParticipationKey - (vote) root participation public key (if any) currently registered for this
     * round.
     * @param stateProofKey - (stprf) Root of the state proof key (if any)
     */ constructor({ selectionParticipationKey , voteFirstValid , voteKeyDilution , voteLastValid , voteParticipationKey , stateProofKey  }){
        super();
        this.selectionParticipationKey = typeof selectionParticipationKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(selectionParticipationKey, "base64")) : selectionParticipationKey;
        this.voteFirstValid = voteFirstValid;
        this.voteKeyDilution = voteKeyDilution;
        this.voteLastValid = voteLastValid;
        this.voteParticipationKey = typeof voteParticipationKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(voteParticipationKey, "base64")) : voteParticipationKey;
        this.stateProofKey = typeof stateProofKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(stateProofKey, "base64")) : stateProofKey;
        this.attribute_map = {
            selectionParticipationKey: "selection-participation-key",
            voteFirstValid: "vote-first-valid",
            voteKeyDilution: "vote-key-dilution",
            voteLastValid: "vote-last-valid",
            voteParticipationKey: "vote-participation-key",
            stateProofKey: "state-proof-key"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["selection-participation-key"] === "undefined") throw new Error(`Response is missing required field 'selection-participation-key': ${data}`);
        if (typeof data["vote-first-valid"] === "undefined") throw new Error(`Response is missing required field 'vote-first-valid': ${data}`);
        if (typeof data["vote-key-dilution"] === "undefined") throw new Error(`Response is missing required field 'vote-key-dilution': ${data}`);
        if (typeof data["vote-last-valid"] === "undefined") throw new Error(`Response is missing required field 'vote-last-valid': ${data}`);
        if (typeof data["vote-participation-key"] === "undefined") throw new Error(`Response is missing required field 'vote-participation-key': ${data}`);
        return new AccountParticipation({
            selectionParticipationKey: data["selection-participation-key"],
            voteFirstValid: data["vote-first-valid"],
            voteKeyDilution: data["vote-key-dilution"],
            voteLastValid: data["vote-last-valid"],
            voteParticipationKey: data["vote-participation-key"],
            stateProofKey: data["state-proof-key"]
        });
    /* eslint-enable dot-notation */ }
}
class AccountResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountResponse` object.
     * @param account - Account information at a given round.
     * Definition:
     * data/basics/userBalance.go : AccountData
     * @param currentRound - Round at which the results were computed.
     */ constructor({ account , currentRound  }){
        super();
        this.account = account;
        this.currentRound = currentRound;
        this.attribute_map = {
            account: "account",
            currentRound: "current-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["account"] === "undefined") throw new Error(`Response is missing required field 'account': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new AccountResponse({
            account: Account.from_obj_for_encoding(data["account"]),
            currentRound: data["current-round"]
        });
    /* eslint-enable dot-notation */ }
}
class AccountStateDelta extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountStateDelta` object.
     * @param address -
     * @param delta - Application state delta.
     */ constructor({ address , delta  }){
        super();
        this.address = address;
        this.delta = delta;
        this.attribute_map = {
            address: "address",
            delta: "delta"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["address"] === "undefined") throw new Error(`Response is missing required field 'address': ${data}`);
        if (!Array.isArray(data["delta"])) throw new Error(`Response is missing required array field 'delta': ${data}`);
        return new AccountStateDelta({
            address: data["address"],
            delta: data["delta"].map(EvalDeltaKeyValue.from_obj_for_encoding)
        });
    /* eslint-enable dot-notation */ }
}
class AccountsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AccountsResponse` object.
     * @param accounts -
     * @param currentRound - Round at which the results were computed.
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ accounts , currentRound , nextToken  }){
        super();
        this.accounts = accounts;
        this.currentRound = currentRound;
        this.nextToken = nextToken;
        this.attribute_map = {
            accounts: "accounts",
            currentRound: "current-round",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["accounts"])) throw new Error(`Response is missing required array field 'accounts': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new AccountsResponse({
            accounts: data["accounts"].map(Account.from_obj_for_encoding),
            currentRound: data["current-round"],
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class Application extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Application` object.
     * @param id - (appidx) application index.
     * @param params - (appparams) application parameters.
     * @param createdAtRound - Round when this application was created.
     * @param deleted - Whether or not this application is currently deleted.
     * @param deletedAtRound - Round when this application was deleted.
     */ constructor({ id , params , createdAtRound , deleted , deletedAtRound  }){
        super();
        this.id = id;
        this.params = params;
        this.createdAtRound = createdAtRound;
        this.deleted = deleted;
        this.deletedAtRound = deletedAtRound;
        this.attribute_map = {
            id: "id",
            params: "params",
            createdAtRound: "created-at-round",
            deleted: "deleted",
            deletedAtRound: "deleted-at-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["id"] === "undefined") throw new Error(`Response is missing required field 'id': ${data}`);
        if (typeof data["params"] === "undefined") throw new Error(`Response is missing required field 'params': ${data}`);
        return new Application({
            id: data["id"],
            params: ApplicationParams.from_obj_for_encoding(data["params"]),
            createdAtRound: data["created-at-round"],
            deleted: data["deleted"],
            deletedAtRound: data["deleted-at-round"]
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationLocalState extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationLocalState` object.
     * @param id - The application which this local state is for.
     * @param schema - (hsch) schema.
     * @param closedOutAtRound - Round when account closed out of the application.
     * @param deleted - Whether or not the application local state is currently deleted from its
     * account.
     * @param keyValue - (tkv) storage.
     * @param optedInAtRound - Round when the account opted into the application.
     */ constructor({ id , schema , closedOutAtRound , deleted , keyValue , optedInAtRound  }){
        super();
        this.id = id;
        this.schema = schema;
        this.closedOutAtRound = closedOutAtRound;
        this.deleted = deleted;
        this.keyValue = keyValue;
        this.optedInAtRound = optedInAtRound;
        this.attribute_map = {
            id: "id",
            schema: "schema",
            closedOutAtRound: "closed-out-at-round",
            deleted: "deleted",
            keyValue: "key-value",
            optedInAtRound: "opted-in-at-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["id"] === "undefined") throw new Error(`Response is missing required field 'id': ${data}`);
        if (typeof data["schema"] === "undefined") throw new Error(`Response is missing required field 'schema': ${data}`);
        return new ApplicationLocalState({
            id: data["id"],
            schema: ApplicationStateSchema.from_obj_for_encoding(data["schema"]),
            closedOutAtRound: data["closed-out-at-round"],
            deleted: data["deleted"],
            keyValue: typeof data["key-value"] !== "undefined" ? data["key-value"].map(TealKeyValue.from_obj_for_encoding) : undefined,
            optedInAtRound: data["opted-in-at-round"]
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationLocalStatesResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationLocalStatesResponse` object.
     * @param appsLocalStates -
     * @param currentRound - Round at which the results were computed.
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ appsLocalStates , currentRound , nextToken  }){
        super();
        this.appsLocalStates = appsLocalStates;
        this.currentRound = currentRound;
        this.nextToken = nextToken;
        this.attribute_map = {
            appsLocalStates: "apps-local-states",
            currentRound: "current-round",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["apps-local-states"])) throw new Error(`Response is missing required array field 'apps-local-states': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new ApplicationLocalStatesResponse({
            appsLocalStates: data["apps-local-states"].map(ApplicationLocalState.from_obj_for_encoding),
            currentRound: data["current-round"],
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationLogData extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationLogData` object.
     * @param logs - (lg) Logs for the application being executed by the transaction.
     * @param txid - Transaction ID
     */ constructor({ logs , txid  }){
        super();
        this.logs = logs;
        this.txid = txid;
        this.attribute_map = {
            logs: "logs",
            txid: "txid"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["logs"])) throw new Error(`Response is missing required array field 'logs': ${data}`);
        if (typeof data["txid"] === "undefined") throw new Error(`Response is missing required field 'txid': ${data}`);
        return new ApplicationLogData({
            logs: data["logs"],
            txid: data["txid"]
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationLogsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationLogsResponse` object.
     * @param applicationId - (appidx) application index.
     * @param currentRound - Round at which the results were computed.
     * @param logData -
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ applicationId , currentRound , logData , nextToken  }){
        super();
        this.applicationId = applicationId;
        this.currentRound = currentRound;
        this.logData = logData;
        this.nextToken = nextToken;
        this.attribute_map = {
            applicationId: "application-id",
            currentRound: "current-round",
            logData: "log-data",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["application-id"] === "undefined") throw new Error(`Response is missing required field 'application-id': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new ApplicationLogsResponse({
            applicationId: data["application-id"],
            currentRound: data["current-round"],
            logData: typeof data["log-data"] !== "undefined" ? data["log-data"].map(ApplicationLogData.from_obj_for_encoding) : undefined,
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationParams extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationParams` object.
     * @param approvalProgram - (approv) approval program.
     * @param clearStateProgram - (clearp) approval program.
     * @param creator - The address that created this application. This is the address where the
     * parameters and global state for this application can be found.
     * @param extraProgramPages - (epp) the amount of extra program pages available to this app.
     * @param globalState - [\gs) global schema
     * @param globalStateSchema - [\gsch) global schema
     * @param localStateSchema - [\lsch) local schema
     */ constructor({ approvalProgram , clearStateProgram , creator , extraProgramPages , globalState , globalStateSchema , localStateSchema  }){
        super();
        this.approvalProgram = typeof approvalProgram === "string" ? new Uint8Array((0, _buffer.Buffer).from(approvalProgram, "base64")) : approvalProgram;
        this.clearStateProgram = typeof clearStateProgram === "string" ? new Uint8Array((0, _buffer.Buffer).from(clearStateProgram, "base64")) : clearStateProgram;
        this.creator = creator;
        this.extraProgramPages = extraProgramPages;
        this.globalState = globalState;
        this.globalStateSchema = globalStateSchema;
        this.localStateSchema = localStateSchema;
        this.attribute_map = {
            approvalProgram: "approval-program",
            clearStateProgram: "clear-state-program",
            creator: "creator",
            extraProgramPages: "extra-program-pages",
            globalState: "global-state",
            globalStateSchema: "global-state-schema",
            localStateSchema: "local-state-schema"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["approval-program"] === "undefined") throw new Error(`Response is missing required field 'approval-program': ${data}`);
        if (typeof data["clear-state-program"] === "undefined") throw new Error(`Response is missing required field 'clear-state-program': ${data}`);
        return new ApplicationParams({
            approvalProgram: data["approval-program"],
            clearStateProgram: data["clear-state-program"],
            creator: data["creator"],
            extraProgramPages: data["extra-program-pages"],
            globalState: typeof data["global-state"] !== "undefined" ? data["global-state"].map(TealKeyValue.from_obj_for_encoding) : undefined,
            globalStateSchema: typeof data["global-state-schema"] !== "undefined" ? ApplicationStateSchema.from_obj_for_encoding(data["global-state-schema"]) : undefined,
            localStateSchema: typeof data["local-state-schema"] !== "undefined" ? ApplicationStateSchema.from_obj_for_encoding(data["local-state-schema"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationResponse` object.
     * @param currentRound - Round at which the results were computed.
     * @param application - Application index and its parameters
     */ constructor({ currentRound , application  }){
        super();
        this.currentRound = currentRound;
        this.application = application;
        this.attribute_map = {
            currentRound: "current-round",
            application: "application"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new ApplicationResponse({
            currentRound: data["current-round"],
            application: typeof data["application"] !== "undefined" ? Application.from_obj_for_encoding(data["application"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationStateSchema extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationStateSchema` object.
     * @param numByteSlice - (nbs) num of byte slices.
     * @param numUint - (nui) num of uints.
     */ constructor({ numByteSlice , numUint  }){
        super();
        this.numByteSlice = numByteSlice;
        this.numUint = numUint;
        this.attribute_map = {
            numByteSlice: "num-byte-slice",
            numUint: "num-uint"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["num-byte-slice"] === "undefined") throw new Error(`Response is missing required field 'num-byte-slice': ${data}`);
        if (typeof data["num-uint"] === "undefined") throw new Error(`Response is missing required field 'num-uint': ${data}`);
        return new ApplicationStateSchema({
            numByteSlice: data["num-byte-slice"],
            numUint: data["num-uint"]
        });
    /* eslint-enable dot-notation */ }
}
class ApplicationsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ApplicationsResponse` object.
     * @param applications -
     * @param currentRound - Round at which the results were computed.
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ applications , currentRound , nextToken  }){
        super();
        this.applications = applications;
        this.currentRound = currentRound;
        this.nextToken = nextToken;
        this.attribute_map = {
            applications: "applications",
            currentRound: "current-round",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["applications"])) throw new Error(`Response is missing required array field 'applications': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new ApplicationsResponse({
            applications: data["applications"].map(Application.from_obj_for_encoding),
            currentRound: data["current-round"],
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class Asset extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Asset` object.
     * @param index - unique asset identifier
     * @param params - AssetParams specifies the parameters for an asset.
     * (apar) when part of an AssetConfig transaction.
     * Definition:
     * data/transactions/asset.go : AssetParams
     * @param createdAtRound - Round during which this asset was created.
     * @param deleted - Whether or not this asset is currently deleted.
     * @param destroyedAtRound - Round during which this asset was destroyed.
     */ constructor({ index , params , createdAtRound , deleted , destroyedAtRound  }){
        super();
        this.index = index;
        this.params = params;
        this.createdAtRound = createdAtRound;
        this.deleted = deleted;
        this.destroyedAtRound = destroyedAtRound;
        this.attribute_map = {
            index: "index",
            params: "params",
            createdAtRound: "created-at-round",
            deleted: "deleted",
            destroyedAtRound: "destroyed-at-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["index"] === "undefined") throw new Error(`Response is missing required field 'index': ${data}`);
        if (typeof data["params"] === "undefined") throw new Error(`Response is missing required field 'params': ${data}`);
        return new Asset({
            index: data["index"],
            params: AssetParams.from_obj_for_encoding(data["params"]),
            createdAtRound: data["created-at-round"],
            deleted: data["deleted"],
            destroyedAtRound: data["destroyed-at-round"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetBalancesResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetBalancesResponse` object.
     * @param balances -
     * @param currentRound - Round at which the results were computed.
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ balances , currentRound , nextToken  }){
        super();
        this.balances = balances;
        this.currentRound = currentRound;
        this.nextToken = nextToken;
        this.attribute_map = {
            balances: "balances",
            currentRound: "current-round",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["balances"])) throw new Error(`Response is missing required array field 'balances': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new AssetBalancesResponse({
            balances: data["balances"].map(MiniAssetHolding.from_obj_for_encoding),
            currentRound: data["current-round"],
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetHolding extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetHolding` object.
     * @param amount - (a) number of units held.
     * @param assetId - Asset ID of the holding.
     * @param isFrozen - (f) whether or not the holding is frozen.
     * @param deleted - Whether or not the asset holding is currently deleted from its account.
     * @param optedInAtRound - Round during which the account opted into this asset holding.
     * @param optedOutAtRound - Round during which the account opted out of this asset holding.
     */ constructor({ amount , assetId , isFrozen , deleted , optedInAtRound , optedOutAtRound  }){
        super();
        this.amount = amount;
        this.assetId = assetId;
        this.isFrozen = isFrozen;
        this.deleted = deleted;
        this.optedInAtRound = optedInAtRound;
        this.optedOutAtRound = optedOutAtRound;
        this.attribute_map = {
            amount: "amount",
            assetId: "asset-id",
            isFrozen: "is-frozen",
            deleted: "deleted",
            optedInAtRound: "opted-in-at-round",
            optedOutAtRound: "opted-out-at-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["asset-id"] === "undefined") throw new Error(`Response is missing required field 'asset-id': ${data}`);
        if (typeof data["is-frozen"] === "undefined") throw new Error(`Response is missing required field 'is-frozen': ${data}`);
        return new AssetHolding({
            amount: data["amount"],
            assetId: data["asset-id"],
            isFrozen: data["is-frozen"],
            deleted: data["deleted"],
            optedInAtRound: data["opted-in-at-round"],
            optedOutAtRound: data["opted-out-at-round"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetHoldingsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetHoldingsResponse` object.
     * @param assets -
     * @param currentRound - Round at which the results were computed.
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ assets , currentRound , nextToken  }){
        super();
        this.assets = assets;
        this.currentRound = currentRound;
        this.nextToken = nextToken;
        this.attribute_map = {
            assets: "assets",
            currentRound: "current-round",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["assets"])) throw new Error(`Response is missing required array field 'assets': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new AssetHoldingsResponse({
            assets: data["assets"].map(AssetHolding.from_obj_for_encoding),
            currentRound: data["current-round"],
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetParams extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetParams` object.
     * @param creator - The address that created this asset. This is the address where the parameters
     * for this asset can be found, and also the address where unwanted asset units can
     * be sent in the worst case.
     * @param decimals - (dc) The number of digits to use after the decimal point when displaying this
     * asset. If 0, the asset is not divisible. If 1, the base unit of the asset is in
     * tenths. If 2, the base unit of the asset is in hundredths, and so on. This value
     * must be between 0 and 19 (inclusive).
     * @param total - (t) The total number of units of this asset.
     * @param clawback - (c) Address of account used to clawback holdings of this asset. If empty,
     * clawback is not permitted.
     * @param defaultFrozen - (df) Whether holdings of this asset are frozen by default.
     * @param freeze - (f) Address of account used to freeze holdings of this asset. If empty, freezing
     * is not permitted.
     * @param manager - (m) Address of account used to manage the keys of this asset and to destroy it.
     * @param metadataHash - (am) A commitment to some unspecified asset metadata. The format of this
     * metadata is up to the application.
     * @param name - (an) Name of this asset, as supplied by the creator. Included only when the
     * asset name is composed of printable utf-8 characters.
     * @param nameB64 - Base64 encoded name of this asset, as supplied by the creator.
     * @param reserve - (r) Address of account holding reserve (non-minted) units of this asset.
     * @param unitName - (un) Name of a unit of this asset, as supplied by the creator. Included only
     * when the name of a unit of this asset is composed of printable utf-8 characters.
     * @param unitNameB64 - Base64 encoded name of a unit of this asset, as supplied by the creator.
     * @param url - (au) URL where more information about the asset can be retrieved. Included only
     * when the URL is composed of printable utf-8 characters.
     * @param urlB64 - Base64 encoded URL where more information about the asset can be retrieved.
     */ constructor({ creator , decimals , total , clawback , defaultFrozen , freeze , manager , metadataHash , name , nameB64 , reserve , unitName , unitNameB64 , url , urlB64  }){
        super();
        this.creator = creator;
        this.decimals = decimals;
        this.total = total;
        this.clawback = clawback;
        this.defaultFrozen = defaultFrozen;
        this.freeze = freeze;
        this.manager = manager;
        this.metadataHash = typeof metadataHash === "string" ? new Uint8Array((0, _buffer.Buffer).from(metadataHash, "base64")) : metadataHash;
        this.name = name;
        this.nameB64 = typeof nameB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(nameB64, "base64")) : nameB64;
        this.reserve = reserve;
        this.unitName = unitName;
        this.unitNameB64 = typeof unitNameB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(unitNameB64, "base64")) : unitNameB64;
        this.url = url;
        this.urlB64 = typeof urlB64 === "string" ? new Uint8Array((0, _buffer.Buffer).from(urlB64, "base64")) : urlB64;
        this.attribute_map = {
            creator: "creator",
            decimals: "decimals",
            total: "total",
            clawback: "clawback",
            defaultFrozen: "default-frozen",
            freeze: "freeze",
            manager: "manager",
            metadataHash: "metadata-hash",
            name: "name",
            nameB64: "name-b64",
            reserve: "reserve",
            unitName: "unit-name",
            unitNameB64: "unit-name-b64",
            url: "url",
            urlB64: "url-b64"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["creator"] === "undefined") throw new Error(`Response is missing required field 'creator': ${data}`);
        if (typeof data["decimals"] === "undefined") throw new Error(`Response is missing required field 'decimals': ${data}`);
        if (typeof data["total"] === "undefined") throw new Error(`Response is missing required field 'total': ${data}`);
        return new AssetParams({
            creator: data["creator"],
            decimals: data["decimals"],
            total: data["total"],
            clawback: data["clawback"],
            defaultFrozen: data["default-frozen"],
            freeze: data["freeze"],
            manager: data["manager"],
            metadataHash: data["metadata-hash"],
            name: data["name"],
            nameB64: data["name-b64"],
            reserve: data["reserve"],
            unitName: data["unit-name"],
            unitNameB64: data["unit-name-b64"],
            url: data["url"],
            urlB64: data["url-b64"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetResponse` object.
     * @param asset - Specifies both the unique identifier and the parameters for an asset
     * @param currentRound - Round at which the results were computed.
     */ constructor({ asset , currentRound  }){
        super();
        this.asset = asset;
        this.currentRound = currentRound;
        this.attribute_map = {
            asset: "asset",
            currentRound: "current-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["asset"] === "undefined") throw new Error(`Response is missing required field 'asset': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new AssetResponse({
            asset: Asset.from_obj_for_encoding(data["asset"]),
            currentRound: data["current-round"]
        });
    /* eslint-enable dot-notation */ }
}
class AssetsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `AssetsResponse` object.
     * @param assets -
     * @param currentRound - Round at which the results were computed.
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ assets , currentRound , nextToken  }){
        super();
        this.assets = assets;
        this.currentRound = currentRound;
        this.nextToken = nextToken;
        this.attribute_map = {
            assets: "assets",
            currentRound: "current-round",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (!Array.isArray(data["assets"])) throw new Error(`Response is missing required array field 'assets': ${data}`);
        if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        return new AssetsResponse({
            assets: data["assets"].map(Asset.from_obj_for_encoding),
            currentRound: data["current-round"],
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class Block extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Block` object.
     * @param genesisHash - (gh) hash to which this block belongs.
     * @param genesisId - (gen) ID to which this block belongs.
     * @param previousBlockHash - (prev) Previous block hash.
     * @param round - (rnd) Current round on which this block was appended to the chain.
     * @param seed - (seed) Sortition seed.
     * @param timestamp - (ts) Block creation timestamp in seconds since eposh
     * @param transactionsRoot - (txn) TransactionsRoot authenticates the set of transactions appearing in the
     * block. More specifically, it's the root of a merkle tree whose leaves are the
     * block's Txids, in lexicographic order. For the empty block, it's 0. Note that
     * the TxnRoot does not authenticate the signatures on the transactions, only the
     * transactions themselves. Two blocks with the same transactions but in a
     * different order and with different signatures will have the same TxnRoot.
     * @param transactionsRootSha256 - (txn256) TransactionsRootSHA256 is an auxiliary TransactionRoot, built using a
     * vector commitment instead of a merkle tree, and SHA256 hash function instead of
     * the default SHA512_256. This commitment can be used on environments where only
     * the SHA256 function exists.
     * @param participationUpdates - Participation account data that needs to be checked/acted on by the network.
     * @param rewards - Fields relating to rewards,
     * @param stateProofTracking - Tracks the status of state proofs.
     * @param transactions - (txns) list of transactions corresponding to a given round.
     * @param txnCounter - (tc) TxnCounter counts the number of transactions committed in the ledger, from
     * the time at which support for this feature was introduced.
     * Specifically, TxnCounter is the number of the next transaction that will be
     * committed after this block. It is 0 when no transactions have ever been
     * committed (since TxnCounter started being supported).
     * @param upgradeState - Fields relating to a protocol upgrade.
     * @param upgradeVote - Fields relating to voting for a protocol upgrade.
     */ constructor({ genesisHash , genesisId , previousBlockHash , round , seed , timestamp , transactionsRoot , transactionsRootSha256 , participationUpdates , rewards , stateProofTracking , transactions , txnCounter , upgradeState , upgradeVote  }){
        super();
        this.genesisHash = typeof genesisHash === "string" ? new Uint8Array((0, _buffer.Buffer).from(genesisHash, "base64")) : genesisHash;
        this.genesisId = genesisId;
        this.previousBlockHash = typeof previousBlockHash === "string" ? new Uint8Array((0, _buffer.Buffer).from(previousBlockHash, "base64")) : previousBlockHash;
        this.round = round;
        this.seed = typeof seed === "string" ? new Uint8Array((0, _buffer.Buffer).from(seed, "base64")) : seed;
        this.timestamp = timestamp;
        this.transactionsRoot = typeof transactionsRoot === "string" ? new Uint8Array((0, _buffer.Buffer).from(transactionsRoot, "base64")) : transactionsRoot;
        this.transactionsRootSha256 = typeof transactionsRootSha256 === "string" ? new Uint8Array((0, _buffer.Buffer).from(transactionsRootSha256, "base64")) : transactionsRootSha256;
        this.participationUpdates = participationUpdates;
        this.rewards = rewards;
        this.stateProofTracking = stateProofTracking;
        this.transactions = transactions;
        this.txnCounter = txnCounter;
        this.upgradeState = upgradeState;
        this.upgradeVote = upgradeVote;
        this.attribute_map = {
            genesisHash: "genesis-hash",
            genesisId: "genesis-id",
            previousBlockHash: "previous-block-hash",
            round: "round",
            seed: "seed",
            timestamp: "timestamp",
            transactionsRoot: "transactions-root",
            transactionsRootSha256: "transactions-root-sha256",
            participationUpdates: "participation-updates",
            rewards: "rewards",
            stateProofTracking: "state-proof-tracking",
            transactions: "transactions",
            txnCounter: "txn-counter",
            upgradeState: "upgrade-state",
            upgradeVote: "upgrade-vote"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["genesis-hash"] === "undefined") throw new Error(`Response is missing required field 'genesis-hash': ${data}`);
        if (typeof data["genesis-id"] === "undefined") throw new Error(`Response is missing required field 'genesis-id': ${data}`);
        if (typeof data["previous-block-hash"] === "undefined") throw new Error(`Response is missing required field 'previous-block-hash': ${data}`);
        if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        if (typeof data["seed"] === "undefined") throw new Error(`Response is missing required field 'seed': ${data}`);
        if (typeof data["timestamp"] === "undefined") throw new Error(`Response is missing required field 'timestamp': ${data}`);
        if (typeof data["transactions-root"] === "undefined") throw new Error(`Response is missing required field 'transactions-root': ${data}`);
        if (typeof data["transactions-root-sha256"] === "undefined") throw new Error(`Response is missing required field 'transactions-root-sha256': ${data}`);
        return new Block({
            genesisHash: data["genesis-hash"],
            genesisId: data["genesis-id"],
            previousBlockHash: data["previous-block-hash"],
            round: data["round"],
            seed: data["seed"],
            timestamp: data["timestamp"],
            transactionsRoot: data["transactions-root"],
            transactionsRootSha256: data["transactions-root-sha256"],
            participationUpdates: typeof data["participation-updates"] !== "undefined" ? ParticipationUpdates.from_obj_for_encoding(data["participation-updates"]) : undefined,
            rewards: typeof data["rewards"] !== "undefined" ? BlockRewards.from_obj_for_encoding(data["rewards"]) : undefined,
            stateProofTracking: typeof data["state-proof-tracking"] !== "undefined" ? data["state-proof-tracking"].map(StateProofTracking.from_obj_for_encoding) : undefined,
            transactions: typeof data["transactions"] !== "undefined" ? data["transactions"].map(Transaction.from_obj_for_encoding) : undefined,
            txnCounter: data["txn-counter"],
            upgradeState: typeof data["upgrade-state"] !== "undefined" ? BlockUpgradeState.from_obj_for_encoding(data["upgrade-state"]) : undefined,
            upgradeVote: typeof data["upgrade-vote"] !== "undefined" ? BlockUpgradeVote.from_obj_for_encoding(data["upgrade-vote"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class BlockRewards extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BlockRewards` object.
     * @param feeSink - (fees) accepts transaction fees, it can only spend to the incentive pool.
     * @param rewardsCalculationRound - (rwcalr) number of leftover MicroAlgos after the distribution of rewards-rate
     * MicroAlgos for every reward unit in the next round.
     * @param rewardsLevel - (earn) How many rewards, in MicroAlgos, have been distributed to each RewardUnit
     * of MicroAlgos since genesis.
     * @param rewardsPool - (rwd) accepts periodic injections from the fee-sink and continually
     * redistributes them as rewards.
     * @param rewardsRate - (rate) Number of new MicroAlgos added to the participation stake from rewards at
     * the next round.
     * @param rewardsResidue - (frac) Number of leftover MicroAlgos after the distribution of
     * RewardsRate/rewardUnits MicroAlgos for every reward unit in the next round.
     */ constructor({ feeSink , rewardsCalculationRound , rewardsLevel , rewardsPool , rewardsRate , rewardsResidue  }){
        super();
        this.feeSink = feeSink;
        this.rewardsCalculationRound = rewardsCalculationRound;
        this.rewardsLevel = rewardsLevel;
        this.rewardsPool = rewardsPool;
        this.rewardsRate = rewardsRate;
        this.rewardsResidue = rewardsResidue;
        this.attribute_map = {
            feeSink: "fee-sink",
            rewardsCalculationRound: "rewards-calculation-round",
            rewardsLevel: "rewards-level",
            rewardsPool: "rewards-pool",
            rewardsRate: "rewards-rate",
            rewardsResidue: "rewards-residue"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["fee-sink"] === "undefined") throw new Error(`Response is missing required field 'fee-sink': ${data}`);
        if (typeof data["rewards-calculation-round"] === "undefined") throw new Error(`Response is missing required field 'rewards-calculation-round': ${data}`);
        if (typeof data["rewards-level"] === "undefined") throw new Error(`Response is missing required field 'rewards-level': ${data}`);
        if (typeof data["rewards-pool"] === "undefined") throw new Error(`Response is missing required field 'rewards-pool': ${data}`);
        if (typeof data["rewards-rate"] === "undefined") throw new Error(`Response is missing required field 'rewards-rate': ${data}`);
        if (typeof data["rewards-residue"] === "undefined") throw new Error(`Response is missing required field 'rewards-residue': ${data}`);
        return new BlockRewards({
            feeSink: data["fee-sink"],
            rewardsCalculationRound: data["rewards-calculation-round"],
            rewardsLevel: data["rewards-level"],
            rewardsPool: data["rewards-pool"],
            rewardsRate: data["rewards-rate"],
            rewardsResidue: data["rewards-residue"]
        });
    /* eslint-enable dot-notation */ }
}
class BlockUpgradeState extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BlockUpgradeState` object.
     * @param currentProtocol - (proto) The current protocol version.
     * @param nextProtocol - (nextproto) The next proposed protocol version.
     * @param nextProtocolApprovals - (nextyes) Number of blocks which approved the protocol upgrade.
     * @param nextProtocolSwitchOn - (nextswitch) Round on which the protocol upgrade will take effect.
     * @param nextProtocolVoteBefore - (nextbefore) Deadline round for this protocol upgrade (No votes will be consider
     * after this round).
     */ constructor({ currentProtocol , nextProtocol , nextProtocolApprovals , nextProtocolSwitchOn , nextProtocolVoteBefore  }){
        super();
        this.currentProtocol = currentProtocol;
        this.nextProtocol = nextProtocol;
        this.nextProtocolApprovals = nextProtocolApprovals;
        this.nextProtocolSwitchOn = nextProtocolSwitchOn;
        this.nextProtocolVoteBefore = nextProtocolVoteBefore;
        this.attribute_map = {
            currentProtocol: "current-protocol",
            nextProtocol: "next-protocol",
            nextProtocolApprovals: "next-protocol-approvals",
            nextProtocolSwitchOn: "next-protocol-switch-on",
            nextProtocolVoteBefore: "next-protocol-vote-before"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["current-protocol"] === "undefined") throw new Error(`Response is missing required field 'current-protocol': ${data}`);
        return new BlockUpgradeState({
            currentProtocol: data["current-protocol"],
            nextProtocol: data["next-protocol"],
            nextProtocolApprovals: data["next-protocol-approvals"],
            nextProtocolSwitchOn: data["next-protocol-switch-on"],
            nextProtocolVoteBefore: data["next-protocol-vote-before"]
        });
    /* eslint-enable dot-notation */ }
}
class BlockUpgradeVote extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BlockUpgradeVote` object.
     * @param upgradeApprove - (upgradeyes) Indicates a yes vote for the current proposal.
     * @param upgradeDelay - (upgradedelay) Indicates the time between acceptance and execution.
     * @param upgradePropose - (upgradeprop) Indicates a proposed upgrade.
     */ constructor({ upgradeApprove , upgradeDelay , upgradePropose  }){
        super();
        this.upgradeApprove = upgradeApprove;
        this.upgradeDelay = upgradeDelay;
        this.upgradePropose = upgradePropose;
        this.attribute_map = {
            upgradeApprove: "upgrade-approve",
            upgradeDelay: "upgrade-delay",
            upgradePropose: "upgrade-propose"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new BlockUpgradeVote({
            upgradeApprove: data["upgrade-approve"],
            upgradeDelay: data["upgrade-delay"],
            upgradePropose: data["upgrade-propose"]
        });
    /* eslint-enable dot-notation */ }
}
class Box extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Box` object.
     * @param name - (name) box name, base64 encoded
     * @param value - (value) box value, base64 encoded.
     */ constructor({ name , value  }){
        super();
        this.name = typeof name === "string" ? new Uint8Array((0, _buffer.Buffer).from(name, "base64")) : name;
        this.value = typeof value === "string" ? new Uint8Array((0, _buffer.Buffer).from(value, "base64")) : value;
        this.attribute_map = {
            name: "name",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["name"] === "undefined") throw new Error(`Response is missing required field 'name': ${data}`);
        if (typeof data["value"] === "undefined") throw new Error(`Response is missing required field 'value': ${data}`);
        return new Box({
            name: data["name"],
            value: data["value"]
        });
    /* eslint-enable dot-notation */ }
}
class BoxDescriptor extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BoxDescriptor` object.
     * @param name - Base64 encoded box name
     */ constructor({ name  }){
        super();
        this.name = typeof name === "string" ? new Uint8Array((0, _buffer.Buffer).from(name, "base64")) : name;
        this.attribute_map = {
            name: "name"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["name"] === "undefined") throw new Error(`Response is missing required field 'name': ${data}`);
        return new BoxDescriptor({
            name: data["name"]
        });
    /* eslint-enable dot-notation */ }
}
class BoxesResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `BoxesResponse` object.
     * @param applicationId - (appidx) application index.
     * @param boxes -
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ applicationId , boxes , nextToken  }){
        super();
        this.applicationId = applicationId;
        this.boxes = boxes;
        this.nextToken = nextToken;
        this.attribute_map = {
            applicationId: "application-id",
            boxes: "boxes",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["application-id"] === "undefined") throw new Error(`Response is missing required field 'application-id': ${data}`);
        if (!Array.isArray(data["boxes"])) throw new Error(`Response is missing required array field 'boxes': ${data}`);
        return new BoxesResponse({
            applicationId: data["application-id"],
            boxes: data["boxes"].map(BoxDescriptor.from_obj_for_encoding),
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}
class ErrorResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ErrorResponse` object.
     * @param message -
     * @param data -
     */ constructor({ message , data  }){
        super();
        this.message = message;
        this.data = data;
        this.attribute_map = {
            message: "message",
            data: "data"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["message"] === "undefined") throw new Error(`Response is missing required field 'message': ${data}`);
        return new ErrorResponse({
            message: data["message"],
            data: data["data"]
        });
    /* eslint-enable dot-notation */ }
}
class EvalDelta extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `EvalDelta` object.
     * @param action - (at) delta action.
     * @param bytes - (bs) bytes value.
     * @param uint - (ui) uint value.
     */ constructor({ action , bytes , uint  }){
        super();
        this.action = action;
        this.bytes = bytes;
        this.uint = uint;
        this.attribute_map = {
            action: "action",
            bytes: "bytes",
            uint: "uint"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["action"] === "undefined") throw new Error(`Response is missing required field 'action': ${data}`);
        return new EvalDelta({
            action: data["action"],
            bytes: data["bytes"],
            uint: data["uint"]
        });
    /* eslint-enable dot-notation */ }
}
class EvalDeltaKeyValue extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `EvalDeltaKeyValue` object.
     * @param key -
     * @param value - Represents a TEAL value delta.
     */ constructor({ key , value  }){
        super();
        this.key = key;
        this.value = value;
        this.attribute_map = {
            key: "key",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["key"] === "undefined") throw new Error(`Response is missing required field 'key': ${data}`);
        if (typeof data["value"] === "undefined") throw new Error(`Response is missing required field 'value': ${data}`);
        return new EvalDeltaKeyValue({
            key: data["key"],
            value: EvalDelta.from_obj_for_encoding(data["value"])
        });
    /* eslint-enable dot-notation */ }
}
class HashFactory extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `HashFactory` object.
     * @param hashType - (t)
     */ constructor({ hashType  }){
        super();
        this.hashType = hashType;
        this.attribute_map = {
            hashType: "hash-type"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new HashFactory({
            hashType: data["hash-type"]
        });
    /* eslint-enable dot-notation */ }
}
class HealthCheck extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `HealthCheck` object.
     * @param dbAvailable -
     * @param isMigrating -
     * @param message -
     * @param round -
     * @param version - Current version.
     * @param data -
     * @param errors -
     */ constructor({ dbAvailable , isMigrating , message , round , version , data , errors  }){
        super();
        this.dbAvailable = dbAvailable;
        this.isMigrating = isMigrating;
        this.message = message;
        this.round = round;
        this.version = version;
        this.data = data;
        this.errors = errors;
        this.attribute_map = {
            dbAvailable: "db-available",
            isMigrating: "is-migrating",
            message: "message",
            round: "round",
            version: "version",
            data: "data",
            errors: "errors"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["db-available"] === "undefined") throw new Error(`Response is missing required field 'db-available': ${data}`);
        if (typeof data["is-migrating"] === "undefined") throw new Error(`Response is missing required field 'is-migrating': ${data}`);
        if (typeof data["message"] === "undefined") throw new Error(`Response is missing required field 'message': ${data}`);
        if (typeof data["round"] === "undefined") throw new Error(`Response is missing required field 'round': ${data}`);
        if (typeof data["version"] === "undefined") throw new Error(`Response is missing required field 'version': ${data}`);
        return new HealthCheck({
            dbAvailable: data["db-available"],
            isMigrating: data["is-migrating"],
            message: data["message"],
            round: data["round"],
            version: data["version"],
            data: data["data"],
            errors: data["errors"]
        });
    /* eslint-enable dot-notation */ }
}
class IndexerStateProofMessage extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `IndexerStateProofMessage` object.
     * @param blockHeadersCommitment - (b)
     * @param firstAttestedRound - (f)
     * @param latestAttestedRound - (l)
     * @param lnProvenWeight - (P)
     * @param votersCommitment - (v)
     */ constructor({ blockHeadersCommitment , firstAttestedRound , latestAttestedRound , lnProvenWeight , votersCommitment  }){
        super();
        this.blockHeadersCommitment = typeof blockHeadersCommitment === "string" ? new Uint8Array((0, _buffer.Buffer).from(blockHeadersCommitment, "base64")) : blockHeadersCommitment;
        this.firstAttestedRound = firstAttestedRound;
        this.latestAttestedRound = latestAttestedRound;
        this.lnProvenWeight = lnProvenWeight;
        this.votersCommitment = typeof votersCommitment === "string" ? new Uint8Array((0, _buffer.Buffer).from(votersCommitment, "base64")) : votersCommitment;
        this.attribute_map = {
            blockHeadersCommitment: "block-headers-commitment",
            firstAttestedRound: "first-attested-round",
            latestAttestedRound: "latest-attested-round",
            lnProvenWeight: "ln-proven-weight",
            votersCommitment: "voters-commitment"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new IndexerStateProofMessage({
            blockHeadersCommitment: data["block-headers-commitment"],
            firstAttestedRound: data["first-attested-round"],
            latestAttestedRound: data["latest-attested-round"],
            lnProvenWeight: data["ln-proven-weight"],
            votersCommitment: data["voters-commitment"]
        });
    /* eslint-enable dot-notation */ }
}
class MerkleArrayProof extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `MerkleArrayProof` object.
     * @param hashFactory -
     * @param path - (pth)
     * @param treeDepth - (td)
     */ constructor({ hashFactory , path , treeDepth  }){
        super();
        this.hashFactory = hashFactory;
        this.path = path;
        this.treeDepth = treeDepth;
        this.attribute_map = {
            hashFactory: "hash-factory",
            path: "path",
            treeDepth: "tree-depth"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new MerkleArrayProof({
            hashFactory: typeof data["hash-factory"] !== "undefined" ? HashFactory.from_obj_for_encoding(data["hash-factory"]) : undefined,
            path: data["path"],
            treeDepth: data["tree-depth"]
        });
    /* eslint-enable dot-notation */ }
}
class MiniAssetHolding extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `MiniAssetHolding` object.
     * @param address -
     * @param amount -
     * @param isFrozen -
     * @param deleted - Whether or not this asset holding is currently deleted from its account.
     * @param optedInAtRound - Round during which the account opted into the asset.
     * @param optedOutAtRound - Round during which the account opted out of the asset.
     */ constructor({ address , amount , isFrozen , deleted , optedInAtRound , optedOutAtRound  }){
        super();
        this.address = address;
        this.amount = amount;
        this.isFrozen = isFrozen;
        this.deleted = deleted;
        this.optedInAtRound = optedInAtRound;
        this.optedOutAtRound = optedOutAtRound;
        this.attribute_map = {
            address: "address",
            amount: "amount",
            isFrozen: "is-frozen",
            deleted: "deleted",
            optedInAtRound: "opted-in-at-round",
            optedOutAtRound: "opted-out-at-round"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["address"] === "undefined") throw new Error(`Response is missing required field 'address': ${data}`);
        if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["is-frozen"] === "undefined") throw new Error(`Response is missing required field 'is-frozen': ${data}`);
        return new MiniAssetHolding({
            address: data["address"],
            amount: data["amount"],
            isFrozen: data["is-frozen"],
            deleted: data["deleted"],
            optedInAtRound: data["opted-in-at-round"],
            optedOutAtRound: data["opted-out-at-round"]
        });
    /* eslint-enable dot-notation */ }
}
class ParticipationUpdates extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `ParticipationUpdates` object.
     * @param expiredParticipationAccounts - (partupdrmv) a list of online accounts that needs to be converted to offline
     * since their participation key expired.
     */ constructor({ expiredParticipationAccounts  }){
        super();
        this.expiredParticipationAccounts = expiredParticipationAccounts;
        this.attribute_map = {
            expiredParticipationAccounts: "expired-participation-accounts"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new ParticipationUpdates({
            expiredParticipationAccounts: data["expired-participation-accounts"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProofFields extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofFields` object.
     * @param partProofs - (P)
     * @param positionsToReveal - (pr) Sequence of reveal positions.
     * @param reveals - (r) Note that this is actually stored as a map[uint64] - Reveal in the actual
     * msgp
     * @param saltVersion - (v) Salt version of the merkle signature.
     * @param sigCommit - (c)
     * @param sigProofs - (S)
     * @param signedWeight - (w)
     */ constructor({ partProofs , positionsToReveal , reveals , saltVersion , sigCommit , sigProofs , signedWeight  }){
        super();
        this.partProofs = partProofs;
        this.positionsToReveal = positionsToReveal;
        this.reveals = reveals;
        this.saltVersion = saltVersion;
        this.sigCommit = typeof sigCommit === "string" ? new Uint8Array((0, _buffer.Buffer).from(sigCommit, "base64")) : sigCommit;
        this.sigProofs = sigProofs;
        this.signedWeight = signedWeight;
        this.attribute_map = {
            partProofs: "part-proofs",
            positionsToReveal: "positions-to-reveal",
            reveals: "reveals",
            saltVersion: "salt-version",
            sigCommit: "sig-commit",
            sigProofs: "sig-proofs",
            signedWeight: "signed-weight"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofFields({
            partProofs: typeof data["part-proofs"] !== "undefined" ? MerkleArrayProof.from_obj_for_encoding(data["part-proofs"]) : undefined,
            positionsToReveal: data["positions-to-reveal"],
            reveals: typeof data["reveals"] !== "undefined" ? data["reveals"].map(StateProofReveal.from_obj_for_encoding) : undefined,
            saltVersion: data["salt-version"],
            sigCommit: data["sig-commit"],
            sigProofs: typeof data["sig-proofs"] !== "undefined" ? MerkleArrayProof.from_obj_for_encoding(data["sig-proofs"]) : undefined,
            signedWeight: data["signed-weight"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProofParticipant extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofParticipant` object.
     * @param verifier - (p)
     * @param weight - (w)
     */ constructor({ verifier , weight  }){
        super();
        this.verifier = verifier;
        this.weight = weight;
        this.attribute_map = {
            verifier: "verifier",
            weight: "weight"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofParticipant({
            verifier: typeof data["verifier"] !== "undefined" ? StateProofVerifier.from_obj_for_encoding(data["verifier"]) : undefined,
            weight: data["weight"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProofReveal extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofReveal` object.
     * @param participant - (p)
     * @param position - The position in the signature and participants arrays corresponding to this
     * entry.
     * @param sigSlot - (s)
     */ constructor({ participant , position , sigSlot  }){
        super();
        this.participant = participant;
        this.position = position;
        this.sigSlot = sigSlot;
        this.attribute_map = {
            participant: "participant",
            position: "position",
            sigSlot: "sig-slot"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofReveal({
            participant: typeof data["participant"] !== "undefined" ? StateProofParticipant.from_obj_for_encoding(data["participant"]) : undefined,
            position: data["position"],
            sigSlot: typeof data["sig-slot"] !== "undefined" ? StateProofSigSlot.from_obj_for_encoding(data["sig-slot"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class StateProofSigSlot extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofSigSlot` object.
     * @param lowerSigWeight - (l) The total weight of signatures in the lower-numbered slots.
     * @param signature -
     */ constructor({ lowerSigWeight , signature  }){
        super();
        this.lowerSigWeight = lowerSigWeight;
        this.signature = signature;
        this.attribute_map = {
            lowerSigWeight: "lower-sig-weight",
            signature: "signature"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofSigSlot({
            lowerSigWeight: data["lower-sig-weight"],
            signature: typeof data["signature"] !== "undefined" ? StateProofSignature.from_obj_for_encoding(data["signature"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class StateProofSignature extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofSignature` object.
     * @param falconSignature -
     * @param merkleArrayIndex -
     * @param proof -
     * @param verifyingKey - (vkey)
     */ constructor({ falconSignature , merkleArrayIndex , proof , verifyingKey  }){
        super();
        this.falconSignature = typeof falconSignature === "string" ? new Uint8Array((0, _buffer.Buffer).from(falconSignature, "base64")) : falconSignature;
        this.merkleArrayIndex = merkleArrayIndex;
        this.proof = proof;
        this.verifyingKey = typeof verifyingKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(verifyingKey, "base64")) : verifyingKey;
        this.attribute_map = {
            falconSignature: "falcon-signature",
            merkleArrayIndex: "merkle-array-index",
            proof: "proof",
            verifyingKey: "verifying-key"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofSignature({
            falconSignature: data["falcon-signature"],
            merkleArrayIndex: data["merkle-array-index"],
            proof: typeof data["proof"] !== "undefined" ? MerkleArrayProof.from_obj_for_encoding(data["proof"]) : undefined,
            verifyingKey: data["verifying-key"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProofTracking extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofTracking` object.
     * @param nextRound - (n) Next round for which we will accept a state proof transaction.
     * @param onlineTotalWeight - (t) The total number of microalgos held by the online accounts during the
     * StateProof round.
     * @param type - State Proof Type. Note the raw object uses map with this as key.
     * @param votersCommitment - (v) Root of a vector commitment containing online accounts that will help sign
     * the proof.
     */ constructor({ nextRound , onlineTotalWeight , type , votersCommitment  }){
        super();
        this.nextRound = nextRound;
        this.onlineTotalWeight = onlineTotalWeight;
        this.type = type;
        this.votersCommitment = typeof votersCommitment === "string" ? new Uint8Array((0, _buffer.Buffer).from(votersCommitment, "base64")) : votersCommitment;
        this.attribute_map = {
            nextRound: "next-round",
            onlineTotalWeight: "online-total-weight",
            type: "type",
            votersCommitment: "voters-commitment"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofTracking({
            nextRound: data["next-round"],
            onlineTotalWeight: data["online-total-weight"],
            type: data["type"],
            votersCommitment: data["voters-commitment"]
        });
    /* eslint-enable dot-notation */ }
}
class StateProofVerifier extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateProofVerifier` object.
     * @param commitment - (cmt) Represents the root of the vector commitment tree.
     * @param keyLifetime - (lf) Key lifetime.
     */ constructor({ commitment , keyLifetime  }){
        super();
        this.commitment = typeof commitment === "string" ? new Uint8Array((0, _buffer.Buffer).from(commitment, "base64")) : commitment;
        this.keyLifetime = keyLifetime;
        this.attribute_map = {
            commitment: "commitment",
            keyLifetime: "key-lifetime"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new StateProofVerifier({
            commitment: data["commitment"],
            keyLifetime: data["key-lifetime"]
        });
    /* eslint-enable dot-notation */ }
}
class StateSchema extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `StateSchema` object.
     * @param numByteSlice - Maximum number of TEAL byte slices that may be stored in the key/value store.
     * @param numUint - Maximum number of TEAL uints that may be stored in the key/value store.
     */ constructor({ numByteSlice , numUint  }){
        super();
        this.numByteSlice = numByteSlice;
        this.numUint = numUint;
        this.attribute_map = {
            numByteSlice: "num-byte-slice",
            numUint: "num-uint"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["num-byte-slice"] === "undefined") throw new Error(`Response is missing required field 'num-byte-slice': ${data}`);
        if (typeof data["num-uint"] === "undefined") throw new Error(`Response is missing required field 'num-uint': ${data}`);
        return new StateSchema({
            numByteSlice: data["num-byte-slice"],
            numUint: data["num-uint"]
        });
    /* eslint-enable dot-notation */ }
}
class TealKeyValue extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TealKeyValue` object.
     * @param key -
     * @param value - Represents a TEAL value.
     */ constructor({ key , value  }){
        super();
        this.key = key;
        this.value = value;
        this.attribute_map = {
            key: "key",
            value: "value"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["key"] === "undefined") throw new Error(`Response is missing required field 'key': ${data}`);
        if (typeof data["value"] === "undefined") throw new Error(`Response is missing required field 'value': ${data}`);
        return new TealKeyValue({
            key: data["key"],
            value: TealValue.from_obj_for_encoding(data["value"])
        });
    /* eslint-enable dot-notation */ }
}
class TealValue extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TealValue` object.
     * @param bytes - (tb) bytes value.
     * @param type - (tt) value type. Value `1` refers to **bytes**, value `2` refers to **uint**
     * @param uint - (ui) uint value.
     */ constructor({ bytes , type , uint  }){
        super();
        this.bytes = bytes;
        this.type = type;
        this.uint = uint;
        this.attribute_map = {
            bytes: "bytes",
            type: "type",
            uint: "uint"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["bytes"] === "undefined") throw new Error(`Response is missing required field 'bytes': ${data}`);
        if (typeof data["type"] === "undefined") throw new Error(`Response is missing required field 'type': ${data}`);
        if (typeof data["uint"] === "undefined") throw new Error(`Response is missing required field 'uint': ${data}`);
        return new TealValue({
            bytes: data["bytes"],
            type: data["type"],
            uint: data["uint"]
        });
    /* eslint-enable dot-notation */ }
}
class Transaction extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `Transaction` object.
     * @param fee - (fee) Transaction fee.
     * @param firstValid - (fv) First valid round for this transaction.
     * @param lastValid - (lv) Last valid round for this transaction.
     * @param sender - (snd) Sender's address.
     * @param applicationTransaction - Fields for application transactions.
     * Definition:
     * data/transactions/application.go : ApplicationCallTxnFields
     * @param assetConfigTransaction - Fields for asset allocation, re-configuration, and destruction.
     * A zero value for asset-id indicates asset creation.
     * A zero value for the params indicates asset destruction.
     * Definition:
     * data/transactions/asset.go : AssetConfigTxnFields
     * @param assetFreezeTransaction - Fields for an asset freeze transaction.
     * Definition:
     * data/transactions/asset.go : AssetFreezeTxnFields
     * @param assetTransferTransaction - Fields for an asset transfer transaction.
     * Definition:
     * data/transactions/asset.go : AssetTransferTxnFields
     * @param authAddr - (sgnr) this is included with signed transactions when the signing address does
     * not equal the sender. The backend can use this to ensure that auth addr is equal
     * to the accounts auth addr.
     * @param closeRewards - (rc) rewards applied to close-remainder-to account.
     * @param closingAmount - (ca) closing amount for transaction.
     * @param confirmedRound - Round when the transaction was confirmed.
     * @param createdApplicationIndex - Specifies an application index (ID) if an application was created with this
     * transaction.
     * @param createdAssetIndex - Specifies an asset index (ID) if an asset was created with this transaction.
     * @param genesisHash - (gh) Hash of genesis block.
     * @param genesisId - (gen) genesis block ID.
     * @param globalStateDelta - (gd) Global state key/value changes for the application being executed by this
     * transaction.
     * @param group - (grp) Base64 encoded byte array of a sha512/256 digest. When present indicates
     * that this transaction is part of a transaction group and the value is the
     * sha512/256 hash of the transactions in that group.
     * @param id - Transaction ID
     * @param innerTxns - Inner transactions produced by application execution.
     * @param intraRoundOffset - Offset into the round where this transaction was confirmed.
     * @param keyregTransaction - Fields for a keyreg transaction.
     * Definition:
     * data/transactions/keyreg.go : KeyregTxnFields
     * @param lease - (lx) Base64 encoded 32-byte array. Lease enforces mutual exclusion of
     * transactions. If this field is nonzero, then once the transaction is confirmed,
     * it acquires the lease identified by the (Sender, Lease) pair of the transaction
     * until the LastValid round passes. While this transaction possesses the lease, no
     * other transaction specifying this lease can be confirmed.
     * @param localStateDelta - (ld) Local state key/value changes for the application being executed by this
     * transaction.
     * @param logs - (lg) Logs for the application being executed by this transaction.
     * @param note - (note) Free form data.
     * @param paymentTransaction - Fields for a payment transaction.
     * Definition:
     * data/transactions/payment.go : PaymentTxnFields
     * @param receiverRewards - (rr) rewards applied to receiver account.
     * @param rekeyTo - (rekey) when included in a valid transaction, the accounts auth addr will be
     * updated with this value and future signatures must be signed with the key
     * represented by this address.
     * @param roundTime - Time when the block this transaction is in was confirmed.
     * @param senderRewards - (rs) rewards applied to sender account.
     * @param signature - Validation signature associated with some data. Only one of the signatures
     * should be provided.
     * @param stateProofTransaction - Fields for a state proof transaction.
     * Definition:
     * data/transactions/stateproof.go : StateProofTxnFields
     * @param txType - (type) Indicates what type of transaction this is. Different types have
     * different fields.
     * Valid types, and where their fields are stored:
     * * (pay) payment-transaction
     * * (keyreg) keyreg-transaction
     * * (acfg) asset-config-transaction
     * * (axfer) asset-transfer-transaction
     * * (afrz) asset-freeze-transaction
     * * (appl) application-transaction
     * * (stpf) state-proof-transaction
     */ constructor({ fee , firstValid , lastValid , sender , applicationTransaction , assetConfigTransaction , assetFreezeTransaction , assetTransferTransaction , authAddr , closeRewards , closingAmount , confirmedRound , createdApplicationIndex , createdAssetIndex , genesisHash , genesisId , globalStateDelta , group , id , innerTxns , intraRoundOffset , keyregTransaction , lease , localStateDelta , logs , note , paymentTransaction , receiverRewards , rekeyTo , roundTime , senderRewards , signature , stateProofTransaction , txType  }){
        super();
        this.fee = fee;
        this.firstValid = firstValid;
        this.lastValid = lastValid;
        this.sender = sender;
        this.applicationTransaction = applicationTransaction;
        this.assetConfigTransaction = assetConfigTransaction;
        this.assetFreezeTransaction = assetFreezeTransaction;
        this.assetTransferTransaction = assetTransferTransaction;
        this.authAddr = authAddr;
        this.closeRewards = closeRewards;
        this.closingAmount = closingAmount;
        this.confirmedRound = confirmedRound;
        this.createdApplicationIndex = createdApplicationIndex;
        this.createdAssetIndex = createdAssetIndex;
        this.genesisHash = typeof genesisHash === "string" ? new Uint8Array((0, _buffer.Buffer).from(genesisHash, "base64")) : genesisHash;
        this.genesisId = genesisId;
        this.globalStateDelta = globalStateDelta;
        this.group = typeof group === "string" ? new Uint8Array((0, _buffer.Buffer).from(group, "base64")) : group;
        this.id = id;
        this.innerTxns = innerTxns;
        this.intraRoundOffset = intraRoundOffset;
        this.keyregTransaction = keyregTransaction;
        this.lease = typeof lease === "string" ? new Uint8Array((0, _buffer.Buffer).from(lease, "base64")) : lease;
        this.localStateDelta = localStateDelta;
        this.logs = logs;
        this.note = typeof note === "string" ? new Uint8Array((0, _buffer.Buffer).from(note, "base64")) : note;
        this.paymentTransaction = paymentTransaction;
        this.receiverRewards = receiverRewards;
        this.rekeyTo = rekeyTo;
        this.roundTime = roundTime;
        this.senderRewards = senderRewards;
        this.signature = signature;
        this.stateProofTransaction = stateProofTransaction;
        this.txType = txType;
        this.attribute_map = {
            fee: "fee",
            firstValid: "first-valid",
            lastValid: "last-valid",
            sender: "sender",
            applicationTransaction: "application-transaction",
            assetConfigTransaction: "asset-config-transaction",
            assetFreezeTransaction: "asset-freeze-transaction",
            assetTransferTransaction: "asset-transfer-transaction",
            authAddr: "auth-addr",
            closeRewards: "close-rewards",
            closingAmount: "closing-amount",
            confirmedRound: "confirmed-round",
            createdApplicationIndex: "created-application-index",
            createdAssetIndex: "created-asset-index",
            genesisHash: "genesis-hash",
            genesisId: "genesis-id",
            globalStateDelta: "global-state-delta",
            group: "group",
            id: "id",
            innerTxns: "inner-txns",
            intraRoundOffset: "intra-round-offset",
            keyregTransaction: "keyreg-transaction",
            lease: "lease",
            localStateDelta: "local-state-delta",
            logs: "logs",
            note: "note",
            paymentTransaction: "payment-transaction",
            receiverRewards: "receiver-rewards",
            rekeyTo: "rekey-to",
            roundTime: "round-time",
            senderRewards: "sender-rewards",
            signature: "signature",
            stateProofTransaction: "state-proof-transaction",
            txType: "tx-type"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["fee"] === "undefined") throw new Error(`Response is missing required field 'fee': ${data}`);
        if (typeof data["first-valid"] === "undefined") throw new Error(`Response is missing required field 'first-valid': ${data}`);
        if (typeof data["last-valid"] === "undefined") throw new Error(`Response is missing required field 'last-valid': ${data}`);
        if (typeof data["sender"] === "undefined") throw new Error(`Response is missing required field 'sender': ${data}`);
        return new Transaction({
            fee: data["fee"],
            firstValid: data["first-valid"],
            lastValid: data["last-valid"],
            sender: data["sender"],
            applicationTransaction: typeof data["application-transaction"] !== "undefined" ? TransactionApplication.from_obj_for_encoding(data["application-transaction"]) : undefined,
            assetConfigTransaction: typeof data["asset-config-transaction"] !== "undefined" ? TransactionAssetConfig.from_obj_for_encoding(data["asset-config-transaction"]) : undefined,
            assetFreezeTransaction: typeof data["asset-freeze-transaction"] !== "undefined" ? TransactionAssetFreeze.from_obj_for_encoding(data["asset-freeze-transaction"]) : undefined,
            assetTransferTransaction: typeof data["asset-transfer-transaction"] !== "undefined" ? TransactionAssetTransfer.from_obj_for_encoding(data["asset-transfer-transaction"]) : undefined,
            authAddr: data["auth-addr"],
            closeRewards: data["close-rewards"],
            closingAmount: data["closing-amount"],
            confirmedRound: data["confirmed-round"],
            createdApplicationIndex: data["created-application-index"],
            createdAssetIndex: data["created-asset-index"],
            genesisHash: data["genesis-hash"],
            genesisId: data["genesis-id"],
            globalStateDelta: typeof data["global-state-delta"] !== "undefined" ? data["global-state-delta"].map(EvalDeltaKeyValue.from_obj_for_encoding) : undefined,
            group: data["group"],
            id: data["id"],
            innerTxns: typeof data["inner-txns"] !== "undefined" ? data["inner-txns"].map(Transaction.from_obj_for_encoding) : undefined,
            intraRoundOffset: data["intra-round-offset"],
            keyregTransaction: typeof data["keyreg-transaction"] !== "undefined" ? TransactionKeyreg.from_obj_for_encoding(data["keyreg-transaction"]) : undefined,
            lease: data["lease"],
            localStateDelta: typeof data["local-state-delta"] !== "undefined" ? data["local-state-delta"].map(AccountStateDelta.from_obj_for_encoding) : undefined,
            logs: data["logs"],
            note: data["note"],
            paymentTransaction: typeof data["payment-transaction"] !== "undefined" ? TransactionPayment.from_obj_for_encoding(data["payment-transaction"]) : undefined,
            receiverRewards: data["receiver-rewards"],
            rekeyTo: data["rekey-to"],
            roundTime: data["round-time"],
            senderRewards: data["sender-rewards"],
            signature: typeof data["signature"] !== "undefined" ? TransactionSignature.from_obj_for_encoding(data["signature"]) : undefined,
            stateProofTransaction: typeof data["state-proof-transaction"] !== "undefined" ? TransactionStateProof.from_obj_for_encoding(data["state-proof-transaction"]) : undefined,
            txType: data["tx-type"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionApplication extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionApplication` object.
     * @param applicationId - (apid) ID of the application being configured or empty if creating.
     * @param accounts - (apat) List of accounts in addition to the sender that may be accessed from the
     * application's approval-program and clear-state-program.
     * @param applicationArgs - (apaa) transaction specific arguments accessed from the application's
     * approval-program and clear-state-program.
     * @param approvalProgram - (apap) Logic executed for every application transaction, except when
     * on-completion is set to "clear". It can read and write global state for the
     * application, as well as account-specific local state. Approval programs may
     * reject the transaction.
     * @param clearStateProgram - (apsu) Logic executed for application transactions with on-completion set to
     * "clear". It can read and write global state for the application, as well as
     * account-specific local state. Clear state programs cannot reject the
     * transaction.
     * @param extraProgramPages - (epp) specifies the additional app program len requested in pages.
     * @param foreignApps - (apfa) Lists the applications in addition to the application-id whose global
     * states may be accessed by this application's approval-program and
     * clear-state-program. The access is read-only.
     * @param foreignAssets - (apas) lists the assets whose parameters may be accessed by this application's
     * ApprovalProgram and ClearStateProgram. The access is read-only.
     * @param globalStateSchema - Represents a (apls) local-state or (apgs) global-state schema. These schemas
     * determine how much storage may be used in a local-state or global-state for an
     * application. The more space used, the larger minimum balance must be maintained
     * in the account holding the data.
     * @param localStateSchema - Represents a (apls) local-state or (apgs) global-state schema. These schemas
     * determine how much storage may be used in a local-state or global-state for an
     * application. The more space used, the larger minimum balance must be maintained
     * in the account holding the data.
     * @param onCompletion - (apan) defines the what additional actions occur with the transaction.
     * Valid types:
     * * noop
     * * optin
     * * closeout
     * * clear
     * * update
     * * update
     * * delete
     */ constructor({ applicationId , accounts , applicationArgs , approvalProgram , clearStateProgram , extraProgramPages , foreignApps , foreignAssets , globalStateSchema , localStateSchema , onCompletion  }){
        super();
        this.applicationId = applicationId;
        this.accounts = accounts;
        this.applicationArgs = applicationArgs;
        this.approvalProgram = typeof approvalProgram === "string" ? new Uint8Array((0, _buffer.Buffer).from(approvalProgram, "base64")) : approvalProgram;
        this.clearStateProgram = typeof clearStateProgram === "string" ? new Uint8Array((0, _buffer.Buffer).from(clearStateProgram, "base64")) : clearStateProgram;
        this.extraProgramPages = extraProgramPages;
        this.foreignApps = foreignApps;
        this.foreignAssets = foreignAssets;
        this.globalStateSchema = globalStateSchema;
        this.localStateSchema = localStateSchema;
        this.onCompletion = onCompletion;
        this.attribute_map = {
            applicationId: "application-id",
            accounts: "accounts",
            applicationArgs: "application-args",
            approvalProgram: "approval-program",
            clearStateProgram: "clear-state-program",
            extraProgramPages: "extra-program-pages",
            foreignApps: "foreign-apps",
            foreignAssets: "foreign-assets",
            globalStateSchema: "global-state-schema",
            localStateSchema: "local-state-schema",
            onCompletion: "on-completion"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["application-id"] === "undefined") throw new Error(`Response is missing required field 'application-id': ${data}`);
        return new TransactionApplication({
            applicationId: data["application-id"],
            accounts: data["accounts"],
            applicationArgs: data["application-args"],
            approvalProgram: data["approval-program"],
            clearStateProgram: data["clear-state-program"],
            extraProgramPages: data["extra-program-pages"],
            foreignApps: data["foreign-apps"],
            foreignAssets: data["foreign-assets"],
            globalStateSchema: typeof data["global-state-schema"] !== "undefined" ? StateSchema.from_obj_for_encoding(data["global-state-schema"]) : undefined,
            localStateSchema: typeof data["local-state-schema"] !== "undefined" ? StateSchema.from_obj_for_encoding(data["local-state-schema"]) : undefined,
            onCompletion: data["on-completion"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionAssetConfig extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionAssetConfig` object.
     * @param assetId - (xaid) ID of the asset being configured or empty if creating.
     * @param params - AssetParams specifies the parameters for an asset.
     * (apar) when part of an AssetConfig transaction.
     * Definition:
     * data/transactions/asset.go : AssetParams
     */ constructor({ assetId , params  }){
        super();
        this.assetId = assetId;
        this.params = params;
        this.attribute_map = {
            assetId: "asset-id",
            params: "params"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new TransactionAssetConfig({
            assetId: data["asset-id"],
            params: typeof data["params"] !== "undefined" ? AssetParams.from_obj_for_encoding(data["params"]) : undefined
        });
    /* eslint-enable dot-notation */ }
}
class TransactionAssetFreeze extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionAssetFreeze` object.
     * @param address - (fadd) Address of the account whose asset is being frozen or thawed.
     * @param assetId - (faid) ID of the asset being frozen or thawed.
     * @param newFreezeStatus - (afrz) The new freeze status.
     */ constructor({ address , assetId , newFreezeStatus  }){
        super();
        this.address = address;
        this.assetId = assetId;
        this.newFreezeStatus = newFreezeStatus;
        this.attribute_map = {
            address: "address",
            assetId: "asset-id",
            newFreezeStatus: "new-freeze-status"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["address"] === "undefined") throw new Error(`Response is missing required field 'address': ${data}`);
        if (typeof data["asset-id"] === "undefined") throw new Error(`Response is missing required field 'asset-id': ${data}`);
        if (typeof data["new-freeze-status"] === "undefined") throw new Error(`Response is missing required field 'new-freeze-status': ${data}`);
        return new TransactionAssetFreeze({
            address: data["address"],
            assetId: data["asset-id"],
            newFreezeStatus: data["new-freeze-status"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionAssetTransfer extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionAssetTransfer` object.
     * @param amount - (aamt) Amount of asset to transfer. A zero amount transferred to self allocates
     * that asset in the account's Assets map.
     * @param assetId - (xaid) ID of the asset being transferred.
     * @param receiver - (arcv) Recipient address of the transfer.
     * @param closeAmount - Number of assets transfered to the close-to account as part of the transaction.
     * @param closeTo - (aclose) Indicates that the asset should be removed from the account's Assets
     * map, and specifies where the remaining asset holdings should be transferred.
     * It's always valid to transfer remaining asset holdings to the creator account.
     * @param sender - (asnd) The effective sender during a clawback transactions. If this is not a
     * zero value, the real transaction sender must be the Clawback address from the
     * AssetParams.
     */ constructor({ amount , assetId , receiver , closeAmount , closeTo , sender  }){
        super();
        this.amount = amount;
        this.assetId = assetId;
        this.receiver = receiver;
        this.closeAmount = closeAmount;
        this.closeTo = closeTo;
        this.sender = sender;
        this.attribute_map = {
            amount: "amount",
            assetId: "asset-id",
            receiver: "receiver",
            closeAmount: "close-amount",
            closeTo: "close-to",
            sender: "sender"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["asset-id"] === "undefined") throw new Error(`Response is missing required field 'asset-id': ${data}`);
        if (typeof data["receiver"] === "undefined") throw new Error(`Response is missing required field 'receiver': ${data}`);
        return new TransactionAssetTransfer({
            amount: data["amount"],
            assetId: data["asset-id"],
            receiver: data["receiver"],
            closeAmount: data["close-amount"],
            closeTo: data["close-to"],
            sender: data["sender"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionKeyreg extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionKeyreg` object.
     * @param nonParticipation - (nonpart) Mark the account as participating or non-participating.
     * @param selectionParticipationKey - (selkey) Public key used with the Verified Random Function (VRF) result during
     * committee selection.
     * @param stateProofKey - (sprfkey) State proof key used in key registration transactions.
     * @param voteFirstValid - (votefst) First round this participation key is valid.
     * @param voteKeyDilution - (votekd) Number of subkeys in each batch of participation keys.
     * @param voteLastValid - (votelst) Last round this participation key is valid.
     * @param voteParticipationKey - (votekey) Participation public key used in key registration transactions.
     */ constructor({ nonParticipation , selectionParticipationKey , stateProofKey , voteFirstValid , voteKeyDilution , voteLastValid , voteParticipationKey  }){
        super();
        this.nonParticipation = nonParticipation;
        this.selectionParticipationKey = typeof selectionParticipationKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(selectionParticipationKey, "base64")) : selectionParticipationKey;
        this.stateProofKey = typeof stateProofKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(stateProofKey, "base64")) : stateProofKey;
        this.voteFirstValid = voteFirstValid;
        this.voteKeyDilution = voteKeyDilution;
        this.voteLastValid = voteLastValid;
        this.voteParticipationKey = typeof voteParticipationKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(voteParticipationKey, "base64")) : voteParticipationKey;
        this.attribute_map = {
            nonParticipation: "non-participation",
            selectionParticipationKey: "selection-participation-key",
            stateProofKey: "state-proof-key",
            voteFirstValid: "vote-first-valid",
            voteKeyDilution: "vote-key-dilution",
            voteLastValid: "vote-last-valid",
            voteParticipationKey: "vote-participation-key"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new TransactionKeyreg({
            nonParticipation: data["non-participation"],
            selectionParticipationKey: data["selection-participation-key"],
            stateProofKey: data["state-proof-key"],
            voteFirstValid: data["vote-first-valid"],
            voteKeyDilution: data["vote-key-dilution"],
            voteLastValid: data["vote-last-valid"],
            voteParticipationKey: data["vote-participation-key"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionPayment extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionPayment` object.
     * @param amount - (amt) number of MicroAlgos intended to be transferred.
     * @param receiver - (rcv) receiver's address.
     * @param closeAmount - Number of MicroAlgos that were sent to the close-remainder-to address when
     * closing the sender account.
     * @param closeRemainderTo - (close) when set, indicates that the sending account should be closed and all
     * remaining funds be transferred to this address.
     */ constructor({ amount , receiver , closeAmount , closeRemainderTo  }){
        super();
        this.amount = amount;
        this.receiver = receiver;
        this.closeAmount = closeAmount;
        this.closeRemainderTo = closeRemainderTo;
        this.attribute_map = {
            amount: "amount",
            receiver: "receiver",
            closeAmount: "close-amount",
            closeRemainderTo: "close-remainder-to"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["amount"] === "undefined") throw new Error(`Response is missing required field 'amount': ${data}`);
        if (typeof data["receiver"] === "undefined") throw new Error(`Response is missing required field 'receiver': ${data}`);
        return new TransactionPayment({
            amount: data["amount"],
            receiver: data["receiver"],
            closeAmount: data["close-amount"],
            closeRemainderTo: data["close-remainder-to"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionResponse` object.
     * @param currentRound - Round at which the results were computed.
     * @param transaction - Contains all fields common to all transactions and serves as an envelope to all
     * transactions type. Represents both regular and inner transactions.
     * Definition:
     * data/transactions/signedtxn.go : SignedTxn
     * data/transactions/transaction.go : Transaction
     */ constructor({ currentRound , transaction  }){
        super();
        this.currentRound = currentRound;
        this.transaction = transaction;
        this.attribute_map = {
            currentRound: "current-round",
            transaction: "transaction"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        if (typeof data["transaction"] === "undefined") throw new Error(`Response is missing required field 'transaction': ${data}`);
        return new TransactionResponse({
            currentRound: data["current-round"],
            transaction: Transaction.from_obj_for_encoding(data["transaction"])
        });
    /* eslint-enable dot-notation */ }
}
class TransactionSignature extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionSignature` object.
     * @param logicsig - (lsig) Programatic transaction signature.
     * Definition:
     * data/transactions/logicsig.go
     * @param multisig - (msig) structure holding multiple subsignatures.
     * Definition:
     * crypto/multisig.go : MultisigSig
     * @param sig - (sig) Standard ed25519 signature.
     */ constructor({ logicsig , multisig , sig  }){
        super();
        this.logicsig = logicsig;
        this.multisig = multisig;
        this.sig = typeof sig === "string" ? new Uint8Array((0, _buffer.Buffer).from(sig, "base64")) : sig;
        this.attribute_map = {
            logicsig: "logicsig",
            multisig: "multisig",
            sig: "sig"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new TransactionSignature({
            logicsig: typeof data["logicsig"] !== "undefined" ? TransactionSignatureLogicsig.from_obj_for_encoding(data["logicsig"]) : undefined,
            multisig: typeof data["multisig"] !== "undefined" ? TransactionSignatureMultisig.from_obj_for_encoding(data["multisig"]) : undefined,
            sig: data["sig"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionSignatureLogicsig extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionSignatureLogicsig` object.
     * @param logic - (l) Program signed by a signature or multi signature, or hashed to be the
     * address of ana ccount. Base64 encoded TEAL program.
     * @param args - (arg) Logic arguments, base64 encoded.
     * @param multisigSignature - (msig) structure holding multiple subsignatures.
     * Definition:
     * crypto/multisig.go : MultisigSig
     * @param signature - (sig) ed25519 signature.
     */ constructor({ logic , args , multisigSignature , signature  }){
        super();
        this.logic = typeof logic === "string" ? new Uint8Array((0, _buffer.Buffer).from(logic, "base64")) : logic;
        this.args = args;
        this.multisigSignature = multisigSignature;
        this.signature = typeof signature === "string" ? new Uint8Array((0, _buffer.Buffer).from(signature, "base64")) : signature;
        this.attribute_map = {
            logic: "logic",
            args: "args",
            multisigSignature: "multisig-signature",
            signature: "signature"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["logic"] === "undefined") throw new Error(`Response is missing required field 'logic': ${data}`);
        return new TransactionSignatureLogicsig({
            logic: data["logic"],
            args: data["args"],
            multisigSignature: typeof data["multisig-signature"] !== "undefined" ? TransactionSignatureMultisig.from_obj_for_encoding(data["multisig-signature"]) : undefined,
            signature: data["signature"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionSignatureMultisig extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionSignatureMultisig` object.
     * @param subsignature - (subsig) holds pairs of public key and signatures.
     * @param threshold - (thr)
     * @param version - (v)
     */ constructor({ subsignature , threshold , version  }){
        super();
        this.subsignature = subsignature;
        this.threshold = threshold;
        this.version = version;
        this.attribute_map = {
            subsignature: "subsignature",
            threshold: "threshold",
            version: "version"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new TransactionSignatureMultisig({
            subsignature: typeof data["subsignature"] !== "undefined" ? data["subsignature"].map(TransactionSignatureMultisigSubsignature.from_obj_for_encoding) : undefined,
            threshold: data["threshold"],
            version: data["version"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionSignatureMultisigSubsignature extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionSignatureMultisigSubsignature` object.
     * @param publicKey - (pk)
     * @param signature - (s)
     */ constructor({ publicKey , signature  }){
        super();
        this.publicKey = typeof publicKey === "string" ? new Uint8Array((0, _buffer.Buffer).from(publicKey, "base64")) : publicKey;
        this.signature = typeof signature === "string" ? new Uint8Array((0, _buffer.Buffer).from(signature, "base64")) : signature;
        this.attribute_map = {
            publicKey: "public-key",
            signature: "signature"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new TransactionSignatureMultisigSubsignature({
            publicKey: data["public-key"],
            signature: data["signature"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionStateProof extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionStateProof` object.
     * @param message - (spmsg)
     * @param stateProof - (sp) represents a state proof.
     * Definition:
     * crypto/stateproof/structs.go : StateProof
     * @param stateProofType - (sptype) Type of the state proof. Integer representing an entry defined in
     * protocol/stateproof.go
     */ constructor({ message , stateProof , stateProofType  }){
        super();
        this.message = message;
        this.stateProof = stateProof;
        this.stateProofType = stateProofType;
        this.attribute_map = {
            message: "message",
            stateProof: "state-proof",
            stateProofType: "state-proof-type"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ return new TransactionStateProof({
            message: typeof data["message"] !== "undefined" ? IndexerStateProofMessage.from_obj_for_encoding(data["message"]) : undefined,
            stateProof: typeof data["state-proof"] !== "undefined" ? StateProofFields.from_obj_for_encoding(data["state-proof"]) : undefined,
            stateProofType: data["state-proof-type"]
        });
    /* eslint-enable dot-notation */ }
}
class TransactionsResponse extends (0, _basemodelDefault.default) {
    /**
     * Creates a new `TransactionsResponse` object.
     * @param currentRound - Round at which the results were computed.
     * @param transactions -
     * @param nextToken - Used for pagination, when making another request provide this token with the
     * next parameter.
     */ constructor({ currentRound , transactions , nextToken  }){
        super();
        this.currentRound = currentRound;
        this.transactions = transactions;
        this.nextToken = nextToken;
        this.attribute_map = {
            currentRound: "current-round",
            transactions: "transactions",
            nextToken: "next-token"
        };
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(data) {
        /* eslint-disable dot-notation */ if (typeof data["current-round"] === "undefined") throw new Error(`Response is missing required field 'current-round': ${data}`);
        if (!Array.isArray(data["transactions"])) throw new Error(`Response is missing required array field 'transactions': ${data}`);
        return new TransactionsResponse({
            currentRound: data["current-round"],
            transactions: data["transactions"].map(Transaction.from_obj_for_encoding),
            nextToken: data["next-token"]
        });
    /* eslint-enable dot-notation */ }
}

},{"buffer":"jlSk7","../../basemodel":"9uRuH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4q133":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class SearchAccounts extends (0, _jsonrequestDefault.default) {
    /**
     * @returns `/v2/accounts`
     */ // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/accounts";
    }
    /**
     * Filtered results should have an amount greater than this value, as int, representing microAlgos, unless an asset-id is provided, in which case units are in the asset's units.
     *
     * #### Example 1
     * ```typescript
     * const minBalance = 300000;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetID = 163650;
     * const minBalance = 300000;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .assetID(assetID)
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     * @remarks
     * If you are looking for accounts with the currency amount greater than 0, simply construct the query without `currencyGreaterThan` because it doesn't accept `-1`, and passing the `0` `currency-greater-than` value would exclude accounts with a 0 amount.
     *
     * @param greater
     * @category query
     */ currencyGreaterThan(greater) {
        this.query["currency-greater-than"] = greater;
        return this;
    }
    /**
     * Filtered results should have an amount less than this value, as int, representing microAlgos, unless an asset-id is provided, in which case units are in the asset's units.
     *
     * #### Example 1
     * ```typescript
     * const maxBalance = 500000;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetID = 163650;
     * const maxBalance = 500000;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .assetID(assetID)
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * @param lesser
     * @category query
     */ currencyLessThan(lesser) {
        this.query["currency-less-than"] = lesser;
        return this;
    }
    /**
     * Maximum number of results to return.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Asset ID to filter with.
     *
     * #### Example
     * ```typescript
     * const assetID = 163650;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .assetID(assetID)
     *        .do();
     * ```
     *
     * @param id
     * @category query
     */ assetID(id) {
        this.query["asset-id"] = id;
        return this;
    }
    /**
     * The next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     *
     * const accountsPage1 = await indexerClient
     *        .searchAccounts()
     *        .limit(maxResults)
     *        .do();
     *
     * const accountsPage2 = await indexerClient
     *        .searchAccounts()
     *        .limit(maxResults)
     *        .nextToken(accountsPage1["next-token"])
     *        .do();
     * ```
     *
     * @param nextToken - provided by the previous results
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Include results for the specified round.
     *
     * #### Example
     * ```typescript
     * const targetBlock = 18309917;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .round(targetBlock)
     *        .do();
     * ```
     * @remarks For performance reasons, this parameter may be disabled on some configurations.
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Include accounts that use this spending key.
     *
     * #### Example
     * ```typescript
     * const authAddr = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .authAddr(authAddr)
     *        .do();
     * ```
     *
     * @param authAddr
     */ authAddr(authAddr) {
        this.query["auth-addr"] = authAddr;
        return this;
    }
    /**
     * Filter for this application.
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .applicationID(appId)
     *        .do();
     * ```
     *
     * @param applicationID
     * @category query
     */ applicationID(applicationID) {
        this.query["application-id"] = applicationID;
        return this;
    }
    /**
     * Includes all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example 1
     * ```typescript
     * const assetId = 163650;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetId = 163650;
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .includeAll()
     *        .do();
     * ```
     *
     * @param value - default true when called without passing a value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
    /**
     * Exclude additional items such as asset holdings, application local data stored for this account, asset parameters created by this account, and application parameters created by this account.
     *
     * #### Example 1
     * ```typescript
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .exclude("all")
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const accounts = await indexerClient
     *        .searchAccounts()
     *        .exclude("assets,created-assets")
     *        .do();
     * ```
     * @remarks By default, it behaves as exclude=none
     * @param exclude - Array of `all`, `assets`, `created-assets`, `apps-local-state`, `created-apps`, `none`
     * @category query
     */ exclude(exclude) {
        this.query.exclude = exclude;
        return this;
    }
}
exports.default = SearchAccounts;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcV13":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _lookupAccountTransactions = require("./lookupAccountTransactions");
class SearchForTransactions extends (0, _jsonrequestDefault.default) {
    /**
     * @returns `/v2/transactions`
     */ // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/transactions";
    }
    /**
     * Specifies a prefix which must be contained in the note field.
     *
     * #### Example
     * ```typescript
     * const notePrefixBase64Encoded = "Y3JlYXRl";
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .notePrefix(notePrefixBase64Encoded)
     *        .do();
     * ```
     *
     * @param prefix - base64 string or uint8array
     * @category query
     */ notePrefix(prefix) {
        this.query["note-prefix"] = (0, _lookupAccountTransactions.base64StringFunnel)(prefix);
        return this;
    }
    /**
     * Type of transaction to filter with.
     *
     * #### Example
     * ```typescript
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .txType("keyreg")
     *        .do();
     * ```
     *
     * @param type - one of `pay`, `keyreg`, `acfg`, `axfer`, `afrz`, `appl`, `stpf`
     * @category query
     */ txType(type) {
        this.query["tx-type"] = type;
        return this;
    }
    /**
     * Type of signature to filter with.
     * - sig: Standard
     * - msig: MultiSig
     * - lsig: LogicSig
     *
     * #### Example
     * ```typescript
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .sigType("sig")
     *        .do();
     * ```
     *
     * @param type - one of `sig`, `msig`, `lsig`
     * @category query
     */ sigType(type) {
        this.query["sig-type"] = type;
        return this;
    }
    /**
     * Lookup the specific transaction by ID.
     *
     * #### Example
     * ```typescript
     * const txId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .txid(txId)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupTransactionByID(txnId).do()`
     * @param txid
     * @category query
     */ txid(txid) {
        this.query.txid = txid;
        return this;
    }
    /**
     * Include results for the specified round.
     *
     * #### Example
     * ```typescript
     * const targetBlock = 18309917;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .round(targetBlock)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupBlock(targetBlock).do()`
     * @param round
     * @category query
     */ round(round) {
        this.query.round = round;
        return this;
    }
    /**
     * Include results at or after the specified min-round.
     *
     * #### Example
     * ```typescript
     * const minRound = 18309917;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .minRound(minRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ minRound(round) {
        this.query["min-round"] = round;
        return this;
    }
    /**
     * Include results at or before the specified max-round.
     *
     * #### Example
     * ```typescript
     * const maxRound = 18309917;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .maxRound(maxRound)
     *        .do();
     * ```
     *
     * @param round
     * @category query
     */ maxRound(round) {
        this.query["max-round"] = round;
        return this;
    }
    /**
     * Asset ID to filter with.
     *
     * #### Example
     * ```typescript
     * const assetID = 163650;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .assetID(assetID)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupAssetTransactions(assetId).do()`
     * @param id
     * @category query
     */ assetID(id) {
        this.query["asset-id"] = id;
        return this;
    }
    /**
     * Maximum number of results to return.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Include results before the given time.
     *
     * #### Example
     * ```typescript
     * const beforeTime = "2022-02-02T20:20:22.02Z";
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .beforeTime(beforeTime)
     *        .do();
     * ```
     *
     * @param before - rfc3339 string
     * @category query
     */ beforeTime(before) {
        this.query["before-time"] = before;
        return this;
    }
    /**
     * Include results after the given time.
     *
     * #### Example
     * ```typescript
     * const afterTime = "2022-10-21T00:00:11.55Z";
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .afterTime(afterTime)
     *        .do();
     * ```
     *
     * @param after - rfc3339 string
     * @category query
     */ afterTime(after) {
        this.query["after-time"] = after;
        return this;
    }
    /**
     * Filtered results should have an amount greater than this value, as int, representing microAlgos, unless an asset-id is provided, in which case units are in the asset's units.
     *
     * #### Example 1
     * ```typescript
     * const minBalance = 300000;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetID = 163650;
     * const minBalance = 300000;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .assetID(assetID)
     *        .currencyGreaterThan(minBalance - 1)
     *        .do();
     * ```
     * @remarks
     * If you are looking for transactions with the currency amount greater than 0, simply construct the query without `currencyGreaterThan` because it doesn't accept `-1`, and passing the `0` `currency-greater-than` value would exclude transactions with a 0 amount.
     *
     * @param greater
     * @category query
     */ currencyGreaterThan(greater) {
        this.query["currency-greater-than"] = greater;
        return this;
    }
    /**
     * Filtered results should have an amount less than this value, as int, representing microAlgos, unless an asset-id is provided, in which case units are in the asset's units.
     *
     * #### Example 1
     * ```typescript
     * const maxBalance = 500000;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assetID = 163650;
     * const maxBalance = 500000;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .assetID(assetID)
     *        .currencyLessThan(maxBalance + 1)
     *        .do();
     * ```
     *
     * @param lesser
     * @category query
     */ currencyLessThan(lesser) {
        this.query["currency-less-than"] = lesser;
        return this;
    }
    /**
     * Combined with address, defines what address to filter on, as string.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const role = "freeze-target";
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .address(address)
     *        .addressRole(role)
     *        .do();
     * ```
     *
     * @param role - one of `sender`, `receiver`, `freeze-target`
     * @category query
     */ addressRole(role) {
        this.query["address-role"] = role;
        return this;
    }
    /**
     * Only include transactions with this address in one of the transaction fields.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .address(address)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupAccountTransactions(address).do()`
     * @param address
     * @category query
     */ address(address) {
        this.query.address = address;
        return this;
    }
    /**
     * Whether or not to consider the `close-to` field as a receiver when filtering transactions, as bool. Set to `true` to ignore `close-to`.
     *
     * #### Example
     * ```typescript
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .excludeCloseTo(true)
     *        .do();
     * ```
     *
     * @param exclude
     * @category query
     */ excludeCloseTo(exclude) {
        this.query["exclude-close-to"] = exclude;
        return this;
    }
    /**
     * The next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 25;
     *
     * const txnsPage1 = await indexerClient
     *        .searchForTransactions()
     *        .limit(maxResults)
     *        .do();
     *
     * const txnsPage2 = await indexerClient
     *        .searchForTransactions()
     *        .limit(maxResults)
     *        .nextToken(txnsPage1["next-token"])
     *        .do();
     * ```
     *
     * @param nextToken - provided by the previous results
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Whether or not to include rekeying transactions.
     *
     * #### Example
     * ```typescript
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .rekeyTo(false)
     *        .do();
     * ```
     *
     * @param rekeyTo
     * @category query
     */ rekeyTo(rekeyTo) {
        this.query["rekey-to"] = rekeyTo;
        return this;
    }
    /**
     * Filter for this application.
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const txns = await indexerClient
     *        .searchForTransactions()
     *        .applicationID(appId)
     *        .do();
     * ```
     *
     * @param applicationID
     * @category query
     */ applicationID(applicationID) {
        this.query["application-id"] = applicationID;
        return this;
    }
}
exports.default = SearchForTransactions;

},{"../jsonrequest":"eWgGi","./lookupAccountTransactions":"2xtNn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aFuOm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class SearchForAssets extends (0, _jsonrequestDefault.default) {
    /**
     * @returns `/v2/assets`
     */ // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/assets";
    }
    /**
     * Limit results for pagination.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Filter just assets with the given creator address.
     *
     * #### Example
     * ```typescript
     * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .creator(address)
     *        .do();
     * ```
     *
     * @param creator
     * @category query
     */ creator(creator) {
        this.query.creator = creator;
        return this;
    }
    /**
     * Filter just assets with the given name.
     *
     * #### Example
     * ```typescript
     * const name = "Test Token";
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .name(name)
     *        .do();
     * ```
     *
     * @param name
     * @category query
     */ name(name) {
        this.query.name = name;
        return this;
    }
    /**
     * Filter just assets with the given unit.
     *
     * #### Example
     * ```typescript
     * const unit = "test";
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .unit(unit)
     *        .do();
     * ```
     *
     * @param unit
     * @category query
     */ unit(unit) {
        this.query.unit = unit;
        return this;
    }
    /**
     * Asset ID for filter, as int.
     *
     * #### Example
     * ```typescript
     * const assetId = 163650;
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .index(assetId)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupAssetByID(assetId).do();`
     * @param index
     * @category query
     */ index(index) {
        this.query["asset-id"] = index;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     *
     * const assetsPage1 = await indexerClient
     *        .searchForAssets()
     *        .limit(maxResults)
     *        .do();
     *
     * const assetsPage2 = await indexerClient
     *        .searchForAssets()
     *        .limit(maxResults)
     *        .nextToken(assetsPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(nextToken) {
        this.query.next = nextToken;
        return this;
    }
    /**
     * Includes all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example 1
     * ```typescript
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const assets = await indexerClient
     *        .searchForAssets()
     *        .includeAll()
     *        .do();
     * ```
     *
     * @param value - default true when called without passing a value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
}
exports.default = SearchForAssets;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zRJ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
class SearchForApplications extends (0, _jsonrequestDefault.default) {
    /**
     * @returns `/v2/applications`
     */ // eslint-disable-next-line class-methods-use-this
    path() {
        return "/v2/applications";
    }
    /**
     * Application ID for filter, as int
     *
     * #### Example
     * ```typescript
     * const appId = 60553466;
     * const apps = await indexerClient
     *        .searchForApplications()
     *        .index(appId)
     *        .do();
     * ```
     * @remarks Alternatively, use `indexerClient.lookupApplications(appId).do()`
     * @param index
     * @category query
     */ index(index) {
        this.query["application-id"] = index;
        return this;
    }
    /**
     * Creator for filter, as string
     *
     * #### Example
     * ```typescript
     * const creator = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
     * const apps = await indexerClient
     *        .searchForApplications()
     *        .creator(creator)
     *        .do();
     * ```
     * @param creator
     * @category query
     */ creator(creator) {
        this.query.creator = creator;
        return this;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     *
     * const appsPage1 = await indexerClient
     *        .searchForApplications()
     *        .limit(maxResults)
     *        .do();
     *
     * const appsPage2 = await indexerClient
     *        .searchForApplications()
     *        .limit(maxResults)
     *        .nextToken(appsPage1["next-token"])
     *        .do();
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(next) {
        this.query.next = next;
        return this;
    }
    /**
     * Limit results for pagination.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const apps = await indexerClient
     *        .searchForApplications()
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    /**
     * Includes all items including closed accounts, deleted applications, destroyed assets, opted-out asset holdings, and closed-out application localstates
     *
     * #### Example 1
     * ```typescript
     * const apps = await indexerClient
     *        .searchForApplications()
     *        .includeAll(false)
     *        .do();
     * ```
     *
     * #### Example 2
     * ```typescript
     * const apps = await indexerClient
     *        .searchForApplications()
     *        .includeAll()
     *        .do();
     * ```
     *
     * @param value - default true when called without passing a value
     * @category query
     */ includeAll(value = true) {
        this.query["include-all"] = value;
        return this;
    }
}
exports.default = SearchForApplications;

},{"../jsonrequest":"eWgGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Wu1e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrequest = require("../jsonrequest");
var _jsonrequestDefault = parcelHelpers.interopDefault(_jsonrequest);
var _types = require("./models/types");
class SearchForApplicationBoxes extends (0, _jsonrequestDefault.default) {
    /**
     * Returns information about indexed application boxes.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const appID = 1234;
     *
     * const responsePage1 = await indexerClient
     *        .searchForApplicationBoxes(appID)
     *        .limit(maxResults)
     *        .do();
     * const boxNamesPage1 = responsePage1.boxes.map(box => box.name);
     *
     * const responsePage2 = await indexerClient
     *        .searchForApplicationBoxes(appID)
     *        .limit(maxResults)
     *        .nextToken(responsePage1.nextToken)
     *        .do();
     * const boxNamesPage2 = responsePage2.boxes.map(box => box.name);
     * ```
     *
     * [Response data schema details](https://developer.algorand.org/docs/rest-apis/indexer/#get-v2applicationsapplication-idboxes)
     * @oaram index - application index.
     * @category GET
     */ constructor(c, intDecoding, index){
        super(c, intDecoding);
        this.index = index;
        this.index = index;
    }
    /**
     * @returns `/v2/applications/${index}/boxes`
     */ path() {
        return `/v2/applications/${this.index}/boxes`;
    }
    /**
     * Specify the next page of results.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const appID = 1234;
     *
     * const responsePage1 = await indexerClient
     *        .searchForApplicationBoxes(appID)
     *        .limit(maxResults)
     *        .do();
     * const boxNamesPage1 = responsePage1.boxes.map(box => box.name);
     *
     * const responsePage2 = await indexerClient
     *        .searchForApplicationBoxes(appID)
     *        .limit(maxResults)
     *        .nextToken(responsePage1.nextToken)
     *        .do();
     * const boxNamesPage2 = responsePage2.boxes.map(box => box.name);
     * ```
     * @param nextToken - provided by the previous results.
     * @category query
     */ nextToken(next) {
        this.query.next = next;
        return this;
    }
    /**
     * Limit results for pagination.
     *
     * #### Example
     * ```typescript
     * const maxResults = 20;
     * const boxesResponse = await indexerClient
     *        .searchForApplicationBoxes(1234)
     *        .limit(maxResults)
     *        .do();
     * ```
     *
     * @param limit - maximum number of results to return.
     * @category query
     */ limit(limit) {
        this.query.limit = limit;
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    prepare(body) {
        return (0, _types.BoxesResponse).from_obj_for_encoding(body);
    }
}
exports.default = SearchForApplicationBoxes;

},{"../jsonrequest":"eWgGi","./models/types":"glILl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lIpq2":[function(require,module,exports) {
/**
 * Wait until a transaction has been confirmed or rejected by the network, or
 * until 'waitRounds' number of rounds have passed.
 * @param client - An Algodv2 client
 * @param txid - The ID of the transaction to wait for.
 * @param waitRounds - The maximum number of rounds to wait for.
 * @returns A promise that, upon success, will resolve to the output of the
 *   `pendingTransactionInformation` call for the confirmed transaction.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "waitForConfirmation", ()=>waitForConfirmation);
async function waitForConfirmation(client, txid, waitRounds) {
    // Wait until the transaction is confirmed or rejected, or until 'waitRounds'
    // number of rounds have passed.
    const status = await client.status().do();
    if (typeof status === "undefined") throw new Error("Unable to get node status");
    const startRound = status["last-round"] + 1;
    let currentRound = startRound;
    /* eslint-disable no-await-in-loop */ while(currentRound < startRound + waitRounds){
        let poolError = false;
        try {
            const pendingInfo = await client.pendingTransactionInformation(txid).do();
            if (pendingInfo["confirmed-round"]) // Got the completed Transaction
            return pendingInfo;
            if (pendingInfo["pool-error"]) {
                // If there was a pool error, then the transaction has been rejected
                poolError = true;
                throw new Error(`Transaction Rejected: ${pendingInfo["pool-error"]}`);
            }
        } catch (err) {
            // Ignore errors from PendingTransactionInformation, since it may return 404 if the algod
            // instance is behind a load balancer and the request goes to a different algod than the
            // one we submitted the transaction to
            if (poolError) // Rethrow error only if it's because the transaction was rejected
            throw err;
        }
        await client.statusAfterBlock(currentRound).do();
        currentRound += 1;
    }
    /* eslint-enable no-await-in-loop */ throw new Error(`Transaction not confirmed after ${waitRounds} rounds`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1CIMA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * bigIntToBytes converts a BigInt to a big-endian Uint8Array for encoding.
 * @param bi - The bigint to convert.
 * @param size - The size of the resulting byte array.
 * @returns A byte array containing the big-endian encoding of the input bigint
 */ parcelHelpers.export(exports, "bigIntToBytes", ()=>bigIntToBytes);
/**
 * bytesToBigInt produces a bigint from a binary representation.
 *
 * @param bytes - The Uint8Array to convert.
 * @returns The bigint that was encoded in the input data.
 */ parcelHelpers.export(exports, "bytesToBigInt", ()=>bytesToBigInt);
var _buffer = require("buffer");
function bigIntToBytes(bi, size) {
    let hex = bi.toString(16);
    // Pad the hex with zeros so it matches the size in bytes
    if (hex.length !== size * 2) hex = hex.padStart(size * 2, "0");
    const byteArray = new Uint8Array(hex.length / 2);
    for(let i = 0, j = 0; i < hex.length / 2; i++, j += 2)byteArray[i] = parseInt(hex.slice(j, j + 2), 16);
    return byteArray;
}
function bytesToBigInt(bytes) {
    let res = BigInt(0);
    const buf = (0, _buffer.Buffer).from(bytes);
    for(let i = 0; i < bytes.length; i++)res = BigInt(Number(buf.readUIntBE(i, 1))) + res * BigInt(256);
    return res;
}

},{"buffer":"jlSk7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8hjV7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateAccount);
var _naclWrappers = require("./nacl/naclWrappers");
var _address = require("./encoding/address");
function generateAccount() {
    const keys = _naclWrappers.keyPair();
    const encodedPk = _address.encodeAddress(keys.publicKey);
    return {
        addr: encodedPk,
        sk: keys.secretKey
    };
}

},{"./nacl/naclWrappers":"hIiu2","./encoding/address":"7lw2f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBqyO":[function(require,module,exports) {
/* eslint-disable no-bitwise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FAIL_TO_DECODE_MNEMONIC_ERROR_MSG", ()=>FAIL_TO_DECODE_MNEMONIC_ERROR_MSG);
parcelHelpers.export(exports, "NOT_IN_WORDS_LIST_ERROR_MSG", ()=>NOT_IN_WORDS_LIST_ERROR_MSG);
/**
 * mnemonicFromSeed converts a 32-byte key into a 25 word mnemonic. The generated mnemonic includes a checksum.
 * Each word in the mnemonic represents 11 bits of data, and the last 11 bits are reserved for the checksum.
 * @param seed - 32 bytes long seed
 * @returns 25 words mnemonic
 */ parcelHelpers.export(exports, "mnemonicFromSeed", ()=>mnemonicFromSeed);
/**
 * seedFromMnemonic converts a mnemonic generated using this library into the source key used to create it.
 * It returns an error if the passed mnemonic has an incorrect checksum, if the number of words is unexpected, or if one
 * of the passed words is not found in the words list.
 * @param mnemonic - 25 words mnemonic
 * @returns 32 bytes long seed
 */ parcelHelpers.export(exports, "seedFromMnemonic", ()=>seedFromMnemonic);
/**
 * mnemonicToSecretKey takes a mnemonic string and returns the corresponding Algorand address and its secret key.
 * @param mn - 25 words Algorand mnemonic
 * @throws error if fails to decode the mnemonic
 */ parcelHelpers.export(exports, "mnemonicToSecretKey", ()=>mnemonicToSecretKey);
/**
 * secretKeyToMnemonic takes an Algorand secret key and returns the corresponding mnemonic.
 * @param sk - Algorand secret key
 * @returns Secret key's associated mnemonic
 */ parcelHelpers.export(exports, "secretKeyToMnemonic", ()=>secretKeyToMnemonic);
/**
 * mnemonicToMasterDerivationKey takes a mnemonic string and returns the corresponding master derivation key.
 * @param mn - 25 words Algorand mnemonic
 * @returns Uint8Array
 * @throws error if fails to decode the mnemonic
 */ parcelHelpers.export(exports, "mnemonicToMasterDerivationKey", ()=>mnemonicToMasterDerivationKey);
/**
 * masterDerivationKeyToMnemonic takes a master derivation key and returns the corresponding mnemonic.
 * @param mdk - Uint8Array
 * @returns string mnemonic
 */ parcelHelpers.export(exports, "masterDerivationKeyToMnemonic", ()=>masterDerivationKeyToMnemonic);
var _english = require("./wordlists/english");
var _englishDefault = parcelHelpers.interopDefault(_english);
var _naclWrappers = require("../nacl/naclWrappers");
var _address = require("../encoding/address");
const FAIL_TO_DECODE_MNEMONIC_ERROR_MSG = "failed to decode mnemonic";
const NOT_IN_WORDS_LIST_ERROR_MSG = "the mnemonic contains a word that is not in the wordlist";
// https://stackoverflow.com/a/51452614
function toUint11Array(buffer8) {
    const buffer11 = [];
    let acc = 0;
    let accBits = 0;
    function add(octet) {
        acc |= octet << accBits;
        accBits += 8;
        if (accBits >= 11) {
            buffer11.push(acc & 0x7ff);
            acc >>= 11;
            accBits -= 11;
        }
    }
    function flush() {
        if (accBits) buffer11.push(acc);
    }
    buffer8.forEach(add);
    flush();
    return buffer11;
}
function applyWords(nums) {
    return nums.map((n)=>(0, _englishDefault.default)[n]);
}
function computeChecksum(seed) {
    const hashBuffer = _naclWrappers.genericHash(seed);
    const uint11Hash = toUint11Array(hashBuffer);
    const words = applyWords(uint11Hash);
    return words[0];
}
function mnemonicFromSeed(seed) {
    // Sanity length check
    if (seed.length !== _naclWrappers.SEED_BTYES_LENGTH) throw new RangeError(`Seed length must be ${_naclWrappers.SEED_BTYES_LENGTH}`);
    const uint11Array = toUint11Array(seed);
    const words = applyWords(uint11Array);
    const checksumWord = computeChecksum(seed);
    return `${words.join(" ")} ${checksumWord}`;
}
// from Uint11Array
// https://stackoverflow.com/a/51452614
function toUint8Array(buffer11) {
    const buffer8 = [];
    let acc = 0;
    let accBits = 0;
    function add(ui11) {
        acc |= ui11 << accBits;
        accBits += 11;
        while(accBits >= 8){
            buffer8.push(acc & 0xff);
            acc >>= 8;
            accBits -= 8;
        }
    }
    function flush() {
        if (accBits) buffer8.push(acc);
    }
    buffer11.forEach(add);
    flush();
    return new Uint8Array(buffer8);
}
function seedFromMnemonic(mnemonic) {
    const words = mnemonic.split(" ");
    const key = words.slice(0, 24);
    // Check that all words are in list
    for (const w of key){
        if ((0, _englishDefault.default).indexOf(w) === -1) throw new Error(NOT_IN_WORDS_LIST_ERROR_MSG);
    }
    const checksum = words[words.length - 1];
    const uint11Array = key.map((word)=>(0, _englishDefault.default).indexOf(word));
    // Convert the key to uint8Array
    let uint8Array = toUint8Array(uint11Array);
    // We need to chop the last byte -
    // the short explanation - Since 256 is not divisible by 11, we have an extra 0x0 byte.
    // The longer explanation - When splitting the 256 bits to chunks of 11, we get 23 words and a left over of 3 bits.
    // This left gets padded with another 8 bits to the create the 24th word.
    // While converting back to byte array, our new 264 bits array is divisible by 8 but the last byte is just the padding.
    // check that we have 33 bytes long array as expected
    if (uint8Array.length !== 33) throw new Error(FAIL_TO_DECODE_MNEMONIC_ERROR_MSG);
    // check that the last byte is actually 0x0
    if (uint8Array[uint8Array.length - 1] !== 0x0) throw new Error(FAIL_TO_DECODE_MNEMONIC_ERROR_MSG);
    // chop it !
    uint8Array = uint8Array.slice(0, uint8Array.length - 1);
    // compute checksum
    const cs = computeChecksum(uint8Array);
    // success!
    if (cs === checksum) return uint8Array;
    throw new Error(FAIL_TO_DECODE_MNEMONIC_ERROR_MSG);
}
function mnemonicToSecretKey(mn) {
    const seed = seedFromMnemonic(mn);
    const keys = _naclWrappers.keyPairFromSeed(seed);
    const encodedPk = _address.encodeAddress(keys.publicKey);
    return {
        addr: encodedPk,
        sk: keys.secretKey
    };
}
function secretKeyToMnemonic(sk) {
    // get the seed from the sk
    const seed = sk.slice(0, _naclWrappers.SEED_BTYES_LENGTH);
    return mnemonicFromSeed(seed);
}
function mnemonicToMasterDerivationKey(mn) {
    return seedFromMnemonic(mn);
}
function masterDerivationKeyToMnemonic(mdk) {
    return mnemonicFromSeed(mdk);
}

},{"./wordlists/english":"kOlkV","../nacl/naclWrappers":"hIiu2","../encoding/address":"7lw2f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kOlkV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const english = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
exports.default = english;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ZBIn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Aux class for group id calculation of a group of transactions
 */ parcelHelpers.export(exports, "TxGroup", ()=>TxGroup);
/**
 * computeGroupID returns group ID for a group of transactions
 * @param txns - array of transactions (every element is a dict or Transaction)
 * @returns Buffer
 */ parcelHelpers.export(exports, "computeGroupID", ()=>computeGroupID);
/**
 * assignGroupID assigns group id to a given list of unsigned transactions
 * @param txns - array of transactions (every element is a dict or Transaction)
 * @param from - optional sender address specifying which transaction return
 * @returns possible list of matching transactions
 */ parcelHelpers.export(exports, "assignGroupID", ()=>assignGroupID);
var _buffer = require("buffer");
var _transaction = require("./transaction");
var _naclWrappers = require("./nacl/naclWrappers");
var _encoding = require("./encoding/encoding");
var _address = require("./encoding/address");
var _utils = require("./utils/utils");
const ALGORAND_MAX_TX_GROUP_SIZE = 16;
class TxGroup {
    constructor(hashes){
        this.name = "Transaction group";
        this.tag = (0, _buffer.Buffer).from("TG");
        if (hashes.length > ALGORAND_MAX_TX_GROUP_SIZE) {
            const errorMsg = `${hashes.length.toString()} transactions grouped together but max group size is ${ALGORAND_MAX_TX_GROUP_SIZE.toString()}`;
            throw Error(errorMsg);
        }
        this.txGroupHashes = hashes;
    }
    // eslint-disable-next-line camelcase
    get_obj_for_encoding() {
        const txgroup = {
            txlist: this.txGroupHashes
        };
        return txgroup;
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(txgroupForEnc) {
        const txn = Object.create(this.prototype);
        txn.name = "Transaction group";
        txn.tag = (0, _buffer.Buffer).from("TG");
        txn.txGroupHashes = [];
        for (const hash of txgroupForEnc.txlist)txn.txGroupHashes.push((0, _buffer.Buffer).from(hash));
        return txn;
    }
    toByte() {
        return _encoding.encode(this.get_obj_for_encoding());
    }
}
function computeGroupID(txns) {
    const hashes = [];
    for (const txn of txns){
        const tx = _transaction.instantiateTxnIfNeeded(txn);
        hashes.push(tx.rawTxID());
    }
    const txgroup = new TxGroup(hashes);
    const bytes = txgroup.toByte();
    const toBeHashed = (0, _buffer.Buffer).from(_utils.concatArrays(txgroup.tag, bytes));
    const gid = _naclWrappers.genericHash(toBeHashed);
    return (0, _buffer.Buffer).from(gid);
}
function assignGroupID(txns, from) {
    const gid = computeGroupID(txns);
    const result = [];
    for (const txn of txns){
        const tx = _transaction.instantiateTxnIfNeeded(txn);
        if (!from || _address.encodeAddress(tx.from.publicKey) === from) {
            tx.group = gid;
            result.push(tx);
        }
    }
    return result;
}
exports.default = TxGroup;

},{"buffer":"jlSk7","./transaction":"1n32l","./nacl/naclWrappers":"hIiu2","./encoding/encoding":"1Yg70","./encoding/address":"7lw2f","./utils/utils":"izzsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3OHRO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** sanityCheckProgram performs heuristic program validation:
 * check if passed in bytes are Algorand address or is B64 encoded, rather than Teal bytes
 *
 * @param program - Program bytes to check
 */ parcelHelpers.export(exports, "sanityCheckProgram", ()=>sanityCheckProgram);
/**
 LogicSig implementation

 LogicSig cannot sign transactions in all cases.  Instead, use LogicSigAccount as a safe, general purpose signing mechanism.  Since LogicSig does not track the provided signature's public key, LogicSig cannot sign transactions when delegated to a non-multisig account _and_ the sender is not the delegating account.
 */ parcelHelpers.export(exports, "LogicSig", ()=>LogicSig);
/**
 * Represents an account that can sign with a LogicSig program.
 */ parcelHelpers.export(exports, "LogicSigAccount", ()=>LogicSigAccount);
/**
 * signLogicSigTransactionObject takes a transaction and a LogicSig object and
 * returns a signed transaction.
 *
 * @param txn - The transaction to sign.
 * @param lsigObject - The LogicSig object that will sign the transaction.
 *
 * @returns Object containing txID and blob representing signed transaction.
 */ parcelHelpers.export(exports, "signLogicSigTransactionObject", ()=>signLogicSigTransactionObject);
/**
 * signLogicSigTransaction takes a transaction and a LogicSig object and returns
 * a signed transaction.
 *
 * @param txn - The transaction to sign.
 * @param lsigObject - The LogicSig object that will sign the transaction.
 *
 * @returns Object containing txID and blob representing signed transaction.
 * @throws error on failure
 */ parcelHelpers.export(exports, "signLogicSigTransaction", ()=>signLogicSigTransaction);
/**
 * logicSigFromByte accepts encoded logic sig bytes and attempts to call logicsig.fromByte on it,
 * returning the result
 */ parcelHelpers.export(exports, "logicSigFromByte", ()=>logicSigFromByte);
/**
 * tealSign creates a signature compatible with ed25519verify opcode from program hash
 * @param sk - uint8array with secret key
 * @param data - buffer with data to sign
 * @param programHash - string representation of teal program hash (= contract address for LogicSigs)
 */ parcelHelpers.export(exports, "tealSign", ()=>tealSign);
/**
 * verifyTealSign verifies a signature as would the ed25519verify opcode
 * @param data - buffer with original signed data
 * @param programHash - string representation of teal program hash (= contract address for LogicSigs)
 * @param sig - uint8array with the signature to verify (produced by tealSign/tealSignFromProgram)
 * @param pk - uint8array with public key to verify against
 */ parcelHelpers.export(exports, "verifyTealSign", ()=>verifyTealSign);
/**
 * tealSignFromProgram creates a signature compatible with ed25519verify opcode from raw program bytes
 * @param sk - uint8array with secret key
 * @param data - buffer with data to sign
 * @param program - buffer with teal program
 */ parcelHelpers.export(exports, "tealSignFromProgram", ()=>tealSignFromProgram);
var _buffer = require("buffer");
var _naclWrappers = require("./nacl/naclWrappers");
var _address = require("./encoding/address");
var _encoding = require("./encoding/encoding");
var _multisig = require("./multisig");
var _utils = require("./utils/utils");
var _transaction = require("./transaction");
function sanityCheckProgram(program) {
    if (!program || program.length === 0) throw new Error("empty program");
    const lineBreakOrd = "\n".charCodeAt(0);
    const blankSpaceOrd = " ".charCodeAt(0);
    const tildeOrd = "~".charCodeAt(0);
    const isPrintable = (x)=>blankSpaceOrd <= x && x <= tildeOrd;
    const isAsciiPrintable = program.every((x)=>x === lineBreakOrd || isPrintable(x));
    if (isAsciiPrintable) {
        const programStr = (0, _buffer.Buffer).from(program).toString();
        if ((0, _address.isValidAddress)(programStr)) throw new Error("requesting program bytes, get Algorand address");
        if ((0, _buffer.Buffer).from(programStr, "base64").toString("base64") === programStr) throw new Error("program should not be b64 encoded");
        throw new Error("program bytes are all ASCII printable characters, not looking like Teal byte code");
    }
}
class LogicSig {
    constructor(program, programArgs){
        this.tag = (0, _buffer.Buffer).from("Program");
        if (programArgs && (!Array.isArray(programArgs) || !programArgs.every((arg)=>arg.constructor === Uint8Array || (0, _buffer.Buffer).isBuffer(arg)))) throw new TypeError("Invalid arguments");
        let args;
        if (programArgs != null) args = programArgs.map((arg)=>new Uint8Array(arg));
        sanityCheckProgram(program);
        this.logic = program;
        this.args = args;
        this.sig = undefined;
        this.msig = undefined;
    }
    // eslint-disable-next-line camelcase
    get_obj_for_encoding() {
        const obj = {
            l: this.logic
        };
        if (this.args) obj.arg = this.args;
        if (this.sig) obj.sig = this.sig;
        else if (this.msig) obj.msig = this.msig;
        return obj;
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(encoded) {
        const lsig = new LogicSig(encoded.l, encoded.arg);
        lsig.sig = encoded.sig;
        lsig.msig = encoded.msig;
        return lsig;
    }
    /**
     * Performs signature verification
     * @param publicKey - Verification key (derived from sender address or escrow address)
     */ verify(publicKey) {
        if (this.sig && this.msig) return false;
        try {
            sanityCheckProgram(this.logic);
        } catch (e) {
            return false;
        }
        const toBeSigned = _utils.concatArrays(this.tag, this.logic);
        if (!this.sig && !this.msig) {
            const hash = _naclWrappers.genericHash(toBeSigned);
            return _utils.arrayEqual(hash, publicKey);
        }
        if (this.sig) return _naclWrappers.verify(toBeSigned, this.sig, publicKey);
        return (0, _multisig.verifyMultisig)(toBeSigned, this.msig, publicKey);
    }
    /**
     * Compute hash of the logic sig program (that is the same as escrow account address) as string address
     * @returns String representation of the address
     */ address() {
        const toBeSigned = _utils.concatArrays(this.tag, this.logic);
        const hash = _naclWrappers.genericHash(toBeSigned);
        return _address.encodeAddress(new Uint8Array(hash));
    }
    /**
     * Creates signature (if no msig provided) or multi signature otherwise
     * @param secretKey - Secret key to sign with
     * @param msig - Multisig account as \{version, threshold, addrs\}
     */ sign(secretKey, msig) {
        if (msig == null) this.sig = this.signProgram(secretKey);
        else {
            const subsigs = msig.addrs.map((addr)=>({
                    pk: _address.decodeAddress(addr).publicKey
                }));
            this.msig = {
                v: msig.version,
                thr: msig.threshold,
                subsig: subsigs
            };
            const [sig, index] = this.singleSignMultisig(secretKey, this.msig);
            this.msig.subsig[index].s = sig;
        }
    }
    /**
     * Appends a signature to multi signature
     * @param secretKey - Secret key to sign with
     */ appendToMultisig(secretKey) {
        if (this.msig === undefined) throw new Error("no multisig present");
        const [sig, index] = this.singleSignMultisig(secretKey, this.msig);
        this.msig.subsig[index].s = sig;
    }
    signProgram(secretKey) {
        const toBeSigned = _utils.concatArrays(this.tag, this.logic);
        const sig = _naclWrappers.sign(toBeSigned, secretKey);
        return sig;
    }
    singleSignMultisig(secretKey, msig) {
        let index = -1;
        const myPk = _naclWrappers.keyPairFromSecretKey(secretKey).publicKey;
        for(let i = 0; i < msig.subsig.length; i++){
            const { pk  } = msig.subsig[i];
            if (_utils.arrayEqual(pk, myPk)) {
                index = i;
                break;
            }
        }
        if (index === -1) throw new Error("invalid secret key");
        const sig = this.signProgram(secretKey);
        return [
            sig,
            index
        ];
    }
    toByte() {
        return _encoding.encode(this.get_obj_for_encoding());
    }
    static fromByte(encoded) {
        const decodedObj = _encoding.decode(encoded);
        return LogicSig.from_obj_for_encoding(decodedObj);
    }
}
class LogicSigAccount {
    /**
     * Create a new LogicSigAccount. By default this will create an escrow
     * LogicSig account. Call `sign` or `signMultisig` on the newly created
     * LogicSigAccount to make it a delegated account.
     *
     * @param program - The compiled TEAL program which contains the logic for
     *   this LogicSig.
     * @param args - An optional array of arguments for the program.
     */ constructor(program, args){
        this.lsig = new LogicSig(program, args);
        this.sigkey = undefined;
    }
    // eslint-disable-next-line camelcase
    get_obj_for_encoding() {
        const obj = {
            lsig: this.lsig.get_obj_for_encoding()
        };
        if (this.sigkey) obj.sigkey = this.sigkey;
        return obj;
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(encoded) {
        const lsigAccount = new LogicSigAccount(encoded.lsig.l, encoded.lsig.arg);
        lsigAccount.lsig = LogicSig.from_obj_for_encoding(encoded.lsig);
        lsigAccount.sigkey = encoded.sigkey;
        return lsigAccount;
    }
    /**
     * Encode this object into msgpack.
     */ toByte() {
        return _encoding.encode(this.get_obj_for_encoding());
    }
    /**
     * Decode a msgpack object into a LogicSigAccount.
     * @param encoded - The encoded LogicSigAccount.
     */ static fromByte(encoded) {
        const decodedObj = _encoding.decode(encoded);
        return LogicSigAccount.from_obj_for_encoding(decodedObj);
    }
    /**
     * Check if this LogicSigAccount has been delegated to another account with a
     * signature.
     *
     * Note this function only checks for the presence of a delegation signature.
     * To verify the delegation signature, use `verify`.
     */ isDelegated() {
        return !!(this.lsig.sig || this.lsig.msig);
    }
    /**
     * Verifies this LogicSig's program and signatures.
     * @returns true if and only if the LogicSig program and signatures are valid.
     */ verify() {
        const addr = this.address();
        return this.lsig.verify(_address.decodeAddress(addr).publicKey);
    }
    /**
     * Get the address of this LogicSigAccount.
     *
     * If the LogicSig is delegated to another account, this will return the
     * address of that account.
     *
     * If the LogicSig is not delegated to another account, this will return an
     *  escrow address that is the hash of the LogicSig's program code.
     */ address() {
        if (this.lsig.sig && this.lsig.msig) throw new Error("LogicSig has too many signatures. At most one of sig or msig may be present");
        if (this.lsig.sig) {
            if (!this.sigkey) throw new Error("Signing key for delegated account is missing");
            return _address.encodeAddress(this.sigkey);
        }
        if (this.lsig.msig) {
            const msigMetadata = {
                version: this.lsig.msig.v,
                threshold: this.lsig.msig.thr,
                pks: this.lsig.msig.subsig.map((subsig)=>subsig.pk)
            };
            return _address.encodeAddress(_address.fromMultisigPreImg(msigMetadata));
        }
        return this.lsig.address();
    }
    /**
     * Turns this LogicSigAccount into a delegated LogicSig. This type of LogicSig
     * has the authority to sign transactions on behalf of another account, called
     * the delegating account. Use this function if the delegating account is a
     * multisig account.
     *
     * @param msig - The multisig delegating account
     * @param secretKey - The secret key of one of the members of the delegating
     *   multisig account. Use `appendToMultisig` to add additional signatures
     *   from other members.
     */ signMultisig(msig, secretKey) {
        this.lsig.sign(secretKey, msig);
    }
    /**
     * Adds an additional signature from a member of the delegating multisig
     * account.
     *
     * @param secretKey - The secret key of one of the members of the delegating
     *   multisig account.
     */ appendToMultisig(secretKey) {
        this.lsig.appendToMultisig(secretKey);
    }
    /**
     * Turns this LogicSigAccount into a delegated LogicSig. This type of LogicSig
     * has the authority to sign transactions on behalf of another account, called
     * the delegating account. If the delegating account is a multisig account,
     * use `signMultisig` instead.
     *
     * @param secretKey - The secret key of the delegating account.
     */ sign(secretKey) {
        this.lsig.sign(secretKey);
        this.sigkey = _naclWrappers.keyPairFromSecretKey(secretKey).publicKey;
    }
}
function signLogicSigTransactionWithAddress(txn, lsig, lsigAddress) {
    if (!lsig.verify(lsigAddress)) throw new Error("Logic signature verification failed. Ensure the program and signature are valid.");
    const signedTxn = {
        lsig: lsig.get_obj_for_encoding(),
        txn: txn.get_obj_for_encoding()
    };
    if (!_naclWrappers.bytesEqual(lsigAddress, txn.from.publicKey)) signedTxn.sgnr = (0, _buffer.Buffer).from(lsigAddress);
    return {
        txID: txn.txID().toString(),
        blob: _encoding.encode(signedTxn)
    };
}
function signLogicSigTransactionObject(txn, lsigObject) {
    let lsig;
    let lsigAddress;
    if (lsigObject instanceof LogicSigAccount) {
        lsig = lsigObject.lsig;
        lsigAddress = _address.decodeAddress(lsigObject.address()).publicKey;
    } else {
        lsig = lsigObject;
        if (lsig.sig) // For a LogicSig with a non-multisig delegating account, we cannot derive
        // the address of that account from only its signature, so assume the
        // delegating account is the sender. If that's not the case, the signing
        // will fail.
        lsigAddress = txn.from.publicKey;
        else if (lsig.msig) {
            const msigMetadata = {
                version: lsig.msig.v,
                threshold: lsig.msig.thr,
                pks: lsig.msig.subsig.map((subsig)=>subsig.pk)
            };
            lsigAddress = _address.fromMultisigPreImg(msigMetadata);
        } else lsigAddress = _address.decodeAddress(lsig.address()).publicKey;
    }
    return signLogicSigTransactionWithAddress(txn, lsig, lsigAddress);
}
function signLogicSigTransaction(txn, lsigObject) {
    const algoTxn = _transaction.instantiateTxnIfNeeded(txn);
    return signLogicSigTransactionObject(algoTxn, lsigObject);
}
function logicSigFromByte(encoded) {
    return LogicSig.fromByte(encoded);
}
const SIGN_PROGRAM_DATA_PREFIX = (0, _buffer.Buffer).from("ProgData");
function tealSign(sk, data, programHash) {
    const parts = _utils.concatArrays(_address.decodeAddress(programHash).publicKey, data);
    const toBeSigned = (0, _buffer.Buffer).from(_utils.concatArrays(SIGN_PROGRAM_DATA_PREFIX, parts));
    return _naclWrappers.sign(toBeSigned, sk);
}
function verifyTealSign(data, programHash, sig, pk) {
    const parts = _utils.concatArrays(_address.decodeAddress(programHash).publicKey, data);
    const toBeSigned = (0, _buffer.Buffer).from(_utils.concatArrays(SIGN_PROGRAM_DATA_PREFIX, parts));
    return _naclWrappers.verify(toBeSigned, sig, pk);
}
function tealSignFromProgram(sk, data, program) {
    const lsig = new LogicSig(program);
    const contractAddress = lsig.address();
    return tealSign(sk, data, contractAddress);
}

},{"buffer":"jlSk7","./nacl/naclWrappers":"hIiu2","./encoding/address":"7lw2f","./encoding/encoding":"1Yg70","./multisig":"lw3S9","./utils/utils":"izzsC","./transaction":"1n32l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lw3S9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MULTISIG_MERGE_LESSTHANTWO_ERROR_MSG", ()=>MULTISIG_MERGE_LESSTHANTWO_ERROR_MSG);
parcelHelpers.export(exports, "MULTISIG_MERGE_MISMATCH_ERROR_MSG", ()=>MULTISIG_MERGE_MISMATCH_ERROR_MSG);
parcelHelpers.export(exports, "MULTISIG_MERGE_MISMATCH_AUTH_ADDR_MSG", ()=>MULTISIG_MERGE_MISMATCH_AUTH_ADDR_MSG);
parcelHelpers.export(exports, "MULTISIG_MERGE_WRONG_PREIMAGE_ERROR_MSG", ()=>MULTISIG_MERGE_WRONG_PREIMAGE_ERROR_MSG);
parcelHelpers.export(exports, "MULTISIG_MERGE_SIG_MISMATCH_ERROR_MSG", ()=>MULTISIG_MERGE_SIG_MISMATCH_ERROR_MSG);
parcelHelpers.export(exports, "MULTISIG_NO_MUTATE_ERROR_MSG", ()=>MULTISIG_NO_MUTATE_ERROR_MSG);
parcelHelpers.export(exports, "MULTISIG_USE_PARTIAL_SIGN_ERROR_MSG", ()=>MULTISIG_USE_PARTIAL_SIGN_ERROR_MSG);
parcelHelpers.export(exports, "MULTISIG_SIGNATURE_LENGTH_ERROR_MSG", ()=>MULTISIG_SIGNATURE_LENGTH_ERROR_MSG);
/**
 * createMultisigTransaction creates a raw, unsigned multisig transaction blob.
 * @param txn - the actual transaction.
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param pks - ordered list of public keys in this multisig
 * @returns encoded multisig blob
 */ parcelHelpers.export(exports, "createMultisigTransaction", ()=>createMultisigTransaction);
/**
 * MultisigTransaction is a Transaction that also supports creating partially-signed multisig transactions.
 */ parcelHelpers.export(exports, "MultisigTransaction", ()=>MultisigTransaction);
/**
 * mergeMultisigTransactions takes a list of multisig transaction blobs, and merges them.
 * @param multisigTxnBlobs - a list of blobs representing encoded multisig txns
 * @returns typed array msg-pack encoded multisig txn
 */ parcelHelpers.export(exports, "mergeMultisigTransactions", ()=>mergeMultisigTransactions);
parcelHelpers.export(exports, "verifyMultisig", ()=>verifyMultisig);
/**
 * signMultisigTransaction takes a raw transaction (see signTransaction), a multisig preimage, a secret key, and returns
 * a multisig transaction, which is a blob representing a transaction and multisignature account preimage. The returned
 * multisig txn can accumulate additional signatures through mergeMultisigTransactions or appendSignMultisigTransaction.
 * @param txn - object with either payment or key registration fields
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param addrs - a list of Algorand addresses representing possible signers for this multisig. Order is important.
 * @param sk - Algorand secret key. The corresponding pk should be in the pre image.
 * @returns object containing txID, and blob of partially signed multisig transaction (with multisig preimage information)
 * If the final calculated fee is lower than the protocol minimum fee, the fee will be increased to match the minimum.
 */ parcelHelpers.export(exports, "signMultisigTransaction", ()=>signMultisigTransaction);
/**
 * appendSignMultisigTransaction takes a multisig transaction blob, and appends our signature to it.
 * While we could derive public key preimagery from the partially-signed multisig transaction,
 * we ask the caller to pass it back in, to ensure they know what they are signing.
 * @param multisigTxnBlob - an encoded multisig txn. Supports non-payment txn types.
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param addrs - a list of Algorand addresses representing possible signers for this multisig. Order is important.
 * @param sk - Algorand secret key
 * @returns object containing txID, and blob representing encoded multisig txn
 */ parcelHelpers.export(exports, "appendSignMultisigTransaction", ()=>appendSignMultisigTransaction);
/**
 * appendMultisigTransactionSignature takes a multisig transaction blob, and appends a given raw signature to it.
 * This makes it possible to compile a multisig signature using only raw signatures from external methods.
 * @param multisigTxnBlob - an encoded multisig txn. Supports non-payment txn types.
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param addrs - a list of Algorand addresses representing possible signers for this multisig. Order is important.
 * @param signerAddr - address of the signer
 * @param signature - raw multisig signature
 * @returns object containing txID, and blob representing encoded multisig txn
 */ parcelHelpers.export(exports, "appendSignRawMultisigSignature", ()=>appendSignRawMultisigSignature);
/**
 * multisigAddress takes multisig metadata (preimage) and returns the corresponding human readable Algorand address.
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param addrs - list of Algorand addresses
 */ parcelHelpers.export(exports, "multisigAddress", ()=>multisigAddress);
var _buffer = require("buffer");
var _naclWrappers = require("./nacl/naclWrappers");
var _address = require("./encoding/address");
var _encoding = require("./encoding/encoding");
var _transaction = require("./transaction");
var _utils = require("./utils/utils");
const MULTISIG_MERGE_LESSTHANTWO_ERROR_MSG = "Not enough multisig transactions to merge. Need at least two";
const MULTISIG_MERGE_MISMATCH_ERROR_MSG = "Cannot merge txs. txIDs differ";
const MULTISIG_MERGE_MISMATCH_AUTH_ADDR_MSG = "Cannot merge txs. Auth addrs differ";
const MULTISIG_MERGE_WRONG_PREIMAGE_ERROR_MSG = "Cannot merge txs. Multisig preimages differ";
const MULTISIG_MERGE_SIG_MISMATCH_ERROR_MSG = "Cannot merge txs. subsigs are mismatched.";
const MULTISIG_KEY_NOT_EXIST_ERROR_MSG = "Key does not exist";
const MULTISIG_NO_MUTATE_ERROR_MSG = "Cannot mutate a multisig field as it would invalidate all existing signatures.";
const MULTISIG_USE_PARTIAL_SIGN_ERROR_MSG = "Cannot sign a multisig transaction using `signTxn`. Use `partialSignTxn` instead.";
const MULTISIG_SIGNATURE_LENGTH_ERROR_MSG = "Cannot add multisig signature. Signature is not of the correct length.";
function createMultisigTransaction(txn, { version , threshold , addrs  }) {
    // construct the appendable multisigned transaction format
    const pks = addrs.map((addr)=>_address.decodeAddress(addr).publicKey);
    const subsigs = pks.map((pk)=>({
            pk: (0, _buffer.Buffer).from(pk)
        }));
    const msig = {
        v: version,
        thr: threshold,
        subsig: subsigs
    };
    const txnForEncoding = txn.get_obj_for_encoding();
    const signedTxn = {
        msig,
        txn: txnForEncoding
    };
    // if the address of this multisig is different from the transaction sender,
    // we need to add the auth-addr field
    const msigAddr = _address.fromMultisigPreImg({
        version,
        threshold,
        pks
    });
    if (_address.encodeAddress(txnForEncoding.snd) !== _address.encodeAddress(msigAddr)) signedTxn.sgnr = (0, _buffer.Buffer).from(msigAddr);
    return new Uint8Array(_encoding.encode(signedTxn));
}
/**
 * createMultisigTransactionWithSignature creates a multisig transaction blob with an included signature.
 * @param txn - the actual transaction to sign.
 * @param rawSig - a Buffer raw signature of that transaction
 * @param myPk - a public key that corresponds with rawSig
 * @param version - multisig version
 * @param threshold - multisig threshold
 * @param pks - ordered list of public keys in this multisig
 * @returns encoded multisig blob
 */ function createMultisigTransactionWithSignature(txn, { rawSig , myPk  }, { version , threshold , pks  }) {
    // Create an empty encoded multisig transaction
    const encodedMsig = createMultisigTransaction(txn, {
        version,
        threshold,
        addrs: pks.map((pk)=>_address.encodeAddress(pk))
    });
    // note: this is not signed yet, but will be shortly
    const signedTxn = _encoding.decode(encodedMsig);
    let keyExist = false;
    // append the multisig signature to the corresponding public key in the multisig blob
    signedTxn.msig.subsig.forEach((subsig, i)=>{
        if (_naclWrappers.bytesEqual(subsig.pk, myPk)) {
            keyExist = true;
            signedTxn.msig.subsig[i].s = rawSig;
        }
    });
    if (keyExist === false) throw new Error(MULTISIG_KEY_NOT_EXIST_ERROR_MSG);
    // if the address of this multisig is different from the transaction sender,
    // we need to add the auth-addr field
    const msigAddr = _address.fromMultisigPreImg({
        version,
        threshold,
        pks
    });
    if (_address.encodeAddress(signedTxn.txn.snd) !== _address.encodeAddress(msigAddr)) signedTxn.sgnr = (0, _buffer.Buffer).from(msigAddr);
    return new Uint8Array(_encoding.encode(signedTxn));
}
class MultisigTransaction extends _transaction.Transaction {
    /* eslint-disable class-methods-use-this,@typescript-eslint/no-unused-vars,no-dupe-class-members */ /**
     * Override inherited method to throw an error, as mutating transactions are prohibited in this context
     */ addLease() {
        throw new Error(MULTISIG_NO_MUTATE_ERROR_MSG);
    }
    /**
     * Override inherited method to throw an error, as mutating transactions are prohibited in this context
     */ addRekey() {
        throw new Error(MULTISIG_NO_MUTATE_ERROR_MSG);
    }
    signTxn(sk) {
        throw new Error(MULTISIG_USE_PARTIAL_SIGN_ERROR_MSG);
    }
    /* eslint-enable class-methods-use-this,@typescript-eslint/no-unused-vars,no-dupe-class-members */ /**
     * partialSignTxn partially signs this transaction and returns a partially-signed multisig transaction,
     * encoded with msgpack as a typed array.
     * @param version - multisig version
     * @param threshold - multisig threshold
     * @param pks - multisig public key list, order is important.
     * @param sk - an Algorand secret key to sign with.
     * @returns an encoded, partially signed multisig transaction.
     */ partialSignTxn({ version , threshold , pks  }, sk) {
        // get signature verifier
        const myPk = _naclWrappers.keyPairFromSecretKey(sk).publicKey;
        return createMultisigTransactionWithSignature(this, {
            rawSig: this.rawSignTxn(sk),
            myPk
        }, {
            version,
            threshold,
            pks
        });
    }
    /**
     * partialSignWithMultisigSignature partially signs this transaction with an external raw multisig signature and returns
     * a partially-signed multisig transaction, encoded with msgpack as a typed array.
     * @param metadata - multisig metadata
     * @param signerAddr - address of the signer
     * @param signature - raw multisig signature
     * @returns an encoded, partially signed multisig transaction.
     */ partialSignWithMultisigSignature(metadata, signerAddr, signature) {
        if (!_naclWrappers.isValidSignatureLength(signature.length)) throw new Error(MULTISIG_SIGNATURE_LENGTH_ERROR_MSG);
        return createMultisigTransactionWithSignature(this, {
            rawSig: signature,
            myPk: _address.decodeAddress(signerAddr).publicKey
        }, metadata);
    }
    // eslint-disable-next-line camelcase
    static from_obj_for_encoding(txnForEnc) {
        return super.from_obj_for_encoding(txnForEnc);
    }
}
function mergeMultisigTransactions(multisigTxnBlobs) {
    if (multisigTxnBlobs.length < 2) throw new Error(MULTISIG_MERGE_LESSTHANTWO_ERROR_MSG);
    const refSigTx = _encoding.decode(multisigTxnBlobs[0]);
    const refTxID = MultisigTransaction.from_obj_for_encoding(refSigTx.txn).txID();
    const refAuthAddr = refSigTx.sgnr ? _address.encodeAddress(refSigTx.sgnr) : undefined;
    const refPreImage = {
        version: refSigTx.msig.v,
        threshold: refSigTx.msig.thr,
        pks: refSigTx.msig.subsig.map((subsig)=>subsig.pk)
    };
    const refMsigAddr = _address.encodeAddress(_address.fromMultisigPreImg(refPreImage));
    const newSubsigs = refSigTx.msig.subsig.map((sig)=>({
            ...sig
        }));
    for(let i = 1; i < multisigTxnBlobs.length; i++){
        const unisig = _encoding.decode(multisigTxnBlobs[i]);
        const unisigAlgoTxn = MultisigTransaction.from_obj_for_encoding(unisig.txn);
        if (unisigAlgoTxn.txID() !== refTxID) throw new Error(MULTISIG_MERGE_MISMATCH_ERROR_MSG);
        const authAddr = unisig.sgnr ? _address.encodeAddress(unisig.sgnr) : undefined;
        if (refAuthAddr !== authAddr) throw new Error(MULTISIG_MERGE_MISMATCH_AUTH_ADDR_MSG);
        // check multisig has same preimage as reference
        if (unisig.msig.subsig.length !== refSigTx.msig.subsig.length) throw new Error(MULTISIG_MERGE_WRONG_PREIMAGE_ERROR_MSG);
        const preimg = {
            version: unisig.msig.v,
            threshold: unisig.msig.thr,
            pks: unisig.msig.subsig.map((subsig)=>subsig.pk)
        };
        const msgigAddr = _address.encodeAddress(_address.fromMultisigPreImg(preimg));
        if (refMsigAddr !== msgigAddr) throw new Error(MULTISIG_MERGE_WRONG_PREIMAGE_ERROR_MSG);
        // now, we can merge
        unisig.msig.subsig.forEach((uniSubsig, index)=>{
            if (!uniSubsig.s) return;
            const current = newSubsigs[index];
            // we convert the Uint8Arrays uniSubsig.s and current.s to Buffers here because (as
            // of Dec 2020) React overrides the buffer package with an older version that does
            // not support Uint8Arrays in the comparison function. See this thread for more
            // info: https://github.com/algorand/js-algorand-sdk/issues/252
            if (current.s && (0, _buffer.Buffer).compare((0, _buffer.Buffer).from(uniSubsig.s), (0, _buffer.Buffer).from(current.s)) !== 0) // mismatch
            throw new Error(MULTISIG_MERGE_SIG_MISMATCH_ERROR_MSG);
            current.s = uniSubsig.s;
        });
    }
    const msig = {
        v: refSigTx.msig.v,
        thr: refSigTx.msig.thr,
        subsig: newSubsigs
    };
    const signedTxn = {
        msig,
        txn: refSigTx.txn
    };
    if (typeof refAuthAddr !== "undefined") signedTxn.sgnr = (0, _buffer.Buffer).from(_address.decodeAddress(refAuthAddr).publicKey);
    return new Uint8Array(_encoding.encode(signedTxn));
}
function verifyMultisig(toBeVerified, msig, publicKey) {
    const version = msig.v;
    const threshold = msig.thr;
    const subsigs = msig.subsig;
    const pks = subsigs.map((subsig)=>subsig.pk);
    if (msig.subsig.length < threshold) return false;
    let pk;
    try {
        pk = _address.fromMultisigPreImg({
            version,
            threshold,
            pks
        });
    } catch (e) {
        return false;
    }
    if (!_utils.arrayEqual(pk, publicKey)) return false;
    let counter = 0;
    for (const subsig of subsigs)if (subsig.s !== undefined) counter += 1;
    if (counter < threshold) return false;
    let verifiedCounter = 0;
    for (const subsig of subsigs){
        if (subsig.s !== undefined) {
            if (_naclWrappers.verify(toBeVerified, subsig.s, subsig.pk)) verifiedCounter += 1;
        }
    }
    if (verifiedCounter < threshold) return false;
    return true;
}
function signMultisigTransaction(txn, { version , threshold , addrs  }, sk) {
    // check that the from field matches the mSigPreImage. If from field is not populated, fill it in.
    const expectedFromRaw = _address.fromMultisigPreImgAddrs({
        version,
        threshold,
        addrs
    });
    if (!Object.prototype.hasOwnProperty.call(txn, "from")) // eslint-disable-next-line no-param-reassign
    txn.from = expectedFromRaw;
    // build pks for partialSign
    const pks = addrs.map((addr)=>_address.decodeAddress(addr).publicKey);
    // `txn` needs to be handled differently if it's a constructed `Transaction` vs a dict of constructor args
    const txnAlreadyBuilt = txn instanceof _transaction.Transaction;
    let algoTxn;
    let blob;
    if (txnAlreadyBuilt) {
        algoTxn = txn;
        blob = MultisigTransaction.prototype.partialSignTxn.call(algoTxn, {
            version,
            threshold,
            pks
        }, sk);
    } else {
        algoTxn = new MultisigTransaction(txn);
        blob = algoTxn.partialSignTxn({
            version,
            threshold,
            pks
        }, sk);
    }
    return {
        txID: algoTxn.txID().toString(),
        blob
    };
}
function appendSignMultisigTransaction(multisigTxnBlob, { version , threshold , addrs  }, sk) {
    const pks = addrs.map((addr)=>_address.decodeAddress(addr).publicKey);
    // obtain underlying txn, sign it, and merge it
    const multisigTxObj = _encoding.decode(multisigTxnBlob);
    const msigTxn = MultisigTransaction.from_obj_for_encoding(multisigTxObj.txn);
    const partialSignedBlob = msigTxn.partialSignTxn({
        version,
        threshold,
        pks
    }, sk);
    return {
        txID: msigTxn.txID().toString(),
        blob: mergeMultisigTransactions([
            multisigTxnBlob,
            partialSignedBlob
        ])
    };
}
function appendSignRawMultisigSignature(multisigTxnBlob, { version , threshold , addrs  }, signerAddr, signature) {
    const pks = addrs.map((addr)=>_address.decodeAddress(addr).publicKey);
    // obtain underlying txn, sign it, and merge it
    const multisigTxObj = _encoding.decode(multisigTxnBlob);
    const msigTxn = MultisigTransaction.from_obj_for_encoding(multisigTxObj.txn);
    const partialSignedBlob = msigTxn.partialSignWithMultisigSignature({
        version,
        threshold,
        pks
    }, signerAddr, signature);
    return {
        txID: msigTxn.txID().toString(),
        blob: mergeMultisigTransactions([
            multisigTxnBlob,
            partialSignedBlob
        ])
    };
}
function multisigAddress({ version , threshold , addrs  }) {
    return _address.fromMultisigPreImgAddrs({
        version,
        threshold,
        addrs
    });
}

},{"buffer":"jlSk7","./nacl/naclWrappers":"hIiu2","./encoding/address":"7lw2f","./encoding/encoding":"1Yg70","./transaction":"1n32l","./utils/utils":"izzsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kOmkQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SourceMap", ()=>SourceMap);
var _vlq = require("vlq");
class SourceMap {
    constructor({ version , sources , names , mappings  }){
        this.version = version;
        this.sources = sources;
        this.names = names;
        this.mappings = mappings;
        if (this.version !== 3) throw new Error(`Only version 3 is supported, got ${this.version}`);
        if (this.mappings === undefined) throw new Error("mapping undefined, cannot build source map without `mapping`");
        const pcList = this.mappings.split(";").map((m)=>{
            const decoded = _vlq.decode(m);
            if (decoded.length > 2) return decoded[2];
            return undefined;
        });
        this.pcToLine = {};
        this.lineToPc = {};
        let lastLine = 0;
        for (const [pc, lineDelta] of pcList.entries()){
            // If the delta is not undefined, the lastLine should be updated with
            // lastLine + the delta
            if (lineDelta !== undefined) lastLine += lineDelta;
            if (!(lastLine in this.lineToPc)) this.lineToPc[lastLine] = [];
            this.lineToPc[lastLine].push(pc);
            this.pcToLine[pc] = lastLine;
        }
    }
    getLineForPc(pc) {
        return this.pcToLine[pc];
    }
    getPcsForLine(line) {
        return this.lineToPc[line];
    }
}

},{"vlq":"1tEr4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tEr4":[function(require,module,exports) {
/** @type {Record<string, number>} */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @param {string} string */ parcelHelpers.export(exports, "decode", ()=>decode);
/** @param {number | number[]} value */ parcelHelpers.export(exports, "encode", ()=>encode);
let char_to_integer = {};
/** @type {Record<number, string>} */ let integer_to_char = {};
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("").forEach(function(char, i) {
    char_to_integer[char] = i;
    integer_to_char[i] = char;
});
function decode(string) {
    /** @type {number[]} */ let result = [];
    let shift = 0;
    let value = 0;
    for(let i = 0; i < string.length; i += 1){
        let integer = char_to_integer[string[i]];
        if (integer === undefined) throw new Error("Invalid character (" + string[i] + ")");
        const has_continuation_bit = integer & 32;
        integer &= 31;
        value += integer << shift;
        if (has_continuation_bit) shift += 5;
        else {
            const should_negate = value & 1;
            value >>>= 1;
            if (should_negate) result.push(value === 0 ? -2147483648 : -value);
            else result.push(value);
            // reset
            value = shift = 0;
        }
    }
    return result;
}
function encode(value) {
    if (typeof value === "number") return encode_integer(value);
    let result = "";
    for(let i = 0; i < value.length; i += 1)result += encode_integer(value[i]);
    return result;
}
/** @param {number} num */ function encode_integer(num) {
    let result = "";
    if (num < 0) num = -num << 1 | 1;
    else num <<= 1;
    do {
        let clamped = num & 31;
        num >>>= 5;
        if (num > 0) clamped |= 32;
        result += integer_to_char[clamped];
    }while (num > 0);
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZxpY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * createDryrun takes an Algod Client (from algod.AlgodV2Client) and an array of Signed Transactions
 * from (transaction.SignedTransaction) and creates a DryrunRequest object with relevant balances
 * @param client - the AlgodClient to make requests against
 * @param txns - the array of SignedTransaction to use for generating the DryrunRequest object
 * @param protocolVersion - the string representing the protocol version to use
 * @param latestTimestamp - the timestamp
 * @returns the DryrunRequest object constructed from the SignedTransactions passed
 */ parcelHelpers.export(exports, "createDryrun", ()=>createDryrun);
parcelHelpers.export(exports, "DryrunResult", ()=>DryrunResult);
var _buffer = require("buffer");
var _types = require("./client/v2/algod/models/types");
var _transactions = require("./types/transactions");
var _address = require("./encoding/address");
const defaultAppId = 1380011588;
const defaultMaxWidth = 30;
function decodePrograms(ap) {
    // eslint-disable-next-line no-param-reassign
    ap.params["approval-program"] = (0, _buffer.Buffer).from(ap.params["approval-program"].toString(), "base64");
    // eslint-disable-next-line no-param-reassign
    ap.params["clear-state-program"] = (0, _buffer.Buffer).from(ap.params["clear-state-program"].toString(), "base64");
    return ap;
}
async function createDryrun({ client , txns , protocolVersion , latestTimestamp , round , sources  }) {
    const appInfos = [];
    const acctInfos = [];
    const apps = [];
    const assets = [];
    const accts = [];
    for (const t of txns)if (t.txn.type === (0, _transactions.TransactionType).appl) {
        accts.push((0, _address.encodeAddress)(t.txn.from.publicKey));
        if (t.txn.appAccounts) accts.push(...t.txn.appAccounts.map((a)=>(0, _address.encodeAddress)(a.publicKey)));
        if (t.txn.appForeignApps) {
            apps.push(...t.txn.appForeignApps);
            accts.push(...t.txn.appForeignApps.map((aidx)=>(0, _address.getApplicationAddress)(aidx)));
        }
        if (t.txn.appForeignAssets) assets.push(...t.txn.appForeignAssets);
        // Create application,
        if (t.txn.appIndex === undefined || t.txn.appIndex === 0) appInfos.push(new (0, _types.Application)({
            id: defaultAppId,
            params: new (0, _types.ApplicationParams)({
                creator: (0, _address.encodeAddress)(t.txn.from.publicKey),
                approvalProgram: t.txn.appApprovalProgram,
                clearStateProgram: t.txn.appClearProgram,
                localStateSchema: new (0, _types.ApplicationStateSchema)({
                    numUint: t.txn.appLocalInts,
                    numByteSlice: t.txn.appLocalByteSlices
                }),
                globalStateSchema: new (0, _types.ApplicationStateSchema)({
                    numUint: t.txn.appGlobalInts,
                    numByteSlice: t.txn.appGlobalByteSlices
                })
            })
        }));
        else {
            apps.push(t.txn.appIndex);
            accts.push((0, _address.getApplicationAddress)(t.txn.appIndex));
        }
    }
    // Dedupe and add creator to accts array
    const assetPromises = [];
    for (const assetId of [
        ...new Set(assets)
    ])assetPromises.push(client.getAssetByID(assetId).do().then((assetInfo)=>{
        accts.push(assetInfo.params.creator);
    }));
    // Wait for assets to finish since we append to accts array
    await Promise.all(assetPromises);
    // Dedupe and get app info for all apps
    const appPromises = [];
    for (const appId of [
        ...new Set(apps)
    ])appPromises.push(client.getApplicationByID(appId).do().then((appInfo)=>{
        const ai = decodePrograms(appInfo);
        appInfos.push(ai);
        accts.push(ai.params.creator);
    }));
    await Promise.all(appPromises);
    const acctPromises = [];
    for (const acct of [
        ...new Set(accts)
    ])acctPromises.push(client.accountInformation(acct).do().then((acctInfo)=>{
        if ("created-apps" in acctInfo) // eslint-disable-next-line no-param-reassign
        acctInfo["created-apps"] = acctInfo["created-apps"].map((app)=>decodePrograms(app));
        acctInfos.push(acctInfo);
    }));
    await Promise.all(acctPromises);
    return new (0, _types.DryrunRequest)({
        txns: txns.map((st)=>({
                ...st,
                txn: st.txn.get_obj_for_encoding()
            })),
        accounts: acctInfos,
        apps: appInfos,
        latestTimestamp,
        round,
        protocolVersion,
        sources
    });
}
class DryrunStackValue {
    constructor(sv){
        this.type = 0;
        this.bytes = "";
        this.uint = 0;
        this.type = sv.type;
        this.bytes = sv.bytes;
        this.uint = sv.uint;
    }
    toString() {
        if (this.type === 1) return `0x${(0, _buffer.Buffer).from(this.bytes, "base64").toString("hex")}`;
        return this.uint.toString();
    }
}
class DryrunTraceLine {
    constructor(line){
        this.error = "";
        this.line = 0;
        this.pc = 0;
        this.scratch = [];
        this.stack = [];
        this.error = line.error === undefined ? "" : line.error;
        this.line = line.line;
        this.pc = line.pc;
        this.scratch = line.scratch;
        this.stack = line.stack.map((sv)=>new DryrunStackValue(sv));
    }
}
class DryrunTrace {
    constructor(t){
        this.trace = [];
        if (t == null) return;
        this.trace = t.map((line)=>new DryrunTraceLine(line));
    }
}
function truncate(str, maxValueWidth) {
    if (str.length > maxValueWidth && maxValueWidth > 0) return `${str.slice(0, maxValueWidth)}...`;
    return str;
}
function scratchToString(prevScratch, currScratch) {
    if (currScratch.length === 0) return "";
    let newScratchIdx = null;
    for(let idx = 0; idx < currScratch.length; idx++){
        if (idx > prevScratch.length) {
            newScratchIdx = idx;
            continue;
        }
        if (JSON.stringify(prevScratch[idx]) !== JSON.stringify(currScratch[idx])) newScratchIdx = idx;
    }
    if (newScratchIdx == null) return "";
    const newScratch = currScratch[newScratchIdx];
    if (newScratch.bytes.length > 0) return `${newScratchIdx} = 0x${(0, _buffer.Buffer).from(newScratch.bytes, "base64").toString("hex")}`;
    return `${newScratchIdx} = ${newScratch.uint.toString()}`;
}
function stackToString(stack, reverse) {
    const svs = reverse ? stack.reverse() : stack;
    return `[${svs.map((sv)=>{
        switch(sv.type){
            case 1:
                return `0x${(0, _buffer.Buffer).from(sv.bytes, "base64").toString("hex")}`;
            case 2:
                return `${sv.uint.toString()}`;
            default:
                return "";
        }
    }).join(", ")}]`;
}
class DryrunTransactionResult {
    constructor(dtr){
        this.disassembly = [];
        this.appCallMessages = [];
        this.localDeltas = [];
        this.globalDelta = [];
        this.cost = 0;
        this.logicSigMessages = [];
        this.logicSigDisassembly = [];
        this.logs = [];
        this.appCallTrace = undefined;
        this.logicSigTrace = undefined;
        this.required = [
            "disassembly"
        ];
        this.optionals = [
            "app-call-messages",
            "local-deltas",
            "global-delta",
            "cost",
            "logic-sig-messages",
            "logic-sig-disassembly",
            "logs"
        ];
        this.traces = [
            "app-call-trace",
            "logic-sig-trace"
        ];
        this.disassembly = dtr.disassembly;
        this.appCallMessages = dtr["app-call-messages"];
        this.localDeltas = dtr["local-deltas"];
        this.globalDelta = dtr["global-delta"];
        this.cost = dtr.cost;
        this.logicSigMessages = dtr["logic-sig-messages"];
        this.logicSigDisassembly = dtr["logic-sig-disassembly"];
        this.logs = dtr.logs;
        this.appCallTrace = new DryrunTrace(dtr["app-call-trace"]);
        this.logicSigTrace = new DryrunTrace(dtr["logic-sig-trace"]);
    }
    appCallRejected() {
        return this.appCallMessages !== undefined && this.appCallMessages.includes("REJECT");
    }
    logicSigRejected() {
        return this.logicSigMessages !== undefined && this.logicSigMessages.includes("REJECT");
    }
    static trace(drt, disassembly, spc) {
        const maxWidth = spc.maxValueWidth || defaultMaxWidth;
        // Create the array of arrays, each sub array contains N columns
        const lines = [
            [
                "pc#",
                "ln#",
                "source",
                "scratch",
                "stack"
            ]
        ];
        for(let idx = 0; idx < drt.trace.length; idx++){
            const { line , error , pc , scratch , stack  } = drt.trace[idx];
            const currScratch = scratch !== undefined ? scratch : [];
            const prevScratch = idx > 0 && drt.trace[idx - 1].scratch !== undefined ? drt.trace[idx - 1].scratch : [];
            const src = error === "" ? disassembly[line] : `!! ${error} !!`;
            lines.push([
                pc.toString().padEnd(3, " "),
                line.toString().padEnd(3, " "),
                truncate(src, maxWidth),
                truncate(scratchToString(prevScratch, currScratch), maxWidth),
                truncate(stackToString(stack, spc.topOfStackFirst), maxWidth)
            ]);
        }
        // Get the max length for each column
        const maxLengths = lines.reduce((prev, curr)=>{
            const newVal = new Array(lines[0].length).fill(0);
            for(let idx = 0; idx < prev.length; idx++)newVal[idx] = curr[idx].length > prev[idx] ? curr[idx].length : prev[idx];
            return newVal;
        }, new Array(lines[0].length).fill(0));
        return `${lines.map((line)=>line.map((v, idx)=>v.padEnd(maxLengths[idx] + 1, " ")).join("|").trim()).join("\n")}\n`;
    }
    appTrace(spc) {
        if (this.appCallTrace === undefined || !this.disassembly) return "";
        let conf = spc;
        if (spc === undefined) conf = {
            maxValueWidth: defaultMaxWidth,
            topOfStackFirst: false
        };
        return DryrunTransactionResult.trace(this.appCallTrace, this.disassembly, conf);
    }
    lsigTrace(spc) {
        if (this.logicSigTrace === undefined || this.logicSigDisassembly === undefined) return "";
        let conf = spc;
        if (spc === undefined) conf = {
            maxValueWidth: defaultMaxWidth,
            topOfStackFirst: true
        };
        return DryrunTransactionResult.trace(this.logicSigTrace, this.logicSigDisassembly, conf);
    }
}
class DryrunResult {
    constructor(drrResp){
        this.error = "";
        this.protocolVersion = "";
        this.txns = [];
        this.error = drrResp.error;
        this.protocolVersion = drrResp["protocol-version"];
        this.txns = drrResp.txns.map((txn)=>new DryrunTransactionResult(txn));
    }
}

},{"buffer":"jlSk7","./client/v2/algod/models/types":"5YZy0","./types/transactions":"8EISr","./encoding/address":"7lw2f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8EISr":[function(require,module,exports) {
// Utilities
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionType", ()=>(0, _base.TransactionType));
var _base = require("./base");
var _encoded = require("./encoded");
parcelHelpers.exportAll(_encoded, exports);

},{"./base":"k2yip","./encoded":"dl6iH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dl6iH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBsla":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnApplicationComplete", ()=>(0, _base.OnApplicationComplete));
/**
 * makePaymentTxnWithSuggestedParams takes payment arguments and returns a Transaction object
 * @param from - string representation of Algorand address of sender
 * @param to - string representation of Algorand address of recipient
 * @param amount - integer amount to send, in microAlgos
 * @param closeRemainderTo - optionally close out remaining account balance to this account, represented as string rep of Algorand address
 * @param note - uint8array of arbitrary data for sender to store
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param rekeyTo - rekeyTo address, optional
 */ parcelHelpers.export(exports, "makePaymentTxnWithSuggestedParams", ()=>makePaymentTxnWithSuggestedParams);
// helper for above makePaymentTxnWithSuggestedParams, instead accepting an arguments object
parcelHelpers.export(exports, "makePaymentTxnWithSuggestedParamsFromObject", ()=>makePaymentTxnWithSuggestedParamsFromObject);
parcelHelpers.export(exports, "makeKeyRegistrationTxnWithSuggestedParams", ()=>makeKeyRegistrationTxnWithSuggestedParams);
parcelHelpers.export(exports, "makeKeyRegistrationTxnWithSuggestedParamsFromObject", ()=>makeKeyRegistrationTxnWithSuggestedParamsFromObject);
/** makeAssetCreateTxnWithSuggestedParams takes asset creation arguments and returns a Transaction object
 * for creating that asset
 *
 * @param from - string representation of Algorand address of sender
 * @param note - uint8array of arbitrary data for sender to store
 * @param total - integer total supply of the asset
 * @param decimals - integer number of decimals for asset unit calculation
 * @param defaultFrozen - boolean whether asset accounts should default to being frozen
 * @param manager - string representation of Algorand address in charge of reserve, freeze, clawback, destruction, etc
 * @param reserve - string representation of Algorand address representing asset reserve
 * @param freeze - string representation of Algorand address with power to freeze/unfreeze asset holdings
 * @param clawback - string representation of Algorand address with power to revoke asset holdings
 * @param unitName - string units name for this asset
 * @param assetName - string name for this asset
 * @param assetURL - string URL relating to this asset
 * @param assetMetadataHash - Uint8Array or UTF-8 string representation of a hash commitment with respect to the asset. Must be exactly 32 bytes long.
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param rekeyTo - rekeyTo address, optional
 */ parcelHelpers.export(exports, "makeAssetCreateTxnWithSuggestedParams", ()=>makeAssetCreateTxnWithSuggestedParams);
// helper for above makeAssetCreateTxnWithSuggestedParams, instead accepting an arguments object
parcelHelpers.export(exports, "makeAssetCreateTxnWithSuggestedParamsFromObject", ()=>makeAssetCreateTxnWithSuggestedParamsFromObject);
/** makeAssetConfigTxnWithSuggestedParams can be issued by the asset manager to change the manager, reserve, freeze, or clawback
 * you must respecify existing addresses to keep them the same; leaving a field blank is the same as turning
 * that feature off for this asset
 *
 * @param from - string representation of Algorand address of sender
 * @param note - uint8array of arbitrary data for sender to store
 * @param assetIndex - int asset index uniquely specifying the asset
 * @param manager - string representation of new asset manager Algorand address
 * @param reserve - string representation of new reserve Algorand address
 * @param freeze - string representation of new freeze manager Algorand address
 * @param clawback - string representation of new revocation manager Algorand address
 * @param strictEmptyAddressChecking - boolean - throw an error if any of manager, reserve, freeze, or clawback are undefined. optional, defaults to true.
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param rekeyTo - rekeyTo address, optional
 */ parcelHelpers.export(exports, "makeAssetConfigTxnWithSuggestedParams", ()=>makeAssetConfigTxnWithSuggestedParams);
// helper for above makeAssetConfigTxnWithSuggestedParams, instead accepting an arguments object
parcelHelpers.export(exports, "makeAssetConfigTxnWithSuggestedParamsFromObject", ()=>makeAssetConfigTxnWithSuggestedParamsFromObject);
/** makeAssetDestroyTxnWithSuggestedParams will allow the asset's manager to remove this asset from the ledger, so long
 * as all outstanding assets are held by the creator.
 *
 * @param from - string representation of Algorand address of sender
 * @param note - uint8array of arbitrary data for sender to store
 * @param assetIndex - int asset index uniquely specifying the asset
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param rekeyTo - rekeyTo address, optional
 */ parcelHelpers.export(exports, "makeAssetDestroyTxnWithSuggestedParams", ()=>makeAssetDestroyTxnWithSuggestedParams);
// helper for above makeAssetDestroyTxnWithSuggestedParams, instead accepting an arguments object
parcelHelpers.export(exports, "makeAssetDestroyTxnWithSuggestedParamsFromObject", ()=>makeAssetDestroyTxnWithSuggestedParamsFromObject);
/** makeAssetFreezeTxnWithSuggestedParams will allow the asset's freeze manager to freeze or un-freeze an account,
 * blocking or allowing asset transfers to and from the targeted account.
 *
 * @param from - string representation of Algorand address of sender
 * @param note - uint8array of arbitrary data for sender to store
 * @param assetIndex - int asset index uniquely specifying the asset
 * @param freezeTarget - string representation of Algorand address being frozen or unfrozen
 * @param freezeState - true if freezeTarget should be frozen, false if freezeTarget should be allowed to transact
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param rekeyTo - rekeyTo address, optional
 */ parcelHelpers.export(exports, "makeAssetFreezeTxnWithSuggestedParams", ()=>makeAssetFreezeTxnWithSuggestedParams);
// helper for above makeAssetFreezeTxnWithSuggestedParams, instead accepting an arguments object
parcelHelpers.export(exports, "makeAssetFreezeTxnWithSuggestedParamsFromObject", ()=>makeAssetFreezeTxnWithSuggestedParamsFromObject);
/** makeAssetTransferTxnWithSuggestedParams allows for the creation of an asset transfer transaction.
 * Special case: to begin accepting assets, set amount=0 and from=to.
 *
 * @param from - string representation of Algorand address of sender
 * @param to - string representation of Algorand address of asset recipient
 * @param closeRemainderTo - optional - string representation of Algorand address - if provided,
 * send all remaining assets after transfer to the "closeRemainderTo" address and close "from"'s asset holdings
 * @param revocationTarget - optional - string representation of Algorand address - if provided,
 * and if "from" is the asset's revocation manager, then deduct from "revocationTarget" rather than "from"
 * @param amount - integer amount of assets to send
 * @param note - uint8array of arbitrary data for sender to store
 * @param assetIndex - int asset index uniquely specifying the asset
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param rekeyTo - rekeyTo address, optional
 */ parcelHelpers.export(exports, "makeAssetTransferTxnWithSuggestedParams", ()=>makeAssetTransferTxnWithSuggestedParams);
// helper for above makeAssetTransferTxnWithSuggestedParams, instead accepting an arguments object
parcelHelpers.export(exports, "makeAssetTransferTxnWithSuggestedParamsFromObject", ()=>makeAssetTransferTxnWithSuggestedParamsFromObject);
/**
 * Make a transaction that will create an application.
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param onComplete - algosdk.OnApplicationComplete, what application should do once the program is done being run
 * @param approvalProgram - Uint8Array, the compiled TEAL that approves a transaction
 * @param clearProgram - Uint8Array, the compiled TEAL that runs when clearing state
 * @param numLocalInts - restricts number of ints in per-user local state
 * @param numLocalByteSlices - restricts number of byte slices in per-user local state
 * @param numGlobalInts - restricts number of ints in global state
 * @param numGlobalByteSlices - restricts number of byte slices in global state
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param extraPages - integer extra pages of memory to rent on creation of application
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationCreateTxn", ()=>makeApplicationCreateTxn);
// helper for above makeApplicationCreateTxn, instead accepting an arguments object
parcelHelpers.export(exports, "makeApplicationCreateTxnFromObject", ()=>makeApplicationCreateTxnFromObject);
/**
 * Make a transaction that changes an application's approval and clear programs
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param appIndex - the ID of the app to be updated
 * @param approvalProgram - Uint8Array, the compiled TEAL that approves a transaction
 * @param clearProgram - Uint8Array, the compiled TEAL that runs when clearing state
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationUpdateTxn", ()=>makeApplicationUpdateTxn);
// helper for above makeApplicationUpdateTxn, instead accepting an arguments object
parcelHelpers.export(exports, "makeApplicationUpdateTxnFromObject", ()=>makeApplicationUpdateTxnFromObject);
/**
 * Make a transaction that deletes an application
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param appIndex - the ID of the app to be deleted
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationDeleteTxn", ()=>makeApplicationDeleteTxn);
// helper for above makeApplicationDeleteTxn, instead accepting an arguments object
parcelHelpers.export(exports, "makeApplicationDeleteTxnFromObject", ()=>makeApplicationDeleteTxnFromObject);
/**
 * Make a transaction that opts in to use an application
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param appIndex - the ID of the app to join
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationOptInTxn", ()=>makeApplicationOptInTxn);
// helper for above makeApplicationOptInTxn, instead accepting an argument object
parcelHelpers.export(exports, "makeApplicationOptInTxnFromObject", ()=>makeApplicationOptInTxnFromObject);
/**
 * Make a transaction that closes out a user's state in an application
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param appIndex - the ID of the app to use
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationCloseOutTxn", ()=>makeApplicationCloseOutTxn);
// helper for above makeApplicationCloseOutTxn, instead accepting an argument object
parcelHelpers.export(exports, "makeApplicationCloseOutTxnFromObject", ()=>makeApplicationCloseOutTxnFromObject);
/**
 * Make a transaction that clears a user's state in an application
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param appIndex - the ID of the app to use
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationClearStateTxn", ()=>makeApplicationClearStateTxn);
// helper for above makeApplicationClearStateTxn, instead accepting an argument object
parcelHelpers.export(exports, "makeApplicationClearStateTxnFromObject", ()=>makeApplicationClearStateTxnFromObject);
/**
 * Make a transaction that just calls an application, doing nothing on completion
 * @param from - address of sender
 * @param suggestedParams - a dict holding common-to-all-txns args:
 * fee - integer fee per byte, in microAlgos. for a flat fee, set flatFee to true
 * flatFee - bool optionally set this to true to specify fee as microalgos-per-txn
 *       If true, txn fee may fall below the ALGORAND_MIN_TX_FEE
 * firstRound - integer first protocol round on which this txn is valid
 * lastRound - integer last protocol round on which this txn is valid
 * genesisHash - string specifies hash genesis block of network in use
 * genesisID - string specifies genesis ID of network in use
 * @param appIndex - the ID of the app to use
 * @param appArgs - Array of Uint8Array, any additional arguments to the application
 * @param accounts - Array of Address strings, any additional accounts to supply to the application
 * @param foreignApps - Array of int, any other apps used by the application, identified by index
 * @param foreignAssets - Array of int, any assets used by the application, identified by index
 * @param note - Arbitrary data for sender to store
 * @param lease - Lease a transaction
 * @param rekeyTo - String representation of the Algorand address that will be used to authorize all future transactions
 * @param boxes - Array of BoxReference, app ID and name of box to be accessed
 */ parcelHelpers.export(exports, "makeApplicationNoOpTxn", ()=>makeApplicationNoOpTxn);
// helper for above makeApplicationNoOpTxn, instead accepting an argument object
parcelHelpers.export(exports, "makeApplicationNoOpTxnFromObject", ()=>makeApplicationNoOpTxnFromObject);
/**
 * Generic function for creating any application call transaction.
 */ parcelHelpers.export(exports, "makeApplicationCallTxnFromObject", ()=>makeApplicationCallTxnFromObject);
var _transaction = require("./transaction");
var _base = require("./types/transactions/base");
var _transactions = require("./types/transactions");
function makePaymentTxnWithSuggestedParams(from, to, amount, closeRemainderTo, note, suggestedParams, rekeyTo) {
    const o = {
        from,
        to,
        amount,
        closeRemainderTo,
        note,
        suggestedParams,
        type: (0, _transactions.TransactionType).pay,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makePaymentTxnWithSuggestedParamsFromObject(o) {
    return makePaymentTxnWithSuggestedParams(o.from, o.to, o.amount, o.closeRemainderTo, o.note, o.suggestedParams, o.rekeyTo);
}
function makeKeyRegistrationTxnWithSuggestedParams(from, note, voteKey, selectionKey, voteFirst, voteLast, voteKeyDilution, suggestedParams, rekeyTo, nonParticipation = false, stateProofKey) {
    const o = {
        from,
        note,
        voteKey,
        selectionKey,
        voteFirst,
        voteLast,
        voteKeyDilution,
        suggestedParams,
        type: (0, _transactions.TransactionType).keyreg,
        reKeyTo: rekeyTo,
        nonParticipation,
        stateProofKey
    };
    return new _transaction.Transaction(o);
}
function makeKeyRegistrationTxnWithSuggestedParamsFromObject(o) {
    return makeKeyRegistrationTxnWithSuggestedParams(o.from, o.note, o.voteKey, o.selectionKey, o.voteFirst, o.voteLast, o.voteKeyDilution, o.suggestedParams, o.rekeyTo, o.nonParticipation, o.stateProofKey);
}
function makeAssetCreateTxnWithSuggestedParams(from, note, total, decimals, defaultFrozen, manager, reserve, freeze, clawback, unitName, assetName, assetURL, assetMetadataHash, suggestedParams, rekeyTo) {
    const o = {
        from,
        note,
        suggestedParams,
        assetTotal: total,
        assetDecimals: decimals,
        assetDefaultFrozen: defaultFrozen,
        assetUnitName: unitName,
        assetName,
        assetURL,
        assetMetadataHash,
        assetManager: manager,
        assetReserve: reserve,
        assetFreeze: freeze,
        assetClawback: clawback,
        type: (0, _transactions.TransactionType).acfg,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeAssetCreateTxnWithSuggestedParamsFromObject(o) {
    return makeAssetCreateTxnWithSuggestedParams(o.from, o.note, o.total, o.decimals, o.defaultFrozen, o.manager, o.reserve, o.freeze, o.clawback, o.unitName, o.assetName, o.assetURL, o.assetMetadataHash, o.suggestedParams, o.rekeyTo);
}
function makeAssetConfigTxnWithSuggestedParams(from, note, assetIndex, manager, reserve, freeze, clawback, suggestedParams, strictEmptyAddressChecking = true, rekeyTo) {
    if (strictEmptyAddressChecking && (manager === undefined || reserve === undefined || freeze === undefined || clawback === undefined)) throw Error("strict empty address checking was turned on, but at least one empty address was provided");
    const o = {
        from,
        suggestedParams,
        assetIndex,
        assetManager: manager,
        assetReserve: reserve,
        assetFreeze: freeze,
        assetClawback: clawback,
        type: (0, _transactions.TransactionType).acfg,
        note,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeAssetConfigTxnWithSuggestedParamsFromObject(o) {
    return makeAssetConfigTxnWithSuggestedParams(o.from, o.note, o.assetIndex, o.manager, o.reserve, o.freeze, o.clawback, o.suggestedParams, o.strictEmptyAddressChecking, o.rekeyTo);
}
function makeAssetDestroyTxnWithSuggestedParams(from, note, assetIndex, suggestedParams, rekeyTo) {
    const o = {
        from,
        suggestedParams,
        assetIndex,
        type: (0, _transactions.TransactionType).acfg,
        note,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeAssetDestroyTxnWithSuggestedParamsFromObject(o) {
    return makeAssetDestroyTxnWithSuggestedParams(o.from, o.note, o.assetIndex, o.suggestedParams, o.rekeyTo);
}
function makeAssetFreezeTxnWithSuggestedParams(from, note, assetIndex, freezeTarget, freezeState, suggestedParams, rekeyTo) {
    const o = {
        from,
        type: (0, _transactions.TransactionType).afrz,
        freezeAccount: freezeTarget,
        assetIndex,
        freezeState,
        note,
        suggestedParams,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeAssetFreezeTxnWithSuggestedParamsFromObject(o) {
    return makeAssetFreezeTxnWithSuggestedParams(o.from, o.note, o.assetIndex, o.freezeTarget, o.freezeState, o.suggestedParams, o.rekeyTo);
}
function makeAssetTransferTxnWithSuggestedParams(from, to, closeRemainderTo, revocationTarget, amount, note, assetIndex, suggestedParams, rekeyTo) {
    const o = {
        type: (0, _transactions.TransactionType).axfer,
        from,
        to,
        amount,
        suggestedParams,
        assetIndex,
        note,
        assetRevocationTarget: revocationTarget,
        closeRemainderTo,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeAssetTransferTxnWithSuggestedParamsFromObject(o) {
    return makeAssetTransferTxnWithSuggestedParams(o.from, o.to, o.closeRemainderTo, o.revocationTarget, o.amount, o.note, o.assetIndex, o.suggestedParams, o.rekeyTo);
}
function makeApplicationCreateTxn(from, suggestedParams, onComplete, approvalProgram, clearProgram, numLocalInts, numLocalByteSlices, numGlobalInts, numGlobalByteSlices, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, extraPages, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex: 0,
        appOnComplete: onComplete,
        appLocalInts: numLocalInts,
        appLocalByteSlices: numLocalByteSlices,
        appGlobalInts: numGlobalInts,
        appGlobalByteSlices: numGlobalByteSlices,
        appApprovalProgram: approvalProgram,
        appClearProgram: clearProgram,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo,
        extraPages
    };
    return new _transaction.Transaction(o);
}
function makeApplicationCreateTxnFromObject(o) {
    return makeApplicationCreateTxn(o.from, o.suggestedParams, o.onComplete, o.approvalProgram, o.clearProgram, o.numLocalInts, o.numLocalByteSlices, o.numGlobalInts, o.numGlobalByteSlices, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.extraPages, o.boxes);
}
function makeApplicationUpdateTxn(from, suggestedParams, appIndex, approvalProgram, clearProgram, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex,
        appApprovalProgram: approvalProgram,
        appOnComplete: (0, _base.OnApplicationComplete).UpdateApplicationOC,
        appClearProgram: clearProgram,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeApplicationUpdateTxnFromObject(o) {
    return makeApplicationUpdateTxn(o.from, o.suggestedParams, o.appIndex, o.approvalProgram, o.clearProgram, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.boxes);
}
function makeApplicationDeleteTxn(from, suggestedParams, appIndex, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex,
        appOnComplete: (0, _base.OnApplicationComplete).DeleteApplicationOC,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeApplicationDeleteTxnFromObject(o) {
    return makeApplicationDeleteTxn(o.from, o.suggestedParams, o.appIndex, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.boxes);
}
function makeApplicationOptInTxn(from, suggestedParams, appIndex, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex,
        appOnComplete: (0, _base.OnApplicationComplete).OptInOC,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeApplicationOptInTxnFromObject(o) {
    return makeApplicationOptInTxn(o.from, o.suggestedParams, o.appIndex, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.boxes);
}
function makeApplicationCloseOutTxn(from, suggestedParams, appIndex, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex,
        appOnComplete: (0, _base.OnApplicationComplete).CloseOutOC,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeApplicationCloseOutTxnFromObject(o) {
    return makeApplicationCloseOutTxn(o.from, o.suggestedParams, o.appIndex, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.boxes);
}
function makeApplicationClearStateTxn(from, suggestedParams, appIndex, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex,
        appOnComplete: (0, _base.OnApplicationComplete).ClearStateOC,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeApplicationClearStateTxnFromObject(o) {
    return makeApplicationClearStateTxn(o.from, o.suggestedParams, o.appIndex, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.boxes);
}
function makeApplicationNoOpTxn(from, suggestedParams, appIndex, appArgs, accounts, foreignApps, foreignAssets, note, lease, rekeyTo, boxes) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from,
        suggestedParams,
        appIndex,
        appOnComplete: (0, _base.OnApplicationComplete).NoOpOC,
        appArgs,
        appAccounts: accounts,
        appForeignApps: foreignApps,
        appForeignAssets: foreignAssets,
        boxes,
        note,
        lease,
        reKeyTo: rekeyTo
    };
    return new _transaction.Transaction(o);
}
function makeApplicationNoOpTxnFromObject(o) {
    return makeApplicationNoOpTxn(o.from, o.suggestedParams, o.appIndex, o.appArgs, o.accounts, o.foreignApps, o.foreignAssets, o.note, o.lease, o.rekeyTo, o.boxes);
}
function makeApplicationCallTxnFromObject(options) {
    const o = {
        type: (0, _transactions.TransactionType).appl,
        from: options.from,
        suggestedParams: options.suggestedParams,
        appIndex: options.appIndex,
        appOnComplete: options.onComplete,
        appLocalInts: options.numLocalInts,
        appLocalByteSlices: options.numLocalByteSlices,
        appGlobalInts: options.numGlobalInts,
        appGlobalByteSlices: options.numGlobalByteSlices,
        appApprovalProgram: options.approvalProgram,
        appClearProgram: options.clearProgram,
        appArgs: options.appArgs,
        appAccounts: options.accounts,
        appForeignApps: options.foreignApps,
        appForeignAssets: options.foreignAssets,
        boxes: options.boxes,
        note: options.note,
        lease: options.lease,
        reKeyTo: options.rekeyTo,
        extraPages: options.extraPages
    };
    return new _transaction.Transaction(o);
}

},{"./transaction":"1n32l","./types/transactions/base":"k2yip","./types/transactions":"8EISr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dp7CF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a TransactionSigner that can sign transactions for the provided basic Account.
 */ parcelHelpers.export(exports, "makeBasicAccountTransactionSigner", ()=>makeBasicAccountTransactionSigner);
/**
 * Create a TransactionSigner that can sign transactions for the provided LogicSigAccount.
 */ parcelHelpers.export(exports, "makeLogicSigAccountTransactionSigner", ()=>makeLogicSigAccountTransactionSigner);
/**
 * Create a TransactionSigner that can sign transactions for the provided Multisig account.
 * @param msig - The Multisig account metadata
 * @param sks - An array of private keys belonging to the msig which should sign the transactions.
 */ parcelHelpers.export(exports, "makeMultiSigAccountTransactionSigner", ()=>makeMultiSigAccountTransactionSigner);
/**
 * Create a makeEmptyTransactionSigner that does not specify any signer or
 * signing capabilities. This should only be used to simulate transactions.
 */ parcelHelpers.export(exports, "makeEmptyTransactionSigner", ()=>makeEmptyTransactionSigner);
/**
 * Check if a value conforms to the TransactionWithSigner structure.
 * @param value - The value to check.
 * @returns True if an only if the value has the structure of a TransactionWithSigner.
 */ parcelHelpers.export(exports, "isTransactionWithSigner", ()=>isTransactionWithSigner);
var _transaction = require("./transaction");
var _logicsig = require("./logicsig");
var _multisig = require("./multisig");
function makeBasicAccountTransactionSigner(account) {
    return (txnGroup, indexesToSign)=>{
        const signed = [];
        for (const index of indexesToSign)signed.push(txnGroup[index].signTxn(account.sk));
        return Promise.resolve(signed);
    };
}
function makeLogicSigAccountTransactionSigner(account) {
    return (txnGroup, indexesToSign)=>{
        const signed = [];
        for (const index of indexesToSign){
            const { blob  } = (0, _logicsig.signLogicSigTransactionObject)(txnGroup[index], account);
            signed.push(blob);
        }
        return Promise.resolve(signed);
    };
}
function makeMultiSigAccountTransactionSigner(msig, sks) {
    return (txnGroup, indexesToSign)=>{
        const signed = [];
        for (const index of indexesToSign){
            const txn = txnGroup[index];
            const partialSigs = [];
            for (const sk of sks){
                const { blob  } = (0, _multisig.signMultisigTransaction)(txn, msig, sk);
                partialSigs.push(blob);
            }
            signed.push((0, _multisig.mergeMultisigTransactions)(partialSigs));
        }
        return Promise.resolve(signed);
    };
}
function makeEmptyTransactionSigner() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (txnGroup, indexesToSign)=>{
        const unsigned = [];
        for (const index of indexesToSign)unsigned.push((0, _transaction.encodeUnsignedSimulateTransaction)(txnGroup[index]));
        return Promise.resolve(unsigned);
    };
}
function isTransactionWithSigner(value) {
    return typeof value === "object" && Object.keys(value).length === 2 && typeof value.txn === "object" && typeof value.signer === "function";
}

},{"./transaction":"1n32l","./logicsig":"3OHRO","./multisig":"lw3S9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3NTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomicTransactionComposerStatus", ()=>AtomicTransactionComposerStatus);
/** A class used to construct and execute atomic transaction groups */ parcelHelpers.export(exports, "AtomicTransactionComposer", ()=>AtomicTransactionComposer);
var _buffer = require("buffer");
var _abi = require("./abi");
var _types = require("./client/v2/algod/models/types");
var _group = require("./group");
var _makeTxn = require("./makeTxn");
var _signer = require("./signer");
var _transaction = require("./transaction");
var _base = require("./types/transactions/base");
var _wait = require("./wait");
var _encoding = require("./encoding/encoding");
// First 4 bytes of SHA-512/256 hash of "return"
const RETURN_PREFIX = (0, _buffer.Buffer).from([
    21,
    31,
    124,
    117
]);
// The maximum number of arguments for an application call transaction
const MAX_APP_ARGS = 16;
var AtomicTransactionComposerStatus;
(function(AtomicTransactionComposerStatus) {
    /** The atomic group is still under construction. */ AtomicTransactionComposerStatus[AtomicTransactionComposerStatus["BUILDING"] = 0] = "BUILDING";
    /** The atomic group has been finalized, but not yet signed. */ AtomicTransactionComposerStatus[AtomicTransactionComposerStatus["BUILT"] = 1] = "BUILT";
    /** The atomic group has been finalized and signed, but not yet submitted to the network. */ AtomicTransactionComposerStatus[AtomicTransactionComposerStatus["SIGNED"] = 2] = "SIGNED";
    /** The atomic group has been finalized, signed, and submitted to the network. */ AtomicTransactionComposerStatus[AtomicTransactionComposerStatus["SUBMITTED"] = 3] = "SUBMITTED";
    /** The atomic group has been finalized, signed, submitted, and successfully committed to a block. */ AtomicTransactionComposerStatus[AtomicTransactionComposerStatus["COMMITTED"] = 4] = "COMMITTED";
})(AtomicTransactionComposerStatus || (AtomicTransactionComposerStatus = {}));
/**
 * Add a value to an application call's foreign array. The addition will be as compact as possible,
 * and this function will return an index that can be used to reference `valueToAdd` in `array`.
 *
 * @param valueToAdd - The value to add to the array. If this value is already present in the array,
 *   it will not be added again. Instead, the existing index will be returned.
 * @param array - The existing foreign array. This input may be modified to append `valueToAdd`.
 * @param zeroValue - If provided, this value indicated two things: the 0 value is special for this
 *   array, so all indexes into `array` must start at 1; additionally, if `valueToAdd` equals
 *   `zeroValue`, then `valueToAdd` will not be added to the array, and instead the 0 indexes will
 *   be returned.
 * @returns An index that can be used to reference `valueToAdd` in `array`.
 */ function populateForeignArray(valueToAdd, array, zeroValue) {
    if (zeroValue != null && valueToAdd === zeroValue) return 0;
    const offset = zeroValue == null ? 0 : 1;
    for(let i = 0; i < array.length; i++){
        if (valueToAdd === array[i]) return i + offset;
    }
    array.push(valueToAdd);
    return array.length - 1 + offset;
}
class AtomicTransactionComposer {
    constructor(){
        this.status = AtomicTransactionComposerStatus.BUILDING;
        this.transactions = [];
        this.methodCalls = new Map();
        this.signedTxns = [];
        this.txIDs = [];
    }
    /**
     * Get the status of this composer's transaction group.
     */ getStatus() {
        return this.status;
    }
    /**
     * Get the number of transactions currently in this atomic group.
     */ count() {
        return this.transactions.length;
    }
    /**
     * Create a new composer with the same underlying transactions. The new composer's status will be
     * BUILDING, so additional transactions may be added to it.
     */ clone() {
        const theClone = new AtomicTransactionComposer();
        theClone.transactions = this.transactions.map(({ txn , signer  })=>({
                // not quite a deep copy, but good enough for our purposes (modifying txn.group in buildGroup)
                txn: (0, _transaction.Transaction).from_obj_for_encoding({
                    ...txn.get_obj_for_encoding(),
                    // erase the group ID
                    grp: undefined
                }),
                signer
            }));
        theClone.methodCalls = new Map(this.methodCalls);
        return theClone;
    }
    /**
     * Add a transaction to this atomic group.
     *
     * An error will be thrown if the transaction has a nonzero group ID, the composer's status is
     * not BUILDING, or if adding this transaction causes the current group to exceed MAX_GROUP_SIZE.
     */ addTransaction(txnAndSigner) {
        if (this.status !== AtomicTransactionComposerStatus.BUILDING) throw new Error("Cannot add transactions when composer status is not BUILDING");
        if (this.transactions.length === AtomicTransactionComposer.MAX_GROUP_SIZE) throw new Error(`Adding an additional transaction exceeds the maximum atomic group size of ${AtomicTransactionComposer.MAX_GROUP_SIZE}`);
        if (txnAndSigner.txn.group && txnAndSigner.txn.group.some((v)=>v !== 0)) throw new Error("Cannot add a transaction with nonzero group ID");
        this.transactions.push(txnAndSigner);
    }
    /**
     * Add a smart contract method call to this atomic group.
     *
     * An error will be thrown if the composer's status is not BUILDING, if adding this transaction
     * causes the current group to exceed MAX_GROUP_SIZE, or if the provided arguments are invalid
     * for the given method.
     */ addMethodCall({ appID , method , methodArgs , sender , suggestedParams , onComplete , approvalProgram , clearProgram , numGlobalInts , numGlobalByteSlices , numLocalInts , numLocalByteSlices , extraPages , appAccounts , appForeignApps , appForeignAssets , boxes , note , lease , rekeyTo , signer  }) {
        if (this.status !== AtomicTransactionComposerStatus.BUILDING) throw new Error("Cannot add transactions when composer status is not BUILDING");
        if (this.transactions.length + method.txnCount() > AtomicTransactionComposer.MAX_GROUP_SIZE) throw new Error(`Adding additional transactions exceeds the maximum atomic group size of ${AtomicTransactionComposer.MAX_GROUP_SIZE}`);
        if (appID === 0) {
            if (approvalProgram == null || clearProgram == null || numGlobalInts == null || numGlobalByteSlices == null || numLocalInts == null || numLocalByteSlices == null) throw new Error("One of the following required parameters for application creation is missing: approvalProgram, clearProgram, numGlobalInts, numGlobalByteSlices, numLocalInts, numLocalByteSlices");
        } else if (onComplete === (0, _base.OnApplicationComplete).UpdateApplicationOC) {
            if (approvalProgram == null || clearProgram == null) throw new Error("One of the following required parameters for OnApplicationComplete.UpdateApplicationOC is missing: approvalProgram, clearProgram");
            if (numGlobalInts != null || numGlobalByteSlices != null || numLocalInts != null || numLocalByteSlices != null || extraPages != null) throw new Error("One of the following application creation parameters were set on a non-creation call: numGlobalInts, numGlobalByteSlices, numLocalInts, numLocalByteSlices, extraPages");
        } else if (approvalProgram != null || clearProgram != null || numGlobalInts != null || numGlobalByteSlices != null || numLocalInts != null || numLocalByteSlices != null || extraPages != null) throw new Error("One of the following application creation parameters were set on a non-creation call: approvalProgram, clearProgram, numGlobalInts, numGlobalByteSlices, numLocalInts, numLocalByteSlices, extraPages");
        if (methodArgs == null) // eslint-disable-next-line no-param-reassign
        methodArgs = [];
        if (methodArgs.length !== method.args.length) throw new Error(`Incorrect number of method arguments. Expected ${method.args.length}, got ${methodArgs.length}`);
        let basicArgTypes = [];
        let basicArgValues = [];
        const txnArgs = [];
        const refArgTypes = [];
        const refArgValues = [];
        const refArgIndexToBasicArgIndex = new Map();
        // TODO: Box encoding for ABI
        const boxReferences = !boxes ? [] : boxes;
        for(let i = 0; i < methodArgs.length; i++){
            let argType = method.args[i].type;
            const argValue = methodArgs[i];
            if ((0, _abi.abiTypeIsTransaction)(argType)) {
                if (!(0, _signer.isTransactionWithSigner)(argValue) || !(0, _abi.abiCheckTransactionType)(argType, argValue.txn)) throw new Error(`Expected ${argType} transaction for argument at index ${i}`);
                if (argValue.txn.group && argValue.txn.group.some((v)=>v !== 0)) throw new Error("Cannot add a transaction with nonzero group ID");
                txnArgs.push(argValue);
                continue;
            }
            if ((0, _signer.isTransactionWithSigner)(argValue)) throw new Error(`Expected non-transaction value for argument at index ${i}`);
            if ((0, _abi.abiTypeIsReference)(argType)) {
                refArgIndexToBasicArgIndex.set(refArgTypes.length, basicArgTypes.length);
                refArgTypes.push(argType);
                refArgValues.push(argValue);
                // treat the reference as a uint8 for encoding purposes
                argType = new (0, _abi.ABIUintType)(8);
            }
            if (typeof argType === "string") throw new Error(`Unknown ABI type: ${argType}`);
            basicArgTypes.push(argType);
            basicArgValues.push(argValue);
        }
        const resolvedRefIndexes = [];
        const foreignAccounts = appAccounts == null ? [] : appAccounts.slice();
        const foreignApps = appForeignApps == null ? [] : appForeignApps.slice();
        const foreignAssets = appForeignAssets == null ? [] : appForeignAssets.slice();
        for(let i = 0; i < refArgTypes.length; i++){
            const refType = refArgTypes[i];
            const refValue = refArgValues[i];
            let resolved = 0;
            switch(refType){
                case (0, _abi.ABIReferenceType).account:
                    {
                        const addressType = new (0, _abi.ABIAddressType)();
                        const address = addressType.decode(addressType.encode(refValue));
                        resolved = populateForeignArray(address, foreignAccounts, sender);
                        break;
                    }
                case (0, _abi.ABIReferenceType).application:
                    {
                        const uint64Type = new (0, _abi.ABIUintType)(64);
                        const refAppID = uint64Type.decode(uint64Type.encode(refValue));
                        if (refAppID > Number.MAX_SAFE_INTEGER) throw new Error(`Expected safe integer for application value, got ${refAppID}`);
                        resolved = populateForeignArray(Number(refAppID), foreignApps, appID);
                        break;
                    }
                case (0, _abi.ABIReferenceType).asset:
                    {
                        const uint64Type = new (0, _abi.ABIUintType)(64);
                        const refAssetID = uint64Type.decode(uint64Type.encode(refValue));
                        if (refAssetID > Number.MAX_SAFE_INTEGER) throw new Error(`Expected safe integer for asset value, got ${refAssetID}`);
                        resolved = populateForeignArray(Number(refAssetID), foreignAssets);
                        break;
                    }
                default:
                    throw new Error(`Unknown reference type: ${refType}`);
            }
            resolvedRefIndexes.push(resolved);
        }
        for(let i = 0; i < resolvedRefIndexes.length; i++){
            const basicArgIndex = refArgIndexToBasicArgIndex.get(i);
            basicArgValues[basicArgIndex] = resolvedRefIndexes[i];
        }
        if (basicArgTypes.length > MAX_APP_ARGS - 1) {
            const lastArgTupleTypes = basicArgTypes.slice(MAX_APP_ARGS - 2);
            const lastArgTupleValues = basicArgValues.slice(MAX_APP_ARGS - 2);
            basicArgTypes = basicArgTypes.slice(0, MAX_APP_ARGS - 2);
            basicArgValues = basicArgValues.slice(0, MAX_APP_ARGS - 2);
            basicArgTypes.push(new (0, _abi.ABITupleType)(lastArgTupleTypes));
            basicArgValues.push(lastArgTupleValues);
        }
        const appArgsEncoded = [
            method.getSelector()
        ];
        for(let i = 0; i < basicArgTypes.length; i++)appArgsEncoded.push(basicArgTypes[i].encode(basicArgValues[i]));
        const appCall = {
            txn: (0, _makeTxn.makeApplicationCallTxnFromObject)({
                from: sender,
                appIndex: appID,
                appArgs: appArgsEncoded,
                accounts: foreignAccounts,
                foreignApps,
                foreignAssets,
                boxes: boxReferences,
                onComplete: onComplete == null ? (0, _base.OnApplicationComplete).NoOpOC : onComplete,
                approvalProgram,
                clearProgram,
                numGlobalInts,
                numGlobalByteSlices,
                numLocalInts,
                numLocalByteSlices,
                extraPages,
                lease,
                note,
                rekeyTo,
                suggestedParams
            }),
            signer
        };
        this.transactions.push(...txnArgs, appCall);
        this.methodCalls.set(this.transactions.length - 1, method);
    }
    /**
     * Finalize the transaction group and returned the finalized transactions.
     *
     * The composer's status will be at least BUILT after executing this method.
     */ buildGroup() {
        if (this.status === AtomicTransactionComposerStatus.BUILDING) {
            if (this.transactions.length === 0) throw new Error("Cannot build a group with 0 transactions");
            if (this.transactions.length > 1) (0, _group.assignGroupID)(this.transactions.map((txnWithSigner)=>txnWithSigner.txn));
            this.status = AtomicTransactionComposerStatus.BUILT;
        }
        return this.transactions;
    }
    /**
     * Obtain signatures for each transaction in this group. If signatures have already been obtained,
     * this method will return cached versions of the signatures.
     *
     * The composer's status will be at least SIGNED after executing this method.
     *
     * An error will be thrown if signing any of the transactions fails.
     *
     * @returns A promise that resolves to an array of signed transactions.
     */ async gatherSignatures() {
        if (this.status >= AtomicTransactionComposerStatus.SIGNED) return this.signedTxns;
        // retrieve built transactions and verify status is BUILT
        const txnsWithSigners = this.buildGroup();
        const txnGroup = txnsWithSigners.map((txnWithSigner)=>txnWithSigner.txn);
        const indexesPerSigner = new Map();
        for(let i = 0; i < txnsWithSigners.length; i++){
            const { signer  } = txnsWithSigners[i];
            if (!indexesPerSigner.has(signer)) indexesPerSigner.set(signer, []);
            indexesPerSigner.get(signer).push(i);
        }
        const orderedSigners = Array.from(indexesPerSigner);
        const batchedSigs = await Promise.all(orderedSigners.map(([signer, indexes])=>signer(txnGroup, indexes)));
        const signedTxns = txnsWithSigners.map(()=>null);
        for(let signerIndex = 0; signerIndex < orderedSigners.length; signerIndex++){
            const indexes = orderedSigners[signerIndex][1];
            const sigs = batchedSigs[signerIndex];
            for(let i = 0; i < indexes.length; i++)signedTxns[indexes[i]] = sigs[i];
        }
        if (!signedTxns.every((sig)=>sig != null)) throw new Error(`Missing signatures. Got ${signedTxns}`);
        const txIDs = signedTxns.map((stxn, index)=>{
            try {
                return (0, _transaction.decodeSignedTransaction)(stxn).txn.txID();
            } catch (err) {
                throw new Error(`Cannot decode signed transaction at index ${index}. ${err}`);
            }
        });
        this.signedTxns = signedTxns;
        this.txIDs = txIDs;
        this.status = AtomicTransactionComposerStatus.SIGNED;
        return signedTxns;
    }
    /**
     * Send the transaction group to the network, but don't wait for it to be committed to a block. An
     * error will be thrown if submission fails.
     *
     * The composer's status must be SUBMITTED or lower before calling this method. If submission is
     * successful, this composer's status will update to SUBMITTED.
     *
     * Note: a group can only be submitted again if it fails.
     *
     * @param client - An Algodv2 client
     *
     * @returns A promise that, upon success, resolves to a list of TxIDs of the submitted transactions.
     */ async submit(client) {
        if (this.status > AtomicTransactionComposerStatus.SUBMITTED) throw new Error("Transaction group cannot be resubmitted");
        const stxns = await this.gatherSignatures();
        await client.sendRawTransaction(stxns).do();
        this.status = AtomicTransactionComposerStatus.SUBMITTED;
        return this.txIDs;
    }
    /**
     * Simulates the transaction group in the network.
     *
     * The composer will try to sign any transactions in the group, then simulate
     * the results.
     * Simulating the group will not change the composer's status.
     *
     * @param client - An Algodv2 client
     * @param request - SimulateRequest with options in simulation.
     *   If provided, the request's transaction group will be overrwritten by the composer's group,
     *   only simulation related options will be used.
     *
     * @returns A promise that, upon success, resolves to an object containing an
     *   array of results containing one element for each method call transaction
     *   in this group (ABIResult[]) and the SimulateResponse object.
     */ async simulate(client, request) {
        if (this.status > AtomicTransactionComposerStatus.SUBMITTED) throw new Error("Simulated Transaction group has already been submitted to the network");
        const stxns = await this.gatherSignatures();
        const txnObjects = stxns.map((stxn)=>_encoding.decode(stxn));
        const currentRequest = request == null ? new (0, _types.SimulateRequest)({
            txnGroups: []
        }) : request;
        currentRequest.txnGroups = [
            new (0, _types.SimulateRequestTransactionGroup)({
                txns: txnObjects
            })
        ];
        const simulateResponse = await client.simulateTransactions(currentRequest).do();
        // Parse method response
        const methodResults = [];
        for (const [txnIndex, method] of this.methodCalls){
            const txID = this.txIDs[txnIndex];
            const pendingInfo = simulateResponse.txnGroups[0].txnResults[txnIndex].txnResult;
            const methodResult = {
                txID,
                rawReturnValue: new Uint8Array(),
                method
            };
            methodResults.push(AtomicTransactionComposer.parseMethodResponse(method, methodResult, pendingInfo.get_obj_for_encoding()));
        }
        return {
            methodResults,
            simulateResponse
        };
    }
    /**
     * Send the transaction group to the network and wait until it's committed to a block. An error
     * will be thrown if submission or execution fails.
     *
     * The composer's status must be SUBMITTED or lower before calling this method, since execution is
     * only allowed once. If submission is successful, this composer's status will update to SUBMITTED.
     * If the execution is also successful, this composer's status will update to COMMITTED.
     *
     * Note: a group can only be submitted again if it fails.
     *
     * @param client - An Algodv2 client
     * @param waitRounds - The maximum number of rounds to wait for transaction confirmation
     *
     * @returns A promise that, upon success, resolves to an object containing the confirmed round for
     *   this transaction, the txIDs of the submitted transactions, and an array of results containing
     *   one element for each method call transaction in this group.
     */ async execute(client, waitRounds) {
        if (this.status === AtomicTransactionComposerStatus.COMMITTED) throw new Error("Transaction group has already been executed successfully");
        const txIDs = await this.submit(client);
        this.status = AtomicTransactionComposerStatus.SUBMITTED;
        const firstMethodCallIndex = this.transactions.findIndex((_, index)=>this.methodCalls.has(index));
        const indexToWaitFor = firstMethodCallIndex === -1 ? 0 : firstMethodCallIndex;
        const confirmedTxnInfo = await (0, _wait.waitForConfirmation)(client, txIDs[indexToWaitFor], waitRounds);
        this.status = AtomicTransactionComposerStatus.COMMITTED;
        const confirmedRound = confirmedTxnInfo["confirmed-round"];
        const methodResults = [];
        for (const [txnIndex, method] of this.methodCalls){
            const txID = txIDs[txnIndex];
            let methodResult = {
                txID,
                rawReturnValue: new Uint8Array(),
                method
            };
            try {
                const pendingInfo = txnIndex === firstMethodCallIndex ? confirmedTxnInfo : await client.pendingTransactionInformation(txID).do();
                methodResult = AtomicTransactionComposer.parseMethodResponse(method, methodResult, pendingInfo);
            } catch (err) {
                methodResult.decodeError = err;
            }
            methodResults.push(methodResult);
        }
        return {
            confirmedRound,
            txIDs,
            methodResults
        };
    }
    /**
     * Parses a single ABI Method transaction log into a ABI result object.
     *
     * @param method
     * @param methodResult
     * @param pendingInfo
     * @returns An ABIResult object
     */ static parseMethodResponse(method, methodResult, pendingInfo) {
        const returnedResult = methodResult;
        try {
            returnedResult.txInfo = pendingInfo;
            if (method.returns.type !== "void") {
                const logs = pendingInfo.logs || [];
                if (logs.length === 0) throw new Error("App call transaction did not log a return value");
                const lastLog = (0, _buffer.Buffer).from(logs[logs.length - 1], "base64");
                if (lastLog.byteLength < 4 || !lastLog.slice(0, 4).equals(RETURN_PREFIX)) throw new Error("App call transaction did not log a return value");
                returnedResult.rawReturnValue = new Uint8Array(lastLog.slice(4));
                returnedResult.returnValue = method.returns.type.decode(methodResult.rawReturnValue);
            }
        } catch (err) {
            returnedResult.decodeError = err;
        }
        return returnedResult;
    }
}
/** The maximum size of an atomic transaction group. */ AtomicTransactionComposer.MAX_GROUP_SIZE = 16;

},{"buffer":"jlSk7","./abi":"jd344","./client/v2/algod/models/types":"5YZy0","./group":"7ZBIn","./makeTxn":"hBsla","./signer":"dp7CF","./transaction":"1n32l","./types/transactions/base":"k2yip","./wait":"lIpq2","./encoding/encoding":"1Yg70","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jd344":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _abiType = require("./abi_type");
parcelHelpers.exportAll(_abiType, exports);
var _contract = require("./contract");
parcelHelpers.exportAll(_contract, exports);
var _interface = require("./interface");
parcelHelpers.exportAll(_interface, exports);
var _method = require("./method");
parcelHelpers.exportAll(_method, exports);
var _transaction = require("./transaction");
parcelHelpers.exportAll(_transaction, exports);
var _reference = require("./reference");
parcelHelpers.exportAll(_reference, exports);

},{"./abi_type":"bvYGr","./contract":"bYfCZ","./interface":"4nHsI","./method":"f3cYe","./transaction":"iXzYU","./reference":"XdEZw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvYGr":[function(require,module,exports) {
/* eslint-disable no-bitwise */ /* eslint-disable no-use-before-define */ /* eslint-disable class-methods-use-this */ /**
    //ABI-Types: uint<N>: An N-bit unsigned integer (8 <= N <= 512 and N % 8 = 0).
    // | byte (alias for uint8)
    // | ufixed <N> x <M> (8 <= N <= 512, N % 8 = 0, and 0 < M <= 160)
    // | bool
    // | address (alias for byte[32])
    // | <type> [<N>]
    // | <type> []
    // | string
    // | (T1, ..., Tn)
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_LEN", ()=>MAX_LEN);
parcelHelpers.export(exports, "ADDR_BYTE_SIZE", ()=>ADDR_BYTE_SIZE);
parcelHelpers.export(exports, "SINGLE_BYTE_SIZE", ()=>SINGLE_BYTE_SIZE);
parcelHelpers.export(exports, "SINGLE_BOOL_SIZE", ()=>SINGLE_BOOL_SIZE);
parcelHelpers.export(exports, "LENGTH_ENCODE_BYTE_SIZE", ()=>LENGTH_ENCODE_BYTE_SIZE);
parcelHelpers.export(exports, "ABIType", ()=>ABIType);
parcelHelpers.export(exports, "ABIUintType", ()=>ABIUintType);
parcelHelpers.export(exports, "ABIUfixedType", ()=>ABIUfixedType);
parcelHelpers.export(exports, "ABIAddressType", ()=>ABIAddressType);
parcelHelpers.export(exports, "ABIBoolType", ()=>ABIBoolType);
parcelHelpers.export(exports, "ABIByteType", ()=>ABIByteType);
parcelHelpers.export(exports, "ABIStringType", ()=>ABIStringType);
parcelHelpers.export(exports, "ABIArrayStaticType", ()=>ABIArrayStaticType);
parcelHelpers.export(exports, "ABIArrayDynamicType", ()=>ABIArrayDynamicType);
parcelHelpers.export(exports, "ABITupleType", ()=>ABITupleType);
var _buffer = require("buffer");
var _address = require("../encoding/address");
var _bigint = require("../encoding/bigint");
var _utils = require("../utils/utils");
const MAX_LEN = 2 ** 16 - 1;
const ADDR_BYTE_SIZE = 32;
const SINGLE_BYTE_SIZE = 1;
const SINGLE_BOOL_SIZE = 1;
const LENGTH_ENCODE_BYTE_SIZE = 2;
const staticArrayRegexp = /^([a-z\d[\](),]+)\[(0|[1-9][\d]*)]$/;
const ufixedRegexp = /^ufixed([1-9][\d]*)x([1-9][\d]*)$/;
class ABIType {
    // De-serializes the ABI type from a string using the ABI specs
    static from(str) {
        if (str.endsWith("[]")) {
            const arrayArgType = ABIType.from(str.slice(0, str.length - 2));
            return new ABIArrayDynamicType(arrayArgType);
        }
        if (str.endsWith("]")) {
            const stringMatches = str.match(staticArrayRegexp);
            // Match the string itself, array element type, then array length
            if (stringMatches.length !== 3) throw new Error(`malformed static array string: ${str}`);
            // Parse static array using regex
            const arrayLengthStr = stringMatches[2];
            const arrayLength = parseInt(arrayLengthStr, 10);
            if (arrayLength > MAX_LEN) throw new Error(`array length exceeds limit ${MAX_LEN}`);
            // Parse the array element type
            const arrayType = ABIType.from(stringMatches[1]);
            return new ABIArrayStaticType(arrayType, arrayLength);
        }
        if (str.startsWith("uint")) {
            // Checks if the parsed number contains only digits, no whitespaces
            const digitsOnly = (string)=>[
                    ...string
                ].every((c)=>"0123456789".includes(c));
            const typeSizeStr = str.slice(4, str.length);
            if (!digitsOnly(typeSizeStr)) throw new Error(`malformed uint string: ${typeSizeStr}`);
            const typeSize = parseInt(typeSizeStr, 10);
            if (typeSize > MAX_LEN) throw new Error(`malformed uint string: ${typeSize}`);
            return new ABIUintType(typeSize);
        }
        if (str === "byte") return new ABIByteType();
        if (str.startsWith("ufixed")) {
            const stringMatches = str.match(ufixedRegexp);
            if (stringMatches.length !== 3) throw new Error(`malformed ufixed type: ${str}`);
            const ufixedSize = parseInt(stringMatches[1], 10);
            const ufixedPrecision = parseInt(stringMatches[2], 10);
            return new ABIUfixedType(ufixedSize, ufixedPrecision);
        }
        if (str === "bool") return new ABIBoolType();
        if (str === "address") return new ABIAddressType();
        if (str === "string") return new ABIStringType();
        if (str.length >= 2 && str[0] === "(" && str[str.length - 1] === ")") {
            const tupleContent = ABITupleType.parseTupleContent(str.slice(1, str.length - 1));
            const tupleTypes = [];
            for(let i = 0; i < tupleContent.length; i++){
                const ti = ABIType.from(tupleContent[i]);
                tupleTypes.push(ti);
            }
            return new ABITupleType(tupleTypes);
        }
        throw new Error(`cannot convert a string ${str} to an ABI type`);
    }
}
class ABIUintType extends ABIType {
    constructor(size){
        super();
        if (size % 8 !== 0 || size < 8 || size > 512) throw new Error(`unsupported uint type bitSize: ${size}`);
        this.bitSize = size;
    }
    toString() {
        return `uint${this.bitSize}`;
    }
    equals(other) {
        return other instanceof ABIUintType && this.bitSize === other.bitSize;
    }
    isDynamic() {
        return false;
    }
    byteLen() {
        return this.bitSize / 8;
    }
    encode(value) {
        if (typeof value !== "bigint" && typeof value !== "number") throw new Error(`Cannot encode value as uint${this.bitSize}: ${value}`);
        if (value >= BigInt(2 ** this.bitSize) || value < BigInt(0)) throw new Error(`${value} is not a non-negative int or too big to fit in size uint${this.bitSize}`);
        if (typeof value === "number" && !Number.isSafeInteger(value)) throw new Error(`${value} should be converted into a BigInt before it is encoded`);
        return (0, _bigint.bigIntToBytes)(value, this.bitSize / 8);
    }
    decode(byteString) {
        if (byteString.length !== this.bitSize / 8) throw new Error(`byte string must correspond to a uint${this.bitSize}`);
        return (0, _bigint.bytesToBigInt)(byteString);
    }
}
class ABIUfixedType extends ABIType {
    constructor(size, denominator){
        super();
        if (size % 8 !== 0 || size < 8 || size > 512) throw new Error(`unsupported ufixed type bitSize: ${size}`);
        if (denominator > 160 || denominator < 1) throw new Error(`unsupported ufixed type precision: ${denominator}`);
        this.bitSize = size;
        this.precision = denominator;
    }
    toString() {
        return `ufixed${this.bitSize}x${this.precision}`;
    }
    equals(other) {
        return other instanceof ABIUfixedType && this.bitSize === other.bitSize && this.precision === other.precision;
    }
    isDynamic() {
        return false;
    }
    byteLen() {
        return this.bitSize / 8;
    }
    encode(value) {
        if (typeof value !== "bigint" && typeof value !== "number") throw new Error(`Cannot encode value as ${this.toString()}: ${value}`);
        if (value >= BigInt(2 ** this.bitSize) || value < BigInt(0)) throw new Error(`${value} is not a non-negative int or too big to fit in size ${this.toString()}`);
        if (typeof value === "number" && !Number.isSafeInteger(value)) throw new Error(`${value} should be converted into a BigInt before it is encoded`);
        return (0, _bigint.bigIntToBytes)(value, this.bitSize / 8);
    }
    decode(byteString) {
        if (byteString.length !== this.bitSize / 8) throw new Error(`byte string must correspond to a ${this.toString()}`);
        return (0, _bigint.bytesToBigInt)(byteString);
    }
}
class ABIAddressType extends ABIType {
    toString() {
        return "address";
    }
    equals(other) {
        return other instanceof ABIAddressType;
    }
    isDynamic() {
        return false;
    }
    byteLen() {
        return ADDR_BYTE_SIZE;
    }
    encode(value) {
        if (typeof value !== "string" && !(value instanceof Uint8Array)) throw new Error(`Cannot encode value as ${this.toString()}: ${value}`);
        if (typeof value === "string") {
            const decodedAddress = (0, _address.decodeAddress)(value);
            return decodedAddress.publicKey;
        }
        // Return the address if it is already in bytes
        if (value.byteLength !== 32) throw new Error(`byte string must be 32 bytes long for an address`);
        return value;
    }
    decode(byteString) {
        if (byteString.byteLength !== 32) throw new Error(`byte string must be 32 bytes long for an address`);
        return (0, _address.encodeAddress)(byteString);
    }
}
class ABIBoolType extends ABIType {
    toString() {
        return "bool";
    }
    equals(other) {
        return other instanceof ABIBoolType;
    }
    isDynamic() {
        return false;
    }
    byteLen() {
        return SINGLE_BOOL_SIZE;
    }
    encode(value) {
        if (typeof value !== "boolean") throw new Error(`Cannot encode value as bool: ${value}`);
        if (value) return new Uint8Array([
            128
        ]);
        return new Uint8Array([
            0
        ]);
    }
    decode(byteString) {
        if (byteString.byteLength !== 1) throw new Error(`bool string must be 1 byte long`);
        const value = byteString[0];
        if (value === 128) return true;
        if (value === 0) return false;
        throw new Error(`boolean could not be decoded from the byte string`);
    }
}
class ABIByteType extends ABIType {
    toString() {
        return "byte";
    }
    equals(other) {
        return other instanceof ABIByteType;
    }
    isDynamic() {
        return false;
    }
    byteLen() {
        return SINGLE_BYTE_SIZE;
    }
    encode(value) {
        if (typeof value !== "number" && typeof value !== "bigint") throw new Error(`Cannot encode value as byte: ${value}`);
        if (typeof value === "bigint") // eslint-disable-next-line no-param-reassign
        value = Number(value);
        if (value < 0 || value > 255) throw new Error(`${value} cannot be encoded into a byte`);
        return new Uint8Array([
            value
        ]);
    }
    decode(byteString) {
        if (byteString.byteLength !== 1) throw new Error(`byte string must be 1 byte long`);
        return byteString[0];
    }
}
class ABIStringType extends ABIType {
    toString() {
        return "string";
    }
    equals(other) {
        return other instanceof ABIStringType;
    }
    isDynamic() {
        return true;
    }
    byteLen() {
        throw new Error(`${this.toString()} is a dynamic type`);
    }
    encode(value) {
        if (typeof value !== "string" && !(value instanceof Uint8Array)) throw new Error(`Cannot encode value as string: ${value}`);
        const encodedBytes = (0, _buffer.Buffer).from(value);
        const encodedLength = (0, _bigint.bigIntToBytes)(encodedBytes.length, LENGTH_ENCODE_BYTE_SIZE);
        const mergedBytes = new Uint8Array(encodedBytes.length + LENGTH_ENCODE_BYTE_SIZE);
        mergedBytes.set(encodedLength);
        mergedBytes.set(encodedBytes, LENGTH_ENCODE_BYTE_SIZE);
        return mergedBytes;
    }
    decode(byteString) {
        if (byteString.length < LENGTH_ENCODE_BYTE_SIZE) throw new Error(`byte string is too short to be decoded. Actual length is ${byteString.length}, but expected at least ${LENGTH_ENCODE_BYTE_SIZE}`);
        const buf = (0, _buffer.Buffer).from(byteString);
        const byteLength = buf.readUIntBE(0, LENGTH_ENCODE_BYTE_SIZE);
        const byteValue = byteString.slice(LENGTH_ENCODE_BYTE_SIZE, byteString.length);
        if (byteLength !== byteValue.length) throw new Error(`string length bytes do not match the actual length of string. Expected ${byteLength}, got ${byteValue.length}`);
        return (0, _buffer.Buffer).from(byteValue).toString("utf-8");
    }
}
class ABIArrayStaticType extends ABIType {
    constructor(argType, arrayLength){
        super();
        if (arrayLength < 0) throw new Error(`static array must have a non negative length: ${arrayLength}`);
        this.childType = argType;
        this.staticLength = arrayLength;
    }
    toString() {
        return `${this.childType.toString()}[${this.staticLength}]`;
    }
    equals(other) {
        return other instanceof ABIArrayStaticType && this.staticLength === other.staticLength && this.childType.equals(other.childType);
    }
    isDynamic() {
        return this.childType.isDynamic();
    }
    byteLen() {
        if (this.childType.constructor === ABIBoolType) return Math.ceil(this.staticLength / 8);
        return this.staticLength * this.childType.byteLen();
    }
    encode(value) {
        if (!Array.isArray(value) && !(value instanceof Uint8Array)) throw new Error(`Cannot encode value as ${this.toString()}: ${value}`);
        if (value.length !== this.staticLength) throw new Error(`Value array does not match static array length. Expected ${this.staticLength}, got ${value.length}`);
        const convertedTuple = this.toABITupleType();
        return convertedTuple.encode(value);
    }
    decode(byteString) {
        const convertedTuple = this.toABITupleType();
        return convertedTuple.decode(byteString);
    }
    toABITupleType() {
        return new ABITupleType(Array(this.staticLength).fill(this.childType));
    }
}
class ABIArrayDynamicType extends ABIType {
    constructor(argType){
        super();
        this.childType = argType;
    }
    toString() {
        return `${this.childType.toString()}[]`;
    }
    equals(other) {
        return other instanceof ABIArrayDynamicType && this.childType.equals(other.childType);
    }
    isDynamic() {
        return true;
    }
    byteLen() {
        throw new Error(`${this.toString()} is a dynamic type`);
    }
    encode(value) {
        if (!Array.isArray(value) && !(value instanceof Uint8Array)) throw new Error(`Cannot encode value as ${this.toString()}: ${value}`);
        const convertedTuple = this.toABITupleType(value.length);
        const encodedTuple = convertedTuple.encode(value);
        const encodedLength = (0, _bigint.bigIntToBytes)(convertedTuple.childTypes.length, LENGTH_ENCODE_BYTE_SIZE);
        const mergedBytes = (0, _utils.concatArrays)(encodedLength, encodedTuple);
        return mergedBytes;
    }
    decode(byteString) {
        const buf = (0, _buffer.Buffer).from(byteString);
        const byteLength = buf.readUIntBE(0, LENGTH_ENCODE_BYTE_SIZE);
        const convertedTuple = this.toABITupleType(byteLength);
        return convertedTuple.decode(byteString.slice(LENGTH_ENCODE_BYTE_SIZE, byteString.length));
    }
    toABITupleType(length) {
        return new ABITupleType(Array(length).fill(this.childType));
    }
}
class ABITupleType extends ABIType {
    constructor(argTypes){
        super();
        if (argTypes.length >= MAX_LEN) throw new Error("tuple type child type number larger than maximum uint16 error");
        this.childTypes = argTypes;
    }
    toString() {
        const typeStrings = [];
        for(let i = 0; i < this.childTypes.length; i++)typeStrings[i] = this.childTypes[i].toString();
        return `(${typeStrings.join(",")})`;
    }
    equals(other) {
        return other instanceof ABITupleType && this.childTypes.length === other.childTypes.length && this.childTypes.every((child, index)=>child.equals(other.childTypes[index]));
    }
    isDynamic() {
        const isDynamic = (child)=>child.isDynamic();
        return this.childTypes.some(isDynamic);
    }
    byteLen() {
        let size = 0;
        for(let i = 0; i < this.childTypes.length; i++)if (this.childTypes[i].constructor === ABIBoolType) {
            const after = findBoolLR(this.childTypes, i, 1);
            const boolNum = after + 1;
            i += after;
            size += Math.trunc((boolNum + 7) / 8);
        } else {
            const childByteSize = this.childTypes[i].byteLen();
            size += childByteSize;
        }
        return size;
    }
    encode(value) {
        if (!Array.isArray(value) && !(value instanceof Uint8Array)) throw new Error(`Cannot encode value as ${this.toString()}: ${value}`);
        const values = Array.from(value);
        if (value.length > MAX_LEN) throw new Error("length of tuple array should not exceed a uint16");
        const tupleTypes = this.childTypes;
        const heads = [];
        const tails = [];
        const isDynamicIndex = new Map();
        let i = 0;
        while(i < tupleTypes.length){
            const tupleType = tupleTypes[i];
            if (tupleType.isDynamic()) {
                // Head is not pre-determined for dynamic types; store a placeholder for now
                isDynamicIndex.set(heads.length, true);
                heads.push(new Uint8Array([
                    0,
                    0
                ]));
                tails.push(tupleType.encode(values[i]));
            } else {
                if (tupleType.constructor === ABIBoolType) {
                    const before = findBoolLR(tupleTypes, i, -1);
                    let after = findBoolLR(tupleTypes, i, 1);
                    // Pack bytes to heads and tails
                    if (before % 8 !== 0) throw new Error("expected before index should have number of bool mod 8 equal 0");
                    after = Math.min(7, after);
                    const compressedInt = compressMultipleBool(values.slice(i, i + after + 1));
                    heads.push((0, _bigint.bigIntToBytes)(compressedInt, 1));
                    i += after;
                } else {
                    const encodedTupleValue = tupleType.encode(values[i]);
                    heads.push(encodedTupleValue);
                }
                isDynamicIndex.set(i, false);
                tails.push(new Uint8Array());
            }
            i += 1;
        }
        // Adjust head lengths for dynamic types
        let headLength = 0;
        for (const headElement of heads)headLength += headElement.length;
        // encode any placeholders for dynamic types
        let tailLength = 0;
        for(let j = 0; j < heads.length; j++){
            if (isDynamicIndex.get(j)) {
                const headValue = headLength + tailLength;
                if (headValue > MAX_LEN) throw new Error(`byte length of ${headValue} should not exceed a uint16`);
                heads[j] = (0, _bigint.bigIntToBytes)(headValue, LENGTH_ENCODE_BYTE_SIZE);
            }
            tailLength += tails[j].length;
        }
        return (0, _utils.concatArrays)(...heads, ...tails);
    }
    decode(byteString) {
        const tupleTypes = this.childTypes;
        const dynamicSegments = [];
        const valuePartition = [];
        let i = 0;
        let iterIndex = 0;
        const buf = (0, _buffer.Buffer).from(byteString);
        while(i < tupleTypes.length){
            const tupleType = tupleTypes[i];
            if (tupleType.isDynamic()) {
                if (byteString.slice(iterIndex, byteString.length).length < LENGTH_ENCODE_BYTE_SIZE) throw new Error("dynamic type in tuple is too short to be decoded");
                const dynamicIndex = buf.readUIntBE(iterIndex, LENGTH_ENCODE_BYTE_SIZE);
                if (dynamicSegments.length > 0) {
                    dynamicSegments[dynamicSegments.length - 1].right = dynamicIndex;
                    // Check that right side of segment is greater than the left side
                    if (dynamicIndex < dynamicSegments[dynamicSegments.length - 1].left) throw new Error("dynamic index segment miscalculation: left is greater than right index");
                }
                // Since we do not know where the current dynamic element ends, put a placeholder and update later
                const seg = {
                    left: dynamicIndex,
                    right: -1
                };
                dynamicSegments.push(seg);
                valuePartition.push(null);
                iterIndex += LENGTH_ENCODE_BYTE_SIZE;
            } else // eslint-disable-next-line no-lonely-if
            if (tupleType.constructor === ABIBoolType) {
                const before = findBoolLR(this.childTypes, i, -1);
                let after = findBoolLR(this.childTypes, i, 1);
                if (before % 8 !== 0) throw new Error("expected before bool number mod 8 === 0");
                after = Math.min(7, after);
                // Parse bool in a byte to multiple byte strings
                for(let boolIndex = 0; boolIndex <= after; boolIndex++){
                    const boolMask = 0x80 >> boolIndex;
                    if ((byteString[iterIndex] & boolMask) > 0) valuePartition.push(new Uint8Array([
                        128
                    ]));
                    else valuePartition.push(new Uint8Array([
                        0
                    ]));
                }
                i += after;
                iterIndex += 1;
            } else {
                const currLen = tupleType.byteLen();
                valuePartition.push(byteString.slice(iterIndex, iterIndex + currLen));
                iterIndex += currLen;
            }
            if (i !== tupleTypes.length - 1 && iterIndex >= byteString.length) throw new Error("input byte not enough to decode");
            i += 1;
        }
        if (dynamicSegments.length > 0) {
            dynamicSegments[dynamicSegments.length - 1].right = byteString.length;
            iterIndex = byteString.length;
        }
        if (iterIndex < byteString.length) throw new Error("input byte not fully consumed");
        // Check segment indices are valid
        // If the dynamic segment are not consecutive and well-ordered, we return error
        for(let j = 0; j < dynamicSegments.length; j++){
            const seg = dynamicSegments[j];
            if (seg.left > seg.right) throw new Error("dynamic segment should display a [l, r] space with l <= r");
            if (j !== dynamicSegments.length - 1 && seg.right !== dynamicSegments[j + 1].left) throw new Error("dynamic segment should be consecutive");
        }
        // Check dynamic element partitions
        let segIndex = 0;
        for(let j = 0; j < tupleTypes.length; j++)if (tupleTypes[j].isDynamic()) {
            valuePartition[j] = byteString.slice(dynamicSegments[segIndex].left, dynamicSegments[segIndex].right);
            segIndex += 1;
        }
        // Decode each tuple element
        const returnValues = [];
        for(let j = 0; j < tupleTypes.length; j++){
            const valueTi = tupleTypes[j].decode(valuePartition[j]);
            returnValues.push(valueTi);
        }
        return returnValues;
    }
    static parseTupleContent(str) {
        if (str.length === 0) return [];
        if (str.endsWith(",") || str.startsWith(",")) throw new Error("tuple string should not start with comma");
        if (str.includes(",,")) throw new Error("tuple string should not have consecutive commas");
        const tupleStrings = [];
        let depth = 0;
        let word = "";
        for (const char of str){
            word += char;
            if (char === "(") depth += 1;
            else if (char === ")") depth -= 1;
            else if (char === ",") // If the comma is at depth 0, then append the word as token.
            {
                if (depth === 0) {
                    tupleStrings.push(word.slice(0, word.length - 1));
                    word = "";
                }
            }
        }
        if (word.length !== 0) tupleStrings.push(word);
        if (depth !== 0) throw new Error("tuple string has mismatched parentheses");
        return tupleStrings;
    }
}
// compressMultipleBool compresses consecutive bool values into a byte in ABI tuple / array value.
function compressMultipleBool(valueList) {
    let res = 0;
    if (valueList.length > 8) throw new Error("value list passed in should be no greater than length 8");
    for(let i = 0; i < valueList.length; i++){
        const boolVal = valueList[i];
        if (typeof boolVal !== "boolean") throw new Error("non-boolean values cannot be compressed into a byte");
        if (boolVal) res |= 1 << 7 - i;
    }
    return res;
}
// Assume that the current index on the list of type is an ABI bool type.
// It returns the difference between the current index and the index of the furthest consecutive Bool type.
function findBoolLR(typeList, index, delta) {
    let until = 0;
    while(true){
        const curr = index + delta * until;
        if (typeList[curr].constructor === ABIBoolType) {
            if (curr !== typeList.length - 1 && delta === 1) until += 1;
            else if (curr > 0 && delta === -1) until += 1;
            else break;
        } else {
            until -= 1;
            break;
        }
    }
    return until;
}

},{"buffer":"jlSk7","../encoding/address":"7lw2f","../encoding/bigint":"1CIMA","../utils/utils":"izzsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYfCZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ABIContract", ()=>ABIContract);
var _method = require("./method");
class ABIContract {
    constructor(params){
        if (typeof params.name !== "string" || !Array.isArray(params.methods) || params.networks && typeof params.networks !== "object") throw new Error("Invalid ABIContract parameters");
        this.name = params.name;
        this.description = params.desc;
        this.networks = params.networks ? {
            ...params.networks
        } : {};
        this.methods = params.methods.map((method)=>new (0, _method.ABIMethod)(method));
    }
    toJSON() {
        return {
            name: this.name,
            desc: this.description,
            networks: this.networks,
            methods: this.methods.map((method)=>method.toJSON())
        };
    }
    getMethodByName(name) {
        return (0, _method.getMethodByName)(this.methods, name);
    }
}

},{"./method":"f3cYe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f3cYe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ABIMethod", ()=>ABIMethod);
parcelHelpers.export(exports, "getMethodByName", ()=>getMethodByName);
var _naclWrappers = require("../nacl/naclWrappers");
var _abiType = require("./abi_type");
var _transaction = require("./transaction");
var _reference = require("./reference");
function parseMethodSignature(signature) {
    const argsStart = signature.indexOf("(");
    if (argsStart === -1) throw new Error(`Invalid method signature: ${signature}`);
    let argsEnd = -1;
    let depth = 0;
    for(let i = argsStart; i < signature.length; i++){
        const char = signature[i];
        if (char === "(") depth += 1;
        else if (char === ")") {
            if (depth === 0) break;
            depth -= 1;
            if (depth === 0) {
                argsEnd = i;
                break;
            }
        }
    }
    if (argsEnd === -1) throw new Error(`Invalid method signature: ${signature}`);
    return {
        name: signature.slice(0, argsStart),
        args: (0, _abiType.ABITupleType).parseTupleContent(signature.slice(argsStart + 1, argsEnd)),
        returns: signature.slice(argsEnd + 1)
    };
}
class ABIMethod {
    constructor(params){
        if (typeof params.name !== "string" || typeof params.returns !== "object" || !Array.isArray(params.args)) throw new Error("Invalid ABIMethod parameters");
        this.name = params.name;
        this.description = params.desc;
        this.args = params.args.map(({ type , name , desc  })=>{
            if ((0, _transaction.abiTypeIsTransaction)(type) || (0, _reference.abiTypeIsReference)(type)) return {
                type,
                name,
                description: desc
            };
            return {
                type: (0, _abiType.ABIType).from(type),
                name,
                description: desc
            };
        });
        this.returns = {
            type: params.returns.type === "void" ? params.returns.type : (0, _abiType.ABIType).from(params.returns.type),
            description: params.returns.desc
        };
    }
    getSignature() {
        const args = this.args.map((arg)=>arg.type.toString()).join(",");
        const returns = this.returns.type.toString();
        return `${this.name}(${args})${returns}`;
    }
    getSelector() {
        const hash = (0, _naclWrappers.genericHash)(this.getSignature());
        return new Uint8Array(hash.slice(0, 4));
    }
    txnCount() {
        let count = 1;
        for (const arg of this.args)if (typeof arg.type === "string" && (0, _transaction.abiTypeIsTransaction)(arg.type)) count += 1;
        return count;
    }
    toJSON() {
        return {
            name: this.name,
            desc: this.description,
            args: this.args.map(({ type , name , description  })=>({
                    type: type.toString(),
                    name,
                    desc: description
                })),
            returns: {
                type: this.returns.type.toString(),
                desc: this.returns.description
            }
        };
    }
    static fromSignature(signature) {
        const { name , args , returns  } = parseMethodSignature(signature);
        return new ABIMethod({
            name,
            args: args.map((arg)=>({
                    type: arg
                })),
            returns: {
                type: returns
            }
        });
    }
}
function getMethodByName(methods, name) {
    if (methods === null || !Array.isArray(methods) || !methods.every((item)=>item instanceof ABIMethod)) throw new Error("Methods list provided is null or not the correct type");
    const filteredMethods = methods.filter((m)=>m.name === name);
    if (filteredMethods.length > 1) throw new Error(`found ${filteredMethods.length} methods with the same name ${filteredMethods.map((m)=>m.getSignature()).join(",")}`);
    if (filteredMethods.length === 0) throw new Error(`found 0 methods with the name ${name}`);
    return filteredMethods[0];
}

},{"../nacl/naclWrappers":"hIiu2","./abi_type":"bvYGr","./transaction":"iXzYU","./reference":"XdEZw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iXzYU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ABITransactionType", ()=>ABITransactionType);
parcelHelpers.export(exports, "abiTypeIsTransaction", ()=>abiTypeIsTransaction);
parcelHelpers.export(exports, "abiCheckTransactionType", ()=>abiCheckTransactionType);
var ABITransactionType;
(function(ABITransactionType) {
    /**
     * Any transaction type
     */ ABITransactionType["any"] = "txn";
    /**
     * Payment transaction type
     */ ABITransactionType["pay"] = "pay";
    /**
     * Key registration transaction type
     */ ABITransactionType["keyreg"] = "keyreg";
    /**
     * Asset configuration transaction type
     */ ABITransactionType["acfg"] = "acfg";
    /**
     * Asset transfer transaction type
     */ ABITransactionType["axfer"] = "axfer";
    /**
     * Asset freeze transaction type
     */ ABITransactionType["afrz"] = "afrz";
    /**
     * Application transaction type
     */ ABITransactionType["appl"] = "appl";
})(ABITransactionType || (ABITransactionType = {}));
function abiTypeIsTransaction(type) {
    return type === ABITransactionType.any || type === ABITransactionType.pay || type === ABITransactionType.keyreg || type === ABITransactionType.acfg || type === ABITransactionType.axfer || type === ABITransactionType.afrz || type === ABITransactionType.appl;
}
function abiCheckTransactionType(type, txn) {
    if (type === ABITransactionType.any) return true;
    return txn.type && txn.type.toString() === type.toString();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XdEZw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ABIReferenceType", ()=>ABIReferenceType);
parcelHelpers.export(exports, "abiTypeIsReference", ()=>abiTypeIsReference);
var ABIReferenceType;
(function(ABIReferenceType) {
    /**
     * Account reference type
     */ ABIReferenceType["account"] = "account";
    /**
     * Application reference type
     */ ABIReferenceType["application"] = "application";
    /**
     * Asset reference type
     */ ABIReferenceType["asset"] = "asset";
})(ABIReferenceType || (ABIReferenceType = {}));
function abiTypeIsReference(type) {
    return type === ABIReferenceType.account || type === ABIReferenceType.application || type === ABIReferenceType.asset;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nHsI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ABIInterface", ()=>ABIInterface);
var _method = require("./method");
class ABIInterface {
    constructor(params){
        if (typeof params.name !== "string" || !Array.isArray(params.methods)) throw new Error("Invalid ABIInterface parameters");
        this.name = params.name;
        this.description = params.desc;
        this.methods = params.methods.map((method)=>new (0, _method.ABIMethod)(method));
    }
    toJSON() {
        return {
            name: this.name,
            desc: this.description,
            methods: this.methods.map((method)=>method.toJSON())
        };
    }
    getMethodByName(name) {
        return (0, _method.getMethodByName)(this.methods, name);
    }
}

},{"./method":"f3cYe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMWK6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transactions = require("./transactions");
parcelHelpers.exportAll(_transactions, exports);
var _multisig = require("./multisig");
parcelHelpers.exportAll(_multisig, exports);
var _address = require("./address");
parcelHelpers.exportAll(_address, exports);

},{"./transactions":"8EISr","./multisig":"1tp2v","./address":"Skvob","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tp2v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Skvob":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ZdDr":[function(require,module,exports) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

},{}],"iYNIy":[function(require,module,exports) {
module.exports = require("47e114314583d2a6")(require("717b9e7a837e775d").getBundleURL("h7kXA") + require("dee10eacf0058aca").resolve("YDSGx")).then(()=>module.bundle.root("d7JJn"));

},{"47e114314583d2a6":"hpx0h","717b9e7a837e775d":"c7Tr5","dee10eacf0058aca":"fyJL2"}],"hpx0h":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["g0GKl"], "g0GKl", "parcelRequirebdeb")

//# sourceMappingURL=index.04bb54c1.js.map
